(function () {
	'use strict';

	var re = /newsis-qa|mynha.com/g;
	if (window.location.href.search(re) > -1) {
		/** configure the script */
		var pingdom = document.createElement('script');
		pingdom.type = 'text/javascript';
		pingdom.async = true;
		pingdom.src = '//rum-static.pingdom.net/pa-5ab3be244c407700070004d2.js';

		/** inject the script */
		var s = document.getElementsByTagName('script')[0];
		s.parentNode.insertBefore(pingdom, s);
	} 
})();;
/**
 * utils.angular
 * @namespace Core
 */

(function () {
	'use strict';

	/** initialization */
	function init() {
		/** setup _ng object with angular utility methods */
		var exports = {
			isModuleLoaded: isModuleLoaded,
			moduleInit: moduleInit
		};

		/**
		 * Check if a module is loaded
		 * @param string moduleName 
		 * @returns bool
		 */
		function isModuleLoaded(moduleName){
			try { angular.module(moduleName); return true; }
			catch (e){ return false; }
		}

		/**
		 * Take in array of module names and check if they are loaded 
		 * if not loaded, create a blank module 
		 * return modules array
		 * @param [] modules 
		 * @returns [] 
		 */
		function moduleInit(modules) {
			/** check that modules are loaded */
			_.forEach(modules, function(m) {
				if (!isModuleLoaded(m)) {
					/** create blank module */
					angular.module(m, []);
					log('Module [' + m + '] is not loaded. Blank module created.');
				}
			});

			/** return loaded modules array */
			return modules;
		}

		/** return exports */
		return exports;
	}

	/** define globally if it doesn't already exist */
	if (typeof (_ng) === 'undefined') {
		window._ng = init();
	}
})();;
/*
 * This is meant to be our generic library with no dependencies.
 * Function likes lodash library
 * Example usage
 * _utils.getODataRequest({
    'top': 20
    })

    // returns
    Object {$top: 20}
 */

; (function () {
    'use strict';

    function init() {

        // ToDo: index by timezoneID & update timezoneLookup.  Can we pull as enums from server?
        var validTimezones = [
            'Etc/UTC',      //  0| 0
            'America/Detroit',   // -5|-4
            'America/Chicago',   // -6|-5
            'America/Denver',  // -7|-6
            // 'America/Phoenix',   // -7|-7
            'America/Los_Angeles'    // -8/-7
        ];

        var exports = {};

        exports.regex = {};
        exports.regex.phoneNumber = '^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$';
        exports.regex.emailAddress = "^[a-zA-Z0-9!#$%&+'._@-]*$";
        exports.regex.zipCode = '^[0-9]{0,5}$';

        /*Returns object representing the OData parameters based on parameters passed in. Angular resources take this as input and is  automatically turned into querystring.
         * Input: { skip: 20, top: 20, filter: { FirstName: 'Bob' } }
         * Output: { "$skip": 20, "$top": 20, "$filter": "FirstName eq 'Bob'" }
         */
        exports.getODataRequest = function (oDataParams) {
            var returnValue = {};

            if (oDataParams) {
                if (typeof (oDataParams.top) != 'undefined') {
                    returnValue['$top'] = oDataParams.top;
                };

                if (typeof (oDataParams.orderby) != 'undefined') {
                    returnValue['$orderby'] = oDataParams.orderby;
                };

                if (typeof (oDataParams.select) != 'undefined') {
                    returnValue['$select'] = oDataParams.select;
                };

                if (typeof (oDataParams.skip) != 'undefined') {
                    returnValue['$skip'] = oDataParams.skip;
                };

                if (typeof (oDataParams.count) != 'undefined') {
                    returnValue['$count'] = oDataParams.count;
                };

                if (typeof (oDataParams.filter) != 'undefined') {
                    if (typeof (oDataParams.$filter) != 'undefined') {
                        returnValue['$filter'] = oDataParams.$filter + " and " + this.getODataFilterQuerystringValue(oDataParams.filter);
                    } else {
                        returnValue['$filter'] = this.getODataFilterQuerystringValue(oDataParams.filter);
                    }
                };
            }

            return returnValue;
        };

        /*Returns full OData url*/
        exports.getODataQuerystringValue = function (oDataParams) {
            var returnValue = '';

            var needAmpersand = false;  // meh, something has to be more clever than this

            if (oDataParams.top > 0) {
                returnValue += '$top=' + oDataParams.top;
                needAmpersand = true;
            }

            if (oDataParams.filter.length > 0) {
                returnValue += (needAmpersand ? '&' : '') + '&$filter=' + this.getODataFilterQuerystringValue(oDataParams.filter);
                needAmpersand = true;
            }

            if (oDataParams.orderby.length > 0) {
                returnValue += (needAmpersand ? '&' : '') + '$orderby=' + oDataParams.orderby;
                needAmpersand = true;
            }

            if (oDataParams.select.length > 0) {
                returnValue += (needAmpersand ? '&' : '') + '$select=' + oDataParams.select;
                needAmpersand = true;
            }

            if (oDataParams.skip > 0) {
                returnValue += (needAmpersand ? '&' : '') + '$skip=' + oDataParams.skip;
                needAmpersand = true;
            }

            if (oDataParams.count > 0) {
                returnValue += (needAmpersand ? '&' : '') + '$count=' + oDataParams.count;
            }

            return returnValue;
        }

        exports.capitalizeFirstLetter = function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        exports.cleanString = function (dirtyString) {
            dirtyString = dirtyString.replace(/[|&;$%@"<>()+,]/g, '');
            dirtyString = dirtyString.replace('\'', '\'\'');
            dirtyString = dirtyString.replace(/'/g, '\'\'');
            dirtyString = dirtyString.replace(/&/g, '%26');
            return dirtyString;
        }

        exports.getODataFilterFromParams = function (params, capitalizeIdString, firstLetterCapitalize) {
            var oDataFilter = {};

            // default to always capitalizing first letter
            if (firstLetterCapitalize == null) {
                firstLetterCapitalize = true;
            }

            // ensure we have params
            if (params) {
                // loop through our properties of the param json
                for (var propertyName in params) {
                    // ensure the propery exists
                    if (params.hasOwnProperty(propertyName)) {
                        // get the new property name, capitalizing the first character
                        var newPropertyName = (firstLetterCapitalize ? this.capitalizeFirstLetter(propertyName) : propertyName);

                        // some apis have capital ID and some have camelCase Id, handle it!
                        if (capitalizeIdString && newPropertyName.lastIndexOf('Id') !== -1) {
                            newPropertyName = newPropertyName.replace('Id', 'ID');
                        }

                        // add our new property name
                        oDataFilter[newPropertyName] = params[propertyName];
                    }
                }
            }

            return oDataFilter;
        }

        exports.getParsedODataFilter = function (params, capitalizeIdString, firstLetterCapitalize) {
            return this.getODataRequest({ 'filter': this.getODataFilterFromParams(params, capitalizeIdString, firstLetterCapitalize) });
        }

        exports.FilterOption = function (key, value, comparer, booleanOperator) {
            this.key = key,
            this.value = value,
            this.comparer = comparer;
            this.booleanOperator = booleanOperator;
        }

        exports.updateODataFilterWithNHAFilter = function updateODataFilterWithNHAFilter(nhaFilters, filterPropertyName, key, oDataFilter, options) {
            if (nhaFilters[filterPropertyName]) {
                var selectedItemIds = _.map(_.filter(nhaFilters[filterPropertyName].items, 'selected'), 'id');

                // merge passed options with defaults
                var opts = _.extend({
                    // if value is an array, default operator to OR, otherwise NULL
                    booleanOperator: (selectedItemIds.length > 1 && (!options || !options.booleanOperator)) ? 'or' : undefined,

                    // default comparer is EQUALS, but can be changes
                    comparer: 'eq'
                }, options);

                if (selectedItemIds) {
                    oDataFilter[filterPropertyName] = new _utils.FilterOption();
                    oDataFilter[filterPropertyName].key = key;
                    oDataFilter[filterPropertyName].value = selectedItemIds.length === 1 ? selectedItemIds[0] : selectedItemIds;
                    oDataFilter[filterPropertyName].comparer = opts.comparer;
                    oDataFilter[filterPropertyName].booleanOperator = opts.booleanOperator;
                }
                else {
                    oDataFilter[key] = 1;
                }
            }
        }
        /*Returns value for $filter querstring parameter for OData queries: <Name> eq <Value>*/
        exports.getODataFilterQuerystringValue = function (filterLookup) {
            var returnValue = '';

            var i = 0;

            for (var prop in filterLookup) {
                if (filterLookup.hasOwnProperty(prop)) {
                    var filterObject = filterLookup[prop];

                    if (filterObject) {
                        if (typeof (filterObject.value) == 'object' && filterLookup[prop] instanceof this.FilterOption) {
                            if (filterObject.value instanceof Array) { //Handles cases like '$filter=(GradeLevelID = 1 or GradeLevelID = 2)'
                                var thisFilter = '';

                                for (var j = 0; j < filterObject.value.length; j++) {
                                    if (j > 0) {
                                        thisFilter += ' ' + filterObject.booleanOperator + ' ';
                                    }

                                    //Array to compare to
                                    thisFilter += (' ' + filterObject.key + ' ' + filterObject.comparer + ' ' + filterObject.value[j]);
                                }

                                if (i > 0) {
                                    returnValue += ' and ';
                                }

                                returnValue += '(' + thisFilter + ')';
                            } else {
                                var value;

                                if (filterObject.value instanceof Date) {
                                    value = 'DateTime\'' + filterObject.value + '\'';
                                } else {
                                    value = filterObject.value;
                                }

                                returnValue += (' ' + filterObject.key + ' ' + filterObject.comparer + ' ' + value);
                            }
                        } else if (filterLookup[prop] instanceof this.FilterOption) {

                            if (i > 0) {
                                returnValue += ' and ';
                            }
                            returnValue += (' ' + filterObject.key + ' ' + filterObject.comparer + ' ' + filterObject.value);

                        } else {
                            var quotePlaceholder = isNaN(filterLookup[prop]) ? '\'' : '';

                            if (i > 0) {
                                returnValue += ' and ';
                            }

                            //PropertyName eq 'PropertyValue'
                            returnValue += (' ' + prop + ' eq ' + quotePlaceholder + filterLookup[prop] + quotePlaceholder);
                        }
                    } else if (filterObject === null) {
                        if (i > 0) {
                            returnValue += ' and ';
                        }
                        returnValue += (' ' + prop + ' eq null ');
                    }

                    i++;
                }
            }

            return returnValue;
        }

        function filterParam(key) {
            return new function () {
                this.value = '';
                this.key = key;
                this.equals = function (val, operator) {
                    if (_.isArray(val)) {
                        this.value += '(' + _.map(val, function (i) {
                            return key + ' eq ' + i;
                        }).join(' ' + (operator || 'or') + ' ') + ')';
                    } else {
                        this.value += key + ' eq ' + val;
                    }
                    return this.value;
                }
                this.any = function (val, childkey) {
                    if (val) {
                        if (_.isArray(val)) {
                            this.value += key + '/any(x:(' + _.map(val, function (i) {
                                return 'x/' + (childkey ? childkey : key + 'ID') + ' eq ' + i;
                            }).join(' or ') + '))';
                        } else {
                            this.value += this.key + '/any(x:x/' + (childkey ? childkey : this.key + 'ID') + ' eq ' + val + ')';
                        }
                    } else {
                        this.value += this.key + '/any';
                    }
                    return this.value;
                }
            }
        }

        exports.filterQuery = function () {
            return new function () {
                this.parameters = [];
                this.equals = function (key, val, operator) {
                    if (!key && !val)
                        return this;

                    this.parameters.push(filterParam(key).equals(val, operator));
                    return this;
                }
                this.any = function (key, val, childkey) {
                    this.parameters.push(filterParam(key).any(val, childkey));
                    return this;
                }
                this.value = function () {
                    return this.parameters.join(' and ');
                }
            }
        }

        exports.setOrderByParameters = function (parameters, sort) {
            var sortString = '';
            if (sort) {
                for (var i = 0; i < sort.length; i++) {
                    sortString += sort[i].criteria + (sort[i].descending ? ' desc' : '');
                    if (i + 1 < sort.length) {
                        sortString += ', ';
                    }
                }
                parameters.$orderby = sortString;
            }


        }

        exports.setSearchFilter = function (parameters, text, searchFields) {
            if (text) {
                var splitText = text.split(' ');

                if (splitText.length > 1) {
                    _.forEach(splitText, function (word) {
                        //Set search filter on each individual word
                        exports.setSearchFilter(parameters, word, searchFields);
                    });
                }
                else {
                    var searchParameter = '(';
                    _.forEach(searchFields, function (searchField) {
                        searchParameter += 'substringof(\'' + text + '\', ' + searchField + ') or ';
                    });
                    searchParameter = searchParameter.slice(0, searchParameter.length - 4);
                    searchParameter += ')';
                    if (parameters.$filter) {
                        parameters.$filter += ' and ' + searchParameter;
                    } else {
                        parameters.$filter = searchParameter;
                    }
                }
            }
        }


        exports.openUrl = function (url, openInNewTab) {
            if (openInNewTab) {
                var win = window.open(url, '');
            } else {
                location.href = url;
            }
        }

        exports.joinUrl = function (baseUrl, url) {
            var theUrl = new URI(url);
            if (theUrl.is('relative')) {
                theUrl = theUrl.absoluteTo(baseUrl);
            }
            return theUrl.toString();
        }

        exports.getHashCode = function (s) {
            for (var h = 0, i = 0; i < s.length; h &= h) {
                h = 31 * h + s.charCodeAt(i++);
            }
            return h;
        }

        exports.ensureDateIsValidMomentDate = function (date) {

            // this could come in as null, a string, a moment, a js date.  Ensure its always a proper moment()
            var momentToReturn = moment();

            try {
                if (date) {
                    switch (typeof (date)) {
                        case 'object':
                            momentToReturn = moment(new Date(date));
                        case 'string':
                            if (moment.isMoment(date)) {
                                momentToReturn = date;
                            }
                            else {
                                date = new String(date);
                                // no - dashes for FF, it does not like them
                                if (date.indexOf('-') > 0) {
                                    date.replace('-', '/');
                                }
                                momentToReturn = moment(new Date(date));
                            }
                            break;
                    }
                }

                if (!momentToReturn.isValid()) {
                    momentToReturn = moment();
                }
            }
            catch (e) {
                // suppress any errors and just give us moment()
                momentToReturn = moment();
            }

            return momentToReturn;
        }

        exports.setFilterItem = function (filters, filterKey) {

            var selectedFilterValue = null;
            if (filters[filterKey]) {

                var selectedFilterItem = _.filter(filters[filterKey].items, 'selected');
                if (selectedFilterItem) {

                    if (selectedFilterItem.length > 1) {
                        selectedFilterValue = _.map(selectedFilterItem, 'id');
                    } else {
                        selectedFilterValue = _.head(selectedFilterItem).id;
                    }
                }
            }
            return selectedFilterValue;
        }

        exports.setFilterODataItem = function (oDataFilter, filters, filterKey, keyName) {

            // if we don't pass this in, default to convention
            if (!keyName) {
                keyName = filterKey + 'ID';
            }

            if (filters && filters[filterKey]) {
                var selectedFilter = _.filter(filters[filterKey].items, 'selected');
                if (selectedFilter) {

                    oDataFilter[filterKey] = new _utils.FilterOption();
                    oDataFilter[filterKey].key = keyName;
                    oDataFilter[filterKey].comparer = 'eq';

                    if (selectedFilter.length > 1) {
                        oDataFilter[filterKey].booleanOperator = 'or';
                        oDataFilter[filterKey].value = _.map(selectedFilter, 'id');
                    } else {
                        oDataFilter[filterKey].value = _.head(selectedFilter).id;
                    }
                }
            }
        }

        exports.setFilterItemsByKeys = function (parameters, filters, useCamelCaseId) {
            if (parameters && filters) {
                _.forEach(_.keys(filters), function (filterKey) {
                    parameters[filterKey + (useCamelCaseId ? 'Id' : 'ID')] = _utils.setFilterItem(filters, filterKey);
                });
            }
        }

        //Date

        exports.renderDatesAsStrings = function (parameters) {
            for (var key in parameters) {
                if (parameters[key] instanceof Date) {
                    parameters[key] = exports.formatDateAsDate(parameters[key]);
                }
            }

            return parameters;
        }

        exports.formatDateAsDate = function (date, delimiter) {
            return moment(date).format('MM' + (delimiter ? delimiter : '/') + 'D' + (delimiter ? delimiter : '/') + 'YYYY');
        }

        exports.stripTimeFromDate = function (datetime) {
            return moment(datetime).format('YYYY-MM-DD');
        }

        exports.getDateFromTimeString = function (time) {
            var returnTime = moment();
            var split = time.split(':');
            returnTime.hour(split[0]);
            returnTime.minute(split[1]);
            return returnTime;
        }


        function timezoneLookup(school) {
            // todo: Use the new timezone field from the database
            switch (school.summerTimeZone) {
                case '06:00:00':
                    return "America/Denver";
                    break;
                case '05:00:00':
                    return "America/Chicago";
                    break;
                case '04:00:00':
                    return "America/Detroit";
                    break;
                default:
                    throw school.shortName + ' timezone of ' + school.summerTimeZone + ' is not recognized.';
                    break;
            }
        }

        exports.inSchoolTimezone = function (dateTime, school) {
            var timeZoneName;

            if (!school.timeZone || !school.timeZone.timeZoneName) {
                if (!!school.timeZoneName) {
                    // school came from the getSchoolsForUser call
                    timeZoneName = school.timeZoneName;
                } else {
                    // log an error
                    timeZoneName = timezoneLookup(school);
                }
            } else {
                timeZoneName = school.timeZone.timeZoneName;
            }

            return moment(dateTime).tz(timeZoneName);
        };

        exports.inSpecifiedTimezone = function(dateTimeString) {
            if (dateTimeString) {
                if (!!dateTimeString.indexOf) { // Warning - they didn't send in an MS Json Date
                    var timezoneStart = dateTimeString.indexOf('-');
                    if (timezoneStart == -1) {
                        timezoneStart = dateTimeString.indexOf('+');    // NHA's branching out!
                    }

                    if (timezoneStart > -1) {
                        var serverOffset = parseInt(dateTimeString.substring(timezoneStart, timezoneStart + 3)) * 60;

                        for (var i = 0, len = validTimezones.length; i < len; i++) {
                            var guess = moment.tz(dateTimeString, validTimezones[i]);   // let's see if the date in this timezone matches the offset

                            if (guess.utcOffset() == serverOffset) {
                                return guess;
                            }
                        }
                    }
                } else {
                    if (moment.isMoment(dateTimeString) && !!dateTimeString.tz && !!dateTimeString.tz()) {
                        // they sent in a moment object with timezone - just return it
                        return dateTimeString;
                    }
                }

                // we didn't find the timezone :-|
                // ToDo: is this the best option?  Maybe we should return something to indicate that there is a timezone, but we just don't know about it.
                return moment.tz(dateTimeString, '');   // Carry on using the default timezone.
            } else {
                return null;
            }

        };

        exports.replaceAll = function (target, search, replacement) {
            return target.replace(new RegExp(search, 'g'), replacement);
        };

        //sets up auto scroll to top - intended to be wired into $stateChangeSuccess at the module level
        exports.enableScrollToTopOnStateChangeSuccess = function() {
            return window.setTimeout(function() {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
            }, 50);
        }

        exports.keyCodes = {
            leftArrow: 37,
            upArrow: 38,
            rightArrow: 39,
            downArrow: 40,
            shift: 16,
            tab: 9,
            enter: 13,
            escape: 27
        };

        return exports;
    }

    //define globally if it doesn't already exist
    if (typeof (_utils) === 'undefined') {
        window._utils = init();
    }
}.call(this));

moment.prototype.zoneNames = {
    EST: 'Eastern Time',
    EDT: 'Eastern Time',
    CST: 'Central Time',
    CDT: 'Central Time',
    MST: 'Mountain Time',
    MDT: 'Mountain Time',
    PST: 'Pacific Time',
    PDT: 'Pacific Time',
    GMT: '',    // proposed: dates are UTC, so they wouldn't show timezone.  UTC implies "everywhere".
    UTC: '',
};

moment.prototype.zoneName = function () {
    var abbr = this.zoneAbbr();
    return this.zoneNames[abbr] || abbr;
};

moment.prototype.toJSON = function () {
    // preserve timezone from client.
    return this.isValid() ? this.format() : null;
};

// Imitation of .NET String.Format().
if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
              ? args[number]
              : match
            ;
        });
    };
}

// Imitation of Java's HashCode function which returns hash representation of an object.
if (!String.prototype.hashCode) {
    String.prototype.hashCode = function () {
        var hash = 0;
        if (this.length === 0) return hash;
        for (var i = 0; i < this.length; i++) {
            var charCode = this.charCodeAt(i);
            hash = ((hash << 5) - hash) + charCode;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
}

String.prototype.toNameCase = function () {
    var name = this.toString();

    if (NameCase.checkName(name)) {
        return NameCase(name, { individualFields: true });
    } else {
        return this;
    }
};
;
(function () {
	'use strict';

	angular.module('nha.core', [
		// Utils
		'ngSanitize',
		// Routing
		'ui.router',
		'ui.utils',
		// Cookies
		'ngCookies',  // this is leagacy at this point, please use ipCookie
		'ipCookie',
		'restangular',
		'angular-data.DSCacheFactory',
		// UI
		'ui.bootstrap',
		'ngAnimate',
		'nsPopover',
		'as.sortable',
		'angular-sortable-view',
		'ng-context-menu',
		'ncy-angular-breadcrumb',
		'nsPopover',
		'tableSort',
		'angular-ladda',
		'infinite-scroll',
		'infinite-scroll-two',
		'timepickerPop',
		'toastr',
		'ui.select',
		'ngInputModified',
		// Security
		'angular-jwt',
		// Mobile/Touch
		'matchmedia-ng',
		'ngTouch',
		'ngPatternRestrict',
		'module-sliding-sidebar',
		'angularSpinner'
	]);
})();
;
(function () {
	'use strict';

	angular.module('nha.core').config(config);

	function config() {
		return UserContextService.ensureUserContext();
	}

	angular.module('nha.core').run(run);
	run.$inject = ['$rootScope'];

	function run($rootScope) {
		var pageTitleAppName = ' | NHA Student Information System';
		var defaultPageTitle = 'CoreWeb' + pageTitleAppName;

		$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
			if (toState.hasOwnProperty('title')) {
				document.title = toState.title + pageTitleAppName;
			} else if (document.title !== defaultPageTitle) {
				document.title = defaultPageTitle;
			}
		});
	}
})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('CoreRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.coreServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('AttendanceRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.attendanceServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('HouseholdRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.householdManagementServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('ApplicationRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.applicationServicesRootUrlv2);
        });
    }]);

    angular.module('nha.core').factory('CaseloadRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.caseloadServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('EnrollmentRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.enrollmentServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('AdminRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.administrationServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('StudentServicesRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.studentServicesServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('MasterSchedulingRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {https://core.mynhadev.com/../directives/dateEntry
            RestangularConfigurer.setBaseUrl(baseService.appSettings.masterSchedulingServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('GradebookRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.gradebookServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('PortalRestangular',  ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.portalServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('CurriculumRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.curriculumServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('LaunchpadRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.launchpadServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('AssessmentRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.assessmentServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('BehaviorRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.behaviorServicesRootUrl);
        });
    }]);
    
    angular.module('nha.core').factory('MasterScheduleBuilderRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.questionnaireServicesRootUrl); 
        });
    }]);

    angular.module('nha.core').factory('ReportingRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.reportingServicesRootUrl);
        });
    }]);

	angular.module('nha.core').factory('DataWarehouseRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.dataWarehouseServicesRootUrl);
        });
	}]);

	angular.module('nha.core').factory('ILMRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
	    return Restangular.withConfig(function (RestangularConfigurer) {
	        RestangularConfigurer.setBaseUrl(baseService.appSettings.ILMServicesRootUrl);
	    });
	}]);

	angular.module('nha.core').factory('CalendarRestangular',  ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.calendarServicesRootUrl);
        });
    }]);

    angular.module('nha.core').factory('RetentionRestangular', ['Restangular', 'baseService', function (Restangular, baseService) {
        return Restangular.withConfig(function (RestangularConfigurer) {
            RestangularConfigurer.setBaseUrl(baseService.appSettings.calendarServicesRootUrl);
        });
    }]);
})();;
(function () {
    'use strict';

    angular.module('nha.core')
        .service('apiResolutionService', ['AttendanceRestangular', 'CoreRestangular', 'ApplicationRestangular', 'CaseloadRestangular', 'EnrollmentRestangular', 'StudentServicesRestangular', 'AdminRestangular', 'MasterSchedulingRestangular', 'HouseholdRestangular', 'PortalRestangular', 'CurriculumRestangular', 'LaunchpadRestangular', 'AssessmentRestangular', 'BehaviorRestangular', 'MasterScheduleBuilderRestangular', 'GradebookRestangular', 'ReportingRestangular', 'ILMRestangular', 'RetentionRestangular', 'Restangular',
        function (AttendanceRestangular, CoreRestangular, ApplicationRestangular, CaseloadRestangular, EnrollmentRestangular, StudentServicesRestangular, AdministrationRestangular, MasterSchedulingRestangular, HouseholdRestangular, PortalRestangular, CurriculumRestangular, LaunchpadRestangular, AssessmentRestangular, BehaviorRestangular, MasterScheduleBuilderRestangular, GradebookRestangular, ReportingRestangular, ILMRestangular, RetentionRestangular, DefaultRestangular)
    {
        //Perry TODO: change this to be convention based instead of hard-coded
        this.apiLookup = {
            'Attendance': AttendanceRestangular,
            'Core': CoreRestangular,
            'Application': ApplicationRestangular,
            'CaseloadManagement': CaseloadRestangular,
            'Enrollment': EnrollmentRestangular,
            'StudentServices': StudentServicesRestangular,
            'Administration': AdministrationRestangular,
            'MasterScheduling': MasterSchedulingRestangular,
            'HouseholdManagement': HouseholdRestangular,
            'Portal': PortalRestangular,
            'Gradebook': GradebookRestangular,
            'Curriculum': CurriculumRestangular,
            'LaunchPad': LaunchpadRestangular,
            'Assessment': AssessmentRestangular,
            'Behavior': BehaviorRestangular,
            'ScheduleQuestionnaire': MasterScheduleBuilderRestangular,
            'Reporting': ReportingRestangular,
            'ILM': ILMRestangular,
            'Retention': RetentionRestangular
        };

        this.getApiByName = getApiByName;
        this.getApiNameByRestangular = getApiNameByRestangular;

        //Returns restangular object by application name
        function getApiByName(name) {
            return this.apiLookup[name] ? this.apiLookup[name] : null;
        }

        //Returns api name corresponding to a restangular object
        function getApiNameByRestangular(restangular) {
            if (!restangular) {
                //Fall back to application default restangular if not explicitly defined
                restangular = DefaultRestangular;
            }

            for (var key in this.apiLookup) {
                if (this.apiLookup[key].configuration.baseUrl === restangular.configuration.baseUrl) {
                    return key;
                }
            }

            return null;
        }
    }]);

})();
;
(function () {
    'use strict';

    angular.module('nha.core')
        .service('baseService', ['appSettings', '$q', 'cache', 'Restangular', function (appSettings, $q, cache, Restangular) {

            var service = {
                appSettings: appSettings,
                q: $q,
                cache: cache,
                Restangular: Restangular,
                getList: getList,
                put: put,
                getSingle: getSingle,
                inMemoryCache: {}
            };

            return service;

            // methods

            function getSingle(endpoint, parameters, shouldCache, shouldLog, RestangularFactory, useInMemoryCache) {
                return service.getList(endpoint, parameters, shouldCache, shouldLog, RestangularFactory, useInMemoryCache).then(function (result) {
                    return result && result.length > 0 ? result[0] : result; // TODO: Mike Perry - 20150625 - Investigate incorrectly returned restangular object possibility
                });
            }

            function getList(endpoint, parameters, shouldCache, shouldLog, RestangularFactory, useInMemoryCache) {

                // turning off Cache, no matter what is passed in.  Should all be coming from endpoint caching
                shouldCache = false;
                
                var deferred = $q.defer();

                //if (shouldLog) {
                //    log('Getting _' + endpoint + '_ ...');
                //}

                var cacheKey = endpoint;

                if (!_.isEmpty(parameters)) {
                    cacheKey += "_" + JSON.stringify(parameters);
                } 

                var cachedData = null; 

                // if we have cache, return it
                if (shouldCache) {
                    if (useInMemoryCache && service.inMemoryCache[cacheKey]) {
                        cachedData = service.inMemoryCache[cacheKey];
                    }
                    else {
                        cachedData = cache.getByObjectKey(cacheKey);
                    }

                    //if (shouldLog) {
                    //    log('getting _' + endpoint + '_ from cache ...');
                    //}

                    if (cachedData) {
                        //if (shouldLog) {
                        //    log('found _' + endpoint + '_ in cache ...');
                        //}

                        // returned our cached data back to the caller
                        deferred.resolve(cachedData);
                        return deferred.promise;
                    }
                }

                //if (shouldLog && !shouldCache) {
                //    log('Cache not used for _' + endpoint + '_ ...');
                //}

                var restangular = (!_.isUndefined(RestangularFactory) && RestangularFactory != null ? RestangularFactory : Restangular).one(endpoint);

                restangular.get(parameters).then(function (data) {

                    // turning off Cache, no matter what is passed in.  Should all be coming from endpoint caching
                    shouldCache = false;


                    if (shouldCache && data != null) {
                        if (shouldLog) {
                            //if (useInMemoryCache) {
                            //    log('adding _' + endpoint + '_ to in-memory cache');
                            //}
                            //else {
                            //    log('adding _' + endpoint + '_ to cache');
                            //}
                        }

                        if (useInMemoryCache) {
                            //Store original object in memory so we can rebind to it in subsequent requests
                            service.inMemoryCache[cacheKey] = data;
                        }
                        else {
                            // adding to cache
                            cache.putByObjectKey(cacheKey, data);
                        }
                    }

                    if (data != null) {
                        deferred.resolve(data);
                    }
                },
                function (error) {
                    log('baseService ERROR: ', endpoint, error);
                    deferred.reject(error);
                });

                return deferred.promise;
            }

            // Updates an entity with option of wiping it from cache
            //NOTE: endpoint must match identically in order to be wiped from cache!
            //TODO: remove paramsOriginallyUsedInGetList parameter when we fix caching -- see TODOs below
            function put(endpoint, objectToUpdate, id, shouldLog, RestangularFactory, paramsOriginallyUsedInGetList) {
                var deferred = $q.defer();

                //if (shouldLog)
                //    log('Calling PUT on _' + endpoint + '_ ...');

                var restangular = (RestangularFactory != undefined ? RestangularFactory : Restangular).all(endpoint);
                restangular.customPUT(objectToUpdate, id).then(function (data) {
                    
                    // Find the object we are updating in the cache and wipe it out
                    //if (shouldLog) {
                    //    log('Wiping _' + endpoint + '_ from cache');
                    //}

                    //TODO: Sending in originally used params to find cache key is pretty ugly. And this doesn't refresh a list of results that we may have cached.
                    //What we'll likely need to do is add categorization by endpoint to cache so we can wipe all cache data related to that endpoint
                    var cacheKey = endpoint;
                    //log('Searching cache for _' + cacheKey + '_');
                    if (cache.getByObjectKey(cacheKey)) {
                        cache.destroyByObjectKey(cacheKey);
                    }
                        
                    cacheKey = endpoint + '/' + id;
                   // log('Searching cache for _' + cacheKey + '_');
                    if (cache.getByObjectKey(cacheKey)) {
                        cache.destroyByObjectKey(cacheKey);
                    }

                    if (paramsOriginallyUsedInGetList) {
                        cacheKey = paramsOriginallyUsedInGetList;
                      //  log('Searching cache for _' + cacheKey + '_');
                        if (cache.getByObjectKey(cacheKey)) {
                            cache.destroyByObjectKey(cacheKey);
                        }
                    }

                    if (data != null) {
                        deferred.resolve(data);
                    } else {
                        deferred.resolve();
                    }

                }, function (error) {
                    log('baseService PUT ERROR: ', endpoint, error);
                    deferred.reject(error);
                });

                return deferred.promise;
            }

            //TODO: When we fix cache keys, we'll want a custom POST method that wipes related objects from the cache.
            //Say we add a new School. We'd want to wipe out any lists of schools we may have loaded.
            function post() {
                
            }
        }]);
})();
;
(function () {
    'use strict';

    angular.module('nha.core')
    .factory('cache', ['DSCacheFactory', function (DSCacheFactory) {

        var options = {
            onExpire: function (key, value) {
              //  log('_Cache Expiration_ ' + key);
            },
            storageMode: (window.localStorage ? 'localStorage' : 'memory'),
            maxAge: 3600000,  // Items added to this cache expire after 60 minutes.
            cacheFlushInterval: 60000,  // This cache will clear itself every hour.
            deleteOnExpire: 'aggressive',  // Items will be deleted from this cache right when they expire.
            capacity: 1000  // only store up to 100 items (key/value pairs)
        };

        // we set all the defaults here, but you can change them when using them for each service
        var cacheFactory = DSCacheFactory('cache', options);

        var cache = {
            cacheFactory: cacheFactory,
            getByObjectKey: function (obj) {
                var key = this.getHashKey(obj);
               // log('_Cache Object Key Hit!_ ' + key);
                return this.cacheFactory.get(key);
            },
            putByObjectKey: function (obj, data) {
                var key = this.getHashKey(obj);
               // log('_Cache Object Write!_ ' + key);
                try {
                    return this.cacheFactory.put(key, data);
                } catch (e) {
                    log('Cache failed to Save: [c="color: red"]' + e.description + '[c]');
                    return null;
                }
            },
            get: function (key) {
                //log('_Cache Hit!_ ' + key);
                return this.cacheFactory.get(key);
            },
            put: function (key, data) {
                //log('_Cache Write!_ ' + key);
                try {
                    return this.cacheFactory.put(key, data);
                } catch (e) {
                    log('Cache failed to Save: [c="color: red"]' + e.description + '[c]');
                    return null;
                }
            },
            getHashKey: function (key) {
                return getHashCode(JSON.stringify(key));
            },
            destroyByObjectKey: function (obj) {
                var key = this.getHashKey(obj);
                log('_Cache Removed_ ' + key);
                return this.cacheFactory.remove(key);
            },
            clearAll: function() {
                log('_Clearing All Caches_');
                return this.cacheFactory.removeAll(); 
            }
        };

        return cache;
    }]);

    function getHashCode(s) {
        for (var h = 0, i = 0; i < s.length; h &= h) {
            h = 31 * h + s.charCodeAt(i++);
        }
        return h;
    }

})();
;
(function () {
    'use strict';

    angular.module('nha.core')
    .factory('extendedRepositoryFactory', ['repositoryFactory', function (repositoryFactory) {

        return function (endpoint, restangular, endpointOptions) {

            var svc = this;

            //Extend base repository functionality
            _.assign(svc, new repositoryFactory(endpoint, restangular, endpointOptions));

            svc.endpoint = endpoint;
            svc.restangular = restangular;

            svc.defaultOptions = _.assign({
                shouldCache: true,  // this will client side cache into local storage
                shouldLog: false,  // this will show console log messages
                isOData: true,  // the getAll is an OData call
                capitalizeIdString: true, // for oData calls, determine whether to make it Id or ID
                firstLetterCapitalize: true,   // for OData calls, capitalize the first string to match the server side OData call.  Example schoolID to SchoolID
                urlAppendString: '',
                requireODataFilter: false,  // this will require at least one OData filter so we don't kill an endpoint
                pageSize: 50,
                append: true
            }, endpointOptions);

            svc.moreExist = true;
            svc.loadedCount = 0;

            /**
            * @name getPage
            * @description gets a page of entities
            * @returns collection of entities
            * @memberOf extendedRepositoryFactory
            */
            svc.getPage = function (params, options) {

                // defaulted options, but allow them to be overidden
                var _options = options ? _.assign(this.defaultOptions, options) : this.defaultOptions;

                if (!options.append) {
                    svc.loadedCount = 0;
                    svc.moreExist = true;
                }

                if (_options.isOData) {
                    params.top = _options.pageSize;
                    params.skip = svc.loadedCount;
                    if (params.sort) {
                        _utils.setOrderByParameters(params, params.sort);
                    }
                    if (params.searchText) {
                        _utils.setSearchFilter(params, params.searchText, svc.textSearchFields);
                    }
                }

                return this.getAll(params, _options).then(function (response) {
                    svc.loadedCount += response.length;
                        if (response.length < _options.pageSize) {
                            svc.moreExist = false;
                        }
                        return response;
                });
            }

        }

    }]);
})();
;
/**
 * pub-sub.factory
 * @namespace core
 */

(function () {
    'use strict';

    /** add factory */
    angular.module('nha.core').factory('pub-sub.factory', pubSubFactory);

    /** injection */
    pubSubFactory.$inject = ['DSCacheFactory'];

    /** implementation */
    function pubSubFactory(DSCacheFactory) {
        /** create pub sub class */
        function PubSubManager(keys, storageMode, appName) {
            /** private properties */
            var cacheName = _.uniqueId((appName || 'myNHA') + '_');
            var cache = DSCacheFactory(cacheName, {
                storageMode: (storageMode ? storageMode : (window.localStorage ? 'localStorage' : 'memory')),
                maxAge: 3600000,
                deleteOnExpire: 'aggressive'
            });

            /** public properties */
            this.keys = {};

            /** public methods */
            this.hasKey = hasKey;
            this.addData = addData;
            this.addCallback = addCallback;
            this.removeCallback = removeCallback;
            this.getData = getData;
            this.setData = setData;
            this.removeData = removeData;
            this.removeAllData = removeAllData;
            this.resetData = resetData;

            /** add initial keys */
            if (!keys) keys = [];
            _.each(keys, function (key) {
                this.addData(key, null);
            }.bind(this));

            /** public method implementations */

            /** check for a key */
            function hasKey(key) {
                return this.keys.hasOwnProperty(key);
            }

            /** add a data value */
            function addData(key, data, callback) {
                /** check for existing key */
                if (!this.hasKey(key)) {
                    this.keys[key] = [];
                }

                /** add the data value */
                cache.put(key, data);

                /** check for a callback and add to callbacks array */
                if (callback) addCallback(key, callback);
            }

            /** add a callback for when the data value changes */
            function addCallback(key, callback, clean, scope) {
                /** check for existing key */
                if (this.hasKey(key)) {
					/** add properties to callback for cleanup */
					callback.signature = callback.toString() + (scope ? '-' + scope.$id : '');

					/** check if we're cleaning up duplicate methods (by signature) */
                    if (clean) this.removeCallback(key, callback);
                    this.keys[key].push(callback);

					/** check for scope */
					if (scope) {
						/** capture when scope is destroyed (callback cleanup) */
						scope.$on('$destroy', function() {
							/** remove the callback */
							this.removeCallback(key, callback);
						}.bind(this));
					}
                }
            }

            /** remove a callback */
            function removeCallback(key, callback) {
                /** check for existing key */
                if (this.hasKey(key)) {
                    /** get callback signature */
                    var signature = callback.signature;

                    /** cycle through key to remove matching callback */
                    _.forEach(this.keys[key], function (cb, index) {
                        /** check for callback */
						if (cb) {
							/** get callback signature */
							var cbSignature = cb.signature;

							/** check for match and remove */
							if (signature === cbSignature) {
								this.keys[key].splice(index, 1);
							}
						} else {
							/** remove undefined callback */
							this.keys[key].splice(index, 1);
						}
                    }.bind(this));
                }
            }

            /** get the data value for the given key */
            function getData(key) {
                /** return data */
                if (!this.hasKey(key)) return null;
                return cache.get(key) || null;
            }

            /** set the data value for the given key */
            function setData(key, data) {
                /** check for existing key */
                if (!this.hasKey(key)) {
                    this.keys[key] = [];
                }

                /** get the old data */
                var oldData = angular.copy(cache.get(key));

                /** set the value for the data key */
                if (data === null || data === undefined) cache.remove(key);
                else cache.put(key, data);

                /** fire off each callback passing new and old values */
                _.forEach(this.keys[key], function (callback) {
                    callback(cache.get(key) || null, oldData);
                });
            }

            /** remove data for key */
            function removeData(key) {
                /** remove from cache */
                cache.remove(key);

                /** remove the key */
                delete this.keys[key];
            }

            /** remove all data */
            function removeAllData() {
                /** remove all from cache */
                cache.removeAll();

                /** clear keys */
                this.keys = {};
            }

            /** reset all data to nulls */
            function resetData(keys) {
                _.each(keys, function (key) {
                    this.setData(key, null);
                }.bind(this));
            }
        }

        /** return PubSubManager class definition */
        return PubSubManager;
    }
})();;
(function () {
    'use strict';

    angular.module('nha.core')
    .factory('repositoryFactory', ['baseService', 'Restangular', '$q', function (baseService, Restangular, $q) {

        return function (endpoint, restangular, endpointOptions) {

            // You have to have an endpoint specified
            if (!endpoint) {
                log('no endpoint specified in the repository factory!');
                return 'No endpoint specified!';
            }

            this.endpoint = endpoint;
            this.restangular = (restangular ? restangular : Restangular);  // default to the default Restangular that the app has configured
            this.defaultOptions = _.assign({
                shouldCache: true,  // this will client side cache into local storage
                shouldLog: false,  // this will show console log messages
                isOData: true,  // the getAll is an OData call
                capitalizeIdString: true, // for oData calls, determine whether to make it Id or ID
                firstLetterCapitalize: true,   // for OData calls, capitalize the first string to match the server side OData call.  Example schoolID to SchoolID
                urlAppendString: '',
                requireODataFilter: false  // this will require at least one OData filter so we don't kill an endpoint
            }, endpointOptions);

            /**
           * @name getOne
           * @description get a single entity by id
           * @returns entity
           * @memberOf repositoryFactory
           */
            this.get = function (id, options) {

                // this supports either a json object or an int passed in
                if (typeof (id) !== 'object') {
                    id = { id: id };
                }

                // defaulted options, but allow them to be overidden
                var _options = options ? _.assign(this.defaultOptions, options) : this.defaultOptions;

                return baseService.getSingle(this.endpoint.concat(_options.urlAppendString), id, _options.shouldCache, _options.shouldLog, this.restangular);
            }

            /**
            * @name getAll
            * @description gets a collection of entities
            * @returns collection of entities
            * @memberOf repositoryFactory
            */
            this.getAll = function (params, options) {

                // defaulted options, but allow them to be overidden
                var _options = options ? _.assign(this.defaultOptions, options) : this.defaultOptions;
                var apiParameters = {};

                // check to see if at least one Odata parameter is required
                if (_options.isOData && _options.requireODataFilter && _.isEmpty(params)) {
                    return $q.reject({ error: 'This endpoint is configured to require at least one OData Filter, usually for performance reasons' });
                }

                // if no filter property, then assume this is older style and that all parms are filters
                if (!_.isEmpty(params)) {

                    // make sure this is configured as an Odata call before we bother with any of this OData
                    if (_options.isOData) {

                        // only go into this if we have a valid odata parm passed in
                        if ((params.filter || params.top || params.count || params.skip || params.orderBy || params.select)) {

                            // loop through our params to see if we have an OData properties to capitalize/fix IDs
                            _.forEach(_.keys(params), function(key) {

                                // we only care about these three because they could have a column name
                                if (_.includes(['filter', 'select', 'orderBy'], key)) {

                                    // ensure they have a value
                                    if (!_.isEmpty(params[key])) {
                                        
                                        // dynamically setup filter model with proper capitalization and ids to match backend
                                        params[key] = _utils.getODataFilterFromParams(params[key], _options.capitalizeIdString, _options.firstLetterCapitalize);
                                    } else {
                                        // its empty, let's just remove it and get it out of the equation
                                        delete params[key];
                                    }
                                } 
                            });

                            // setup our OData properties for everything now that its ready.
                            // This assumes its all just an OData filter
                            apiParameters = _utils.getODataRequest(params);

                        } else {
                            // if no params, don't run it through the odata filters, also is the caller is saying its not OData.
                            apiParameters = _utils.getParsedODataFilter(params, _options.capitalizeIdString, _options.firstLetterCapitalize);
                        }
                    } else {
                        apiParameters = params;
                    }
                }

                // ensure we have something in here
                var endpointUrl = this.endpoint;
                if (_options.urlAppendString) {
                    endpointUrl = endpointUrl.concat(_options.urlAppendString);
                }

                return baseService.getList(endpointUrl, apiParameters, _options.shouldCache, _options.shouldLog, this.restangular);
            }

            /**
            * @name put
            * @description updates an existing entity
            * @returns promise
            * @memberOf repositoryFactory
            */
            this.put = function (entity, id, options) {

                // defaulted options, but allow them to be overidden
                var _options = options ? _.assign(this.defaultOptions, options) : this.defaultOptions;

                // ensure we have something in here
                var endpointUrl = this.endpoint;
                if (_options.urlAppendString) {
                    endpointUrl = endpointUrl.concat(_options.urlAppendString);
                }

                return restangular.all(endpointUrl).customPUT(entity, id);
            }

            /**
            * @name post
            * @description inserts new entity
             * @returns promise
            * @memberOf repositoryFactory
            */
            this.post = function (entity, options) {

                // defaulted options, but allow them to be overidden
                var _options = options ? _.assign(this.defaultOptions, options) : this.defaultOptions;

                // ensure we have something in here
                var endpointUrl = this.endpoint;
                if (_options.urlAppendString) {
                    endpointUrl = endpointUrl.concat(_options.urlAppendString);
                }

                return restangular.all(endpointUrl).customPOST(entity);
            }

            /**
           * @name save
           * @description saves or updates an entity.  This is a convenience method
            * @returns promise
           * @memberOf repositoryFactory
           */
            this.save = function (entity, id) {
                return (id ? this.put(entity, id) : this.post(entity));
            }

            /**
           * @name patch
           * @description updates parts of an existing entity
           * @returns promise
           * @memberOf repositoryFactory
           */
            this.patch = function (entity, id) {
                return restangular.one(endpoint).patch(entity, id);
            }

            /**
          * @name remove
          * @description removes the entity by id
          * @returns promise
          * @memberOf repositoryFactory
          */
            this.remove = function (id) {
                return restangular.one(this.endpoint, id).remove();
            }
        }

    }]);

})();
;
(function () {
	'use strict';

	angular.module('nha.core').factory('htmlTemplateInjector', ['$templateCache', function ($templateCache) {
		function guid() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				const r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
				return v.toString(16);
			});
		};

		return {
			request: function (config) {
				if (config.url.includes('.html') && !$templateCache.get(config.url)) {
					config.url += '?v=' + (window.cacheKey ? window.cacheKey : guid());
					return config;
				}

				return config;
			}
		};
	}]);

	angular.module('nha.core').config(['$httpProvider', function ($httpProvider) {
		$httpProvider.interceptors.push('htmlTemplateInjector');
	}]);
})();
;
(function () {
	'use strict';

	var _appSettings = myNHA.appSettings;
	var IMPERSONATION_COOKIE = _appSettings.environment + '-mynha-impersonation';

	angular.module('nha.core').factory('impersonationInjector', [
		function () {
			function addImpersonationHeader(config) {
				config.headers['impersonation-user'] = Cookies.get(IMPERSONATION_COOKIE);
				config.headers['impersonation-user-type'] = 'staff';
				config.headers['impersonation-application'] = 'mynha';
				return config;
			}

			return {
				request: function (config) {
					if (!config.url.includes('/api')) {
						return config;
					}

					if (Cookies.get(IMPERSONATION_COOKIE)) {
						return addImpersonationHeader(config);
					}

					return config;
				}
			};
		}
	]);

	angular.module('nha.core').config([
		'$httpProvider',
		function ($httpProvider) {
			$httpProvider.interceptors.push('impersonationInjector');
		}
	]);
})();
;
'use strict';

/**
 * nha.interceptors
 *	Interceptors for $http requests made in NHA applications
 */

/**
 * nha.interceptors.responseErrorInterceptor
 *	A default response error interceptor
 */
angular.module('nha.core').factory('responseErrorInterceptor', [, function(notifySvc){
	/** create object of status codes */
	var statusCodes = {
		'400': { 'title': 'Bad Request', 'message': 'The request cannot be fulfilled due to bad syntax' },
		'401': { 'title': 'Unauthorized', 'message': 'The request was a legal request, but the server is refusing to respond to it. For use when authentication is possible but has failed or not yet been provided' },
		'403': { 'title': 'Forbidden', 'message': 'The request was a legal request, but the server is refusing to respond to it' },
		'404': { 'title': 'Not Found', 'message': 'The requested page could not be found but may be available again in the future' },
		'405': { 'title': 'Method Not Allowed', 'message': 'A request was made of a page using a request method not supported by that page' },
		'406': { 'title': 'Not Acceptable', 'message': 'The server can only generate a response that is not accepted by the client' },
		'407': { 'title': 'Proxy Authentication Required', 'message': 'The client must first authenticate itself with the proxy' },
		'408': { 'title': 'Request Timeout', 'message': 'The server timed out waiting for the request' },
		'409': { 'title': 'Conflict', 'message': 'The request could not be completed because of a conflict in the request' },
		'410': { 'title': 'Gone', 'message': 'The requested page is no longer available' },
		'411': { 'title': 'Length Required', 'message': 'The "Content-Length" is not defined. The server will not accept the request without it' },
		'412': { 'title': 'Precondition Failed', 'message': 'The precondition given in the request evaluated to false by the server' },
		'413': { 'title': 'Request Entity Too Large', 'message': 'The server will not accept the request, because the request entity is too large' },
		'414': { 'title': 'Request-URI Too Long', 'message': 'The server will not accept the request, because the URL is too long. Occurs when you convert a POST request to a GET request with a long query information' },
		'415': { 'title': 'Unsupported Media Type', 'message': 'The server will not accept the request, because the media type is not supported' },
		'416': { 'title': 'Requested Range Not Satisfiable', 'message': 'The client has asked for a portion of the file, but the server cannot supply that portion' },
		'417': { 'title': 'Expectation Failed', 'message': 'The server cannot meet the requirements of the Expect request-header field' },
		'500': { 'title': 'Internal Server Error', 'message': 'A generic error message, given when no more specific message is suitable' },
		'501': { 'title': 'Not Implemented', 'message': 'The server either does not recognize the request method, or it lacks the ability to fulfill the request' },
		'502': { 'title': 'Bad Gateway', 'message': 'The server was acting as a gateway or proxy and received an invalid response from the upstream server' },
		'503': { 'title': 'Service Unavailable', 'message': 'The server is currently unavailable (overloaded or down)' },
		'504': { 'title': 'Gateway Timeout', 'message': 'The server was acting as a gateway or proxy and did not receive a timely response from the upstream server' },
		'505': { 'title': 'HTTP Version Not Supported', 'message': 'The server does not support the HTTP protocol version used in the request' },
		'511': { 'title': 'Network Authentication Required', 'message': 'The client needs to authenticate to gain network access' }
	};

	/** create interceptor */
	var interceptor = {
		/** intercept response errors */
		'responseError': function(response){
			/** create notification */
			notifySvc.error(statusCodes[response.status].title, statusCodes[response.status].message);

			/** return an empty array */
			return { 'data': { 'success': false, 'error': { 'title': statusCodes[response.status].title, 'message': statusCodes[response.status].message } } };
		}
	};

	/** return the interceptor */
	return interceptor;
}]);

/** modify nha configuration to include interceptor */
angular.module('nha.core').config(function () {
    /** add interceptor */

    // TODO:  don't push this interceptor quite yet

	//$httpProvider.interceptors.push('responseErrorInterceptor');
});;
(function () {
	'use strict';

	angular.module('nha.core').factory('sessionInjector', [function () {
		/** set myNHA const */
		var _myNHA = window['myNHA'];
		var _appSettings = _myNHA.appSettings;
		var _userSessionService = new _myNHA.UserSessionService();
		var _refreshInProgress = false;

		/** track the session cookie name for token */
		var SESSION_COOKIE = _appSettings.environment + '-user-token';

		/** get the token */
		function getToken() {
			/** get the jwt token and return */
			var token = Cookies.get(SESSION_COOKIE);
			return token;
		}

		/** add the authentication header */
		function addAuthToken(config) {
			/** add the token */
			config.headers['Authorization'] = 'Bearer ' + getToken();
			return config;
		}

		/** create the interceptor methods */
		return {
			request: function (config) {
				/** check the request to see if it is an api request */
				if (!config.url.includes('/api')) {
					return config;
				}

				if (_appSettings.enableSessionInjectorApiRequestLogging) {
					console.log('API Request: ' + config.url);
				}

				/** check to see if the refresh is in progress */
				if (_refreshInProgress) {
					console.log('Token Refresh In Progress');

					/** wait for refresh to produce new token */
					return new Promise(function (resolve) {
						console.log('Waiting For Token');

						var check = null;
						check = window.setInterval(function () {
							if (_userSessionService.hasUserToken()) {
								console.log('Token Is Ready');
								resolve(addAuthToken(config));
								window.clearInterval(check);
								check = null;
							}
						}, 100);
					});
				} else {
					/** get the token */
					var token = getToken(config);

					/** check if the token is expired */
					if (_myNHA.JWT.isTokenExpired(token)) {
						console.log('%cToken Is Expired. Refresh It.', 'color: blue; font-weight: bold;');

						/** flip refreshing flag */
						_refreshInProgress = true;

						/** refresh the token, emit new token, continue request */
						return _userSessionService.refreshToken().then(function (jwt) {
							console.log('Token Refreshed: ' + jwt);

							/** flip refreshing flag */
							_refreshInProgress = false;

							console.log('%cContinue Request', 'color: red; font-weight: bold;');

							/** get the token */
							return addAuthToken(config);
						});
					} else {
						/** return the config with auth header */
						return addAuthToken(config);
					}
				}
			}
		};
	}]);

	/** add interceptors to pipeline */
	angular.module('nha.core').config(['$httpProvider', function ($httpProvider) {
		$httpProvider.interceptors.push('sessionInjector');
	}]);
})();
;
/**
 * academic-year.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('academicYearRepository', academicYearRepository);

    // protect against minification
    /* @ngInject */
    academicYearRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name academicYearRepository
    * @description Constructor for academic-year.repository
    * @memberOf core
    */
    function academicYearRepository(baseService, coreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getAllAcademicYears = getAllAcadmicYears;
        service.getByAcademicYearId = getByAcademicYearId;
        service.getCurrentAcademicYear = getCurrentAcademicYear;

        return service;

        /**
         * @name getAllAcadedmicYears
         * @description retrieves list of academicYears from storage
         * @returns List<object> List of objects containing a subset of academicYear properties
         * @memberOf academic-year.repository
         */
        function getAllAcadmicYears() {
            return baseService.getList("academicyear", null, true, true, coreRestangular);
        }

        /**
         * @name getByAcademicYearId
         * @description retrieves a single academicYear by academicYearId from storage
         * @returns a single academicYear object
         * @memberOf academic-year.repository
         */
        function getByAcademicYearId(academicYearId) {
            return baseService.getSingle('academicyear', { id: academicYearId }, false, true, coreRestangular);
        }

        /**
         * @name getCurrentAcademicYear
         * @description retrieves the current academicYear from storage
         * @returns a single academicYear object
         * @memberOf academic-year.repository
         */
        function getCurrentAcademicYear() {
            var oDataFilter = {
                IsCurrent: true
            };

            var params = _utils.getODataRequest({ 'filter': oDataFilter });
            return baseService.getSingle('academicyear', params, false, true, coreRestangular);
        }

    }

})();;
/**
 * academic-year.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('accessibleResourceRepository', accessibleResourceRepository);

    // protect against minification
    /* @ngInject */
    accessibleResourceRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name academicYearRepository
    * @description Constructor for academic-year.repository
    * @memberOf core
    */
    function accessibleResourceRepository(baseService, coreRestangular) {

        /*jshint validthis: true */
        var service = this;

        service.getAll = getAll;

        function getAll() {
            return baseService.getList("AccessibleResource", null, false, true, coreRestangular);
        }

        return service;
    }

})();;
(function () {
	'use strict';

	angular.module('nha.core').service('apiSecurityService', ApiSecurityService);

	ApiSecurityService.$inject = ['baseService', 'userContextService', '$q', 'appSettings', 'accessibleResourceRepository', '$timeout', 'apiResolutionService'];

	function ApiSecurityService(baseService, UserContextService, $q, appSettings, accessibleResourceRepository, $timeout, apiResolutionService) {
		var service = {
			doesUserHaveClaim: doesUserHaveClaim,
			isAccessAllowed: isAccessAllowed,
			getClaimValue: getClaimValue,
			isFeatureAccessible: isFeatureAccessible,
			parseResource: parseResource,
			parseApiResourceAction: parseApiResourceAction,
			accessibleResources: null,
			doesPolicyAllowAccess: doesPolicyAllowAccess,
			setAccessibleResources: setAccessibleResources,
			loadAccessibleResources: loadAccessibleResources,
			waitForAccessibleResources: waitForAccessibleResources,
			isAccessAllowedBulk: isAccessAllowedBulk,
			isAccessAllowedSingle: isAccessAllowedSingle,
			hasSaviyntEntitlement: hasSaviyntEntitlement,
			isBulkLoadingAccess: false
		};

		return service;

		function parseResource(singleResourceString) {
			var returnValue = {};

			if (singleResourceString) {
				if (singleResourceString.indexOf(':') > -1) {
					var splitText = singleResourceString.split(':');
					returnValue.resource = splitText.shift();

					if (splitText.length > 0) {
						returnValue.action = splitText.join(':');
					}
				} else {
					returnValue.resource = singleResourceString;
				}
			}

			if (!returnValue.action) {
				returnValue.action = 'Get';
			}

			return returnValue;
		}

		function parseApiResourceAction(apiResourceAction, defaultApi) {
			var apiTokenIndex = apiResourceAction.indexOf('\\');
			var api = apiTokenIndex > 0 ? apiResourceAction.substr(0, apiTokenIndex) : defaultApi;

			var resourceAction = apiTokenIndex > 0 ? apiResourceAction.substr(apiTokenIndex + 1) : apiResourceAction;
			var parsedResourceAction = parseResource(resourceAction);

			return {
				api: api,
				resource: parsedResourceAction.resource,
				action: parsedResourceAction.action
			};
		}

		function doesPolicyAllowAccess(resource, action, application) {
			if (service.accessibleResources) {
				var returnValue =
					service.accessibleResources[application] &&
					service.accessibleResources[application][resource] &&
					service.accessibleResources[application][resource][action];

				if (!_.isUndefined(returnValue)) {
					return returnValue;
				} else {
					return false;
				}
			} else {
				return false;
			}
		}

		function isAccessAllowed(resource, action, restangular) {
			if (appSettings.disableApiSecurity) {
				var deferred = $q.defer();
				deferred.resolve(true);
				return deferred.promise;
			}

			// this wil force this ti always to go the more performant bulk loading
			if (appSettings.forceBulkAccessCall !== true && (appSettings.debug || appSettings.disableBulkAuthorizationRetrieval)) {
				return service.isAccessAllowedSingle(resource, action, restangular);
			} else {
				return service.isAccessAllowedBulk(resource, action, restangular);
			}
		}

		function hasSaviyntEntitlement(entitlement) {
			return UserContextService.ensureUserContext().then(function (context) {
				var entitlementParts = entitlement.toLowerCase().split('|');
				var entitlementType = entitlementParts[0];
				var entitlementName = entitlementParts[1];

				if (
					context.entitlements.find(function (entitlement) {
						return entitlement.entitlementType.toLowerCase() === entitlementType && entitlement.entitlementName.toLowerCase() === entitlementName;
					})
				) {
					return true;
				} else {
					return false;
				}
			});
		}

		function isAccessAllowedBulk(resource, action, restangular) {
			var deferred = $q.defer();

			if (service.accessibleResources) {
				var applicationName = apiResolutionService.getApiNameByRestangular(restangular);
				deferred.resolve(service.doesPolicyAllowAccess(resource, action, applicationName));
			} else {
				if (!service.isBulkLoadingAccess) {
					service.loadAccessibleResources(resource, action, restangular, deferred);
				} else {
					service.waitForAccessibleResources(resource, action, restangular, deferred);
				}
			}

			return deferred.promise;
		}

		function waitForAccessibleResources(resource, action, restangular, deferred) {
			$timeout(function () {
				if (service.accessibleResources) {
					var applicationName = apiResolutionService.getApiNameByRestangular(restangular);
					deferred.resolve(service.doesPolicyAllowAccess(resource, action, applicationName));
				} else {
					service.waitForAccessibleResources(resource, action, restangular, deferred);
				}
			}, 500);
		}

		function loadAccessibleResources(resource, action, restangular, deferred) {
			service.isBulkLoadingAccess = true;

			accessibleResourceRepository.getAll().then(
				function (result) {
					service.setAccessibleResources(result);

					var applicationName = apiResolutionService.getApiNameByRestangular(restangular);

					deferred.resolve(service.doesPolicyAllowAccess(resource, action, applicationName));
					service.isBulkLoadingAccess = false;
				},
				function () {
					service.isBulkLoadingAccess = false;
				}
			);
		}

		function isAccessAllowedSingle(resource, action, restangular) {
			return baseService.getSingle('Access', { resource: resource, action: action }, false, true, restangular, false).then(function (result) {
				return result && result.isAllowed;
			});
		}

		function setAccessibleResources(accessibleResources) {
			var tmpResources = {};
			var applicationResources = _.groupBy(accessibleResources, 'application');

			for (var applicationName in applicationResources) {
				if (!tmpResources[applicationName]) {
					tmpResources[applicationName] = {};
				}

				var groupedResources = _.groupBy(applicationResources[applicationName], 'resource');

				for (var resourceName in groupedResources) {
					var trimmedResourceName = _.trim(resourceName);

					if (!tmpResources[applicationName][trimmedResourceName]) {
						tmpResources[applicationName][trimmedResourceName] = {};
					}

					var resources = groupedResources[trimmedResourceName];

					_.forEach(resources, function (individualResource) {
						if (individualResource.action.indexOf(',') > -1) {
							_.forEach(individualResource.action.split(','), function (action) {
								tmpResources[applicationName][_.trim(individualResource.resource)][_.trim(action)] = true;
							});
						} else {
							tmpResources[applicationName][_.trim(individualResource.resource)][_.trim(individualResource.action)] = true;
						}
					});
				}
			}

			service.accessibleResources = tmpResources;
		}

		function doesUserHaveClaim(claimType) {
			var context = UserContextService.getUserContext();
			return context && context[claimType];
		}

		function isFeatureAccessible(claimType) {
			return doesUserHaveClaim(claimType);
		}

		function getClaimValue(claimType) {
			var context = UserContextService.getUserContext();
			return context[claimType];
		}
	}
})();
;
/**
 * core-app-context.factory
 * @namespace core
 * @remarks '.factory' is a sub-classification of service, including exclusively business logic
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .factory('appContextFactory', appContextFactory);

    // protect against minification
    /* @ngInject */
    appContextFactory.$inject = ['$stateParams', '$q', 'appContextModel',
        'schoolService', 'stateRepository', 'academicYearRepository', 'schoolAcademicYearRepository', 'ipCookie'];

    /**
    * @name appContextFactory
    * @description Define app-context.factory
    * @memberOf core
    */
    function appContextFactory($stateParams, $q, appContextModel,
        schoolService, stateRepository, academicYearRepository, schoolAcademicYearRepository, ipCookie) {

        return function(modelExtension, retrievalMethodExtension) {
            var service = this;

            // extend the model if new fields provided
            if (modelExtension) {
                appContextModel = _.assign(appContextModel, modelExtension);
            }

            // define methods
            service.ensureAppContext = ensureAppContext;
            service.getContext = getContext;

            function ensureAppContext() {
                return loadContext().then(function() { return getContext(); });
            }

            function getContext() {
                var context = appContextModel;
                return context;
            }

            function compileMethods() {
                // initial core methods to load, generate promises and store in array
                service.retrievalMethods = [
                    loadAcademicYear(),
                    loadState(),
                    loadSchool(),
                    loadSchoolAcademicYear()
                ];

                // unpack the promises from the methods and extend the retrievalMethods
                if (retrievalMethodExtension) {
                    _.forEach(retrievalMethodExtension, function(item) {
                        service.retrievalMethods.push(item());
                    });
                }
            }

            function loadContext() {
                compileMethods();
                var deferred = $q.defer();
                $q.all(service.retrievalMethods).then(function () {
                    deferred.resolve();
                });
                return deferred.promise;
            }

            function getPersistedAcademicYearId() {
                var academicYearId = ipCookie('filter-AcademicYear');
                if (!academicYearId) {
                    academicYearId = -1;
                }
                return academicYearId;
            }

            function loadAcademicYear() {
                var deferred = $q.defer();
                //Needs to not be dependent on $stateParams
                if (!appContextModel.academicYear || ($stateParams.academicYearId && (appContextModel.academicYear.academicYearID != $stateParams.academicYearId))) {
                    academicYearRepository.getAllAcademicYears().then(function (academicYears) {
                        if ($stateParams.academicYearId) {
                            appContextModel.academicYear = _.find(academicYears, function (year) { return year.academicYearID === (+$stateParams.academicYearId) }); //TODO: Get current year
                        } else {
                            var persistedAcademicYearId = getPersistedAcademicYearId();
                            if (persistedAcademicYearId > 0) {
                                appContextModel.academicYear = _.find(academicYears, { academicYearID: persistedAcademicYearId });
                            }
                            if (!appContextModel.academicYear) {
                                appContextModel.academicYear = _.find(academicYears, { isCurrent: true });
                            }
                        }
                        deferred.resolve();
                    });
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            }

            function loadState() {
                var deferred = $q.defer();
                if ($stateParams.stateId) {
                    var stateId = $stateParams.stateId;
                    stateRepository.get(stateId).then(function (state) {
                        appContextModel.state = state;
                        deferred.resolve();
                    });
                } else {
                    appContextModel.state = null;
                    deferred.resolve();
                }
                return deferred.promise;
            }

            function loadSchool() {
                var deferred = $q.defer();
                if ($stateParams.schoolId) {
                    var schoolId = $stateParams.schoolId;
                    schoolService.get(schoolId).then(function (school) {
                        appContextModel.school = school;
                        deferred.resolve();
                    });
                } else {
                    appContextModel.school = null;
                    deferred.resolve();
                }
                return deferred.promise;
            }

            function loadSchoolAcademicYear() {
                var deferred = $q.defer();
                // If we have a selected year, set school year to that
                if (!appContextModel.schoolAcademicYear) {
                    if ($stateParams.schoolId) {
                        var schoolId = $stateParams.schoolId;

                        schoolAcademicYearRepository.getBySchoolId(schoolId).then(function (schoolAcademicYears) {
                            appContextModel.schoolAcademicYear = _.find(schoolAcademicYears, { academicYearID: $stateParams.academicYearID });

                            if (appContextModel.schoolAcademicYear)
                                deferred.resolve();
                            else { // If we can't find the selected academic year, default to the school's current year
                                schoolAcademicYearRepository.getBySchoolId(schoolId).then(function (schoolAcademicYears) {
                                    var persistedAcademicYearId = getPersistedAcademicYearId();
                                    if (persistedAcademicYearId > 0) {
                                        appContextModel.schoolAcademicYear = _.find(schoolAcademicYears, { academicYearID: persistedAcademicYearId });
                                    }
                                    if (!appContextModel.schoolAcademicYear) {
                                        appContextModel.schoolAcademicYear = _.find(schoolAcademicYears, { isCurrentYear: true });
                                    }
                                    deferred.resolve();
                                });
                            }
                        });
                    } else {
                        appContextModel.school = null;
                        deferred.resolve();
                    }
                } else {
                    deferred.resolve();
                }
                return deferred.promise;
            }
        }

    }
})();;
/**
 * app-context.model
 * @namespace core
 * @remarks '.model' is a sub-classification of service, including exclusively stateful model information (context)
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('appContextModel', appContextModel);

    // protect against minification
    /* @ngInject */
    appContextModel.$inject = [];

    /**
     * @name appContextModel
     * @description Define app-context.model
     * @memberOf core
     * @instructions Add object to model for each entity, and set to null
     * @remarks This service acts as a stateful model.  This shouldn't be for http calls or defining methods
     */
    function appContextModel() {
        var model = { 
            state: null,
            school: null,
            academicYear: null,
            schoolAcademicYear: null
        };
        return model;
    }

})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('availabilityService', ['$injector', 'appSettings',

    function ($injector, appSettings) {
        var svc = {
            getView: getView,
            getController: getController,
            getTemplateUrl: getTemplateUrl

        };

        return svc;

        function getTemplateUrl(templateUrl, serviceName) {
            if ($injector.has(serviceName)) {
                return templateUrl;
            } else {
                return appSettings.coreWebRootUrl + '/app/templates/offline.html';
            }

        }

        function getController(serviceName, controllerExpression) {
            return $injector.has(serviceName) ? controllerExpression : null;

        }

        function getView(templateUrl, serviceName, controllerExpression) {
            return {
                templateUrl: getTemplateUrl(templateUrl, serviceName),
                controller: getController(serviceName, controllerExpression)
            }
        }

    }]);

})();;
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('businessApplicationLastViewedRecordRepository', businessApplicationLastViewedRecordRepository);

    // protect against minification
    /* @ngInject */
    businessApplicationLastViewedRecordRepository.$inject = ['baseService', 'CoreRestangular', '$http', 'appSettings'];

    function businessApplicationLastViewedRecordRepository(baseService, coreRestangular, $http, appSettings) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getByApplicationNameAndStaffId = getByApplicationNameAndStaffId;
        service.update = update;
        service.add = add;

        return service;

        function getByApplicationNameAndStaffId(applicationName, staffId) {
            return baseService.getList('businessApplicationLastViewedRecord/' + applicationName + '/' + staffId, null, false, true, coreRestangular);
        }

        function update(businessApplicationLastViewedRecord) {
            return $http.put(appSettings.coreServicesRootUrl + 'businessApplicationLastViewedRecord', businessApplicationLastViewedRecord);
        }

        function add(businessApplicationLastViewedRecord) {
            return $http.post(appSettings.coreServicesRootUrl + 'businessApplicationLastViewedRecord', businessApplicationLastViewedRecord);
        }
    }

})();;
(function() {
    "use strict";

    // define one component per file (single responsibility)
    angular
        .module("nha.core")
        .service("businessApplicationsSvc", businessApplicationsSvc);

    // protect against minification
    /* @ngInject */
    businessApplicationsSvc.$inject = ["baseService", "CoreRestangular", "$rootScope"];

    
    function businessApplicationsSvc(baseService, CoreRestangular, $rootScope) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.get = get;
		service.getAll = getAll;
        service.getById = getById;
        service.getByRoles = getByRoles;
        service.getForUser = getForUser;

        return service;

        function get() {
            return baseService.getList("businessApplication", null, true, true, CoreRestangular);
        }

		function getAll() {
			return baseService.getList("businessApplication/all", null, true, true, CoreRestangular);
		}
        
        function getById(businessApplicationId) {
            var params = null;
            return baseService.getList('businessApplication/getById/'+businessApplicationId, params, true, true, CoreRestangular);
        }

        function getForUser() {
            return baseService.getList("businessApplication/getforuser", null, true, true, CoreRestangular);
        }

        function getByRoles(roles) {
            var params = { roleNames: roles };
            return baseService.getList("businessApplication", params, true, true, CoreRestangular);
        }

    }
})();;
(function () {
    'use strict';

    angular.module('nha.core').service('businessResponseService', businessResponseService);

    businessResponseService.$inject = ["$q"];

    function businessResponseService($q) {

        var service = {
            showBusinessResponse: showBusinessResponse
        };

        function showBusinessResponse(businessResponse, title, customMessageToDisplay) {

            var deferred = $q.defer();

            var messageTitle = (title || 'Operation was not successful!');
            var messageText = '';
            var swalType = 'error';

            var messages = (customMessageToDisplay ? [ customMessageToDisplay ] : []);

            var isOverride = false;
            var isException = false;

            // get business messages
            if (businessResponse && businessResponse.operationResult) {

                // any exceptions
                if (businessResponse.operationResult.exception) {

                    var exception = businessResponse.operationResult.exception;

                    isException = true;

                    var errorMessage = exception.Message;
                    
                    messages.push('A technical error occurred with this operation:');
                    messages.push(errorMessage);

                    // the real error is usually two levels deep in the inner exception
                    if (exception.InnerException && exception.InnerException.InnerException) {
                        var innerExceptionMessage = exception.InnerException.InnerException.Message;
                        if (innerExceptionMessage) {
                            messages.push(innerExceptionMessage);
                        }
                    }
                }

                if (!isException) {

                    // model state, if any
                    if (businessResponse.modelState) {
                        messages.push(businessResponse.modelState);
                    }

                    if (businessResponse.operationResult.rules) {

                        var errorsExist = _.some(businessResponse.operationResult.rules, function (rule) { return rule.ruleSeverity === 'Error' || rule.ruleSeverity === 'Critical' });
                        if (errorsExist) {
                            // if we have errors, we don't want to offer an overide yes/no prompt
                            businessResponse.operationResult.rules = _.reject(businessResponse.operationResult.rules, { ruleSeverity: 'Warning' });
                        }
                        else {
                            // determine rule severity so we can show correct swal type: "warning", "error", "success" and "info"
                            if (_.every(businessResponse.operationResult.rules, { ruleSeverity: 'Warning' })) {
                                swalType = 'warning';
                                isOverride = true;
                            }

                            if (_.every(businessResponse.operationResult.rules, { ruleSeverity: 'Info' })) {
                                swalType = 'info';
                            }
                        }

                        // rule messages
                        _.forEach(businessResponse.operationResult.rules, function (rule) {
                            _.forEach(rule.messages, function (message) {
                                messages.push(message);
                            });
                        });
                    }
                }
            }

            // put all of our messages together for display, if we have any
            if (!_.isEmpty(messages)) {
                messageText = messages.join('\n\n');
            }

            var swalOptions = { title: messageTitle, type: swalType };

            if (messageText) {
                swalOptions.text = messageText;
            }

            if (isOverride) {
                swalOptions.showCancelButton = true;
                swalOptions.confirmButtonText = 'Override';
                swalOptions.closeOnConfirm = true;
            }

            // show the swal and then resolve the promise
            if (isOverride) {
                swal(swalOptions, function (isConfirm) {
                    deferred.resolve(isConfirm);
                });
            }
            else {
                swal(swalOptions);
            }

            return deferred.promise;
        }

        return service;
    }

})();;
/**
 * core-app-context.manager
 * @namespace core
 * @remarks '.manager' is a sub-classification of service, including exclusively business logic
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('coreAppContextManager', coreAppContextManager);

    // protect against minification
    /* @ngInject */
    coreAppContextManager.$inject = ['appContextFactory', 'appContextModel', 'coreAppContextModel'];

    /**
    * @name coreAppContextManager
    * @description Define core-app-context.manager
    * @memberOf core
    */
    function coreAppContextManager(appContextFactory, appContextModel, coreAppContextModel) {

        ///**
        // * @name loadSample
        // * @description Defines a deferred method to retrieve and set model context
        // * @returns promise for factory consumption
        // * @memberOf gradebook-app-context.manager
        // * @remarks assignment is made to appContextModel, not local model
        // *          and should explicitly clear out model context if no state param is available
        // */
        //function loadSample() {
        //    var deferred = $q.defer();
        //    if ($stateParams.sampleId) {
        //        var sampleId = $stateParams.sampleId;
        //        sampleService.get(sampleId).then(function (sample) {
        //            appContextModel.sample = sample; // needs to be appContextModel
        //            deferred.resolve();
        //        });
        //    } else {
        //        appContextModel.sample = null; // explicitly null this out if no $stateParam exists
        //        deferred.resolve();
        //    }
        //    return deferred.promise; // method needs to return a promise
        //}

        // package methods for injection into factory - no parenthesis
        var retrievalMethodExtensions = []; // [loadSample];

        // Instantiate service from factory
        return new appContextFactory(coreAppContextModel, retrievalMethodExtensions);
    }

})();;
/**
 * core-app-context.model
 * @namespace core
 * @remarks '.model' is a sub-classification of service, including exclusively stateful model information (context)
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('coreAppContextModel', coreAppContextModel);

    /**
     * @name coreAppContextModel
     * @description Define core-app-context.model
     * @memberOf core
     * @instructions Add object to model for each entity to add to app-context.model, and set to null
     * @remarks This service acts as a stateful model.  This shouldn't be for http calls or defining methods
     */
    function coreAppContextModel() {
        var model = {
            // sample: null
        };
        return model;

    }
})();
;
/**
 * country.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('countryRepository', countryRepository);

    // protect against minification
    /* @ngInject */
    countryRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name countryRepository
    * @description Constructor for country.repository
    * @memberOf core
    */
    function countryRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getCountries = getCountries;

        return service;

        /**
         * @name getCountries
         * @description retrieves countries from storage
         * @returns List<object> List of objects containing a subset of country properties
         * @memberOf country.repository
         */
        function getCountries() {
            return baseService.getList('country', { $orderby: 'CountrySortOrderID' }, false, true, CoreRestangular);
        }

    }
})();;
/**
 * course-section.repository
 * @namespace core 
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
*/
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('courseSectionGroupMarkingPeriodRepository', courseSectionGroupMarkingPeriodRepository);

    // protect against minification
    /* @ngInject */
    courseSectionGroupMarkingPeriodRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name courseSectionRepository
    * @description Constructor for course-section.repository
    * @memberOf core
    */
    function courseSectionGroupMarkingPeriodRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.get = get;

        return service;

        /**
         * @name getAll
         * @description retrieves course sections from storage
         * @returns List<object> List of objects containing course section properties
         * @memberOf course-section.repository
         */
        function get(courseSectionGroupID) {
            return baseService.getList('courseSectionGroupMarkingPeriod', _utils.getODataRequest({ filter: { CourseSectionGroupID: courseSectionGroupID }}), true, true, CoreRestangular);
        }
    }
})();;
/**
 * course-section-group.repository
 * @namespace core 
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
*/
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('courseSectionGroupRepository', courseSectionGroupRepository);

    // protect against minification
    /* @ngInject */
    courseSectionGroupRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name courseSectionGroupRepository
    * @description Constructor for course-section-group.repository
    * @memberOf core
    */
    function courseSectionGroupRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getAll = getAll;
        service.get = get;
        service.remove = remove; // DELETE but delete is a reserved word, so using remove
        service.put = put;
        service.post = post;
        service.getByCourseSectionId = getByCourseSectionId;
        service.getByAcademicYearSchoolAndGrade = getByAcademicYearSchoolAndGrade;
		service.getByAcademicYearSchool = getByAcademicYearSchool;

        return service;

        /**
         * @name getAll
         * @description retrieves courseSectionGroups from storage
         * @returns List<object> List of objects containing courseSectionGroup properties
         * @memberOf course-section-group.repository
         */
        function getAll() {
            return baseService.getList('courseSectionGroup', null, true, true, CoreRestangular);
        }

        function getByAcademicYearSchoolAndGrade(academicYearId, schoolId, gradeLevelId) {
            var oDataParameters = _utils.getODataRequest({
                filter: {
                    AcademicYearID: academicYearId,
                    SchoolID: schoolId,
                    GradeLevelID: gradeLevelId
                }
            });

            if (!oDataParameters || !oDataParameters.$filter) { return null; }

            return baseService.getList('courseSectionGroup', oDataParameters, true, true, CoreRestangular);
        }

		function getByAcademicYearSchool(academicYearId, schoolId) {
            var oDataParameters = _utils.getODataRequest({
                filter: {
                    AcademicYearID: academicYearId,
                    SchoolID: schoolId
                }
            });

            if (!oDataParameters || !oDataParameters.$filter) { return null; }

            return baseService.getList('courseSectionGroup', oDataParameters, true, true, CoreRestangular);
        }

        /**
         * @name get
         * @description retrieves an courseSectionGroup from storage
         * @param int courseSectionGroupId identifier of the courseSectionGroup object
         * @returns object object containing courseSectionGroup properties
         * @memberOf course-section-group.repository
         */
        function get(courseSectionGroupId) {
            return baseService.getSingle('courseSectionGroup', { id: courseSectionGroupId }, true, true, CoreRestangular);
        }
        /**
         * @name remove
         * @description deletes an courseSectionGroup from storage
         * @param int courseSectionGroupId identifier of the courseSectionGroup object
         * @returns promise
         * @memberOf course-section-group.repository
         * @remarks DELETE is a reserved word, so using name REMOVE
         */
        function remove(courseSectionGroupId) {
            return CoreRestangular.one('courseSectionGroup', courseSectionGroupId).remove();
        }
        /**
         * @name put
         * @description updates an courseSectionGroup to storage
         * @param object courseSectionGroup courseSectionGroup object to update
         * @param int courseSectionGroupId identifier of the courseSectionGroup object
         * @returns promise
         * @memberOf course-section-group.repository
         */
        function put(courseSectionGroup, courseSectionGroupId) {
            return CoreRestangular.all('courseSectionGroup').customPUT(courseSectionGroup, courseSectionGroupId);
        }
        /**
         * @name remove
         * @description deletes an courseSectionGroup from storage
         * @param object courseSectionGroup courseSectionGroup object to update
         * @returns promise
         * @memberOf course-section-group.repository
         */
        function post(courseSectionGroup) {
            return CoreRestangular.all('courseSectionGroup').customPOST(courseSectionGroup);
        }
        /**
         * @name getByCourseSectionId
         * @description retrieves an courseSectionGroup from storage for a courseSectionId
         * @param int courseSectionId identifier for the courseSectionGroup object
         * @returns object object containing courseSectionGroup properties
         * @memberOf course-section-group.repository
         */
        function getByCourseSectionId(courseSectionId) {
            //return CoreRestangular.all('courseSectionGroup').one('getByCourseSectionId', courseSectionId);
            return baseService.getSingle('courseSectionGroup/getByCourseSectionId/' + courseSectionId, null, true, true, CoreRestangular);
        }

    }
})();;
/**
 * courseSectionRosterOrder.repository
 * @namespace gradebook 
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
*/
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('courseSectionRosterOrderRepository', courseSectionRosterOrderRepository);

    // protect against minification
    /* @ngInject */
    courseSectionRosterOrderRepository.$inject = ['baseService', 'CoreRestangular'];

    function courseSectionRosterOrderRepository(baseService, CoreRestangular) {
        var service = this;

        service.saveRosterOrders = saveRosterOrders;

        function saveRosterOrders(rosterOrders) {
            return CoreRestangular.all('courseSectionRosterOrder').customPUT(rosterOrders);
        }

        return service;
    }
})();;
/**
 * course-section-roster.repository
 * @namespace core 
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
*/
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('courseSectionRosterRepository', courseSectionRosterRepository);

    // protect against minification
    /* @ngInject */
    courseSectionRosterRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name courseSectionRosterRepository
    * @description Constructor for course-section-roster.repository
    * @memberOf core
    */
    function courseSectionRosterRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.get = get;
        service.getAll = getAll;
        service.getByCourseSection = getByCourseSection;
        service.getActiveRostersForMarkingPeriod = getActiveRostersForMarkingPeriod;
        service.remove = remove; // DELETE but delete is a reserved word, so using remove
        service.put = put;
        service.post = post;

        return service;

        /**
         * @name get
         * @description retrieves an courseSectionRoster from storage
         * @param int courseSectionRosterId identifier of the courseSectionRoster object
         * @returns object object containing courseSectionRoster properties
         * @memberOf course-section-roster.repository
         */
        function get(courseSectionRosterId) {
            return baseService.getSingle('courseSectionRoster', { id: courseSectionRosterId }, true, true, CoreRestangular);
        }
        /**
         * @name getAll
         * @description retrieves courseSectionRosters from storage
         * @returns List<object> List of objects containing courseSectionRoster properties
         * @memberOf course-section-roster.repository
         */
        function getAll() {
            return baseService.getList('courseSectionRoster', null, true, true, CoreRestangular);
        }
        /**
         * @name getByCourseSection
         * @description retrieves an courseSectionRoster from storage
         * @param int courseSectionId identifier of the courseSectionRoster object
         * @returns List<object> list of objects containing courseSectionRoster properties
         * @memberOf course-section-roster.repository
         */
        function getByCourseSection(courseSectionId) {
            var oDataParameters = _utils.getODataRequest({ filter: { CourseSectionID: courseSectionId } });
            return baseService.getList('courseSectionRoster', oDataParameters, true, true, CoreRestangular);
        }

        function getActiveRostersForMarkingPeriod(courseSectionID, markingPeriodID) {
            return baseService.getList('courseSectionRoster/activeRosters', { courseSectionID: courseSectionID, markingPeriodID : markingPeriodID}, true, true, CoreRestangular);
        }
        /**
         * @name remove
         * @description deletes an courseSectionRoster from storage
         * @param int courseSectionRosterId identifier of the courseSectionRoster object
         * @returns promise
         * @memberOf course-section-roster.repository
         * @remarks DELETE is a reserved word, so using name REMOVE
         */
        function remove(courseSectionRosterId) {
            return CoreRestangular.one('courseSectionRoster', courseSectionRosterId).remove();
        }
        /**
         * @name put
         * @description updates an courseSectionRoster to storage
         * @param object courseSectionRoster courseSectionRoster object to update
         * @param int courseSectionRosterId identifier of the courseSectionRoster object
         * @returns promise
         * @memberOf course-section-roster.repository
         */
        function put(courseSectionRoster, courseSectionRosterId) {
            return CoreRestangular.all('courseSectionRoster').customPUT(courseSectionRoster, courseSectionRosterId);
        }
        /**
         * @name remove
         * @description deletes an courseSectionRoster from storage
         * @param object courseSectionRoster courseSectionRoster object to update
         * @returns promise
         * @memberOf course-section-roster.repository
         */
        function post(courseSectionRoster) {
            return CoreRestangular.all('courseSectionRoster').customPOST(courseSectionRoster);
        }

    }
})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('courseSectionStaffRepository', ['CoreRestangular', 'baseService',

    function (CoreRestangular, baseService) {
        var svc = {
            getAll: getAll
        };

        return svc;

        function getAll(parameters) {
            return baseService.getList('CourseSectionStaff', _utils.getODataRequest({ filter: parameters }), true, true, CoreRestangular);
        }
    }]);
})();;
/**
 * course-section.repository
 * @namespace core 
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
*/
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('courseSectionRepository', courseSectionRepository);

    // protect against minification
    /* @ngInject */
    courseSectionRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name courseSectionRepository
    * @description Constructor for course-section.repository
    * @memberOf core
    */
    function courseSectionRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getAll = getAll;
        service.getBySchoolAndStaff = getBySchoolAndStaff;
        service.getBySchoolAndAcademicYear = getBySchoolAndAcademicYear;
        service.getByStudentInSchool = getByStudentInSchool;
        service.get = get;
        service.remove = remove; // DELETE but delete is a reserved word, so using remove
        service.put = put;
        service.post = post;

        return service;

        /**
         * @name getAll
         * @description retrieves course sections from storage
         * @returns List<object> List of objects containing course section properties
         * @memberOf course-section.repository
         */
        function getAll() {
            return baseService.getList('courseSection', null, true, true, CoreRestangular);
        }

        function getBySchoolAndStaff(schoolId, staffId, acadademicYearId) {
            return baseService.getList('coursesection/GetBySchoolAndStaff/' + schoolId + '/' + staffId + '/' + acadademicYearId, null, true, true, CoreRestangular);
        }

        function getBySchoolAndAcademicYear(schoolId, acadademicYearId) {
            return baseService.getList('coursesection/GetBySchoolAndAcademicYear/' + schoolId + '/' + acadademicYearId, null, true, true, CoreRestangular);
        }

        function getByStudentInSchool(studentInSchoolId) {
            return baseService.getList('courseSection/GetByStudentInSchool/' + studentInSchoolId, null, true, true, CoreRestangular);
        }

        /**
         * @name get
         * @description retrieves a course section from storage
         * @param int courseSectionId identifier of the course section object
         * @returns object object containing course section properties
         * @memberOf course-section.repository
         */
        function get(courseSectionId) {
            return baseService.getSingle('courseSection', { id: courseSectionId }, false, true, CoreRestangular);
        }
        /**
         * @name remove
         * @description deletes a course section from storage
         * @param int courseSectionId identifier of the course section object
         * @returns promise
         * @memberOf course-section.repository
         * @remarks DELETE is a reserved word, so using name REMOVE
         */
        function remove(courseSectionId) {
            return CoreRestangular.one('courseSection', courseSectionId).remove();
        }
        /**
         * @name put
         * @description updates a course section to storage
         * @param object courseSection course section object to update
         * @param int courseSectionId identifier of the course section object
         * @returns promise
         * @memberOf course-section.repository
         */
        function put(courseSection, courseSectionId) {
            return CoreRestangular.all('courseSection').customPUT(courseSection, courseSectionId);
        }
        /**
         * @name remove
         * @description deletes a course section from storage
         * @param object courseSection course section object to update
         * @returns promise
         * @memberOf course-section.repository
         */
        function post(courseSection) {
            return CoreRestangular.all('courseSection').customPOST(courseSection);
        }

    }
})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('courseSummaryMarkingPeriodRollupRepository', ['repositoryFactory', 'CoreRestangular', 'baseService',
           function (repositoryFactory, coreRestangular, baseService) {
               var repo = new repositoryFactory('CourseSummaryMarkingPeriodRollup', coreRestangular);

               repo.getByCourseSection = getByCourseSection;

               /**
                 * @name getByCourseSection
                 * @description retrieves an courseSummaryMarkingPeriodRollup from storage for a courseSectionId
                 * @param int courseSectionId identifier for the courseSummaryMarkingPeriodRollup object
                 * @returns object object containing courseSummaryMarkingPeriodRollup properties
                 * @memberOf course-summary-marking-period.repository
                 */
               function getByCourseSection(courseSectionId) {
                   //return CoreRestangular.all('courseSummaryMarkingPeriodRollup').one('getByCourseSection', courseSectionId);
                   return baseService.getSingle('courseSummaryMarkingPeriodRollup/getByCourseSection/' + courseSectionId, null, true, true, coreRestangular);
               }

               return repo;
           }
       ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('courseSummaryMeetingBlockRollupRepository', ['repositoryFactory', 'CoreRestangular', 'baseService',
           function (repositoryFactory, coreRestangular, baseService) {
               var repo = new repositoryFactory('CourseSummaryMeetingBlockRollup', coreRestangular);

               repo.getByCourseSection = getByCourseSection;

               /**
                 * @name getByCourseSection
                 * @description retrieves an courseSummaryMeetingBlockRollup from storage for a courseSectionId
                 * @param int courseSectionId identifier for the courseSummaryMeetingBlockRollup object
                 * @returns object object containing courseSummaryMeetingBlockRollup properties
                 * @memberOf course-summary-meeting-block.repository
                 */
               function getByCourseSection(courseSectionId) {
                   //return CoreRestangular.all('courseSummaryMeetingBlockRollup').one('getByCourseSection', courseSectionId);
                   return baseService.getSingle('courseSummaryMeetingBlockRollup/getByCourseSection/' + courseSectionId, null, true, true, coreRestangular);
               }

               return repo;
           }
       ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('courseSummaryStaffRollupRepository', ['repositoryFactory', 'CoreRestangular', 'baseService',
           function (repositoryFactory, coreRestangular, baseService) {
               var repo = new repositoryFactory('CourseSummaryStaffRollup', coreRestangular);

               repo.getByCourseSection = getByCourseSection;

               /**
                 * @name getByCourseSection
                 * @description retrieves an courseSummaryStaffRollup from storage for a courseSectionId
                 * @param int courseSectionId identifier for the courseSummaryStaffRollup object
                 * @returns object object containing courseSummaryStaffRollup properties
                 * @memberOf course-summary-staff-rollup.repository
                 */
               function getByCourseSection(courseSectionId) {
                   //return CoreRestangular.all('courseSummaryStaffRollup').one('getByCourseSection', courseSectionId);
                   return baseService.getSingle('courseSummaryStaffRollup/getByCourseSection/' + courseSectionId, null, true, true, coreRestangular);
               }

               return repo;
           }
       ]);
})();;
(function () {
	"use strict";

	angular.module("nha.core")
		.service("dataSecurityService", ['userContextService', '$q',
			function (userContextService, $q) {
				var adminroles = ["SIS Admin"];

				var service = {
					doesUserHaveAccessToSchool: doesUserHaveAccessToSchool,
					doesUserHaveAdminRole: doesUserHaveAdminRole,
					isSingleSchoolUser: isSingleSchoolUser,
					isStaffUser: isStaffUser,
					isAdminUser: isAdminUser
				}

				function doesUserHaveAccessToSchool(schoolID) {

					var deferred = $q.defer();

					userContextService.ensureUserContext().then(function (context) {
						var hasAccessToSchool = false;
						var validSchoolID = context['http://schemas.mynha.com/ILM/SchoolID'];

						if (Array.isArray(validSchoolID)) {
							//This user has multiple school associated
							hasAccessToSchool = _.some(validSchoolID, function (s) {
								return s === '000' || schoolID === (+s);
							});
						} else {
							//Single school association
							hasAccessToSchool = validSchoolID === '000' || schoolID === (+validSchoolID) || _.find(context['http://schemas.mynha.com/ILM/Department'], 'Administration');
						}

						if (context.role.includes('Service Center')) {
							hasAccessToSchool = true;
						}

						if (Array.isArray(context.role)) {
							if (_.intersection(adminroles, context.role).length > 0) {
								hasAccessToSchool = true;
							}
						} else {
							if (_.includes(adminroles, context.role)) {
								hasAccessToSchool = true;
							}
						}

						deferred.resolve(hasAccessToSchool);
					});

					return deferred.promise;
				}

				/*
				 * @description Returns true if user's school array contains 1 school ID > 0
				 */
				function isSingleSchoolUser(context) {
					var deferred = $q.defer();

					$q.all([
						userContextService.ensureUserContext(),
						doesUserHaveAdminRole()
					]).then(_.spread(function (context, hasAdminRole) {

						var userSchools = context['http://schemas.mynha.com/ILM/SchoolID'];

						if (!Array.isArray(userSchools) && (+userSchools) > 0 && !hasAdminRole) {
							deferred.resolve(true);
						} else {
							deferred.resolve(false);
						}
					}));

					return deferred.promise;
				}

				function isMultiRoleUser(context) {
					var returnValue = false;

					if (Array.isArray(context.role)) {
						if (_.filter(context.role, function (role) {
								return role != 'Employee'
							}).length > 1) {
							returnValue = true;
						}
					}

					return returnValue;
				}

				function isMultiDepartmentUser(context) {
					return context['http://schemas.mynha.com/ILM/Department'] &&
						Array.isArray(context['http://schemas.mynha.com/ILM/Department']) &&
						context['http://schemas.mynha.com/ILM/Department'].length > 1;
				}

				function isMultiPositionUser(context) {
					return context['http://schemas.mynha.com/ILM/Position'] &&
						Array.isArray(context['http://schemas.mynha.com/ILM/Position']) &&
						context['http://schemas.mynha.com/ILM/Position'].length > 1;
				}

				function isMultiTeamUser(context) {
					return context['http://schemas.mynha.com/ILM/Team'] &&
						Array.isArray(context['http://schemas.mynha.com/ILM/Team']) &&
						context['http://schemas.mynha.com/ILM/Team'].length > 1;
				}

				/*Returns whether or not user is more than just a teacher.*/
				function isStaffUser(context) {
					return isMultiRoleUser(context) ||
						isMultiDepartmentUser(context) ||
						isMultiPositionUser(context) ||
						isMultiTeamUser(context);
				}

				function isAdminUser(context) {
					if (Array.isArray(context.role)) {
						if (_.intersection(adminroles, context.role).length > 0) {
							return true;
						}
					} else {
						if (_.includes(adminroles, context.role)) {
							return true;
						}
					}

					return false;
				}

				/*
				 * Returns true if user has role of SIS Admin
				 */
				function doesUserHaveAdminRole() {

					var deferred = $q.defer();

					var hasAdminRole = false;

					userContextService.ensureUserContext().then(function (context) {
						hasAdminRole = isAdminUser(context);

						deferred.resolve(hasAdminRole);
					});

					return deferred.promise;
				}

				return service;
			}
		]);
})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('enumService', ['baseService', 'CoreRestangular',

    function (baseService, CoreRestangular) {
        var svc = {
            get: get
        };

        return svc;

        function get(restangularToInvoke) {
            return baseService.getList('enum', {}, false, true, restangularToInvoke || CoreRestangular).then(function (result) {
                var returnValue = {};

                /*TODO: Performance enhancement: move all processing before cache call. This code currently caches web call and always converts 
                 *results results into Enum objects real time instead of caching Enum objects*/
                if (result) {
                    for (var enumSet in result) {
                        if (Object.prototype.toString.call(result[enumSet]) === '[object Array]') {
                            var allEnums = {};

                            _.forEach(result[enumSet], function (individualEnumValue) {
                                allEnums[individualEnumValue.name] = individualEnumValue.value;
                            });

                            returnValue[enumSet] = new Enum(allEnums);
                        }
                    }
                }

                return returnValue;
            });
        }
    }]);

})();;
(function () {
    'use strict';

    /*Service to persist in memory transaction errors when calling backend services. Can be used to see if the user has any transaction errors that need to be addressed.*/
    angular.module('nha.core').factory('errorSvc',
        ['$http', 'appSettings', '$q',

    function ($http, appSettings, $q) {
        var svc = {
            recordErrors: recordErrors,
            getActiveErrors: getActiveErrors,
            dismissAllErrors: dismissAllErrors, 
            areErrorsPresent: areErrorsPresent,
            getUnhandledError: getUnhandledError,
            allErrors: [],
            gatherAllErorrs: gatherAllErorrs
        };

        return svc;

        function recordErrors(errorObj) {
            if (!errorObj) return;

            if (errorObj instanceof Array) {
                _.forEach(errorObj, function (error) {
                    svc.allErrors.push(error);
                });
            }
            else if (errorObj) {
                svc.allErrors.push(errorObj);
            }
        }

        function getActiveErrors() {
            return svc.allErrors;
        }

        function dismissAllErrors() {
            _.remove(svc.allErrors, function () { return true; });
        }

        function areErrorsPresent(type) {
            return _.find(svc.allErrors, function (item) { return item.severity == type || item.type == type || _.isUndefined(type); });
        }

        function getUnhandledError(error, userMessage) {
            if (error != null) {

                if (userMessage == null) {
                    userMessage = 'An error has occurred.';
                }

                svc.recordErrors({ 'message': userMessage, 'type': 'error', 'detail': JSON.stringify(error) });
            }
        }

        function gatherAllErorrs(obj, result) {
            var result = result || [];

            if (obj) {
                for (var propertyName in obj) {
                    if (propertyName == 'errors') {
                        result = _.union(result, obj[propertyName]);
                    }
                    else if (typeof (obj[propertyName]) == 'object') {
                        result = _.union(result, svc.gatherAllErorrs(obj[propertyName], result));
                    }
                    else if (typeof (obj[propertyName]) == 'array') {
                        _.forEach(obj[propertyName], function () {
                            result = _.union(result, svc.gatherAllErorrs(obj[propertyName], result));
                        });
                    }
                }
            }

            return result;
        }
    }]);

})();;
/**
 * file-reader.factory
 * @namespace core
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('fileReaderFactory', fileReaderFactory);

    // protect against minification
    /* @ngInject */
    fileReaderFactory.$inject = ['$q'];

    /**
    * @name fileReaderFactory
    * @description Constructor for file-reader.factory
    * @memberOf core
    */
    function fileReaderFactory($q) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.onLoad = onLoad;
        service.onError = onError;
        service.onProgress = onProgress;
        service.readAsArrayBuffer = readAsArrayBuffer; 
        service.readAsBinaryString = readAsBinaryString;
        service.readAsDataUrl = readAsDataUrl;
        service.readAsText = readAsText;

        return service;

        /**
         * @name onLoad
         * @description 
         * @returns 
         * @memberOf file-reader.factory
         */
        function onLoad(reader, deferred, scope) {
            return function () {
                scope.$apply(function () {
                    deferred.resolve(reader.result);
                });
            }
        }

        /**
         * @name onError
         * @description 
         * @returns 
         * @memberOf file-reader.factory
         */
        function onError(reader, deferred, scope) {
            return function () {
                scope.$apply(function () {
                    deferred.reject(reader.result);
                });
            }
        }

        /**
         * @name onProgress
         * @description 
         * @returns 
         * @memberOf file-reader.factory
         */
        function onProgress() {
            return function (event) {
                scope.$broadcast('fileProgress', {
                    total: event.total,
                    loaded: event.loaded
                });
            }
        }

        /**
         * @name getReader
         * @description 
         * @returns 
         * @memberOf file-reader.factory
         * @remarks https://developer.mozilla.org/en-US/docs/Web/API/FileReader
         */
        function getReader(deferred, scope) {
            var reader = new FileReader();
            reader.onload = onLoad(reader, deferred, scope);
            reader.onerror = onError(reader, deferred, scope);
            reader.onProgress = onProgress(reader, scope);
            return reader;
        }

        /**
         * @name readAsArrayBuffer
         * @description 
         * @returns 
         * @memberOf file-reader.factory
         */
        function readAsArrayBuffer(file, scope) {
            var deferred = $q.defer();
            var reader = getReader(deferred, scope);
            reader.readAsArrayBuffer(file);

            return deferred.promise;
        }

        /**
         * @name readAsBinaryString
         * @description 
         * @returns 
         * @memberOf file-reader.factory
         */
        function readAsBinaryString(file, scope) {
            var deferred = $q.defer();
            var reader = getReader(deferred, scope);
            reader.readAsBinaryString(file);

            return deferred.promise;
        }

        /**
         * @name readAsDataUrl
         * @description 
         * @returns 
         * @memberOf file-reader.factory
         */
        function readAsDataUrl(file, scope) {
            var deferred = $q.defer();
            var reader = getReader(deferred, scope);
            reader.readAsDataURL(file);

            return deferred.promise;
        }

        /**
         * @name readAsText
         * @description 
         * @returns 
         * @memberOf file-reader.factory
         */
        function readAsText(file, scope) {
            var deferred = $q.defer();
            var reader = getReader(deferred, scope);
            reader.readAsText(file);

            return deferred.promise;
        }

    }
})();;
/**
 * form-received.repository
 * @namespace core
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.core').service('form-received.repository', formReceivedRepo);

	/** setup injection */
	formReceivedRepo.$inject = ['repositoryFactory', 'CoreRestangular'];

	/** implement the repo */
	function formReceivedRepo(repositoryFactory, coreRestangular) {
		/** create the repo */
		var repo = new repositoryFactory('FormReceived', coreRestangular);

		/** return the repo */
		return repo;
	}
})();;
/**
 * gender.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('genderRepository', genderRepository);

    // protect against minification
    /* @ngInject */
    genderRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name genderRepository
    * @description Constructor for gender.repository
    * @memberOf core
    */
    function genderRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getGenders = getGenders;

        return service;

        /**
         * @name getGenders
         * @description retrieves genders from storage
         * @returns List<object> List of objects containing gender properties
         * @memberOf gender.repository
         */
        function getGenders() {
            return baseService.getList('gender', { $orderby: 'GenderID' }, true, true, CoreRestangular);
        }

    }
})();;
/**
 * grade-level.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('gradeLevelRepository', gradeLevelRepository);

    // protect against minification
    /* @ngInject */
    gradeLevelRepository.$inject = ['CoreRestangular', 'baseService'];

    /**
    * @name gradeLevelRepository
    * @description Constructor for grade-level.repository
    * @memberOf core
    */
    function gradeLevelRepository(coreRestangular, baseService) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.get = get;
        service.getAll = getAll;
        service.getByStudentInSchool = getByStudentInSchool;
        service.getForAcademicYearAndState = getForAcademicYearAndState;
        service.getForScoolIDAndAcademicYearID = getForScoolIDAndAcademicYearID;
        service.getForCourseSection = getForCourseSection;
        service.getForCourseSectionGroup = getForCourseSectionGroup;

        return service;

        /**
         * @name get
         * @description retrieves a grade level from storage
         * @returns object Object containing grade level properties
         * @memberOf grade-level.repository
         */
        function get(gradeLevelId, options) {
            if (!options) {
                options = { shouldCache: true, shouldLog: true };
            }
            return baseService.getList('GradeLevel', { id: gradeLevelId }, options.shouldCache, options.shouldLog, coreRestangular);
        }
        /**
         * @name getAll
         * @description retrieves grade levels from storage
         * @returns List<object> List of objects containing a subset of grade level properties
         * @memberOf grade-level.repository
         */
        function getAll(options) {
            if (!options) {
                options = { shouldCache: true, shouldLog: true };
            } 
            return baseService.getList('GradeLevel', {}, options.shouldCache, options.shouldLog, coreRestangular);
        }

        function getByStudentInSchool(studentInSchoolId, options) {
            if (!options) {
                options = { shouldCache: true, shouldLog: true };
            }
            return baseService.getList('GradeLevel/studentinschool/' + studentInSchoolId, {}, options.shouldCache, options.shouldLog, coreRestangular);
        }

		function getForAcademicYearAndState(academicYearID, stateID, options) {
			if (!options) options = { shouldCache: true, shouldLog: true };
			return baseService.getList('gradelevel/academicyearstate/' + academicYearID + '/' + stateID, {}, options.shouldCache, options.shouldLog, coreRestangular);
		}

		function getForScoolIDAndAcademicYearID(schoolID, academicYearID, options) {
		    if (!options) options = { shouldCache: true, shouldLog: true };
		    return baseService.getList('gradelevel/academicyear/' + schoolID + '/' + academicYearID, {}, options.shouldCache, options.shouldLog, coreRestangular);
		}

		function getForCourseSection(courseSectionID, options) {
		    if (!options) options = { shouldCache: true, shouldLog: true };
		    return baseService.getList('gradelevel/courseSection/' + courseSectionID, {}, options.shouldCache, options.shouldLog, coreRestangular);
		}

		function getForCourseSectionGroup(courseSectionGroupID, options) {
		    if (!options) options = { shouldCache: true, shouldLog: true };
		    return baseService.getList('gradelevel/courseSectionGroup/' + courseSectionGroupID, {}, options.shouldCache, options.shouldLog, coreRestangular);
		}

    }
})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('languageService', ['CoreRestangular', 'baseService',

    function (CoreRestangular, baseService) {
        var service = {
            get: get
        };

        return service;

        function get(languageId) {
            return baseService.getList('Language', { id: languageId }, true, true, CoreRestangular);
        }
    }]);

})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('markingPeriodGroupRepository', ['repositoryFactory', 'CoreRestangular',
           function (repositoryFactory, coreRestangular) {
               return new repositoryFactory('MarkingPeriodGroup', coreRestangular);
           }
       ]);
})();;
/**
 * marking-period.repository
 * @namespace core 
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
*/
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('markingPeriodRepository', MarkingPeriodRepository);

    // protect against minification
    /* @ngInject */
    MarkingPeriodRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name markingPeriodRepository
    * @description Constructor for marking-period.repository
    * @memberOf core
    */
    function MarkingPeriodRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.get = get;

        return service;

        function get(markingPeriodID) {
            return baseService.getSingle('markingPeriod', { id: markingPeriodID }, true, true, CoreRestangular);
        }
    }
})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('markingPeriodService', ['baseService', 'CoreRestangular',

    function (baseService, coreRestangular) {
        var svc = {
            get: get
        };

        return svc;

        function get() {
            return baseService.getList('MarkingPeriod', null, true, true, coreRestangular);
        }
    }]);

})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('masterScheduleTypeRepository', ['repositoryFactory', 'MasterSchedulingRestangular',
           function (repositoryFactory, masterSchedulingRestangular) {
               return new repositoryFactory('masterScheduleTypes', masterSchedulingRestangular, { capitalizeIdString: false });
           }
       ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('masterStatusService', ['baseService',

    function (baseService) {
        var svc = {
            getAll: getAll,
            get: get
        };

        return svc;

        // this method should be the only one, but i don't know what is using the get().
        function getAll(parameters) {
            return baseService.getList('MasterStatus', parameters || {}, true, true);
        }

        function get(masterStatusTypeID) {
            var params = {};

            if (masterStatusTypeID) {
                params = _utils.getODataRequest({ filter: { MasterStatusTypeID: masterStatusTypeID } });
            }

            return baseService.getList('masterStatus', params, true, true);
        }
    }]);

})();;
/**
 * nha-timezone.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('nhaTimezoneRepository', nhaTimezoneRepository);

    // protect against minification
    /* @ngInject */
    nhaTimezoneRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name nhaTimezoneRepository
    * @description Constructor for nha-timezone.repository
    * @memberOf core
    */
    function nhaTimezoneRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getNHATimezones = getNHATimezones;

        return service;

        /**
         * @name getNHATimezones
         * @description retrieves NHA timezones from storage
         * @returns List<object> List of objects containing NHA timezone properties
         * @memberOf nha-timezone.repository
         */
        function getNHATimezones() {
            return baseService.getList('NHATimezone', { $orderby: 'DisplayOrder' }, false, true, CoreRestangular);
        }
    }
})();;
/**
 * Phone Format Service
 * @namespace app.services
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('phoneFormatService', phoneFormatService);

    // protect against minification
    /* @ngInject */
    phoneFormatService.$inject = ['baseService'];

    /**
    * @namespace PhoneFormatService
    * @description Instantiate PhoneFormatService
    * @memberOf app.services
    */
    function phoneFormatService(baseService) {
        var svc = {
            formatPhoneNumberForStorage: formatPhoneNumberForStorage
        };

        return svc;

        /**
         * @name formatPhoneNumberForStorage
         * @description Format passed in phone number in standard arrangement for storage (e.g. to database)
         * @param string phoneNumber Number to be formatted
         * @returns string Formatted phone number
         * @memberOf phone-format.service
         */
        function formatPhoneNumberForStorage(phoneNumber) {
            if (!phoneNumber) { return ''; }

            var value = phoneNumber.toString().trim().replace(/^\+/, '');
            var city, number, extension;

            if (value.length <= 10) {
                city = value.slice(0, 3);
                number = value.slice(3);
                number = number.slice(0, 3) + '-' + number.slice(3);
                return (city + '-' + number).trim();
            } else {
                city = value.slice(0, 3);
                number = value.slice(3, 10);
                number = number.slice(0, 3) + '-' + number.slice(3);
                extension = value.slice(10);
                return (city + '-' + number + 'x' + extension).trim();
            }
        }

    }
})();;
/**
 * race.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('raceRepository', raceRepository);

    // protect against minification
    /* @ngInject */
    raceRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name raceRepository
    * @description Constructor for race.repository
    * @memberOf core
    */
    function raceRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getRaces = getRaces;

        return service;

        /**
         * @name getRaces
         * @description retrieves races from storage
         * @returns List<object> List of objects containing race properties
         * @memberOf race.repository
         */
        function getRaces() {
            return baseService.getList('race', { $orderby: 'RaceId' }, true, true, CoreRestangular);
        }

    }
})();;
/**
 * role-type.repository
 * @namespace core
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.core').service('role-type.repository', roleTypeRepo);

	/** injection */
	roleTypeRepo.$inject = ['repositoryFactory', 'CoreRestangular'];

	/** implementation */
	function roleTypeRepo(repositoryFactory, coreRestangular) {
		/** create the repo */
		var repo = new repositoryFactory('RoleType', coreRestangular);

		/** return the repo */
		return repo;
	}
})();;
/**
 * role.repository
 * @namespace core
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.core').service('role.repository', roleRepo);

	/** injection */
	roleRepo.$inject = ['repositoryFactory', 'CoreRestangular'];

	/** implementation */
	function roleRepo(repositoryFactory, coreRestangular) {
		/** create the repo */
		var repo = new repositoryFactory('Role', coreRestangular);

		/** return the repo */
		return repo;
	}
})();;
(function () {
    'use strict';

    angular.module('nha.core')
        .service('roomRepository', ['repositoryFactory', 'CoreRestangular',
            function (repositoryFactory, CoreRestangular) {
                return new repositoryFactory('Room', CoreRestangular);
            }
        ]);
})();;
/**
 * salutation.repository
 * @namespace core 
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
*/
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('salutationRepository', salutationRepository);

    // protect against minification
    /* @ngInject */
    salutationRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name salutationRepository
    * @description Constructor for assignment.repository
    * @memberOf core
    */
    function salutationRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getAll = getAll;
        service.get = get;       

        return service;

        /**
         * @name getAll
         * @description retrieves salutations from storage
         * @returns List<object> List of objects containing salutations properties
         * @memberOf salutation.repository
         */
        function getAll() {
            return baseService.getList('salutation', null, true, true, CoreRestangular);
        }
        
        /**
         * @name get
         * @description retrieves a salutation from storage
         * @param int salutationID identifier of the salutation object
         * @returns object object containing salutation properties
         * @memberOf salutation.repository
         */
        function get(salutationID) {
            return baseService.getSingle('salutation', { id: salutationID }, true, true, CoreRestangular);
        }    

    }
})();


;
/**
 * schoolAcademicYear.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('schoolAcademicYearRepository', schoolAcademicYearRepository);

    // protect against minification
    /* @ngInject */
    schoolAcademicYearRepository.$inject = ['baseService', 'repositoryFactory', 'CoreRestangular'];

    /**
    * @name schoolAcademicYearRepository
    * @description Constructor for schoolAcademicYear.repository
    * @memberOf core
    */
    function schoolAcademicYearRepository(baseService, repositoryFactory, coreRestangular) {

        //Adding base repository functionality.  Allowing these other methods to tag along.
        var service = new repositoryFactory('SchoolAcademicYear', coreRestangular);;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getBySchoolId = getBySchoolId;
        service.getSchoolsByYear = getSchoolsByYear;
		service.getSchoolsByYearAndState = getSchoolsByYearAndState;
        service.getSchoolByYear = getSchoolByYear;
        service.updateSchoolByYear = updateSchoolByYear;
        service.addSchoolByYear = addSchoolByYear;

        return service;

        /**
         * @name get
         * @description retrieves a schoolAcademicYear from storage by the primary key
         * @returns object Object containing schoolAcademicYear properties
         * @memberOf schoolAcademicYear.repository
         */
        function getBySchoolId(schoolId) {
            var oDataFilter = {
                SchoolID: schoolId
            };

            var params = _utils.getODataRequest({ 'filter': oDataFilter });
            baseService.cache.destroyByObjectKey(params);
            return baseService.getList("schoolacademicyear", params, true, true, coreRestangular);
        }

        function getSchoolsByYear(academicYearId) {
            var oDataFilter = {
                AcademicYearID: academicYearId
            };
            var params = _utils.getODataRequest({ 'filter': oDataFilter, 'orderby': 'School/SchoolName' });
            return baseService.getList('schoolacademicyear', params, true, true, coreRestangular);
        }

		function getSchoolsByYearAndState(academicYearId, stateID) {
			var oDataFilter = {
				AcademicYearID: academicYearId,
				'School/StateID': stateID
			};
			var params = _utils.getODataRequest({ 'filter': oDataFilter, 'orderby': 'School/SchoolName' });
			return baseService.getList('schoolacademicyear', params, true, true, coreRestangular);
		};

		function getSchoolByYear(schoolId, academicYearId) {
            var oDataFilter = {
                SchoolID: schoolId,
                AcademicYearID: academicYearId
            };
            var params = _utils.getODataRequest({ 'filter': oDataFilter });
            return baseService.getList('schoolacademicyear', params, true, true, coreRestangular);
        }

        function updateSchoolByYear(school) {
            //TODO: Remove params when we fix caching
            var oDataFilter = {
                SchoolID: school.schoolID,
                AcademicYearID: school.academicYearID
            };
            var params = _utils.getODataRequest({ 'filter': oDataFilter });
            return baseService.put('schoolacademicyear', school, school.schoolAcademicYearID, true, coreRestangular, params);
        }

        function addSchoolByYear(school) {
            return coreRestangular.all('schoolacademicyear').post(school);
        }


    }
})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('schoolDateService', ['repositoryFactory', 'CoreRestangular', 'baseService',
           function (repositoryFactory, coreRestangular, baseService) {
               var repo = new repositoryFactory('SchoolDate', coreRestangular);

               repo.getActiveSchoolDates = getActiveSchoolDates;

               function getActiveSchoolDates(schoolId, academicYearId, beginDate, endDate) {

                   var beginDateStr = beginDate.format('YYYY-MM-DD');
                   var endDateStr = endDate.format('YYYY-MM-DD');

                   var filter = "?$filter=SchoolID+eq+" + schoolId + "+and+AcademicYearID+eq+" + academicYearId + "+and+IsCancelled+ne+true+and+Date+ge+datetime'" + beginDateStr + "'+and+Date+le+datetime'" + endDateStr + "'";

                   return baseService.getList("SchoolDate" + filter, {}, false, false, coreRestangular)
               }

               return repo;
           }
       ]);
})(); ;
/**
 * school-form.repository
 * @namespace core
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.core').service('school-form.repository', schoolFormRepo);

	/** setup injection */
	schoolFormRepo.$inject = ['repositoryFactory', 'CoreRestangular'];

	/** implement the repo */
	function schoolFormRepo(repositoryFactory, coreRestangular) {
		/** create the repo */
		var repo = new repositoryFactory('SchoolForm', coreRestangular);

		/** add the method */
		repo.getBySchoolAndYear = getBySchoolAndYear;

		/** get school forms by school id and academic year id */
		function getBySchoolAndYear(schoolID, academicYearID){
			return coreRestangular.all('schoolform').customGET(academicYearID + '/' + schoolID).then(function(schoolForms){
				return schoolForms;
			});
		}

		/** return the repo */
		return repo;
	}
})();;
(function () {
    'use strict';

    angular.module('nha.core')
        .service('schoolGradeLevelSectionRepository', ['repositoryFactory', 'CoreRestangular',
            function (repositoryFactory, CoreRestangular) {
                return new repositoryFactory('SchoolGradeLevelSection', CoreRestangular);
            }
        ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('schoolGradeLevelService', ['baseService', 'CoreRestangular',

    function (baseService, coreRestangular) {
        var svc = {
            get: get
        };

        return svc;

        function get(schoolId, academicYearId) {
            var filter = {};

            if (!_.isUndefined(schoolId)) {
                filter.SchoolID = schoolId;
            }

            if (!_.isUndefined(academicYearId)) {
                filter.AcademicYearID = academicYearId;
            }

            return baseService.getList('SchoolGradeLevel', _utils.getODataRequest({ filter: filter }), true, true, coreRestangular);
        }
    }]);

})();;
/**
 * schoolInstructionalAcademicYear.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('schoolInstructionalAcademicYearRepository', schoolInstructionalAcademicYearRepository);

    // protect against minification
    /* @ngInject */
    schoolInstructionalAcademicYearRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name schoolInstructionalAcademicYearRepository
    * @description Constructor for schoolInstructionalAcademicYear.repository
    * @memberOf core
    */
    function schoolInstructionalAcademicYearRepository(baseService, coreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getSchoolInstructionalAcademicYears = getSchoolInstructionalAcademicYears;
        service.getByAcademicYearAndSchool = getByAcademicYearAndSchool;

        return service;

        /**
         * @name get
         * @description retrieves a list of schoolInstructionalAcademicYear from storage by schoolId
         * @returns object Object containing schoolInstructionalAcademicYear properties
         * @memberOf schoolInstructionalAcademicYear.repository
         */
        function getSchoolInstructionalAcademicYears(schoolId) {
            return baseService.getList("schoolinstructionalacademicyear", { $filter: "SchoolID eq " + schoolId }, true, true, coreRestangular);
        }


        function getByAcademicYearAndSchool(academicYearId, schoolId) {
            var oDataParameters = _utils.getODataRequest({
                filter: {
                    AcademicYearID: academicYearId,
                    SchoolID: schoolId
                }
            });

            return baseService.getList('SchoolInstructionalAcademicYear', oDataParameters, true, true, coreRestangular);
        }

    }
})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('schoolMarkingPeriodCombinedService', ['baseService', 'CoreRestangular',

    function (baseService, coreRestangular) {

        var svc = {
            get: get,
            getByAcademicYear: getByAcademicYear,
            getByStudentInSchool: getByStudentInSchool,
            getByCourseSection: getByCourseSection,
            getByCourseSectionGroup: getByCourseSectionGroup,
            getBySchoolIdsAndAcademicYear: getBySchoolIdsAndAcademicYear
        };

        return svc;

        function get(schoolId, academicYearId, isDisplayedInFilters) {
            var filter = {};

            if (!_.isUndefined(schoolId)) {
                filter.SchoolID = schoolId;
            }

            if (!_.isUndefined(academicYearId)) {
                filter.AcademicYearID = academicYearId;
            }

            // by default, we show everything, but if you pass this in, we show only values that are supposed to be shown in filters/dropdowns
            if (isDisplayedInFilters) {
                filter.isDisplayedInFilters = isDisplayedInFilters;
            }

            return baseService.getList('SchoolMarkingPeriodCombined', _utils.getODataRequest({ filter: filter }), true, true, coreRestangular);
        }

        function getByAcademicYear(academicYearId) {
            var filter = {};

            if (!_.isUndefined(academicYearId)) {
                filter.AcademicYearID = academicYearId;
            }

            return baseService.getList('SchoolMarkingPeriodCombined', _utils.getODataRequest({ filter: filter }), true, true, coreRestangular);
        }

        function getByStudentInSchool(studentInSchoolId) {
            return baseService.getList('SchoolMarkingPeriodCombined/GetByStudentInSchool/' + studentInSchoolId, null, true, true, coreRestangular);
        }

        function getByCourseSection(courseSectionID) {
            return baseService.getList('SchoolMarkingPeriodCombined/GetByCourseSection/' + courseSectionID, null, true, true, coreRestangular);
        }

        function getByCourseSectionGroup(courseSectionGroupID) {
            return baseService.getList('SchoolMarkingPeriodCombined/GetByCourseSectionGroup/' + courseSectionGroupID, null, true, true, coreRestangular);
        }

        function getBySchoolIdsAndAcademicYear(schoolIds, academicYearId) {
            var filter = {};

            if (!_.isUndefined(schoolIds)) {
                filter.schoolIds = _.isArray(schoolIds) ? schoolIds : [schoolIds];
            }

            return baseService.getList('SchoolMarkingPeriodCombined/GetBySchoolIdsAndAcademicYear/' + academicYearId, filter, true, true, coreRestangular);
        }
    }]);

})();;
(function () {
    'use strict';

    angular.module('nha.core').service('schoolMarkingPeriodManager', ['baseService', 'CoreRestangular', 'schoolMarkingPeriodService', '$q',

    function (baseService, coreRestangular, schoolMarkingPeriodService, $q) {
        var service = this;

        service.getCurrentSchoolMarkingPeriod = getCurrentSchoolMarkingPeriod;

        /*
         * @description Get current marking period for school
         */
        function getCurrentSchoolMarkingPeriod(schoolId, academicYearId) {
            var deferred = $q.defer();

            var now = moment();

            schoolMarkingPeriodService.get(schoolId, academicYearId).then(function (results) {
                var currentMarkingPeriod = _.find(results, function (schoolMarkingPeriod) {
                    return moment(schoolMarkingPeriod.beginDate).isBefore(now)
                        && moment(schoolMarkingPeriod.endDate).isAfter(now);
                });

                deferred.resolve(currentMarkingPeriod);
            });

            return deferred.promise;
        }
    }]);

})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('schoolMarkingPeriodService', ['baseService', 'CoreRestangular',

    function (baseService, coreRestangular) {

        var svc = {
            get: get,
            getByAcademicYear: getByAcademicYear,
            getByStudentInSchool: getByStudentInSchool,
            getByCourseSection: getByCourseSection,
            getByCourseSectionGroup: getByCourseSectionGroup,
            getBySchoolIdsAndAcademicYear: getBySchoolIdsAndAcademicYear
        };

        return svc;

        function get(schoolId, academicYearId, isDisplayedInFilters) {
            var filter = {};

            if (!_.isUndefined(schoolId)) {
                filter.SchoolID = schoolId;
            }

            if (!_.isUndefined(academicYearId)) {
                filter.AcademicYearID = academicYearId;
            }

            // by default, we show everything, but if you pass this in, we show only values that are supposed to be shown in filters/dropdowns
            if (isDisplayedInFilters) {
                filter.isDisplayedInFilters = isDisplayedInFilters;
            }

            return baseService.getList('SchoolMarkingPeriod', _utils.getODataRequest({ filter: filter }), true, true, coreRestangular);
        }

        function getByAcademicYear(academicYearId) {
            var filter = {};
            
            if (!_.isUndefined(academicYearId)) {
                filter.AcademicYearID = academicYearId;
            }

            return baseService.getList('SchoolMarkingPeriod', _utils.getODataRequest({ filter: filter }), true, true, coreRestangular);
        }

        function getByStudentInSchool(studentInSchoolId) {
            return baseService.getList('SchoolMarkingPeriod/GetByStudentInSchool/' + studentInSchoolId, null, true, true, coreRestangular);
        }

        function getByCourseSection(courseSectionID) {
            return baseService.getList('SchoolMarkingPeriod/GetByCourseSection/' + courseSectionID, null, true, true, coreRestangular);
        }

        function getByCourseSectionGroup(courseSectionGroupID) {
            return baseService.getList('SchoolMarkingPeriod/GetByCourseSectionGroup/' + courseSectionGroupID, null, true, true, coreRestangular);
        }

        function getBySchoolIdsAndAcademicYear(schoolIds, academicYearId) {
            var filter = {};

            if (!_.isUndefined(schoolIds)) {
                filter.schoolIds = _.isArray(schoolIds) ? schoolIds : [schoolIds];
            }

            return baseService.getList('SchoolMarkingPeriod/GetBySchoolIdsAndAcademicYear/' + academicYearId, filter, true, true, coreRestangular);
        }
    }]);

})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('schoolYearRepository', ['repositoryFactory','baseService', 'CoreRestangular',
           function (repositoryFactory, baseService, coreRestangular) {
               var repository = new repositoryFactory('SchoolAcademicYear', coreRestangular);

               repository.getSystemCurrentYear = getSystemCurrentYear;
               repository.getByAcademicYearAndSchool = getByAcademicYearAndSchool;

               function getSystemCurrentYear() {
                   return baseService.getList("schoolYear/getSystemCurrentYear", null, true, true, coreRestangular);
               }

               function getByAcademicYearAndSchool(academicYearId, schoolId) {
                   var oDataParameters = _utils.getODataRequest({
                       filter: {
                           AcademicYearID: academicYearId,
                           SchoolID: schoolId
                       }
                   });

                   return baseService.getList('SchoolAcademicYear', oDataParameters, true, true, coreRestangular);
               }

               return repository;
           }
       ]);
})();

;
(function () {
    'use strict';

    angular.module('nha.core').factory('schoolService',
        ['CoreRestangular', 'baseService',

    function (coreRestangular, baseService) {
        var service = {
            get: get, // getsingle
            getSchool: getSchool, // getlist
            getSchools: getSchools,
            getSchoolsForUser: getSchoolsForUser,
            getSchoolsByState: getSchoolsByState,
            getStartEndTimes: getStartEndTimes,
            getSchoolAcademicYears: getSchoolAcademicYears,
            getSchoolAcademicYearsWithDates: getSchoolAcademicYearsWithDates,
            getSchoolInstructionalAcademicYear: getSchoolInstructionalAcademicYear,
            updateSchoolAcademicYear: updateSchoolAcademicYear,
            updateSchool: updateSchool,
            deleteSchool: deleteSchool
        };

        return service;

        function get(schoolID) {
            return getSchool(schoolID);
        }

        function getSchool(schoolId) {
            return baseService.getSingle("school", _utils.getODataRequest({ filter: { SchoolID: schoolId }}), false, true, coreRestangular);
        }

        function getSchools(params) {
            if (params) {
                var oDataFilter = {};
                if (params.academicYearID) {
                    oDataFilter.AcademicYearID = params.academicYearID;
                }
                if (params.stateID) {
                    oDataFilter.StateID = params.stateID;
                }
                if (params.schoolID) {
                    oDataFilter.SchoolID = params.schoolID;
                }
                params = _utils.getODataRequest({ 'filter': oDataFilter });
            }
            return baseService.getList("School", params, false, true, coreRestangular);
        }

        function getSchoolsForUser() {
            return baseService.getList('getschoolsforuser', null, false, true, coreRestangular);
        }

        function getSchoolsByState(stateId) {
            var oDataFilter = {
                StateID: stateId
            };
            var params = _utils.getODataRequest({ 'filter': oDataFilter, 'orderby': 'SchoolName' });
            return baseService.getList('school', params, false, true, coreRestangular);
        }

        function getStartEndTimes(schoolID, academicYearID) {
            var oDataFilter = {
                SchoolID: schoolID,
                AcademicYearID: academicYearID
            };

            var params = _utils.getODataRequest({ 'filter': oDataFilter });
            return baseService.getSingle('schoolstartendtime', params, true, true, coreRestangular);
        }

        function getSchoolAcademicYears(schoolID) {
            var oDataFilter = {
                SchoolID: schoolID
            };

            var params = _utils.getODataRequest({ 'filter': oDataFilter });
            return baseService.getList("schoolacademicyear", params, true, true, coreRestangular);
        }

        // Call in to SchoolInstructionalAcademicYears to get start date of first marking period and end date of last marking period
        // Did this to keep support of having BeginDate and EndDate on SchoolAcademicYears after they were removed from the table
        function getSchoolAcademicYearsWithDates(schoolID) {
            var oDataFilter = {
                SchoolID: schoolID
            };

            var params = _utils.getODataRequest({ 'filter': oDataFilter });

            return baseService.getList("schoolinstructionalacademicyear", params, true, true, coreRestangular).then(function(schoolInstYears) {
                return baseService.getList("schoolacademicyear", params, true, true, coreRestangular).then(function(schoolYears) {
                    return _.merge(schoolInstYears, schoolYears);
                });
            });
        }

        function getSchoolInstructionalAcademicYear(schoolId, academicYearId) {
            var oDataFilter = {
                SchoolID: schoolId,
                AcademicYearID: academicYearId
            };

            var params = _utils.getODataRequest({ 'filter': oDataFilter });

            return baseService.getList("schoolinstructionalacademicyear", params, true, true, coreRestangular);
        }

        function updateSchoolAcademicYear(schoolAcademicYear) {
            return baseService.put('schoolacademicyear', schoolAcademicYear, schoolAcademicYear.schoolAcademicYearID, true, coreRestangular);
        }

        function updateSchool(school) {
            return baseService.put('school', school, school.schoolID, true, coreRestangular);
        }

        function deleteSchool(parms) {
            return coreRestangular.remove(parms);
        }

    }]);
})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('screenFieldUsageRepository', ['repositoryFactory','baseService', 'CoreRestangular',
           function (repositoryFactory, baseService, coreRestangular) {
               var repository = new repositoryFactory('ScreenFieldUsage', coreRestangular);

               //repository.getSystemCurrentYear = getSystemCurrentYear;
               //repository.getByAcademicYearAndSchool = getByAcademicYearAndSchool;

               //function getSystemCurrentYear() {
               //    return baseService.getList("schoolYear/getSystemCurrentYear", null, true, true, coreRestangular);
               //}

               //function getByAcademicYearAndSchool(academicYearId, schoolId) {
               //    var oDataParameters = _utils.getODataRequest({
               //        filter: {
               //            AcademicYearID: academicYearId,
               //            SchoolID: schoolId
               //        }
               //    });

               //    return baseService.getList('SchoolAcademicYear', oDataParameters, true, true, coreRestangular);
               //}

               return repository;
           }
       ]);
})();

;
(function () {
    'use strict';

    angular.module('nha.core').factory('staffImageService', ['CoreRestangular', 'baseService',

    function (CoreRestangular, baseService) {
        var svc = {
            get: get

        };

        return svc;

        function get(id) {
            return baseService.getList('StaffImage', { id: id }, false, true, CoreRestangular);
        }

    }]);

})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('staffPositionSchoolSummaryRepository', ['repositoryFactory', 'CoreRestangular',
           function (repositoryFactory, coreRestangular) {
               return new repositoryFactory('StaffPositionSchoolSummary', coreRestangular);
           }
       ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('staffPositionRepository', ['CoreRestangular', 'baseService',

    function (CoreRestangular, baseService) {
        var svc = {
            getAll: getAll
        };

        return svc;

        function getAll(parameters) {
            return baseService.getList('StaffPosition', _utils.getODataRequest({ filter: parameters }), true, true, CoreRestangular);
        }
    }]);

})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('staffService', ['CoreRestangular', 'baseService',

    function (CoreRestangular, baseService) {
        var svc = {
            get: get,
            getAll: getAll,
            getBySchool: getBySchool,
            getAvatar: getAvatar
        };

        return svc;

        function get(staffId) {
            return baseService.getList('Staff', { id: staffId }, true, true, CoreRestangular);
        }

        function getAll(parameters) {
            return baseService.getList('Staff', _utils.getODataRequest({ filter: parameters }), true, true, CoreRestangular);
        }

        function getBySchool(schoolId) {
            return baseService.getList('staff/getbyschool/' + schoolId, null, true, true, CoreRestangular);
        }

        function getAvatar(staffId, size) {
            if (!size) {size = 60;}
            return baseService.getSingle('staff/' + staffId + '/avatar/' + size, null, true, true, CoreRestangular);
        }

    }]);

})();;
/**
 * state-academic-year.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('stateAcademicYearRepository', stateAcademicYearRepository);

    // protect against minification
    /* @ngInject */
    stateAcademicYearRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name stateAcademicYearRepository
    * @description Constructor for state-academic-year.repository
    * @memberOf core
    */
    function stateAcademicYearRepository(baseService, coreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getByAcademicYearId = getByAcademicYearId;
        service.getByStateId = getByStateId;
        service.post = post;
        service.put = put;
        service.remove = remove;

        return service;

        function remove(stateAcademicYearId) {
            return coreRestangular.one('stateAcademicYear', stateAcademicYearId).remove();
        }

        /**
         * @name getByAcademicYearId
         * @description retrieves list of stateAcademicYears by academicYearId from storage
         * @returns List<object> List of objects containing a subset of stateAcademicYear properties
         * @memberOf state-academic-year.repository
         */
        function getByAcademicYearId(academicYearId) {
            var oDataFilter = {
                AcademicYearID: academicYearId
            };
            var params = _utils.getODataRequest({ 'filter': oDataFilter, 'orderby': 'State/Name' });
            return baseService.getList('stateacademicyear', params, false, true, coreRestangular);
        }
        /**
         * @name getByStateId
         * @description retrieves list of stateAcademicYears by stateId from storage
         * @returns List<object> List of objects containing a subset of stateAcademicYear properties
         * @memberOf state-academic-year.repository
         */
        function getByStateId(stateId) {
            var oDataFilter = {
                StateID: stateId
            };

            var params = _utils.getODataRequest({ 'filter': oDataFilter });
            baseService.cache.destroyByObjectKey(params);
            return baseService.getList("stateacademicyear", params, true, true, coreRestangular);
        }

        /**
         * @name post
         * @description adds a stateAcademicYear to storage
         * @returns undefined
         * @memberOf state-academic-year.repository
         */
        function post(state) {
            return coreRestangular.all('stateacademicyear').post(state);
        }

        /**
         * @name put
         * @description updates a stateAcademicYear to storage
         * @returns undefined
         * @memberOf state-academic-year.repository
         */
        function put(state) {
            return baseService.put('stateacademicyear', state, state.stateAcademicYearID, true, coreRestangular);
        }

    }

})();;
angular.module("nha.core").service("stateTransitionSecurityCheck", [
	"$state",
	"$q",
	"$rootScope",
	"apiSecurityService",
	"appSettings",
	"Restangular",
	"apiResolutionService",
	"$location",
	"$timeout",
	function (
		$state,
		$q,
		$rootScope,
		apiSecurityService,
		appSettings,
		restangular,
		apiResolutionService,
		$location,
		$timeout
	) {
		$rootScope.forbiddenStateName = "403";

		var service = {
			attachStateChangeListener: attachStateChangeListener,
			resolveAuthorization: resolveAuthorization,
			goToForbiddenState: goToForbiddenState,
		};
		return service;

		function goToForbiddenState() {
			if ($state.get($rootScope.forbiddenStateName)) {
				$state.go($rootScope.forbiddenStateName);
			} else if (appSettings && appSettings.defaultState) {
				$state.go(appSettings.defaultState);
			} else {
				// redirect to root of application
				$location.path("/");
			}
		}

		function isAuthorized(requiredResource, api) {
			if (!requiredResource) {
				return false;
			}

			const resources = requiredResource.split(',');

			// Make sure current user has access to security claim required for this state
			var apiRestangular = api
				? apiResolutionService.getApiByName(api) // if an api is specified, get it
				: restangular; // otherwise  use the modules default

			var allRequests = [];

			_.forEach(resources, function(resource) {
				if (resource.contains('|')) {
					allRequests.push(apiSecurityService.hasSaviyntEntitlement(resource))
				} else {
					// split by resource:action
					var action = "Get"; // default to :Get when not included
					if (resource.indexOf(":") > -1) {
						var splitText = resource.split(":");
						resource = splitText.shift();
						action = splitText.join(":");
					}

					allRequests.push(apiSecurityService.isAccessAllowed(resource, action, apiRestangular))
				}
			})

			return $q.all(allRequests).then(function (results) {
				return _.find(results, function (x) { return x; });
		});
		}

		function resolveAuthorization(requiredResource, api) {
			return isAuthorized(requiredResource, api).then(function (result) {
				//	check resource authorization
				if (result) {
					//	resolve/promise continuation
					return $q.when();
				} else {
					//	wait for promise to be rejected, then go to forbidden
					$timeout(function () {
						goToForbiddenState(); //	this code runs after the resolve promise has been rejected.
					});

					//	resolve/promise rejection
					return $q.reject();
				}
			});
		}

		function attachStateChangeListener(forbiddenStateName) {
			$rootScope.forbiddenStateName =
				forbiddenStateName || $rootScope.forbiddenStateName;

			$rootScope.$on(
				"$stateChangeStart",
				function (e, toState, toParams, fromState, fromParams) {
					if (
						!toState ||
						!toState.data ||
						!toState.data.security ||
						!toState.data.security.requiredResource
					) {
						log(
							"No requiredResource setup for " +
								toState.name +
								', security check not run.  The ui route would need "data.security.requiredResource" defined. Example:  Students:Get or Students (defaults to Get) '
						);
						return;
					}

					log('[c="color: purple"]toState.data[c]', toState.data);

					isAuthorized(
						toState.data.security.requiredResource,
						toState.data.security.api
					).then(function (result) {
						if (result) {
							log(
								"State change validation successful for " +
									toState.name
							);
						} else {
							log(
								"User does not have permission to navigate to " +
									toState.name +
									"! Required Resource checked:'" +
									toState.data.security.requiredResource +
									"'"
							);
							e.preventDefault();
							goToForbiddenState();
						}
					});
				}
			);
		}
	},
]);
;
/**
 * state.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('stateRepository', stateRepository);

    // protect against minification
    /* @ngInject */
    stateRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name stateRepository
    * @description Constructor for state.repository
    * @memberOf core
    */
    function stateRepository(baseService, coreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.get = get;
        service.getAll = getAll;
        service.getSchoolsForStateByAcademicYear = getSchoolsForStateByAcademicYear;

        return service;

        /**
         * @name get
         * @description retrieves a state from storage by the primary key
         * @returns object Object containing state properties
         * @memberOf state.repository
         */
        function get(stateId) {
            return baseService.getList('state', { id: stateId }, true, true, coreRestangular);
        }

        /**
         * @name getAll
         * @description retrieves list of states from storage
         * @returns List<object> List of objects containing a subset of state properties
         * @memberOf state.repository
         */
        function getAll() {
            var params = _utils.getODataRequest({ 'orderby': 'Name' });
            return baseService.getList('state', params, true, true, coreRestangular);
        }
        /**
         * @name getSchoolsForStateByAcademicYear
         * @description retrieves a list of states and child schools from storage by academic year
         * @returns List<object> Object containing a list of states and child schools properties
         * @memberOf state.repository
         */
        function getSchoolsForStateByAcademicYear(academicYearId) {
            return baseService.getList('state/getSchoolsForStateByAcademicYear/' + academicYearId, null, true, true, coreRestangular);
        }

    }

})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('studentInSchoolRepository', ['repositoryFactory', 'CoreRestangular',
           function (repositoryFactory, coreRestangular) {
               return new repositoryFactory('StudentInSchool', coreRestangular);
           }
       ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core').factory('studentInSchoolService',
        ['CoreRestangular', 'baseService',

    function (CoreRestangular, baseService) {
        var service = {
            get: get,
            getAllForStudentByStudentInSchool: getAllForStudentByStudentInSchool,
            getByStudentID: getByStudentID,
            getByStudentIDandYear: getByStudentIDandYear
        };

        return service;

        function get(studentInSchoolId) {
            return baseService.getSingle('StudentInSchool', { id: studentInSchoolId }, true, true, CoreRestangular);
        }

        function getAllForStudentByStudentInSchool(studentInSchoolId) {
            return baseService.getList('StudentInSchool/GetAllForStudentByStudentInSchool/' + studentInSchoolId, null, true, true, CoreRestangular);
        }

        function getByStudentID(academicYearID, studentID) {
            return baseService.getSingle('StudentInSchool', { StudentID: studentID, AcademicYearID: academicYearID }, true, true, CoreRestangular);
        }
        
        function getByStudentIDandYear(academicYearID, studentID) {
            return baseService.getList('StudentInSchool', { StudentID: studentID, AcademicYearID: academicYearID }, true, true, CoreRestangular);
        }


    }]);

})();;
/**
 * student-status-history.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('studentStatusHistoryRepository', studentStatusHistoryRepository);

    // protect against minification
    /* @ngInject */
    studentStatusHistoryRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name studentStatusHistoryRepository
    * @description Constructor for student-status-history.repository
    * @memberOf core
    */
    function studentStatusHistoryRepository(baseService, CoreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.getStudentStatusHistories = getStudentStatusHistories;

        return service;

        /**
         * @name getStudentStatusHistories
         * @description retrieves student status histories from storage
         * @returns List<object> List of objects containing a subset of student status history properties
         * @memberOf student-status-history.repository
         */
        function getStudentStatusHistories(studentInSchoolId) {
            return null; // baseService.getList('studentStatusHistory', { $filter: { studentInSchoolID: studentInSchoolId } }, true, true, CoreRestangular);
        }

    }
})();;
(function () {
    'use strict';

    angular.module('nha.core')
       .service('studentRepository', ['repositoryFactory', 'CoreRestangular',
           function (repositoryFactory, coreRestangular) {
               return new repositoryFactory('Student', coreRestangular);
           }
       ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core')
        .service('termService', ['baseService', 'MasterSchedulingRestangular',
            function (baseService, masterSchedulingRestangular) {

                var service = {
                    termDisplay: termDisplay
                };

                return service;

                function termDisplay(s, schoolMarkingPeriods) {

                    if (s && s.markingPeriods) {

                        // unique list of marking periods
                        var markingPeriods = _.map(schoolMarkingPeriods, 'markingPeriod');

                        if (markingPeriods) {
                            // get list of school marking periods that match our row
                            var courseSchoolMarkingPeriods = _.filter(schoolMarkingPeriods, function (smp) {
                                return _.includes(s.markingPeriods, smp.markingPeriodID);
                            });

                            if (courseSchoolMarkingPeriods) {
                                var markingPeriodGroup = _.head(courseSchoolMarkingPeriods);
                                if (markingPeriodGroup && markingPeriodGroup.markingPeriod) {
                                    // get our MarkingPeriodGroupId off of any record, the first will do, since they should all be the same
                                    var markingPeriodGroupId = markingPeriodGroup.markingPeriod.markingPeriodGroupID;

                                    // count the number of records that we have MarkingPeriodGroup, that should be the total possible for that AY/School
                                    var count = _.filter(markingPeriods, { markingPeriodGroupID: markingPeriodGroupId }).length;

                                    // if the number of items in the two matches the number totally available, then that means we have all of them, so return 'Year'
									// also have to check to see if it is a recapture group, because we'll want to show the short name then
                                    if (courseSchoolMarkingPeriods.length === count && markingPeriodGroupId !== 9) {
                                        return 'Year';
                                    } else {
                                        return _.map(courseSchoolMarkingPeriods, 'markingPeriodShortName').join(', ');
                                    }
                                }
                            }
                        }
                    }
                }
            }
        ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core').service('uiAlertService', uiAlertService);

    uiAlertService.$inject = ['toastr', 'toastrConfig', '$q'];

    function uiAlertService(toastr, toastrConfig, $q) {

        function success(message, title, optionOverrides, toastrConfigOverrides) {
            // default these values, so you don't need to send anything in
            title = title || 'Success'; // TODO: Consider defaulting to no title, if not provided - EdLang
            message = message || 'Changes were saved successfully.';
            
            // send to main toastr
            toast(message, title, 'success', optionOverrides, toastrConfigOverrides);
        }

        function info(message, title, optionOverrides, toastrConfigOverrides) {
            // default these values, so you don't need to send anything in
            title = title || 'Info'; // TODO: Consider defaulting to no title, if not provided - EdLang
            message = message || 'Saving changes...';

            // send to main toastr
            toast(message, title, 'info', optionOverrides, toastrConfigOverrides);
        }

        function warning(message, title, optionOverrides, toastrConfigOverrides) {
            // default these values, so you don't need to send anything in
            title = title || 'Warning'; // TODO: Consider defaulting to no title, if not provided - EdLang
            message = message || 'There was an issue saving changes.';

            // send to main toastr
            toast(message, title, 'warning', optionOverrides, toastrConfigOverrides);
        }

        function error(message, title, error, optionOverrides, toastrConfigOverrides) {
            // default these values, so you don't need to send anything in
            title = title || 'Error'; // TODO: Consider defaulting to no title, if not provided - EdLang
            message = message || 'There was an error saving changes.';

            // this is the javascript error we catch 
            if (error) {
                message = error.message;
            }

            // send to main toastr
            toast(message, title, 'error', optionOverrides, toastrConfigOverrides);
        }

        function toast(message, title, toastType, optionOverrides, toastrConfigOverrides) {
            // default toastr options
            var _options = {
                closeButton: true,
                debug: false,
                extendedTimeOut: '1000',
                hideDuration: '1000',
                hideEasing: 'linear',
                hideMethod: 'fadeOut',
                onclick: null,
                progressBar: false, // progress bar for this toast notification
                showDuration: '300',
                showEasing: 'swing',
                showMethod: 'fadeIn',
                timeOut: '5000'
            };

            // default toastrConfig options
            var _toastrConfig = {
                allowHtml: false,
                autoDismiss: false,
                closeButton: false,
                closeHtml: '<button>&times;</button>',
                containerId: 'toast-container',
                extendedTimeOut: 1000,
                iconClasses: {
                    error: 'toast-error',
                    info: 'toast-info',
                    success: 'toast-success',
                    warning: 'toast-warning'
                },
                maxOpened: 0,
                messageClass: 'toast-message',
                newestOnTop: false,
                onHidden: null,
                onShown: null,
                onTap: null,
                positionClass: 'toast-bottom-left',
                preventDuplicates: false,
                preventOpenDuplicates: false,
                progressBar: false, // progress bar for ??? Seems to work as well as toastrOptions.progressBar. Need further investigation.
                tapToDismiss: true,
                target: 'body',
                templates: {
                    toast: 'directives/toast/toast.html',
                    progressbar: 'directives/progressbar/progressbar.html'
                },
                timeOut: 5000,
                titleClass: 'toast-title',
                toastClass: 'toast'
            };

            // override passed in toastrConfig overrides
            if (toastrConfigOverrides) {
                _toastrConfig = _.assign(_toastrConfig, toastrConfigOverrides);
            }

            // override injected toastrConfig entries within toastr 
            if (_toastrConfig) {
                toastrConfig = _.assign(toastrConfig, _toastrConfig);
            }

            // if we want to overide, merge our objects
            if (optionOverrides) {
                _options = _.assign(_options, optionOverrides);
            }

            // set the toastr options
            toastr.options = _options;
            
            // default our values if they don't exist
            title = title || 'Success'; // TODO: Consider defaulting to no title, if not provided - EdLang
            message = message || 'Changes were saved successfully.';
            
            // default to success
            if (!toastType) {
                toastType = 'success';
            }

            // send the toastr (note: expects message, title parameter order)
            switch (toastType) {
                case 'error':
                    toastr.error(message, title, _options);
                    break;
                case 'warning':
                    toastr.warning(message, title, _options);
                    break;
                case 'info':
                    toastr.info(message, title, _options);
                    break;
                case 'success':
                default:
                    toastr.success(message, title, _options);
            }
        }

        function alert(options) {
            if (options.message && options.title) {
                swal(options.message, options.title);
            }
            else if(options.message && !options.title) {
                swal(options.message);
            }
        }

        function prompt(message, title) {
            var deferred = $q.defer();

            swal({
                title: title || "Are you sure?",
                text: message,
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes",
                closeOnConfirm: true
            }, function () {
                deferred.resolve(true);
            });

            return deferred.promise;
        }

        return {
            success: success,
            info: info,
            warning: warning,
            fail: error, // alias
            error: error, 
            toast: toast,
            alert: alert,
            prompt: prompt
        };
    }

})();;
var UserContextService = {
	ensureUserContext: function () {
		return new Promise(function(resolve) {
			if (window.userContext) {
				resolve(window.userContext);
				return;
			}

			var userService = myNHA.GetApiService('Account', 'UserService');
			userService.get(null, null, false).then(function(user) {
				user = UserContextService.modifyUserObjectForBackwardsCompatibility(JSON.parse(user));
				window.userContext = user;
				resolve(window.userContext);
			});
		});
	},

	getUserContext: function () {
		return window.userContext;
	},

	modifyUserObjectForBackwardsCompatibility: function (user) {
		user['common_name'] = user.fullName;
		user['family_name'] = user.lastName;
		user['given_name'] = user.firstName;
		user['nameid'] = user.username;
		user['unique_name'] = user.username;
		user['winaccountname'] = user.username;

		user['role'] = user.roles.map(function(r) {
			return r.roleName;
		});

		var department = user.roles.find(function(r) {
			return r.roleType === 'Department';
		})
		if (department) {
			user['http://schemas.mynha.com/ILM/Department'] = department.roleName;
		}

		user['http://schemas.mynha.com/AtSchool/SchoolID'] = user.schoolIDs;
		user['http://schemas.mynha.com/ILM/LocationID'] = user.locationID;
		user['http://schemas.mynha.com/ILM/SchoolID'] = user.schoolIDs;
		user['http://schemas.mynha.com/ILM/Title'] = user.jobTitle;
		user['http://schemas.mynha.com/ILM/UserGuid'] = user.userGuid;
		user['http://schemas.mynha.com/SIS/Core/StaffID'] = user.staffID;
		user['http://schemas.mynha.com/Savyint/Location'] = '';
		user['http://schemas.mynha.com/Savyint/UserID'] = user.userID;

		return user;
	},

	getDefaultSchool: function () {
		var context = UserContextService.getUserContext();
		var schools = context["http://schemas.mynha.com/ILM/SchoolID"];

		if (_.isArray(schools)) {
			return _.parseInt(_.head(schools));
		}

		return _.parseInt(schools);
	},

	getStaffId: function () {
		var context = UserContextService.getUserContext();
		var staffId = context["http://schemas.mynha.com/SIS/Core/StaffID"];

		if (staffId) {
			return _.parseInt(staffId);
		} else {
			return null;
		}
	},

	doesUserHaveRole: function (role) {
		var doesHaveRole = false;
		var context = UserContextService.getUserContext();

		if (Array.isArray(context.role)) {
			if (context.role.indexOf(role) > -1) {
				doesHaveRole = true;
			}
		} else {
			if (context.role == role) {
				doesHaveRole = true;
			}
		}

		return doesHaveRole;
	}
};

angular.module('nha.core').service('userContextService', function () {
	return UserContextService;
});;
/**
 * wing.repository
 * @namespace core
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('wingRepository', wingRepository);

    // protect against minification
    /* @ngInject */
    wingRepository.$inject = ['baseService', 'CoreRestangular'];

    /**
    * @name wingRepository
    * @description Constructor for wing.repository
    * @memberOf core
    */
    function wingRepository(baseService, coreRestangular) {

        /*jshint validthis: true */
        var service = this;

        // Service methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the service can be used 
        service.get = get;
        service.getAll = getAll;
        service.getGradeLevelWingsMap = getGradeLevelWingsMap;

        return service;

        /**
         * @name get
         * @description retrieves a wing from storage by the primary key
         * @returns object Object containing wing properties
         * @memberOf wing.repository
         */
        function get(wingId) {
            return baseService.getList('wing', { wingID: wingId }, true, true, coreRestangular);
        }

        /**
         * @name getAll
         * @description retrieves list of wings from storage
         * @returns List<object> List of objects containing a subset of wing properties
         * @memberOf wing.repository
         */
        function getAll() {
            return baseService.getList('wing', {}, true, true, coreRestangular);
        }
        /**
         * @name getGradeLevelWingsMap
         * @description creates a manual mapping of grade levelids to wing id - // TODO: Confirm: PRESUME THIS TO BE TEMPORARY
         * @returns List<object> List of objects containing a subset of wing properties
         * @memberOf wing.repository
         */
        function getGradeLevelWingsMap() {
            var map =
                [
                    { 'gradeLevelId': 1, 'wingId': 1 },
                    { 'gradeLevelId': 2, 'wingId': 1 },
                    { 'gradeLevelId': 3, 'wingId': 1 },
                    { 'gradeLevelId': 4, 'wingId': 2 },
                    { 'gradeLevelId': 5, 'wingId': 2 },
                    { 'gradeLevelId': 6, 'wingId': 2 },
                    { 'gradeLevelId': 7, 'wingId': 3 },
                    { 'gradeLevelId': 8, 'wingId': 3 },
                    { 'gradeLevelId': 9, 'wingId': 3 },
                    { 'gradeLevelId': 322, 'wingId': 1 },
                    { 'gradeLevelId': 323, 'wingId': 1 },
                    { 'gradeLevelId': 399, 'wingId': 1 },
                    { 'gradeLevelId': 403, 'wingId': 1 }
                ];
            return map;
        }

    }

})();;
/**
 * message.manager
 * @namespace core
 */

(function () {
	'use strict';

	/** add model */
	angular.module('nha.core').service('message.manager', messageManager);

	/** setup injection */
	messageManager.$inject = ['pub-sub.factory'];

	/** implement the model */
	function messageManager(pubSubFactory) {
		/** create pub sub manager */
		var pubSubManager = new pubSubFactory(['message'], 'memory', 'core');

		/** add an empty message */
		pubSubManager.addData('message', { 'key': null, 'value': null });

		/** return the pub sub */
		return pubSubManager;
	}
})();;
(function () {
    'use strict';

    // sample usage: <bind-lookup watch-expression="states" result="state" find="{ID: householdObject.stateID)">{{state.Name}}</bind-lookup> 
    // $attrs.lookup: collection of objects to search based on the find expression. During an async web service call populating the collection, a $watch() will wait for the data to be retrieved.
    // $attrs.find: expression that returns a boolean indicating the row is a match in the call to _.find()
    // $attrs.result: name of the object returned from the call to _.find()
    angular
        .module('nha.core')
        .directive('bindLookup', bindLookupDirective);

    function bindLookupDirective() {
        var directive = {
            transclude: true,
            template: '<ng-transclude />',
            scope: false, //Inherited scope so we can watch on parent scope for changes to lookup
            link: bindLookupLink,
            controller: bindLookupController
        }
        return directive;

        function bindLookupLink(scope, element, attrs, ctrl, transclude) {

        }
    }
    
    bindLookupController.$inject = ['$scope', '$attrs'];
    
    function bindLookupController($scope, $attrs) {
        function setResult() {
            if ($attrs.find) {
                $scope.find = $scope.$eval($attrs.find);
            }
            if ($attrs.lookup) {
                $scope.lookup = $scope.$eval($attrs.lookup);
            }
            if ($attrs.result && 
                $scope.find && JSON.stringify($scope.find) !== '{}'
                && $scope.lookup) {
                $scope[$attrs.result] = _.find($scope.lookup, $scope.find);
            }
        }

        if ($attrs.lookup && $attrs.find && $attrs.result) {
            setResult();

            $scope.$watch($attrs.lookup, function (newVal, oldVal) {
                setResult();
            });
            $scope.$watch($attrs.find, function (newVal, oldVal) {
                setResult();
            });
        }
    }

})();;
(function () {
    'use strict';

    angular.module('nha.core').directive('businessResponse', ['$timeout', '$parse', 'appSettings', function ($timeout, $parse, appSettings) {
        return {
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/business-response/business-response.html',
            scope: {
                businessResponse: '='
            },
            link: function(scope, el, attrs) {
                scope.showRuleAlert = function (rule) {
                    //Show only if not a overrideable warning.  If overrideable warning, only show if there are no errors.
                    return rule.ruleSeverity !== "Warning" || !_(scope.businessResponse.operationResult.rules).reject('criteriaMet').some({ 'ruleSeverity': 'Error' });
                }
            }
        }
    }]
    );

})();;
(function () {
    'use strict';

    angular.module('nha.core')
    .directive('tableSort', function () {
        return {
            scope: {
                sortExpression: '=?',
                sortChanged: '&'
            },
            controller: ['$scope', '$timeout' ,function ($scope, $timeout) {
                $scope.headings = [];
                if(!$scope.sortExpression)
                {
                    $scope.sortExpression = [];
                }

                this.setSortField = function (criteria, element, toggle, append) {
                    var expr = { criteria: criteria, descending: false };
                    if (!append) {
                        _.forEach($scope.headings, function (heading) {
                            heading.removeClass('tablesort-asc');
                            heading.removeClass('tablesort-desc');
                        });
                    }

                    if (_.some($scope.sortExpression, { 'criteria': criteria }) && toggle) {
                        var selectedCriteria = _.find($scope.sortExpression, { 'criteria': criteria });
                        selectedCriteria.descending = !selectedCriteria.descending;
                        if (selectedCriteria.descending) {
                            element.removeClass("tablesort-asc");
                            element.addClass("tablesort-desc");
                        }
                        else {
                            element.removeClass("tablesort-desc");
                            element.addClass("tablesort-asc");
                        }
                        if (!append) {
                            $scope.sortExpression = [selectedCriteria];
                        }
                    } else {
                        //this logic prevents sort direction from changing on First Name/Lastname change
                        if ($scope.sortExpression.length > 0 ) {
                            expr.descending = $scope.sortExpression[0].descending;
                            if (expr.descending) {
                                element.removeClass("tablesort-asc");
                                element.addClass("tablesort-desc");
                            }
                            else {
                                element.removeClass("tablesort-desc");
                                element.addClass("tablesort-asc");
                            }
                        }
                        
                        if (append) {
                            $scope.sortExpression.push(expr);
                        } else {
                            $scope.sortExpression = [expr];
                        }
                        
                    }
                    $scope.notifySortChanged();
                }



                $scope.notifySortChanged = function() {
                    $timeout(function() {
                        $scope.sortChanged({ expression: $scope.sortExpression });
                    });
                }

                this.registerHeading = function (element, criteria) {
                    element.addClass('tablesort-sortable');
                    $scope.headings.push(element);

                    var selectedCriteria = _.find($scope.sortExpression, { 'criteria': criteria });
                    if (selectedCriteria) {
                        if (selectedCriteria.descending) {
                            element.removeClass("tablesort-asc");
                            element.addClass("tablesort-desc");
                        }
                        else {
                            element.removeClass("tablesort-desc");
                            element.addClass("tablesort-asc");
                        }
                    }

                };
            }]
        }
    }
    )
    .directive('tableSortCriteria',['$timeout', function ($timeout) {
        return {
            require: '^tableSort',
            link: function (scope, el, attrs, tableSortCtrl) {
                el.bind('click', function (e) {
                    if (e.shiftKey) {
                        $timeout(function () {
                            tableSortCtrl.setSortField(attrs.tableSortCriteria, el, true, true);
                        });
                    } else {
                        $timeout(function () {
                            tableSortCtrl.setSortField(attrs.tableSortCriteria, el, true);
                        });
                    }

               });

                tableSortCtrl.registerHeading(el, attrs.tableSortCriteria);

            }
        }
    }]
    )
     .directive('tableSortCriteriaGroup', ['$timeout', '$compile', function ($timeout, $compile) {
         return {
             require: '^tableSort',
             scope: {
                 criteria : '=tableSortCriteriaGroup'
             },
             template: '<span id="selected-criteria">{{selectedCriteria.displayName}}</span>' +
                 '<div class="pull-right" uib-dropdown>' +
                             '<a uib-dropdown-toggle><i class="fa fa-caret-square-o-down"></i></a>' +
                             '<ul class="dropdown-menu" uib-dropdown-menu>' +
                                 '<li ng-click="setSelected(criterion)" ng-repeat="criterion in criteria">' +
                                     '<a>{{criterion.displayName}}</a>' +
                             '</li>' +
                             '</ul>' +
                             '</div>',
             link: function (scope, el, attrs, tableSortCtrl) {
                 scope.selectedCriteria = scope.criteria && scope.criteria.length > 0 ? scope.criteria[0] : '';

                 el.find('#selected-criteria').bind('click', function (e) {
                     if (e.shiftKey) {
                         $timeout(function () {
                             tableSortCtrl.setSortField(scope.selectedCriteria.criteria, el, true, true);
                         });
                     } else {
                         $timeout(function () {
                             tableSortCtrl.setSortField(scope.selectedCriteria.criteria, el, true);
                         });
                     }
                 });

                 scope.setSelected = function (criteria) {
                     scope.selectedCriteria = criteria;
                     tableSortCtrl.setSortField(scope.selectedCriteria.criteria, el, false);
                 }

                 tableSortCtrl.registerHeading(el, scope.selectedCriteria.criteria);

             }

         }
     }]
    )
    ;

})();;
(function () {
    'use strict';

    angular.module('nha.core')
        .directive('avatar', [
            'appSettings', function (appSettings) {
                return {
                    restrict: 'EA',
                    scope: {
                        studentId: '=?',
                        staffId: '=?',
                        altText: '=?',
                        avatarWidth: '=?'
                    },
                    templateUrl: appSettings.coreWebRootUrl + 'app/directives/avatar/avatar.html',
                    link: function (scope, el, attrs) {
                        scope.$watch('studentId', function (newVal, oldVal) {
                            if (newVal) {
                                scope.avatarUrl = scope.getAvatarUrl();
                            }
                        });
                    },
                    controller: ['$scope', 'appSettings', function ($scope, appSettings) {
                        var avatarWidth = 60; // default width
                        if ($scope.avatarWidth) {
                            avatarWidth = $scope.avatarWidth;
                        }

                        $scope.getAvatarUrl = function () {
                            var type = !_.isUndefined($scope.studentId) ? 'student' : 'staff';
                            return appSettings.coreServicesRootUrl + type + '/'  + (($scope.staffId || $scope.studentId) || 0) + '/avatar/' + avatarWidth;
                        }
                        $scope.avatarUrl = $scope.getAvatarUrl();
                    }]
                }
            }
        ]);
})();;
/**
 * concat.directive
 * @namespace core
 */

(function () {
	'use strict';

	/** get the angular module and add directive */
	angular.module('nha.core').directive('concat', concatDirective);

	/** implementation */
	function concatDirective() {
		/** return directive */
		return {
			restrict: 'A',
			scope: {
				length: '=?'
			},
			link: link
		};

		/** define the link function */
		function link(scope, element, attrs) {
			/** check for length */
			if (!scope.length || parseInt(scope.length) < 1) scope.length = 100;

			/** check the concat length */
			var content = attrs.concat;
			if (attrs.concat.length > scope.length) {
				/** concatenate string */
				content = attrs.concat.substring(0, scope.length) + '...';
			}

			/** set the element content */
			element.text(content);
		}
	}
})();;
/**
 * assignment.repository
 * @namespace gradebook 
 * @remarks '.repository' is a sub-classification of service, including exclusively webAPI calls (CRUD+Special); one file per webAPI endpoint
*/
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .service('breadcrumbContextManager', BreadcrumbContextManager);

    // protect against minification
    /* @ngInject */
    BreadcrumbContextManager.$inject = ['baseService', 'GradebookRestangular'];

    /**
    * @name assignmentRevisionRepository
    * @description Constructor for assignment.repository
    * @memberOf gradebook
    */
    function BreadcrumbContextManager() {

        /*jshint validthis: true */
        var service = this;

        service.customSteps = [];

        service.setCustomStep = setCustomStep;
        
        return service;

        function setCustomStep(step) {
            var existingStep = _.find(service.customSteps, function (item) { return item.key == step.key; });

            if (existingStep) {
                _.extend(existingStep, step);
            }
            else {
                service.customSteps.push(step);
            }
        }
    }
})();;
/**
 * assignment-copy.controller
 * @namespace gradebook
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .controller('coreBreadcrumbController', CoreBreadcrumbController);

    // protect against minification
    /* @ngInject */
    CoreBreadcrumbController.$inject = ['$state', '$scope', '$controller', 'breadcrumbContextManager'];

    /**
    * @name AssignmentCopyController
    * @description Constructor for assignment-copy.controller
    * @memberOf gradebook
    */
    function CoreBreadcrumbController($state, $scope, $controller, breadcrumbContextManager) {

        // Controller as vm - see route configuration
        var coreBreadcrumbVM = this;

        coreBreadcrumbVM.customSteps = breadcrumbContextManager.customSteps;

        coreBreadcrumbVM.currentState = currentState;

        function currentState(step) {
            return step.state == $state.current.name;
        }
    }
})();
;
(function () {
    'use strict';

    angular.module('nha.core').directive('navDropdown', [
        function () {
            return {
                restrict: 'E',
                scope: {
                    items: '=ddItems',
                    label: '=',
                    goToState: '&',
                    href:'@?'
                },
                template:
                    '<div class="dropdown">' +
                        '<a class="dropdown-toggle" data-toggle="dropdown">' +
                            '{{label}} <spann class="caret downArrow pull-right"></spann>' + // Not a typo - don't want to inherit <span> styling
                        '</a>' +
                        '<ul class="dropdown-menu" role="menu">' +
                            '<li ng-if="!item.href" role="presentation" ng-repeat="item in items"><a role="menuitem" style="color: #aaa;" ng-click="goToPage(item)">{{item.description}}</a></li>' +
                            '<li ng-if="item.href" role="presentation" ng-repeat="item in items"><a role="menuitem" style="color: #aaa;" ng-href="{{item.href}}">{{item.description}}</a></li>' +
                        '</ul>' +
                    '</div>',
                link: function (scope, el, attrs) {
                    // Pass through to the controller to handle state change
                    scope.goToPage = function (item) {
                        scope.goToState({ item: item });
                    }
                    
                }
            }
        }
    ]);
})();;
/**
 * filters.directive
 * @namespace core
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .directive('filters', filters);

    // protect against minification
    /* @ngInject */
    filters.$inject = ['appSettings'];

    /**
     * @name filters
     * @description Define filters.directive
     * @memberOf core
     */
    function filters(appSettings) {
        var directive = {
            restrict: 'EA',
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/filters/filters.html',
            link: filtersLink,
            controller: filtersController //,
            //controllerAs: 'filtersVM',
            //bindToController: true

        };
        return directive;

        /**
         * @name filtersLink
         * @description link function for filters.directive
         * @memberOf core
         */
        function filtersLink(scope, element, attrs, ctrl) {

        }
    }

    // protect against minification
    /* @ngInject */
    filtersController.$inject = ['$scope', '$q', '$rootScope', '$sce', '$location', '$timeout', 'filterService', 'ipCookie',
        'errorSvc', 'userContextService', 'dataSecurityService', 'message.manager'];

    /**
     * @name filtersController
     * @description controller function for filters.directive
     * @memberOf core
     */
    function filtersController($scope, $q, $rootScope, $sce, $location, $timeout, filterService, ipCookie,
        errorService, userContextService, dataSecurityService, messageManager) {
        //TODO: Convert to use controllerAs, remove $scope, and change all usages of this directive to accomodate these changes

        /*jshint validthis: true */
        //var filtersVM = this;

        // Properties associated to view model - sorted alphabetically
        // helps you instantly identify which members of the controller can be bound and used in the View
        var defaultFilterSetName = 'default';
        var lastStateFilterSetName = 'last';  // this represents the last state before you do something like change a school

        // Controller methods associated to view model (init, reset, submit)
        //var filtersVM.init = init;

        // Navigation pass-thru methods - sorted alphabetically, linked directly to navigationManager method calls
        // helps you instantly identify which members of the controller can be bound and used in the View
        // - None at this time

        // Methods - sorted alphabetically, matching sorted implementations below
        // helps you instantly identify which members of the controller can be bound and used in the View

        // Events ($watch, $on, $broadcast, $emit) related to the view model
        $scope.$on('nha:core:default-school-changed', function (event, school) {

            // listen for Navbar school selector changes
            if (school.schoolID !== $scope.selectedSchoolId) {
                $scope.selectedSchoolId = school.schoolID;
                $scope.selectRadio($scope.selectedSchoolId, 'School', true);
                $scope.selectedFilter();
            }
        });
        $scope.$watch(function () {
            return $scope.filterConfig;
        }, function (newVal, oldVal) {
            init();
        });

        /**
         * @name init
         * @description Initialize state of controller
         * @returns undefined
         * @memberOf filters.controller
         */
        function init() {
            // just a check to ensure we actually have a filter config, else get out
            if ($scope.filterConfig === undefined) {
                log('no filter config specified in this view.');
                return;
            }

            userContextService.ensureUserContext().then(function (context) {
                $scope.defaultSchoolCookieName = 'nha.core.user-default-school.' + context['http://schemas.mynha.com/Savyint/UserID'];
            });

            $scope.viewState = { filtersLoading: true };
            $scope.filterTimer = false;
            $scope.selectedSchoolId = -1;
            $scope.selectedAcademicYearIds = [];
			$scope.selectedGradeLevelIds = [];
            $scope.filters = {};

            //Items for mobile implementation
            $scope.isPhone = false;
            $scope.mobileAcademicYearSelection = "";
            if ($scope.filterConfig.isPhone) {
                $scope.isPhone = $scope.filterConfig.isPhone;
            }
            $scope.isTeacher = false;
            if ($scope.filterConfig.isTeacher) {
                $scope.isTeacher = true;
            }
            $scope.oneSchool = false;
            //End mobile implementation items

            log('[c=\'color: green\']Calling filters query...[c]');

            // our default and preset filtersets
            $scope.filterSets = [
                { name: defaultFilterSetName },  // this is our default state when the user first comes to the app
                { name: lastStateFilterSetName }  // this represents the last state before you do something like change a school
            ];

            $scope.requestedTypes = _.omitBy($scope.filterConfig.filters, function (filter) {
                return filter.items != null;
            });

            // go get the actual filter data now
            $scope.loadFilterData();

        }

        $scope.saveFilterSet = function (filterSetName, notThisFilter) {

            // default to the default filterset, although we can use other filterset too, such as last state
            if (!filterSetName) {
                filterSetName = defaultFilterSetName;
            }

            var filterSet = _.find($scope.filterSets, { name: filterSetName });

            // reset the data
            filterSet.data = {};

            // go through these and get our default values that are set
            _.forEach($scope.filterConfig.filters, function (key) {

                if (key.name !== 'School' && key.name !== 'MarkingPeriod' && key.name !== notThisFilter) {
                    // update our default filter set with these keys
                    filterSet.data[key.name] = {
                        name: key.name,
                        values: $scope.getSelectedFilterValue(key)
                    };
                }
            });

            log('saved filterSet', defaultFilterSetName, filterSet);
        }

        $scope.loadFilterSet = function (filterSetName, fromFilterName) {

            // default to the default filterset, although we can use other filterset too, such as last state
            if (!filterSetName) {
                filterSetName = defaultFilterSetName;
            }

            // get our filter set that we want to work with, in this case the default one
            var filterSet = _.find($scope.filterSets, { 'name': filterSetName });

            // go through these and get our default values that are set
            _.forEach(filterSet.data, function (key) {

                // look up in our data and set these defaults back to this list
                var filter = _.find($scope.filterConfig.filters, { 'name': key.name });
                if (filter) {

                    if (key.name !== 'School' || key.name !== fromFilterName) {

                        // we found it, now get set it back to its default when we first loaded this list
                        _.forEach(filter.items, function (filterItem) {
                            // find any of these matching values
                            var keyValueMatch = _.find(key.values, function (v) {
                                return v === filterItem.id;
                            });

                            if (keyValueMatch != null) {

                                // update the item in the filter list to be selected
                                filterItem.selected = true;

                                // if we only have one value, such as a radio button selection, set this too
                                if (key.values.length === 1) {
                                    filter.selectedID = keyValueMatch;
                                }
                            }
                        });
                    }
                }
            });

            //log('loaded filterSet', defaultFilterSetName, filterSet);
        }

        $scope.getSelectedFilterValue = function (filter) {
            if (filter) {
                var selectedItems = _.filter(filter.items, { selected: true });
                if (selectedItems) {
                    return _.map(selectedItems, 'id');
                }
            }
            return null;
        }

        $scope.loadFilterData = function (dontSaveDefaultFilterSet, fromFilterName) {

            log('[c=\'color: green\']Loading Filter data...[c]');

            // these are the keys we will use to run our query to the db
            $scope.requestTypeKeys = _.clone(_.keys($scope.requestedTypes));

            // get our school key
            if ($scope.requestedTypes.School) {

                userContextService.ensureUserContext().then(function (userContext) {

                    ensureSchoolID().then(function () {
                        var i = 0;
                        // create our endpoint lookup keys, mainly with any schoolIds added to request token, or AcademicYear
                        // Example: https://core-services.mynhadev.com/api/Filters?types=AcademicYear-2014|2015,School-338

                        _.forEach($scope.requestTypeKeys, function (key) {

                            if (key === 'School' && $scope.selectedSchoolId != undefined) {
                                $scope.requestTypeKeys[i] = key + '-' + $scope.selectedSchoolId;
                            }
                            else if (key === 'State') {
                                // school ID is the primary key of all of filters, however, States can filter that down.
                                var stateElement = _.filter($scope.requestedTypes.State.items, 'selected');
                                if (stateElement != null && stateElement.length > 0) {
                                    $scope.requestTypeKeys[i] = key + '-' + _.head(stateElement).id;
                                }
                            }
                            else if (key === 'AcademicYear' && $scope.selectedAcademicYearIds) {
                                $scope.selectedAcademicYearIds = _.filter($scope.requestedTypes.AcademicYear.items, 'selected');

                                //log('$scope.selectedAcademicYearIds', $scope.selectedAcademicYearIds);
                                var academicYearString = _.map($scope.selectedAcademicYearIds, 'id').join('|');
                                log('academicYearString', academicYearString);


                                if (academicYearString) {
                                    $scope.requestTypeKeys[i] = key + '-' + academicYearString;
                                }
                            }
							else if (key === 'GradeLevel' && $scope.selectedGradeLevelIds) {
								$scope.selectedGradeLevelIds = _.filter($scope.requestedTypes.GradeLevel.items, 'selected');

								var gradeLevelString = _.map($scope.selectedGradeLevelIds, 'id').join('|');
								log('gradeLevelString', gradeLevelString);

								if (gradeLevelString) {
									$scope.requestTypeKeys[i] = key + '-' + gradeLevelString;
								}
							}

                            i++;
                        });

                        filterService.getFilters($scope.requestTypeKeys, $scope.filterConfig.source).then(function (result) {

//                            log('Got filters...');

                            // Don't auto-select current AY if persistence is desired
                            if ($scope.filterConfig.filters.AcademicYear && $scope.filterConfig.filters.AcademicYear.persist) {
                                var cachedYearSelections = getPersistedFilter('AcademicYear');

                                if (cachedYearSelections) {
                                    if (_.isInteger(cachedYearSelections) || !_.isEmpty(cachedYearSelections)) {
                                        _.forEach(result, function (item) {
                                            if (item.typeName === 'AcademicYear') {
                                                _.forEach(item.items, function (year) {
                                                    year.selected = false;
                                                });
                                            }
                                        });
                                    }
                                }
                            }

                            _.forEach($scope.requestedTypes, function (filter) {

                                filter.items = _.find(result, { 'typeName': filter.name }).items;

                                if(filter.name === 'GradeLevel') {
                                    if ($scope.shouldShowHighSchoolInGradeLevels) { // This should change to the highschool filter for academic years after 2021
                                        var selectedAcademicYear = _.find(
											$scope.filterConfig.filters.AcademicYear.items,
											"selected"
										);
                                        if(selectedAcademicYear.id > 2021) {
                                            // remove highschool grades except for 9th grade
                                            var highSchoolGradeLevelsToExclude = [ 405/*10th grade*/, 406/*11th grade*/, 407/*12th grade*/, 410/*13th grade*/ ];
                                            _.forEach(filter.items, function (item) {
                                                if (_.includes(highSchoolGradeLevelsToExclude, item.id)) {
                                                    filter.items = filter.items.filter(function(item2) {
                                                        return item2.id !== item.id
                                                    });
                                                }
                                                // rename 9th grade in the UI to "High school" because that is where all highschool grade levels put their classes
                                                if (item.id === 404) {
                                                    item.description = "High School";
                                                }
                                            })
                                        }
                                    }
                                }

                                // Set the default item supplied in the 'defaultId' prop and select its corresponding control
                                // if persist (meaning save as a cookie, we don't want to use the default)
                                if (filter.defaultId && !filter.persist) {

                                    if (filter.type === 'radio') {
                                        var selectedId = parseInt(filter.defaultId, 10);
                                        if (filter.name === 'School') {
                                            selectedId = $scope.selectedSchoolId;
                                        }

                                        // we need this to be an int to do a proper filter
                                        selectedId = parseInt(selectedId, 10);

                                        var item = _.head(_.filter(filter.items, { id: selectedId }));
                                        if (item != null) {
                                            item.selected = true;
                                            $scope.selectRadio(item.id, filter.name);
                                        }
                                    }
                                    if (filter.type === 'checkbox') {
                                        var selectedIds = _.isArray(filter.defaultId) ?
                                                            _.map(filter.defaultId, _.parseInt) :
                                                            [_.parseInt(filter.defaultId, 10)];

                                        _.each(selectedIds, function (id) {
                                            var item = _.head(_.filter(filter.items, { id: id }));
                                            if (item != null) {
                                                $scope.selectCheckbox(item.id, filter.name);
                                            }
                                        });
                                    }
                                }
                                else if (filter.persist) {
                                    if (filter.type === 'radio') {
                                        var selectedId = getPersistedFilter(filter.name);

                                        if (filter.name === 'AcademicYear' && !selectedId) {
                                            setCurrentAcademicYear();
                                            return;
                                        }

                                        // we need this to be an int to do a proper filter
                                        selectedId = parseInt(selectedId, 10);

                                        var item = _.head(_.filter(filter.items, { id: selectedId }));
                                        if (item != null) {
                                            item.selected = true;
                                            $scope.selectRadio(item.id, filter.name);
                                        }
                                    }
                                    if (filter.type === 'checkbox') {
                                        var idArray = [];
                                        var checkboxIds = getPersistedFilter(filter.name);

                                        if (checkboxIds) {
                                            if (_.isString(checkboxIds)) {
                                                checkboxIds = checkboxIds.split('|').map(function (item) {
                                                    return parseInt(item, 10);
                                                });
                                            }

                                            idArray = idArray.concat(checkboxIds);

                                            _.forEach(idArray, function (id) {
                                                $scope.selectCheckbox(id, filter.name, false);
                                            });
                                        }
                                    }
                                }
                                else if (!_.isUndefined(filter.defaultIndex) && filter.defaultIndex != null) {
                                    var item = filter.items[filter.defaultIndex];

                                    if (item != null) {
                                        item.selected = true;

                                        if (filter.type === 'radio') {
                                            $scope.selectRadio(item.id, filter.name);
                                        }
                                        if (filter.type === 'checkbox') {
                                            $scope.selectCheckbox(item.id, filter.name);
                                        }
                                    }
                                }

                                // filter out subTypes if specified, this is mainly for MasterStatus and MasterStatusTypeId
                                if (filter.subType) {
                                    filter.items = _.filter(filter.items, { 'subType': filter.subType });
                                }

                                // you can configure a filter to prepend items to a list
                                if (filter.prependItems) {
                                    _.forEach(filter.prependItems.reverse(), function (item) {
                                        filter.items.unshift(item);
                                    });
                                }
                            });

                            if ($scope.selectedSchoolId) {
                                $scope.selectRadio($scope.selectedSchoolId, 'School');
                            } else {
                                //Default to first school
                                $scope.selectRadio(_.head($scope.filterConfig.filters.School.items).id, 'School');
                            }

                            // set to current year
                            if ($scope.filterConfig.filters.AcademicYear && !$scope.filterConfig.filters.AcademicYear.persist) {
                                setCurrentAcademicYear();
                            }

                            // Set default marking period
                            if ($scope.filterConfig.filters.MarkingPeriod && $scope.filterConfig.filters.MarkingPeriod.type === 'radio') {
                                var selectedItem = _.find($scope.filterConfig.filters.MarkingPeriod.items, 'selected');

                                if (selectedItem) {
                                    $scope.selectRadio(selectedItem.id, 'MarkingPeriod');
                                }
                            }

                            // Letter Items Type (Send/Resend filter)
                            if ($scope.filterConfig.filters.LetterType != undefined) {
                                var defaultLetterType = _.find($scope.filterConfig.filters.LetterType.items, 'selected');
                                if (defaultLetterType != null) {
                                    $scope.selectRadio(defaultLetterType.id, $scope.filterConfig.filters.LetterType.name);
                                    //$scope.selectItem(defaultLetterType, defaultLetterType);
                                }
                            }

                            //Load Preset Filters - See '$scope.filterSets'
                            $scope.loadPreset();

                            // this is our default filter set that we will reload if a user clicks reset button
                            if (!dontSaveDefaultFilterSet) {
                                $scope.saveFilterSet();
                            } else {

                                // load our last state since a user changed a school
                                $scope.loadFilterSet(lastStateFilterSetName, fromFilterName);

                                // always ensure we have an AY selected
                                var selectedAcademicYear = _.find($scope.filterConfig.filters.AcademicYear.items, 'selected');
                                if (selectedAcademicYear == null) {

                                }
                            }

                            if ($scope.filterConfig.filters.School.items.length === 1) {
                                $scope.oneSchool = true;
                            }

                            //Broadcast selected filters
                            $scope.selectedFilter();

                            $scope.viewState.filtersLoading = false;
							messageManager.setData('message', { 'key': 'filters', 'value': 'loaded' });
                        });
                    });
                }, function (error) {
                    $scope.viewState.filtersLoading = false;
                    errorService.getUnhandledError(error, 'An error occurred loading Filters');
                });
            }
        }

        function setCurrentAcademicYear() {
            if ($scope.filterConfig.filters.AcademicYear != undefined) {
                var academicYear = _.find($scope.filterConfig.filters.AcademicYear.items, 'selected');
                if (academicYear != null) {
                    $scope.selectRadio(academicYear.id, 'AcademicYear');
                }
                // if user has selected years manually overwrite with those selections.
                if (!_.isEmpty($scope.selectedAcademicYearIds)) {
					var selectedIds = $scope.selectedAcademicYearIds.map(function (ay) { return ay.id; });

					// if none of the values in `selectedAcademicYearIds` are in
					// `$scope.filterConfig.filters.AcademicYear.items` then
					// don't update the filter items `selected` properties
					var hasValidAySelection = _.some($scope.filterConfig.filters.AcademicYear.items, function (i) {
						return _.includes(selectedIds, i.id);
					});

					if (hasValidAySelection) {
						_.forEach($scope.filterConfig.filters.AcademicYear.items, function (i) {
							i.selected = _.includes(selectedIds, i.id);
						});
					}
                }
            }
        }

        function ensureSchoolID() {

            var deferred = $q.defer();

            if ($scope.selectedSchoolId !== -1) {
                deferred.resolve();
            } else {
                var persistedSchoolID = getPersistedSchool();

                dataSecurityService.doesUserHaveAccessToSchool(persistedSchoolID).then(function (permission) {
                    //Use the school id retrieved from the cookie if we have permission. Otherwise default the school
                    if (permission) {
                        $scope.selectedSchoolId = persistedSchoolID;
                    } else {
                        if (userContextService.getDefaultSchool()) {
                            $scope.selectedSchoolId = userContextService.getDefaultSchool();
                        } else {
                            $scope.selectedSchoolId = $scope.requestedTypes.School.defaultId;
                        }
                    }

                    deferred.resolve();
                });
            }

            return deferred.promise;
        }

        $scope.showCountForItem = function (item) {
            if (item) {
                if ($scope.filterConfig.hideCountsIfZero && item.count < 1) {
                    return false;
                }

                return (item.count < 9999);
            }

            return false;
        }

        //Helper function to allow filters in ng-repeat to be rendered in the order that they are declared.
        $scope.notSorted = function (obj) {
            if (!obj) {
                return [];
            }
            return (Object != null ? Object.keys(obj) : null);
        }

        $scope.selectedFilter = function (overrideClick) {
            if (overrideClick) return;

            var filters = $scope.getAppliedFilters();

            log('[c=\'color:blue\']Subscribe to me for selected filters on \'filterChange\' [c]', filters);

            if ($scope.filterTimer) {
                var isCancelled = $timeout.cancel($scope.filterTimer);
            }

            $scope.filterTimer = $timeout(function () {
                $rootScope.$broadcast('filterChange', { selectedFilters: filters });

                // always scroll to top after a selection
                _utils.enableScrollToTopOnStateChangeSuccess();

            }, 1000);
        }

        $scope.selectItem = function (item, filter) {
            if (filter.type !== 'radio') {
                return;
            }
            // Clear other selections
            _.forEach(_.find($scope.filterConfig.filters, { 'name': filter.name }).items, function (i) {
                i.selected = false;
            });
            //Select the new item
            item.selected = true;
            $scope.selectedFilter();
        }

        $scope.selectCheckbox = function (id, filterName, isClick) {
            if (isClick) {
                var filter = _.find($scope.filterConfig.filters, { 'name': filterName });
                // someone actually clicked this, not just calling the function

                // persist means save that preference in a cookie
                if (filter.persist) {
                    $scope.persistMultipleFilterSelection(filterName);
                }
                if (filterName === "AcademicYear" || filterName === 'GradeLevel') {

                    // save our last filter set off before we load other stuff
                    $scope.saveFilterSet(lastStateFilterSetName);

                    // if this is School, we should trigger an update if we have filters for Staff, Homeroom, GradeLevel, AcademicYear (ones that rely on school id)
                    if ($scope.filterConfig.filters.Staff || $scope.filterConfig.filters.Homeroom || $scope.filterConfig.filters.GradeLevel || $scope.filterConfig.filters.AcademicYear) {
                        // now trigger reload of data:
                        $scope.loadFilterData(true, filterName);
                    }
				} else {
                    $scope.selectedFilter();
                }

            } else {
                var filterItems = _.find($scope.filterConfig.filters, { 'name': filterName }).items;
                var foundCheckBox = _.find(filterItems, { 'id': id });
                if (foundCheckBox != null) {
                    foundCheckBox.selected = true;
                }
            }
        }

        $scope.selectRadio = function (id, filterName, isClick) {

            log('Filter radio selected', id, filterName);

            // get our filter by name from the collection
            var filter = _.find($scope.filterConfig.filters, { 'name': filterName });

            // persist means save that preference in a cookie
            if (filter.persist || filter.name === 'School') {
                $scope.persistFilterSelection(filterName, id);
            }

            // ensure we have items data
            if (filter.items) {
                var item;
                // Mark All items as unselected, select the new item.
                _.forEach(filter.items, function (i) {
                    if (i.id === id) {
                        i.selected = true;
                        item = i;
                    }
                    else { i.selected = false; }
                });
                // set our selectedID with the id that we passed in
                filter.selectedID = id;

                // This is only for the DateRange selection specifically and should be ignored by everything else
                if (filterName === 'DateRange') {
                    var today = moment().format('MM/DD/YYYY');
                    switch (id) {
                        case 0:
                            item.startDate = moment(today).set('date', 1).toDate(); // 1st of month
                            item.endDate = moment(today).set('date', moment(today).daysInMonth()).endOf('day').toDate(); // Last day of month
                            break;
                        case 1:
                            item.startDate = moment(today).day(0).toDate(); // Past Sunday
                            item.endDate = moment(today).day(6).endOf('day').toDate(); // Next Saturday
                            break;
                        case 2:
                            item.startDate = moment(today).startOf('day').toDate();
                            item.endDate = moment(today).endOf('day').toDate();
                            break;
                        default:
                            var dateFilter = _.find($scope.filterConfig.filters, { 'name': 'DateRange' });
                            if (dateFilter) {
                                item.startDate = moment(dateFilter.customStart).startOf('day');
                                item.endDate = moment(dateFilter.customEnd).endOf('day');
                            }
                            break;
                    }
                }

                // for mobile, default to current year for academic year dropdown selector
                if (filterName === 'AcademicYear') { $scope.mobileAcademicYearSelection = item.description };

                log('Our selected filter item', item);
            }

            // someone actually clicked this, not just calling the function
            if (isClick && filterName === 'School' && $scope.filterConfig.filters.School) {

                // save our last filter set off before we load other stuff
                $scope.saveFilterSet(lastStateFilterSetName);

                // if this is School, we should trigger an update if we have filters for Staff, Homeroom, GradeLevel, AcademicYear, Marking Period (ones that rely on school id)
                if ($scope.filterConfig.filters.Staff || $scope.filterConfig.filters.Homeroom || $scope.filterConfig.filters.GradeLevel || $scope.filterConfig.filters.AcademicYear || $scope.filterConfig.filters.MarkingPeriod) {

                    // we have our selected id, which is id
                    $scope.selectedSchoolId = id;

                    // now trigger reload of data:
                    $scope.loadFilterData(true);
                }
            }

            // someone actually clicked this, not just calling the function
            if (isClick && filterName === 'AcademicYear' && $scope.filterConfig.filters.AcademicYear) {

                // save our last filter set off before we load other stuff
                $scope.saveFilterSet(lastStateFilterSetName);

                // if this is School, we should trigger an update if we have filters for Staff, Homeroom, GradeLevel, AcademicYear (ones that rely on school id)
                if ($scope.filterConfig.filters.Staff || $scope.filterConfig.filters.Homeroom || $scope.filterConfig.filters.GradeLevel || $scope.filterConfig.filters.AcademicYear) {
                    // now trigger reload of data:
                    $scope.loadFilterData(true, filterName);
                }
            }

            // someone actually clicked this, not just calling the function
            if (isClick && filterName === 'State' && $scope.filterConfig.filters.State) {

                // save our last filter set off before we load other stuff
                $scope.saveFilterSet(lastStateFilterSetName);

                // if this is School, we should trigger an update if we have filters for Staff, Homeroom, GradeLevel, AcademicYear (ones that rely on school id)
                if ($scope.filterConfig.filters.Staff || $scope.filterConfig.filters.Homeroom || $scope.filterConfig.filters.GradeLevel || $scope.filterConfig.filters.AcademicYear) {
                    // now trigger reload of data:
                    $scope.loadFilterData(true, filterName);
                }
            }

            // Clear filter selections for filters configured.
            if (filter.clearOnSelect) {
                if (filter.type === 'checkbox') {
                    log(_.find($scope.filterConfig.filters, { 'name': filter.clearOnSelect }));
                    _.find($scope.filterConfig.filters, { 'name': filter.clearOnSelect }).selectedID = null;
                } else {
                    _.forEach(_.find($scope.filterConfig.filters, { 'name': filter.clearOnSelect }).items, function (i) {
                        i.selected = false;
                    });
                }
            }
        }

        // this is when we uncheck a filter item
        $scope.deselectItem = function (name, id) {
            var filter = _.find($scope.filterConfig.filters, { 'name': name });
            _.find(filter.items, { 'id': id }).selected = false;

            // Want to remove date selection even though it's a radio
            if (name == 'DateRange') {
                filter.selectedID = null;
            }

            // Want to remove academic year selection from cache
            if (name === 'AcademicYear' && $scope.filterConfig.filters['AcademicYear'].persist) {
                $scope.persistMultipleFilterSelection('AcademicYear');
            }

            $scope.selectedFilter();
        }

        // sync item counts with the filter list, this is called per filter section (i.e. AcademicyYear, School, etc)
        $scope.syncItemCounts = function (fetchItems, syncItems) {

            _.forEach(syncItems, function (item) {

                var countItem = _.find(fetchItems, function (fetchItem) {
                    return fetchItem && item.id === fetchItem.id;
                });

                if (countItem) {
                    item.count = countItem.count;
                } else {
                    item.count = 0;  //item wasn't present in the latest filter counts, so force to zero to clear previous binging.
                }
            });
        };

        if (!$scope.resetFilters) {
            $scope.resetFilters = function () {

                $scope.loadPreset('default');

                // loop through and clear out values
                _.forEach($scope.filterConfig.filters, function (f) {

                    // do not reset school or (if radio button, marking period either)
                    if (f.name !== 'School' && !(f.name === 'MarkingPeriod' && f.type === 'radio')) {
                        _.forEach(f.items, function (i) {
                            i.selected = false;
                        });

                        f.selectedID = null;
                    }
                });
                // need to reset our cached academic years if we reset the filters
                if ($scope.filterConfig.filters['AcademicYear'].persist) {
                    $scope.persistMultipleFilterSelection('AcademicYear');
                }

                $scope.loadFilterSet();
                $scope.selectedFilter();
            }
        }

        $scope.loadPreset = function (preset) {
            if (!preset)
                preset = $location.search()['preset'];
            if (preset) {
                var filterset = _.find($scope.filterSets, { 'name': preset });
                if (filterset) {
                    //set attendance code
                    if (filterset.attendanceCodes)
                        $scope.selectCheckbox(filterset.AttendanceCode, 'AttendanceCode');
                }
            }
            $scope.selectedFilter();
        }

        $scope.getAppliedFilters = function () {
			/** initialize filters */
			var filters = {};

			/** cycle through filter configs to get selected values */
			_.forEach($scope.filterConfig.filters, function (filter) {
				/** get the selected items, and check if any exist */
				var selectedItems = _.filter(filter.items, 'selected');
				if (selectedItems.length > 0) {
					/** add to filters */
					filters[filter.name] = {
						'name': filter.name,
						'required': filter.type === 'radio' && filter.name !== 'DateRange'
					};

					/** copy over filter values */
					_.forOwn(filter, function(value, key) {
						filters[filter.name][key] = value;
					});

					/** only get selected items */
					filters[filter.name].items = selectedItems;
				}
			});

			/** return filters */
			return filters;
        }

		/** add getAppliedFilters to filterService for sharing out */
		filterService.getAppliedFilters = $scope.getAppliedFilters;

        function getPersistedSchool() {
            var schoolID = -1;
            var schoolID = ipCookie('filter-School');
            //If filter cookie has not been initialized yet, check for user default school cookie.
            if (!schoolID) {
                var defaultSchool = ipCookie($scope.defaultSchoolCookieName);
                if (defaultSchool) {
                    schoolID = defaultSchool.schoolID;
                }
            }
            return schoolID;
        }

        function getPersistedFilter(filterName) {
            var id = ipCookie('filter-' + filterName);
            return id;
        }

        // Filter Peristance
        $scope.persistFilterSelection = function (filterName, id) {
            var hostnameParts = $location.host().split('.');
            var domainName = $location.host();
            if (hostnameParts.length > 2) {
                domainName = hostnameParts[hostnameParts.length-2] + '.' + hostnameParts[hostnameParts.length-1];
            }
            var key = 'filter-' + filterName;
            var value = id;
            log('Persisting with key: ' + key + ' ID: ' + id + ' Domain: ' + domainName);

            ipCookie(key, value, { domain: domainName, path: '/' });
        }

        $scope.persistMultipleFilterSelection = function (filterName) {
            var hostnameParts = $location.host().split('.');
            var domainName = $location.host();
            if (hostnameParts.length > 2) {
                domainName = hostnameParts[hostnameParts.length-2] + '.' + hostnameParts[hostnameParts.length-1];
            }
            var key = 'filter-' + filterName;
            var idValues = '';

            _.forEach($scope.filterConfig.filters[filterName].items, function(option) {
                if (option.selected) {
                    idValues = _.isEmpty(idValues) ? option.id.toString() : (idValues + '|' + option.id.toString());
                }
            });

            log('Persisting with key: ' + key + ' ID: ' + idValues + ' Domain: ' + domainName);

            ipCookie(key, idValues, { domain: domainName, path: '/' });
        }

        $scope.applyDateFilter = function (filter) {
            var myFilter = _.find($scope.filterConfig.filters, { 'name': 'DateRange' });
            var customDateItem = _.find(myFilter.items, { id: 3 });

            $scope.selectRadio(customDateItem.id, 'DateRange');
            $scope.selectedFilter();
        };

        $scope.initDate = function (filter, isStart) {
            if (isStart) {
                var daysOffset = ($scope.filterConfig.customStartDaysOffset !== undefined
                                        && $scope.filterConfig.customStartDaysOffset !== null) ?
                                    $scope.filterConfig.customStartDaysOffset :
                                    -30;
                filter.customStart = moment().add(daysOffset, 'days');
            } else {
                filter.customEnd = moment();
            }
        }

        $scope.trust = function (html) {
            return $sce.trustAsHtml(html);
        }

        // Initialize
        init();

    }

})();;
angular.module('nha.core')
    .service('filterService', ['baseService', 'CoreRestangular', 'appSettings', function (baseService, coreRestangular, appSettings) {

    	/*Set name casing for filters that need name casing*/
    	var setNameCasing = function (filters) {
    	    if (filters) {

	            var homeRoomTeacherNameFilters = _.find(filters, { 'typeName': 'Homeroom' });
    			if (homeRoomTeacherNameFilters && homeRoomTeacherNameFilters.items) {
    				_.forEach(homeRoomTeacherNameFilters.items, function (item) { item.description = item.description.toNameCase().toString(); });
    			}

    			var staffFilters = _.find(filters, { 'typeName': 'Staff' });
                if (staffFilters && staffFilters.items) {
                    _.forEach(staffFilters.items, function (item) { item.description = item.description.toNameCase().toString(); });
    			}
            }
    	}

    	var getFilters = function (filterTypes, sourceRestangular) {

    	    var moduleID = appSettings.moduleID || 0;

    	    log('moduleID', moduleID);

            // default to Core
    	    if (sourceRestangular == undefined) {
	            sourceRestangular = coreRestangular;
	        }

    	    return baseService.getList('Filters', { types: filterTypes.join(','), moduleID: moduleID }, false, true, sourceRestangular);
    	}

    	return {
    		getFilters: getFilters,
    		setNameCasing: setNameCasing
    	};
    }]);;
(function() {
    'use strict';

    angular.module('nha.core')
        .directive('selectedFilters', [
            'appSettings', '$sce', function(appSettings, $sce) {
                return {
                    restrict: 'E',
                    templateUrl: appSettings.coreWebRootUrl + 'app/directives/filters/selected-filters.html',
                    controller: ['$scope', '$location', '$cookieStore', '$attrs', function($scope, $location, $cookieStore, $attrs) {
                        //Using attributes for options because we're not using isolated scope (opted not to rewrite and use isolated scope)
                        $scope.showFilters = $attrs.defaultState == 'open';

                        $scope.getCookiedPosition = function() {
                            var path = $location.url().match(/[^?]*/)[0];
                            var position = $cookieStore.get('filterPosition-' + path);
                            if (position) {
                                $scope.showFilters = position;
                            }
                        }

                        $scope.getCookiedPosition();

                        $scope.togglePosition = function() {
                            var path = $location.url().match(/[^?]*/)[0];
                            $scope.showFilters = !$scope.showFilters;
                            $cookieStore.put('filterPosition-' + path, $scope.showFilters);
                            if ($scope.showFilters) {
                                $scope.$broadcast('filterPanelOpened');
                            } else {
                                $scope.$broadcast('filterPanelClosed');
                            }
                           
                        }

                        $scope.removeFilterSelection = function(filter, item) {
                            log(filter);
                            if (!filter.required) {
                                log('Removing ' + filter.name + ': ' + item.id);
                                $scope.deselectItem(filter.name, item.id);
                            }
                        }

						$scope.removeFilterGroup = function(filter) {
							log(filter);
                            if (!filter.required) {
                                log('Removing ' + filter.name + ': All Items');
								_.forEach(filter.items, function(item) {
									$scope.deselectItem(filter.name, item.id);
								});
                            }
						};

                        $scope.$on('filterChange', function(event, data) {
                            //Get Selected filters and convert to array to be sorted by index rather than alphabetically by key name.
                            $scope.selectedFiltersToShow = Object.keys(data.selectedFilters).map(function(k) { return data.selectedFilters[k] });
                        });

                        $scope.trust = function (html) {
                            return $sce.trustAsHtml(html);
                        }

                    }]
                }
            }
        ]);
})();;
/**
 * file-input.directive
 * @namespace core
 * @usage 
 *     In Markup: 
 *         <div file-input="myVM.file" on-change="myVM.readFile()"></div>
 *         <img ng-src="{{myVM.imageSrc}}" />
 *     In a controller:
 *         function MyController($scope, fileReader) {
 *             var myVM = this;
 *             myVM.file = 'somefile.jpg';
 *             myVM.imageSrc = ''; 
 *             function readFile() {
 *                 fileReader.readAsDataUrl(myVM.file, $scope).then(function(result) {
 *                     myVM.imageSrc = result;
 *                 });
 *             }
 *         }
 * @references
 *     http://odetocode.com/blogs/scott/archive/2013/07/03/building-a-filereader-service-for-angularjs-the-service.aspx
 *     http://odetocode.com/blogs/scott/archive/2013/07/05/a-file-input-directive-for-angularjs.aspx
 *     http://www.abeautifulsite.net/whipping-file-inputs-into-shape-with-bootstrap-3/
 */
(function () {
    'use strict';

    // define one component per file (single responsibility)
    angular
        .module('nha.core')
        .directive('fileInput', fileInput);

    // protect against minification
    /* @ngInject */
    fileInput.$inject = ['$parse', 'appSettings'];

    /**
     * @name fileInputDirective
     * @description Constructor for file-input.directive
     * @memberOf core
     */
    function fileInput($parse, appSettings) {
        var directive = {
            restrict: 'EA',
            scope: {
                buttonText: '@',
                acceptFilter: '@'
            },
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/file-input/file-input.html',
            replace: true,
            link: fileInputLink
        };
        return directive;

        /**
         * @name fileInputLink
         * @description link function for file-input.directive
         * @memberOf core
         */
        function fileInputLink(scope, element, attrs) {
            var modelGet = $parse(attrs.fileInput);
            var modelSet = modelGet.assign;
            var onChange = $parse(attrs.onChange);

            function updateModel() {
                scope.$apply(function () {
                    modelSet(scope.$parent, element[0].childNodes[1].files[0]); // assumes strict adherence to file-input.html object hierarchy
                    onChange(scope.$parent);
                });
            }

            element.bind('change', updateModel);
        }
    }
})();;
(function () {
    'use strict';
    angular.module('nha.core').directive('scrollIf', function () {
        return function (scope, element, attributes) {
            function scrollTo() {
                var innerTopPosition = element[0].offsetTop;
                var containerTopPosition = element[0].parentElement.offsetTop;
                element[0].parentElement.scrollTop = innerTopPosition - containerTopPosition;
            }
            setTimeout(function () {
                if (scope.$eval(attributes.scrollIf)) {
                    scrollTo();
                }
            });
            
            if (attributes.scrollWhen) {
                var events = attributes.scrollWhen.split(',');
                _.each(events, function (eventName) {
                    // Enable ability to broadcast a scrollTo with scroll-when="<eventName>"
                    scope.$on(eventName, function (e) {
                        setTimeout(function () {
                            if (scope.$eval(attributes.scrollIf)) {
                                scrollTo();
                            }
                        });
                    });
                });
            }

        }
    });

})();;
angular.module('nha.core')
.directive('focusOn', function () {
	return function (scope, elem, attr) {
		scope.$on(attr.focusOn, function (e) {
			elem[0].focus();
		});
	};
});;
/**
 * horizontal-grid.directive
 * @namespace assessment
 */

(function () {
	'use strict';

	/** create directive */
	angular.module('nha.core').directive('horizontalGrid', horizontalGrid);

	/** implementation */
	function horizontalGrid() {
		return {
			restrict: 'A',
			scope: {},
			link: link
        };

		/** link implementation */
		function link(scope, elem) {
			/** get the scrollbar area */
			var scrollBar = $('.scrollbar', elem);

			/** get the default height */
			var defaultHeight = parseInt(scrollBar.css('height'));

			/** get the table */
			var table = $('table', elem);

			/** set the function to tie the scrolling action of the inner scroll to the table */
			$('.scroll', scrollBar).scroll(function(e){
				/** get the amount to scroll */
				var $step = $(e.currentTarget).scrollLeft();

				/** move the table */
				table.css('margin-left', -$step);
			});

			/** adjust the scrollbar size on window resize */
			$(window).resize(function(){
				/** get the scrollbar position top */
				var posTop = scrollBar.position().top;

				/** calculate the desired height */
				var newHeight = ($(window).height() - posTop) - 5; // there's some sort of padding issue

				/** set the scrollbar height (only if greater than height off scrollbar as set by css file) */
				if (newHeight > defaultHeight) scrollBar.css('height', newHeight + 'px');
				else scrollBar.css('height', defaultHeight + 'px');

				/** get the scrollable area width */
				var scrollableAreaWidth = parseInt(table.css('width')) - parseInt($('.spacer', scrollBar).css('width'));

				/** set the width of the inner scroll */
				$('.inner', scrollBar).css('width', scrollableAreaWidth + 'px');
			});

			/** run the resize */
			$(window).resize();
		}
    };
}());;
(function() {
    'use strict';

    angular.module('nha.core').directive('promptIfDirty',['$rootScope', '$timeout', '$location', function($rootScope, $timeout, $location) {
        return {
            scope: false, // Needs to be false. Stuff blows up when true.
            restrict: 'A',
            controller: ['$scope', '$element', function($scope, $element) {
                // Initialize the stateManagement obj for use in the parent/page controller
                if (!$rootScope.stateManagement) {
                    $rootScope.stateManagement = {};
                    $rootScope.stateManagement.isDirty = false;
                }
            }],
            link: function(scope, element, attrs, ngModelCtrl) {
                var message = attrs.message ? attrs.message :
                    "Some changes you have made have not been saved. Click \"Cancel\" to remain on this page and prevent your changes from being lost.";

                //When the user navigates away from the SPA
                $(window).bind('beforeunload', function() {
                    if ($rootScope.stateManagement.isDirty) {
                        return "Some changes you have made have not been saved. Click \"Don't reload\" to remain on this page and prevent your changes from being lost.";
                    }
                });

                //When the user navigates within the SPA
                scope.$on('$locationChangeStart', function(event, next, current) {
                    if ($rootScope.stateManagement.isDirty && !$rootScope.stateManagement.ignorePendingChanges) {
                        var answer = confirm(message);

                        if (!answer) {
                            event.preventDefault();
                        } else {
                            $rootScope.stateManagement.ignorePendingChanges = true;
                            $rootScope.stateManagement.isDirty = false;

                            $timeout(function() {
                                $location.url($location.url(next).hash());
                            });
                        }
                    }

                    // Need this to reset AFTER everything has executed
                    // Unfortunately, these events occur in different order depending on the situation
                    $timeout(function() {
                        $rootScope.stateManagement.ignorePendingChanges = false;
                    }, 100);
                });

                //The previous event wasn't catching some state changes in ui-router so added this
                scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
                    if ($rootScope.stateManagement.isDirty && !$rootScope.stateManagement.ignorePendingChanges) {
                        var answer = confirm(message);

                        if (!answer) {
                            event.preventDefault();
                        } else {
                            $rootScope.stateManagement.ignorePendingChanges = true;
                            $rootScope.stateManagement.isDirty = false;
                        }
                    }

                    $timeout(function() {
                        $rootScope.stateManagement.ignorePendingChanges = false;
                    }, 100);
                });
            }
        }
    }]);
})();;
/**
 * @author http://jsfiddle.net/ExpertSystem/w8kZn/
 */
(function () {
    'use strict';

    angular
        .module('nha.core')
        .directive('requiredAny', function () {
            // Hash for holding the state of each group
            var groups = {};

            // Helper function: Determines if at least one control
            //                  in the group is non-empty
            function determineIfRequired(groupName) {
                var group = groups[groupName];
                if (!group) return false;

                var keys = Object.keys(group);
                return keys.every(function (key) {
                    return (key === 'isRequired') || !group[key];
                });
            }

            return {
                restrict: 'A',
                require: '?ngModel',
                scope: {},   // an isolate scope is used for easier/cleaner
                             // $watching and cleanup (on destruction)
                link: function postLink(scope, elem, attrs, modelCtrl) {
                    // If there is no `ngModel` or no groupName has been specified,
                    // then there is nothing we can do
                    if (!modelCtrl || !attrs.requiredAny) return;

                    // Get a hold on the group's state object
                    // (if it doesn't exist, initialize it first)
                    var groupName = attrs.requiredAny;
                    if (groups[groupName] === undefined) {
                        groups[groupName] = { isRequired: true };
                    }
                    var group = scope.group = groups[groupName];

                    // Clean up when the element is removed
                    scope.$on('$destroy', function () {
                        delete (group[scope.$id]);
                        if (Object.keys(group).length <= 1) {
                            delete (groups[groupName]);
                        }
                    });

                    // Updates the validity state for the 'required' error-key
                    // based on the group's status
                    function updateValidity() {
                        if (group.isRequired) {
                            modelCtrl.$setValidity('required', false);
                        } else {
                            modelCtrl.$setValidity('required', true);
                        }
                    }

                    // Updates the group's state and this control's validity
                    function validate(value) {
                        group[scope.$id] = !modelCtrl.$isEmpty(value);
                        group.isRequired = determineIfRequired(groupName);
                        updateValidity();
                        return group.isRequired ? undefined : value;
                    };

                    // Make sure re-validation takes place whenever:
                    //   either the control's value changes
                    //   or the group's `isRequired` property changes
                    modelCtrl.$formatters.push(validate);
                    modelCtrl.$parsers.unshift(validate);
                    scope.$watch('group.isRequired', updateValidity);
                }
            };
        });
})();;
angular.module('nha.core').directive('slideBottomPanel', function () {
    return {
        restrict: 'EA',
        templateUrl: '/core/app/directives/slideBottomPanel/slideBottomPanel.html',
        controller: function ($scope) {
        }
    }
});
;
/**
 * loader.directive
 * @namespace core
 */

(function () {
	'use strict';

	/** get the angular module and add directive */
	angular.module('nha.core').directive('loader', loaderDirective);

	/** setup injection */
	loaderDirective.$inject = ['appSettings'];

	/** implementation */
	function loaderDirective(appSettings) {
		/** return directive */
		return {
			restrict: 'EA',
			transclude: true,
			templateUrl: appSettings.coreWebRootUrl + 'app/directives/loader/loader.directive.html',
			scope: {
				isLoading: '=',
				mini: '=',
				message: '@'
			}
		};
	}
})();;
(function () {
    'use strict';

    angular.module('nha.core')
    .directive('spinner', ['appSettings', function (appSettings) {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/spinner/spinner.html',
            scope: {
                isLoading: '=',
                message: '@',
                noMessage: '=?'
            }
        }
    }
    ]);

})();;
(function () {
    'use strict';

    angular.module('nha.core')
        .directive('datePanel', ['appSettings', function (appSettings) {
            return {
                restrict: 'EA',
                templateUrl: appSettings.coreWebRootUrl + 'app/directives/datePanel/datePanel.html',
                scope: {
                    viewOptions: '=',
                    events: '=?',
                    dateChanged: '&',
                },
                link: function (scope, element, attrs, ngModelCtrl) {
                    scope.init(attrs);
                    if (!attrs.dateChanged) { scope.dateChanged = angular.noop };
                },
                controller: ['$scope', '$rootScope', '$state', '$stateParams', '$location', 'appContextModel', function ($scope, $rootScope, $state, $stateParams, $location, appContextModel) {

                    var unbindLocationChange = $rootScope.$on('$locationChangeSuccess', function (val) {
                        if (!moment($stateParams.startDate).isSame(moment($scope.viewOptions.startDate), 'day') ||
                            !moment($stateParams.endDate).isSame(moment($scope.viewOptions.endDate), 'day')) {

                            $scope.viewOptions.startDate = moment($stateParams.startDate).toDate();
                            $scope.viewOptions.endDate = moment($stateParams.endDate).toDate();
                            
                            $scope.updateDtpViewValue($stateParams.startDate);
                            $scope.dateChanged();
                        }
                    });

                    $scope.$on('$destroy', function () {
                        unbindLocationChange();
                    });

                    $scope.viewOptions = $scope.viewOptions || {};

                    $scope.isCurrentTimePeriod = function () {

                        var isCurrentTimePeriod = true;
                        if ($scope.isMultiDayView()) {
                            isCurrentTimePeriod = moment().startOf('week').isSame(moment($scope.viewOptions.startDate).startOf('week'), "day");
                        }
                        else {
                            isCurrentTimePeriod = moment().isSame(moment($scope.viewOptions.startDate), "day");
                        }

                        return isCurrentTimePeriod;
                    }

                    $scope.init = function (attrs) {

                        // default date Panel options
                        $scope.datePanelOptions = {
                            selectedDateView: 'dayView',
                            showDayWeekSelector: true,
                            showCalendarSelector: true,
                            currentDateRangePosition: 'left',
                            maxDate: null // moment()
                        };

                        // if we have options, merge them with the defaults
                        if (!_.isEmpty(attrs.datePanelOptions)) {
                            $scope.datePanelOptions = angular.extend($scope.datePanelOptions, angular.fromJson(attrs.datePanelOptions));
                        }

                        if (!$scope.viewOptions.startDate) {
                            $scope.viewOptions.startDate = $scope.datePanelOptions.selectedDateView == 'dayView' ? new Date() : moment(new Date()).startOf('week').toDate();
                        }

                        if (!$scope.viewOptions.endDate) {
                            $scope.viewOptions.endDate = $scope.datePanelOptions.selectedDateView == 'dayView' ? new Date() : moment(new Date()).endOf('week').toDate();
                        }

                        $scope.isToday = true;

                        if (_utils.ensureDateIsValidMomentDate($scope.viewOptions.startDate).isSame(_utils.ensureDateIsValidMomentDate($scope.viewOptions.endDate), "day")) {
                            $scope.datePanelOptions.selectedDateView = 'dayView';
                        }
                        else {
                            $scope.datePanelOptions.selectedDateView = 'weekView';
                        }
                    }

                    $scope.isMaxDateReached = function () {

                        if ($scope.datePanelOptions.maxDate != null && $scope.viewOptions.endDate != null && $scope.viewOptions.endDate !== undefined) {
                            return (-moment($scope.datePanelOptions.maxDate).diff(moment($scope.viewOptions.endDate), 'days') >= 0);
                        }

                        return false;
                    }

                    $scope.isMultiDayView = function () {
                        var startDate = _utils.ensureDateIsValidMomentDate($scope.viewOptions.startDate);
                        var endDate = _utils.ensureDateIsValidMomentDate($scope.viewOptions.endDate);
                        return $scope.viewOptions && !startDate.isSame(endDate, "day");
                    }

                    $scope.getCurrentTimePeriodDescription = function () {
                        if ($scope.isMultiDayView()) {
                            return 'This week';
                        }
                        else {
                            return 'Today';
                        }
                    }

                    $scope.isWeekDisabled = function () {
                        return $state.current.name === 'behavior-students.grid' || $state.current.name === 'takeattendance.grid';
                    }

                    // Navication functions
                    $scope.showNextDay = navigateToDateByOffset(1);
                    $scope.showPreviousDay = navigateToDateByOffset(-1);

                    function navigateToDateByOffset(offsetFromCurrentDay) {
                        return function () {
                            var startDate, endDate;

                            if ($scope.isMultiDayView()) {
                                startDate = _utils.ensureDateIsValidMomentDate($scope.viewOptions.startDate).add('weeks', offsetFromCurrentDay).startOf('week'); // TODO add('weeks', offsetFromCurrentDay) is deprecated, make add(offsetFromCurrentDay, 'weeks')
                                endDate = _utils.ensureDateIsValidMomentDate($scope.viewOptions.endDate).add('weeks', offsetFromCurrentDay).endOf('week');
                            }
                            else {
                                startDate = _utils.ensureDateIsValidMomentDate($scope.viewOptions.startDate).add('days', offsetFromCurrentDay);
                                endDate = startDate;
                            }

                            $scope.navigateToDates(startDate, endDate);
                        }
                    }
                    
                    $scope.showCurrentTimePeriod = function () {
                        var startDate, endDate;

                        // get to either today or to current week
                        if ($scope.isMultiDayView()) {
                            startDate = moment().startOf('week');
                            endDate = moment().endOf('week');
                        }
                        else {
                            startDate = moment();
                            endDate = moment();
                        }

                        $scope.navigateToDates(startDate, endDate);
                    }

                    $scope.showDayView = function () {
                        if (!$scope.isMultiDayView()) {
                            return;
                        }

                        var startDate, endDate;
                        // if we have a last start date that was remembered, change our start date to it
                        if (appContextModel.lastStartDate != null) {
                            $scope.viewOptions.startDate = _utils.ensureDateIsValidMomentDate(appContextModel.lastStartDate);
                        }

                        startDate = moment($scope.viewOptions.startDate);
                        endDate = startDate;
                        $scope.datePanelOptions.selectedDateView = 'dayView';

                        $scope.navigateToDates(startDate, endDate);
                    }

                    $scope.showWeekView = function () {
                        if ($scope.isMultiDayView()) {
                            return;
                        }

                        var startDate, endDate;
                        // remember what day they were on
                        appContextModel.lastStartDate = _utils.ensureDateIsValidMomentDate($scope.viewOptions.startDate);

                        if (!$scope.isWeekDisabled()) {
                            startDate = _utils.ensureDateIsValidMomentDate($scope.viewOptions.startDate).startOf('week');
                            endDate = _utils.ensureDateIsValidMomentDate($scope.viewOptions.endDate).endOf('week');
                            $scope.datePanelOptions.selectedDateView = 'weekView';
                        }

                        $scope.navigateToDates(startDate, endDate);
                    }
                }]
            }
        }]);


    angular.module('nha.core').directive('datePickerButton', ['$state', function ($state) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, element, attrs, ngModelCtrl) {

                scope.preventNavigation = false;
                scope.navigateToDates = navigateToDates;
                scope.updateDtpViewValue = updateDtpViewValue;

                var parent = $(element).parent();
                var dtp = parent.datetimepicker({
                    format: "LL",
                    showTodayButton: false,
                    defaultDate: scope.viewOptions.startDate
                });

                // Fired when date picker is used
                dtp.on("dp.change", function (e) {
                    if (!scope.preventNavigation) {
                        var startDate,
                            endDate;

                        if (scope.isMultiDayView()) {
                            startDate = moment(e.date).startOf('week'); // Sunday   
                            endDate = moment(e.date).endOf('week'); // Saturday
                        } else {
                            startDate = moment(e.date);
                            endDate = startDate;
                        }

                        navigateToDates(startDate, endDate);
                        scope.$applyAsync();
                    }
                });

                // Updates the date time picker's date() value, but prevents navigateToDates() in the "dp.change" event.
                // This should be called after navigation so the date picker matches the viewOptions.startDate.
                function updateDtpViewValue(startDate) {
                    var startDate = moment(startDate);

                    scope.preventNavigation = true;
                    $(dtp).data('DateTimePicker').date(startDate); // Will emit "dp.change" event
                    scope.preventNavigation = false;
                }

                function navigateToDates(startDate, endDate) {
                    var newStartDate = moment(startDate);
                    var newEndDate = moment(endDate);

                    var params = _.assign($state.params, { startDate: startDate.format('YYYY-MM-DD'), endDate: endDate.format('YYYY-MM-DD') });
                    $state.transitionTo($state.current.name, params, { location: true, inherit: true, relative: $state.current, notify: false });
                }
            }
        };
    }]);

})();;
//document.createElement('swipedrag');

//(function () {
//    'use strict';

//    angular.module('nha.core').directive('draggable', ['$timeout', '$rootScope', '$location', function ($timeout, $rootScope, $location) {
//        return {
//            restrict: 'A',
//            scope: {
//                datePickerOptions: '@'
//            },
//            link: function (scope, element, attrs, ngModelCtrl) {
//                scope.animateRight = function () {
//                    $(element).animate({
//                        left: "+=100"
//                    }, 100, function () {
//                    });
//                }

//                scope.animateLeft = function () {
//                    $(element).animate({
//                        left: "-=100"
//                    }, 100, function () {
//                    });
//                }

//                scope.swipe = {};

//                var options = {
//                    dragLockToAxis: true,
//                    dragBlockHorizontal: true
//                };

//                var hammer = Hammer($(element)[0], options);

//                hammer.on("swipeleft", function (event) {
//                    scope.animateLeft();
//                    scope.animateRight();

//                    if (attrs.swipeLeft) {
//                        scope.$apply(function () {
//                            scope.$eval(attrs.swipeLeft);
//                        });
//                    }

//                    log('attendance swipe left');
//                });

//                hammer.on("swiperight", function (event) {
//                    scope.animateRight();
//                    scope.animateLeft();

//                    if (attrs.swipeRight) {
//                        scope.$apply(function () {
//                            scope.$eval(attrs.swipeRight);
//                        });
//                    }

//                    log('attendance swipe right');
//                });
//            }
//        }
//    }
//    ]);
//})();;
(function () {
    'use strict';

    angular.module('nha.core').directive('datePicker', ['$timeout', function ($timeout) {
        return {
            require: '?ngModel',
            restrict: 'AE',
            scope: {
                datePickerOptions: '@',
                dynamicDatePickerOptions: '=?'
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    var input = element.find('input').data('$ngModelController');
                    ngModelCtrl = input ? input : console.error('ngModel required by datePicker directive.');
                }

                var defaultOptions = {
                    format: 'MM/DD/YYYY', extraFormats: ['MM.DD.YY'],
                    icons: {
                        time: "nha-circle-clock",
                        date: "fa fa-calendar",
                        up: 'fa fa-chevron-up',
                        down: 'fa fa-chevron-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right'
                    }
                };

                var passedInOptions = scope.$eval(attrs.datePickerOptions);
                var options = angular.extend({}, defaultOptions, passedInOptions);

                var extensionOptions = scope.$eval(attrs.datePickerExtensionOptions) || {};

                // add a parser to preserve timezone if it exists
                ngModelCtrl.$parsers.push(function (newDate) {
                    // if the original model was a moment with a timezone that was set...
                    if (!!ngModelCtrl.$modelValue && moment.isMoment(ngModelCtrl.$modelValue) && !!ngModelCtrl.$modelValue.tz && !!ngModelCtrl.$modelValue.tz()) {
                        if (moment.isMoment(newDate)) {
                            // return a new version of the datetime within the original timezone
                            return moment.tz(ngModelCtrl.$modelValue.tz()).set({
                                'year': newDate.get('year'),
                                'month': newDate.get('month'),
                                'date': newDate.get('date'),
                                'hour': newDate.get('hour'),
                                'minute': newDate.get('minute'),
                                'second': newDate.get('second'),
                                'millisecond': newDate.get('millisecond'),
                            });
                        } else {
                            // it was a moment, and now it's not (now it's empty?).  Let moment try to parse it, then set the timezone.  We could get offset problems, but at least we get something.
                            return moment(newDate, options.format).tz(ngModelCtrl.$modelValue.tz());    // Ensure we're using the format they want, in case it's simply a Time.
                        }
                    }

                    return newDate; // by default, just return whatever they entered.
                });

                element.on('dp.change', function (e) {
                    $timeout(function () {
                        var dtp = element.data('DateTimePicker');
                        ngModelCtrl.$setViewValue(dtp.date());
                    });
                });

                // Clear keybinds when datepicker is closed to user can type and use arrow keys.
                element.on('dp.hide', function (e) {
                    disableKeyBinds();
                });

                // Apply keybinds back to datepicker now that it is open.
                element.on('dp.show', function (e) {
                    enableKeyBinds();
                });

                function disableKeyBinds() {
                    element.data("__DPKeys", element.data("DateTimePicker").options().keyBinds);
                    element.data("DateTimePicker").keyBinds({
                        // Down arrow for opening datepicker.
                        down: function (widget) {
                            if (!widget) {
                                this.show();
                            }
                        }
                    });
                }

                function enableKeyBinds() {
                    var keys = element.data("__DPKeys");
                    if (keys) {
                        element.data("DateTimePicker").keyBinds(keys);
                        element.data("__DPKeys", null);
                    }
                }

                function setPickerValue() {
                    var result = null;
                    // verify we have a model with a value
                    if (!!ngModelCtrl) {
                        // if we've already got a moment object, keep it.  It could have offset information in there.
                        if (!!ngModelCtrl.$modelValue && moment.isMoment(ngModelCtrl.$modelValue)) {
                            result = ngModelCtrl.$modelValue;
                        } else {
                            if (!!ngModelCtrl.$viewValue) {
                                result = moment(ngModelCtrl.$viewValue);
                            }
                        }
                    }

                    var dtp = element.data('DateTimePicker');

                    if (extensionOptions.maxDateIsCurrent) {
                        dtp.maxDate(moment());
                    }

                    dtp.date(result);
                }

                function setToolTip() {
                    if (!!ngModelCtrl.$modelValue && moment.isMoment(ngModelCtrl.$modelValue) && !!ngModelCtrl.$modelValue.zoneAbbr && ngModelCtrl.$modelValue.zoneAbbr() != '') {
                        var midnight = ngModelCtrl.$modelValue.clone().startOf('day');
                        if (!midnight.diff(ngModelCtrl.$modelValue, 'minutes') == 0) {
                            attrs.$set('title', ngModelCtrl.$modelValue.zoneName());
                        }
                    }
                }

                ngModelCtrl.$render = function (value) {
                    setPickerValue();
                    disableKeyBinds();
                    setToolTip();
                };

                element.datetimepicker(options);
                setPickerValue();

                //Watch for changes in options and apply them to the date picker
                scope.$watch('dynamicDatePickerOptions', function (newVal, oldVal) {
                    if (newVal) {
                        var allOptions = angular.extend({}, defaultOptions, passedInOptions, newVal);
                        $(element).data('DateTimePicker').options(allOptions);
                    }
                })
            }
        }
    }
    ]);
})();;
(function () {
    'use strict';

    /**
    * Generic hierarchical/tree selection control. It can either have the whole data structure
    * or asynchronously load each level.
    *
    * Allows auto-complete searching of the tree, optional multiple selection
    */
    angular.module('nha.core')
    .directive('hierarchicalSelector', ['$compile', 'selectorUtils', 'appSettings', function ($compile, selectorUtils, appSettings) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/hierarchicalSelector/hierarchical-selector.html',
            scope: {
                syncData: '=data',
                multiSelect: '=?',
                onSelectionChanged: '&',
                selectOnlyLeafs: '=?',
                canSelectItem: '&',
                loadChildItems: '&',
                itemHasChildren: '&',
                selection: '=',
                tagName: '&',
                placeholder: '@',
            },
            link: function (scope, element, attrs) {
                // is there a better way to know the callbacks are actually set. So we have make decisions on what to use
                if (attrs.canSelectItem) {
                    scope.useCanSelectItemCallback = true;
                }
                if (attrs.loadChildItems) {
                    scope.isAsync = true;
                }
                if (attrs.noButton === undefined) {
                    scope.showButton = true;
                }
                if (attrs.tagName) {
                    scope.useTagName = true;
                }
                if (attrs.selectAllLeafs) {
                    scope.selectAllLeafs = true;
                }

                // init async
                // if we have no data and have the callback
                if (!scope.syncData && scope.isAsync) {
                    scope.data = [];
                    var items = scope.loadChildItems({ parent: null });
                    if (angular.isArray(items)) {
                        scope.data = items;
                    }
                    else {
                        items.then(function (data) {
                            scope.data = data;
                        });
                    }
                }

                if (scope.syncData) {
                    scope.data = scope.syncData;
                    scope.$watch('syncData', function () {
                        scope.data = scope.syncData;
                    });
                }
            },
            controller: ['$scope', '$document', '$window', '$interpolate', function ($scope, $document, $window, $interpolate) {
                var activeItem;

                $scope.showTree = false;
                $scope.selectedItems = [];
                $scope.multiSelect = $scope.multiSelect || false;
                // we need somewhere to hold the async loaded children to reference them in navigation etc.
                $scope.asyncChildCache = {};

                function docClickHide(e) {
                    closePopup();
                    $scope.$apply();
                }

                function closePopup() {
                    $scope.showTree = false;
                    if (activeItem) {
                        var itemMeta = selectorUtils.getMetaData(activeItem);
                        itemMeta.isActive = false;
                        activeItem = undefined;
                    }
                    // clear cache
                    $scope.asyncChildCache = {};
                    $document.off('click', docClickHide);
                    $document.off('keydown', keyboardNav);
                }

                function findItemOwnerAndParent(item, array, parentArray, parentIndex) {
                    if (!array) {
                        // we don't know where we are, find the array that we belong to
                        return;
                    }
                    var itemIndex = array.indexOf(item);
                    if (itemIndex > -1) {
                        return { currentArray: array, parentArray: parentArray, parentIndex: parentIndex, itemIndex: itemIndex };
                    }
                    var newArray;
                    for (var i = 0; i < array.length; i++) {
                        if (selectorUtils.hasChildren(array[i], $scope.isAsync)) {
                            newArray = findItemOwnerAndParent(item, selectorUtils.getChildren(array[i], $scope.isAsync, $scope.asyncChildCache), array, i);
                            if (newArray) {
                                break;
                            }
                        }
                    }
                    return newArray;
                }

                function findLowestExpandedItem(item) {
                    var children = selectorUtils.getChildren(item, $scope.isAsync, $scope.asyncChildCache);
                    var c = children[children.length - 1];
                    if (selectorUtils.getMetaData(c).isExpanded) {
                        return findLowestExpandedItem(c);
                    }
                    return c;
                }

                /*
                 * Get the next or previous item from a item in the tree
                 */
                function getNextItem(down, item, array) {
                    var itemData = findItemOwnerAndParent(item, array);
                    var itemMeta = selectorUtils.getMetaData(item);

                    if (down) {
                        if (itemMeta.isExpanded) {
                            // go down the branch
                            return selectorUtils.getChildren(item, $scope.isAsync, $scope.asyncChildCache)[0];
                        }
                        if (itemData.itemIndex < itemData.currentArray.length - 1) {
                            // next item at this level
                            return itemData.currentArray[itemData.itemIndex + 1];
                        }
                        if (itemData.itemIndex == itemData.currentArray.length - 1 && itemData.parentArray && itemData.parentIndex < itemData.parentArray.length - 1) {
                            // Next item up a level
                            return itemData.parentArray[itemData.parentIndex + 1];
                        }
                    }
                    else {
                        if (itemData.itemIndex > 0) {
                            // previous item at this level
                            var previousAtSameLevel = itemData.currentArray[itemData.itemIndex - 1];
                            if (selectorUtils.getMetaData(previousAtSameLevel).isExpanded) {
                                // find the lowest item
                                return findLowestExpandedItem(previousAtSameLevel);
                            }
                            return previousAtSameLevel;
                        }
                        if (itemData.itemIndex === 0 && itemData.parentArray) {
                            // go to parent
                            return itemData.parentArray[itemData.parentIndex];
                        }
                    }

                    return item;
                }

                function changeActiveItem(down) {
                    if (!activeItem) {
                        // start at the top or bottom
                        idx = down ? 0 : $scope.data.length - 1;
                        $scope.onActiveItem($scope.data[idx]);
                    } else {
                        $scope.onActiveItem(getNextItem(down, activeItem, $scope.data));
                    }
                    $scope.$apply();
                }

                // handle keyboard navigation
                function keyboardNav(e) {
                    switch (e.keyCode) {
                        // backspace
                        // case 8: {

                        // break;
                        // }
                        // ESC closes
                        case 27: {
                            e.preventDefault();
                            e.stopPropagation();
                            closePopup();
                            $scope.$apply();
                            break;
                        }
                            // space/enter - select item
                        case 32:
                        case 13: {
                            e.preventDefault();
                            e.stopPropagation();
                            if (activeItem) {
                                $scope.itemSelected(activeItem);
                                $scope.$apply();
                            }
                            break;
                        }
                            // down arrow - move down list (next item, child or not)
                        case 40: {
                            e.preventDefault();
                            e.stopPropagation();
                            changeActiveItem(true);
                            break;
                        }
                            // up arrow - move up list (previous item, child or not)
                        case 38: {
                            e.preventDefault();
                            e.stopPropagation();
                            changeActiveItem(false);
                            break;
                        }
                            // left arrow - colapse node if open
                        case 37: {
                            e.preventDefault();
                            e.stopPropagation();
                            if (activeItem) {
                                selectorUtils.getMetaData(activeItem).isExpanded = false;
                                $scope.$apply();
                            }
                            break;
                        }
                            // right arrow - expand node if has children
                        case 39: {
                            e.preventDefault();
                            e.stopPropagation();
                            if (activeItem) {
                                selectorUtils.getMetaData(activeItem).isExpanded = true;
                                $scope.$apply();
                            }
                            break;
                        }
                    }
                }

                $scope.onActiveItem = function (item) {
                    if (activeItem != item) {
                        if (activeItem) {
                            var itemMeta = selectorUtils.getMetaData(activeItem);
                            itemMeta.isActive = false;
                        }
                        activeItem = item;
                        var itemMeta2 = selectorUtils.getMetaData(activeItem);
                        itemMeta2.isActive = true;
                    }
                };

                $scope.deselectItem = function (item, $event) {
                    $event.stopPropagation();
                    $scope.selectedItems.splice(findIndexForItemById(item), 1);

                    closePopup();

                    //Search for the item in our options collection so we can uncheck it.
                    var dataItem = _.find($scope.data, { id: item.id });
                    //If not found at base level search children.
                    if (!dataItem) {
                        _.each($scope.data, function (grp) {
                            dataItem = _.find(grp.children, { id: item.id });
                            if (dataItem)
                                return false;
                        });
                    }
                    var itemMeta = selectorUtils.getMetaData(dataItem);
                    itemMeta.selected = false;

                    // if there are children, deselect them.
                    if (item.children) {
                        _.forEach(dataItem.children, function (child) {
                            var childMeta = selectorUtils.getMetaData(child);
                            //var indexOfItem = $scope.selectedItems.indexOf(child);
                            var indexOfItem = findIndexForItemById(child);
                            childMeta.selected = false;
                            delete childMeta.isParentSelected;
                            $scope.selectedItems.splice(indexOfItem, 1);
                        });
                    }

                    if ($scope.onSelectionChanged) {
                        $scope.onSelectionChanged({ items: $scope.selectedItems.length ? $scope.selectedItems : undefined });
                    }
                };

                $scope.onButtonClicked = function ($event) {
                    if ($scope.showTree) {
                        closePopup();
                    }
                    else {
                        $scope.onControlClicked($event);
                    }
                };

                $scope.onControlClicked = function ($event) {
                    $event.stopPropagation();
                    if (!$scope.showTree) {
                        $scope.showTree = true;

                        $document.on('click', docClickHide);
                        $document.on('keydown', keyboardNav);
                    }
                };

                $scope.showSelectedItem = function (item) {
                    var itemMeta = selectorUtils.getMetaData(item);
                    if (itemMeta && itemMeta.isParentSelected) {
                        return false;
                    }

                    return true;
                }

                $scope.itemSelected = function (item) {
                    if (($scope.useCanSelectItemCallback && $scope.canSelectItem({ item: item }) === false) || ($scope.selectOnlyLeafs && selectorUtils.hasChildren(item, $scope.isAsync))) {
                        return;
                    }
                    var itemMeta = selectorUtils.getMetaData(item);
                    if (!$scope.multiSelect) {
                        closePopup();
                        for (var i = 0; i < $scope.selectedItems.length; i++) {
                            selectorUtils.getMetaData($scope.selectedItems[i]).selected = false;
                        }

                        itemMeta.selected = true;
                        $scope.selectedItems = [];
                        $scope.selectedItems.push(item);
                    } else {
                        itemMeta.selected = true;
                        log(item, itemMeta);

                        //var indexOfItem = $scope.selectedItems.indexOf(item);
                        var indexOfItem = findIndexForItemById(item);
                        if (indexOfItem > -1) {
                            itemMeta.selected = false;
                            $scope.selectedItems.splice(indexOfItem, 1);
                        } else {
                            $scope.selectedItems.push(item);
                        }

                        // if there are children, always selected them all (or toggle unselect)
                        if ($scope.selectAllLeafs) {
                            if (item.children) {
                                _.forEach(item.children, function (child) {

                                    var childMeta = selectorUtils.getMetaData(child);
                                    //var indexOfItem = $scope.selectedItems.indexOf(child);
                                    var indexOfItem = findIndexForItemById(child);

                                    if (!itemMeta.selected) {
                                        childMeta.selected = false;
                                        delete childMeta.isParentSelected;
                                        $scope.selectedItems.splice(indexOfItem, 1);
                                    } else {
                                        childMeta.selected = true;
                                        childMeta.isParentSelected = true;

                                        if (indexOfItem === -1) {
                                            $scope.selectedItems.push(child);
                                        } else {
                                            $scope.selectedItems[indexOfItem]._hsmeta.isParentSelected = true;
                                        }
                                    }
                                });
                            }
                        }
                    }

                    if ($scope.onSelectionChanged) {
                        $scope.onSelectionChanged({ items: $scope.selectedItems.length ? $scope.selectedItems : undefined });
                    }
                };

                function findIndexForItemById(item) {
                    return _.findIndex($scope.selectedItems, { id: item.id });
                }

                $scope.clearSelection = function () {
                    $scope.selectedItems = [];
                    if ($scope.onSelectionChanged) {
                        $scope.onSelectionChanged({ items: undefined });
                    }
                };

                $scope.$watch('selection', function (newValue, oldValue) {
                    if (newValue) {
                        if (angular.isArray(newValue)) {
                            for (var i = 0; i < newValue.length; i++) {
                                $scope.itemSelected(angular.copy(newValue[i]));
                            }
                        }
                        else {
                            $scope.itemSelected(angular.copy(newValue));
                        }
                    }
                    else if ($scope.selectedItems.length > 0) { // only clear if it is changing/don't trigger a onSelectionChanged
                        $scope.clearSelection();
                    }
                });

                $scope.getTagName = function (i) {
                    if ($scope.useTagName) {
                        return $scope.tagName({ item: i });
                    }
                    return i.name;
                };
            }]
        };
    }])
    ;

    /**
    * The recursive tree item used in the hierarchical/tree selector control
    */
    angular.module('nha.core')
    .directive('treeItem', ['$compile', '$q', 'selectorUtils', 'appSettings', function ($compile, $q, selectorUtils, appSettings) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/hierarchicalSelector/tree-item.html',
            scope: {
                item: '=',
                itemSelected: '&',
                onActiveItem: '&',
                multiSelect: '=?',
                isActive: '=', // the item is active - means it is highlighted but not selected
                selectOnlyLeafs: '=?',
                useCanSelectItem: '=',
                canSelectItem: '=', // reference from the parent control
                loadChildItems: '=', // reference from parent
                itemHasChildren: '&',
                async: '=',
                asyncChildCache: '='
            },
            controller: ['$scope', function ($scope) {
                $scope.metaData = selectorUtils.getMetaData($scope.item);
                $scope.metaData.isExpanded = false;

                $scope.theChildren = $scope.item.children;

                $scope.showExpando = function (item) {
                    return selectorUtils.hasChildren(item, $scope.async);
                };

                $scope.onExpandoClicked = function (item, $event) {
                    $event.stopPropagation();
                    var meta = selectorUtils.getMetaData(item);
                    meta.isExpanded = !meta.isExpanded;
                };

                $scope.clickSelectItem = function (item, $event) {
                    $event.stopPropagation();
                    if ($scope.itemSelected) {
                        var itemMeta = selectorUtils.getMetaData(item);
                        if (itemMeta.isParentSelected) {
                            return false;
                        }

                        $scope.itemSelected({ item: item });
                    }
                };

                $scope.subItemSelected = function (item, $event) {
                    if ($scope.itemSelected) {
                        $scope.itemSelected({ item: item });
                    }
                };

                $scope.activeSubItem = function (item, $event) {
                    if ($scope.onActiveItem) {
                        $scope.onActiveItem({ item: item });
                    }
                };

                $scope.onMouseOver = function ($event) {
                    $event.stopPropagation();
                    if (angular.isFunction($scope.onActiveItem)) {
                        $scope.onActiveItem({ item: $scope.item });
                    }
                };

                $scope.showCheckbox = function () {
                    if (!$scope.multiSelect) {
                        return false;
                    }
                    // it is multi select
                    // canSelectItem callback takes preference
                    if ($scope.useCanSelectItem) {
                        return $scope.canSelectItem({ item: $scope.item });
                    }
                    return !$scope.selectOnlyLeafs || ($scope.selectOnlyLeafs && !selectorUtils.hasChildren($scope.item, $scope.async));
                };
            }],
            /**
            * Manually compiles the element, fixing the recursion loop.
            * @param element
            * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
            * @returns An object containing the linking functions.
            */
            compile: function (element, attrs, link) {
                // Normalize the link parameter
                if (angular.isFunction(link)) {
                    link = { post: link };
                }

                // Break the recursion loop by removing the contents
                var contents = element.contents().remove();
                var compiledContents;
                return {
                    pre: (link && link.pre) ? link.pre : null,
                    /**
                    * Compiles and re-adds the contents
                    */
                    post: function (scope, element, attrs) {
                        // Compile the contents
                        if (!compiledContents) {
                            compiledContents = $compile(contents);
                        }
                        // Re-add the compiled contents to the element
                        compiledContents(scope, function (clone) {
                            element.append(clone);
                        });

                        // Call the post-linking function, if any
                        if (link && link.post) {
                            link.post.apply(null, arguments);
                        }

                        // when someone expands a node fetch data if needed
                        if (scope.async) {
                            scope.$watch('item.' + selectorUtils.getMetaPath() + '.isExpanded', function (newVal) {
                                if (!newVal) {
                                    return;
                                }
                                if (scope.asyncChildCache[scope.item.$$hashKey]) {
                                    return scope.asyncChildCache[scope.item.$$hashKey];
                                }

                                scope.theChildren = [{ placeholder: true }];
                                if (angular.isFunction(scope.loadChildItems) && scope.item) {
                                    var items = scope.loadChildItems({ parent: scope.item });
                                    if (angular.isArray(items)) {
                                        scope.theChildren = items;
                                    }
                                    items.then(function (data) {
                                        scope.theChildren = data;
                                        // cache the children
                                        scope.asyncChildCache[scope.item.$$hashKey] = data;
                                    });
                                }
                            });
                        }
                    }
                };
            }
        };
    }])
    ;

    /**
    * Service contianing shared fuctions between the two directives
    */
    angular.module('nha.core')
    .factory('selectorUtils', ['$q', function ($q) {
        return {
            getMetaPath: function () {
                return '_hsmeta'; // change below if you change this
            },

            getMetaData: function (item) {
                // we store some meta data on the object - maybe we shouldn't but it is easy now
                // they should be passing us a 'view-model' anyway as we require a few fields (children, name, hasChildren)
                if (!item._hsmeta) {
                    item._hsmeta = {};
                }
                return item._hsmeta;
            },

            hasChildren: function (item, async) {
                return async ? item.hasChildren : item.children && item.children.length > 0;
            },

            getChildren: function (item, async, cache) {
                var children = async ? cache[item.$$hashKey] : item.children;
                if (async && !children && item.hasChildren) {
                    // we haven't loaded them yet. Return palceholder
                    return [];
                }
                return children;
            }
        };
    }])
    ;

})();
;
(function () {
    'use strict';

    angular.module('nha.core')
    .directive('searchBox', ['appSettings', '$timeout', function (appSettings, $timeout) {
        return {
            restrict: 'EA',
            replace:true,
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/search-box/search-box.html',
            scope: {
                placeholder: '@placeholder', //watermark placeholder text
                search: '=', //the bound property to use in your search
                display: '=?', //the bound property that maintains the original text entered by the user (optional)
                changed: '&?' //a callback function for reporting changes to the directive consumer (optional)
            },
            link: function (scope, el) {
                var searchPlaceholderText = 'Enter search criteria...';

                if (scope.placeholder) {
                    searchPlaceholderText = scope.placeholder;
                }
                scope.searchPlaceholderText = searchPlaceholderText;

                function cleanString(dirtyString) {
                    var clean = dirtyString;
                    clean = clean.replace(/[|&;$%@"<>()+,]/g, '');
                    clean = clean.replace('\'', '\'\'');
                    //clean = clean.replace(/'/g, '\'\''); -- removed as it double processes the apostrophe
                    clean = clean.replace(/&/g, '%26');
                    return clean;
                }

                scope.updateSearch = function () {
                    
                    scope.search = cleanString(scope.display);
                    $timeout(function () {
                        if (scope.changed) {
                            scope.changed({ value: scope.search, display: scope.display });
                        }
                    }, 0);
                }
            }
        }
    }
    ]);

})();;
(function () {
    'use strict';

    angular.module('nha.core')
        .directive('crudPanel', [
            'appSettings', function (appSettings) {
                return {
                    restrict: 'E',
                    scope: {
                        saveCall: '&',
                        saving: '=',
                        deleting: '=',
                        disabled: '=',
                        cancelCall: '&',
                        deleteCall: '&',
                        lastSavedDate: '=',
                        lastSavedBy: '@'
                    },
                    templateUrl: appSettings.coreWebRootUrl + 'app/directives/crudPanel/crudPanel.html',
                    link: function (scope, el, attrs) {
                        scope.showSave = attrs.saveCall;
                        scope.showDelete = attrs.deleteCall;
                        scope.showCancel = attrs.cancelCall;

                        if (attrs.cancelLabel) {
                            scope.cancelLabel = attrs.cancelLabel;
                        } else {
                            scope.cancelLabel = 'Cancel';
                        }

                        if (attrs.saveLabel) {
                            scope.saveLabel = attrs.saveLabel;
                        } else {
                            scope.saveLabel = 'Save';
                        }

                        if (attrs.deleteLabel) {
                            scope.deleteLabel = attrs.deleteLabel;
                        } else {
                            scope.deleteLabel = 'Delete';
                        }

                        scope.save = function () {
                            // Call the callback function passed in from consuming controller.
                            scope.saveCall();
                        }
                        scope.delete = function () {
                            scope.deleteCall();
                        }
                        scope.cancel = function () {
                            scope.cancelCall();
                        }
                    }
                }
            }
        ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core')
        .directive('errorPanel', [
            'appSettings', function (appSettings) {
                return {
                    restrict: 'EA',
                    scope: {
                        studentId: '=',
                        altText: '='
                    },
                    templateUrl: appSettings.coreWebRootUrl + 'app/directives/errorPanel/errorPanel.html',
                    controller: function ($scope) {

                        $scope.showErrorPanel = function (isLoading) {

                            // don't show while the view is still loading
                            if (isLoading)
                                return false;

                            // if we have an error, show this panel, else don't
                            return !_.isEmpty($scope.error);
                        };

                        $scope.handleError = function (error) {

                            log('An error occurred', error);

                            // check data response for errors
                            if (error.status) {
                                if (!_.isEmpty(error.data)) {
                                    $scope.error = {};
                                    $scope.error.errorMessage = (error.data.errorException ? error.data.errorException : error.data.message);
                                    $scope.error.errorDetails = JSON.stringify(error.data);
                                }
                            }
                        }
                    }
                }
            }
        ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core')
    .directive('transactionErrorPanel', ['appSettings', function (appSettings) {
        return {
            restrict: 'E',
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/transactionErrorPanel/transactionErrorPanel.html',
            scope: false,
            controller: ['$scope', '$attrs', 'errorSvc', function ($scope, $attrs, errorSvc) {
                $scope.errorPanelVM = { errorArray: errorSvc.allErrors, displayClass: 'alert-danger' };

                // this will default to the X showing up in the upper right hand corner to clear the errors and hide the panel
                $scope.allowDismiss = true;

                // default to all, you can categorize what error messages go where.  for example. have a filter errors and a list errors seperate.
                $scope.category = 'all';

                // this will show tech details
                $scope.showDetails = false;

                if ($attrs.displayType) {
                    $scope.errorPanelVM.displayType = $attrs.displayType;

                    switch($attrs.displayType) {
                        case 'notification':
                        case 'Notification':
                            $scope.errorPanelVM.displayClass = 'alert-warning';
                            break;
                        case 'error':
                        case 'Alert':
                        case 'alert':
                        case 'validation':
                        case 'Validation':
                            $scope.errorPanelVM.displayClass = 'alert-danger';
                            break;
                    }
                }

                $scope.isVisible = function () {
                    return _.filter($scope.errorPanelVM.errorArray, { type: $attrs.displayType }).length > 0;
                }

                $scope.dismissErrorPanel = function() {
                    $scope.errorPanelVM = [];
                }
            }],
            link: function (scope, element, attrs, ngModelCtrl) { }
        }
    }
    ]);

})();;
(function () {
    'use strict';
    angular.module('nha.core').directive('dateEntry', ['$state', '$rootScope', '$window', 'appSettings', function ($state, $rootScope, $window, appSettings) {
        return {
            restrict: 'E',
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/dateEntry/dateEntry.html',
            scope: {
                date: '=',
                inputName: '@?',
                isRequired: '@?',
                isDisabled: '=',
                isReadOnly: '=?',
                options: '@?',
                onChange: '&?',
                scaled: '=',
                iconClass: '@',
                dynamicDatePickerOptions: '=?'
            },
            link: function(scope, element, attrs, ngModelCtrl) {
                // Check to see if element is within a disabled fieldset
                scope.isFieldSetDisabled = element.closest('fieldset').prop('disabled') || false;

                // ensure we have the correct placeholder text
                scope.placeholderMessage = scope.iconClass === 'nha-circle-clock' ? 'Enter a time' : 'Enter a date';

                if (scope.isReadOnly === undefined) scope.isReadOnly = false;

                // define default input control name, if none supplied
                if (!scope.inputName) {
                    scope.inputName = 'dateField';
                }
                if (scope.onChange) {
                    scope.changed = function() {
                        scope.onChange();
                    };
                }
            }
        };
    }]);
})();;
angular.module('nha.core')
.directive('dateFormatter', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelController) {
            ngModelController.$parsers.push(function (data) {
                //View -> Model
                return data;
            });
            ngModelController.$formatters.push(function (data) {
                //Model -> View
                return moment(data).format("MMM DD, YYYY");
            });
        }
    }
})
.directive('timeFormatter', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelController) {
            ngModelController.$parsers.push(function (data) {
                return data;
            });
            ngModelController.$formatters.push(function (data) {
                return moment(data).format("h:mm:ss a");
            });
        }
    }
});
;
(function () {
	"use strict";

	angular.module("nha.core").directive("ifHasEntitlement", [
		function () {
			return {
				restrict: "A",
				link: function (scope, element, attrs) {
					$(element).hide();

					var entitlementParts = attrs.ifHasEntitlement
						.toLowerCase()
						.split("|");
					var entitlementType = entitlementParts[0];
					var entitlementName = entitlementParts[1];

					var userContext = window.userContext;

					if (
						userContext.entitlements.find(function (entitlement) {
							return (
								entitlement.entitlementType.toLowerCase() ===
									entitlementType &&
								entitlement.entitlementName.toLowerCase() ===
									entitlementName
							);
						})
					) {
						$(element).show();
					} else {
						$(element).remove();
					}
				},
			};
		},
	]);
})();
;
(function () {
	"use strict";

	var featureFlagService = myNHA.GetApiService("Core", "FeatureFlagService");

	angular.module("nha.core").directive("ifHasFeatureFlag", [
		"$parse",
		function ($parse) {
			return {
				restrict: "A",
				link: function (scope, element, attrs) {
					$(element).hide();

					featureFlagService
						.checkFeatureFlagStatus(attrs.ifHasFeatureFlag)
						.then(function (status) {
							if (status) {
								$(element).show();
							}
						});
				},
			};
		},
	]);
})();
;
/* @name ifAtLeastOneResourceAccessible.directive
 * @description Only shows element if at least 1 resource defined in attribute is accessible to the current user
 * @syntax ifAtLeastOneResourceAccessible: [{api}\]{resource}[:{action}]
 */
(function () {
    'use strict';
    angular.module('nha.core').directive('ifAtLeastOneResourceAccessible', ['$parse', 'apiSecurityService', 'apiResolutionService', '$q', function ($parse, apiSecurityService, apiResolutionService, $q) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
            	//debugger;
                //	hide this element until we've verified at least 1 resource is accessible
                $(element).hide();      

				//	begin parsing ifAtLeastOneResourceAccessible
	            var apiResourceActions = [];
				var parsedArray = [];
                var saviyntEntitlements = [];
	            if (attrs.ifAtLeastOneResourceAccessible) {
	            	if (attrs.ifAtLeastOneResourceAccessible.indexOf(',') > -1) {
						apiResourceActions = attrs.ifAtLeastOneResourceAccessible.split(',');
	            	} else {
	            		apiResourceActions.push(attrs.ifAtLeastOneResourceAccessible);
		            }

	            	//	parse apiResourceActions
                    _.forEach(apiResourceActions, function (apiResourceAction) {
                        // If is new entitlement
                        if (apiResourceAction.contains('|')) {
                            saviyntEntitlements.push(apiResourceAction);
                        } else {
                            parsedArray.push(apiSecurityService.parseApiResourceAction(apiResourceAction, attrs.api));
                        }
                        
                    });
                }

                var allRequests = [];

                _.forEach(parsedArray, function (parsed) {
                	var restangular = apiResolutionService.getApiByName(parsed.api);
                    allRequests.push(apiSecurityService.isAccessAllowed(parsed.resource, parsed.action, restangular));
                });

                _.forEach(saviyntEntitlements, function (saviyntEntitlement) {
                    allRequests.push(apiSecurityService.hasSaviyntEntitlement(saviyntEntitlement))
                })

                //If at least 1 resource is accessible, show this element
                $q.all(allRequests).then(function (results) {
                    if (_.find(results, function (individualResult) {
                        return individualResult;
                    })) {
                        $(element).show();
                    };
                });
            }
    }}]);
})();;
(function () {
    'use strict';
    angular.module('nha.core').directive('ifResourceAccessible', ['$parse', 'apiSecurityService', 'apiResolutionService', function ($parse, apiSecurityService, apiResolutionService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
            	$(element).hide();

                var parsed = apiSecurityService.parseApiResourceAction(attrs.ifResourceAccessible, attrs.api);
                var restangular = apiResolutionService.getApiByName(parsed.api);
                apiSecurityService.isAccessAllowed(parsed.resource, parsed.action, restangular).then(function (result) {
                    if (result) {
                        $(element).show();
                    }
                });
            }
    }}]);
})();;
(function () {
	'use strict';

	angular.module('nha.core')
		.directive('httpSrc', ['$http', function ($http) {
			return {
				restrict: 'A',
				scope: {
					httpSrc: '='
				},
				template: '<p>{{name}}</p>',
				link: function (scope, element, attrs) {
					scope.$watch('httpSrc', function (newVal, oldVal) {
						if (newVal) {
							var requestConfig = {
								method: 'Get',
								url: scope.httpSrc,
								responseType: 'arraybuffer',
								cache: 'true'
							};

							$http(requestConfig)
								.success(function (data) {
									var arr = new Uint8Array(data);

									var raw = '';
									var i, j, subArray, chunk = 5000;
									for (i = 0, j = arr.length; i < j; i += chunk) {
										subArray = arr.subarray(i, i + chunk);
										raw += String.fromCharCode.apply(null, subArray);
									}

									var b64 = btoa(raw);

									attrs.$set('src', 'data:image/jpeg;base64,' + b64);
								});
						}
					});
				}
			};
	}]);
})();;
(function () {
    'use strict';

    angular.module('nha.core')
    .directive('dropdownSubmenu', ['appSettings', '$timeout', function (appSettings, $timeout) {
        return {
            restrict: 'EA',
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/dropdownSubmenu/dropdownSubmenu.html',
            scope: {
                options: '=',
                selectedModel: '=',
                customSettings: '=?settings',
                customTexts: '=?texts',
                showTagCloud: '=?',
                disabled: '=',
                onChange: '&',
            },
            link: function (scope, el, attrs) {

                scope.grpSelectAll = {};

                //Default settings that can be overridden by customSettings.
                var defaultSettings = {
                    optionID: 'id',
                    optionLabel: 'label',
                    selectionLimit: 1, /* 0 = Infinite Multiselct*/
                    selectAll: false
                }

                //Default texts that can be overridden by customTexts.
                var defaultTexts = {
                    selectAll: 'Select All'
                }

                // If no on change callback is provided, use angular.noop function.
                if (!attrs.onChange) { scope.onChange = angular.noop };

                //Override default settings with passed in settings
                scope.settings = _.assign(defaultSettings, scope.customSettings || {});
                scope.texts = _.assign(defaultTexts, scope.customTexts || {});

                scope.$watch('customSettings', function() {
                    scope.settings = _.assign(defaultSettings, scope.customSettings || {});
                    scope.texts = _.assign(defaultTexts, scope.customTexts || {});

                    scope.singleSelection = scope.settings.selectionLimit === 1;
                });


                function getFindObj(id) {
                    var findObj = {};
                    findObj[scope.settings.optionID] = id;

                    return findObj;
                }

                if (scope.settings.groupBy) {
                    scope.$watch('options', function(newValue) {
                        if (newValue) {
                            scope.groupedOptions = _.groupBy(scope.options, scope.settings.groupBy);

                            //Default Select All if all options are selected on init
                            if (scope.settings.selectAll) {
                                _.each(_.keys(scope.groupedOptions), function(key) {
                                    scope.grpSelectAll[key] = _.every(scope.groupedOptions[key], function(i) {
                                        return scope.isChecked(scope.getPropertyForObject(i, scope.settings.optionID));
                                    });
                                });
                            }
                        }
                    });
                }

                scope.checkboxClick = function ($event, id, key) {
                    $event.stopPropagation();
                    if (!scope.grpSelectAll[key])
                        scope.setSelectedItem(id);
                    
                };

                scope.selectAll = function ($event, grpItems, key, allowRemove) {
                    if (scope.singleSelection) {
                        if (grpItems.length > 1) {
                            return;
                        }
                        scope.selectedModel = _.head(grpItems);
                        $timeout(function () {
                            scope.onChange();
                        });
                        return;
                    }
                    $event.stopPropagation();

                    scope.grpSelectAll[key] = !scope.grpSelectAll[key];

                    _.forEach(grpItems, function (value) {
                        scope.setSelectedItem(value[scope.settings.optionID], !allowRemove);
                    });
                };

                scope.setSelectedItem = function (id, preventRemove) {
                    var findObj = getFindObj(id);
                    var item = _.find(scope.options, findObj);

                    if (scope.singleSelection) {
                        scope.selectedModel = item;
                        $timeout(function () {
                            scope.onChange();
                        });
                        return;
                    } else {
                        if (!_.isArray(scope.selectedModel)) {
                            scope.selectedModel = [];
                        }
                    }

                    preventRemove = preventRemove || item.disabled || false;

                    var exists = _.findIndex(scope.selectedModel, findObj) !== -1;

                    if (!preventRemove && exists) {
                        scope.selectedModel.splice(_.findIndex(scope.selectedModel, findObj), 1);
                        scope.onChange();
                    } else if (!exists && !item.disabled && (scope.settings.selectionLimit === 0 || scope.selectedModel.length < scope.settings.selectionLimit)) {
                        scope.selectedModel.push(item);
                        scope.onChange();
                    }
                };

                scope.getPropertyForObject = function (object, property) {
                    if (object && object.hasOwnProperty(property)) {
                        return object[property];
                    }
                    return '';
                };

                scope.isChecked = function (id) {
                    if (!scope.selectedModel)
                        return 0;

                    if (scope.singleSelection) {
                        if (_.isArray(scope.selectedModel)) {
                            var item = _.head(scope.selectedModel);
                            return item && item[scope.settings.optionID] && item[scope.settings.optionID] === getFindObj(id)[scope.settings.optionID];
                        } else {
                            return scope.selectedModel !== null && scope.selectedModel[scope.settings.optionID] && scope.selectedModel[scope.settings.optionID] === getFindObj(id)[scope.settings.optionID];
                        }
                    }

                    return _.findIndex(scope.selectedModel, getFindObj(id)) !== -1;
                };

                scope.getModelDisplayValue = function () {
                    if (!scope.selectedModel || _.isEmpty(scope.selectedModel)) {
                        return "Select...";
                    } else {
                        
                        var selectedItems = [];
                        if (scope.settings.groupBy && scope.groupedOptions) {
                            _.forOwn(scope.groupedOptions, function (opts, key) {
                                var allSelected = _.every(opts, function(opt) {
                                    return scope.isChecked(scope.getPropertyForObject(opt, scope.settings.optionID));
                                });
                                if (allSelected) {
                                    selectedItems.push(key);
                                } else {
                                    _.each(opts, function (opt) {
                                        if (scope.isChecked(scope.getPropertyForObject(opt, scope.settings.optionID))) {
                                            selectedItems.push(scope.getPropertyForObject(opt, scope.settings.optionLabel));
                                        }
                                    });
                                }
                            });
                        } else {
                            _.each(scope.options, function(opt) {
                                if (scope.isChecked(scope.getPropertyForObject(opt, scope.settings.optionID))) {
                                    selectedItems.push(scope.getPropertyForObject(opt, scope.settings.optionLabel));
                                }
                            });
                        }
                        return selectedItems.length > 1 ? "Multiple" : _.head(selectedItems);
                    }

                };

            }
        }
    }
    ]);

})();;
(function () {
    'use strict';


    angular.module('nha.core')
    .directive('tagCloud', ['appSettings', function (appSettings) {
        return {
            restrict: 'EA',
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/tagCloud/tagCloud.html',
            scope: {
                data: '='
            },
            link: function (scope, el) {

                // example structure
                //  [{ "id": 21, "name": "Every day", "disableOtherItemsIfSelected": true }, { "id": 22, "name": "Monday", "disabled": true }, { "id": 23, "name": "Tuesday", "disabled": true }, { "id": 24, "name": "Wednesday", "disabled": true }, { "id": 25, "name": "Thursday", "disabled": true }, { "id": 26, "name": "Friday", "disabled": true }, { "id": 51, "name": "Every day", "disableOtherItemsIfSelected": true }, { "id": 52, "name": "Monday", "disabled": true }, { "id": 53, "name": "Tuesday", "disabled": true }, { "id": 54, "name": "Wednesday", "disabled": true }, { "id": 55, "name": "Thursday", "disabled": true }, { "id": 56, "name": "Friday", "disabled": true }, { "id": 12, "name": "Monday" }, { "id": 13, "name": "Tuesday" }]

                scope.unselectItem = function ($index, tag) {
                    if (tag && !tag.disabled) {
                        scope.data.splice($index, 1);
                    }
                }

                var init = function () {

                }

                init();
            }
        }
    }
    ]);

    //angular.module('nha.core').filter('selectedItemsFilter', function () {
    //    return function (items) {
    //        log('item', items);
    //       return (items);

    //        var selectedItems = [];

    //        if (items) {
    //            //var selectedFirstLevelItems = _.filter(items, 'selected');
    //            //log('selectedFirstLevelItems', selectedFirstLevelItems);
    //            //if (selectedFirstLevelItems) {
    //            ////    selectedItems.push(selectedFirstLevelItems);
    //            //}
    //            //log(_.filter(items, 'selected'));
    //            //selectedItems.push(_.filter(items, 'selected'));
    //            _.forEach(items, function(i) {
    //                if (i.items) {
    //                    selectedItems.push(_.filter(i.items, 'selected'));
    //                }
    //            });
    //        }

    //        return selectedItems;
    //    };
    //});
    

})();


;
(function () {
    'use strict';
    angular.module('nha.core')
        .directive('actionSaveStatus', function () {
            return {
                restrict: 'E',
                scope: {
                    // Array of promises
                    saveQueue: '='
                },
                template: '<span>{{currentState}}</span>',
                controller: ['$scope', '$q', '$timeout', function ($scope, $q, $timeout) {

                    //Watch our queue for new promises.
                    $scope.$watchCollection('saveQueue', function () {
                        if ($scope.saveQueue.length) {
                            $scope.currentState = 'Saving...';
                            log('Save Queue Count', $scope.saveQueue.length);
                            // Catch any notifications from the latest singular promise.
                            _.last($scope.saveQueue).then(null,null,function(notification) {
                                $scope.currentState = notification || 'Notification Recieved';
                            });

                            //Wait for empty queue.
                            $q.all($scope.saveQueue).then(
                                // Success
                                function (success) {
                                    $scope.currentState = _.last(success) || 'All Changes Saved';
                                },
                                // Rejected
                                function (failed) {
                                    $scope.currentState = failed || 'Error Saving Changes!';
                                }).finally(function () {
                                    $scope.saveQueue = [];
                                    log('Save Queue Count', $scope.saveQueue.length);
                            });
                        }
                    });
                }]
            }
        }
        );
})();;
(function () {
    'use strict';

    /**
     * @name confirmOnExit
     * 
     * @description
     * Prompts user while he navigating away from the current route (or, as long as this directive 
     * is not destroyed) if any unsaved form changes present.
     * 
     * @element Attribute
     * @scope
     * @param confirmOnExit Scope function which will be called on window refresh/close or AngularS $route change to
     *                          decide whether to display the prompt or not.
     * @param confirmMessageWindow Custom message to display before browser refresh or closed.
     * @param confirmMessageRoute Custom message to display before navigating to other route.
     * @param isolateArea Allows you to not prompt for confirmation if the next state/url contains this string.
     * 
     * @example
     * Usage:
     * Example Controller: (using controllerAs syntax in this example)
     * 
     *      angular.module('AppModule', []).controller('pageCtrl', [function () {
     *          this.isDirty = function () {
     *              // do your logic and return 'true' to display the prompt, or 'false' otherwise.
     *              return true;
     *          };
     *      }]);
     * 
     * Template:
     * 
     *      <div confirm-on-exit="pageCtrl.isDirty()" 
     *          confirm-message-window="All your changes will be lost."
     *          confirm-message-route="All your changes will be lost. Are you sure you want to do this?">
     * 
     * @see
     * http://stackoverflow.com/a/28905954/340290
     * 
     * @author Manikanta G
     */
    angular.module('nha.core').directive('confirmOnExit', function () {
        return {
            scope: {
                confirmOnExit: '&',
                confirmMessageWindow: '@',
                confirmMessageRoute: '@',
                ignoredUrls: '=?',
                isolateArea: '@'
            },
            link: function ($scope, elem, attrs) {
                var defaultConfirmMessageWindowMessage = 'All your changes will be lost!';
                var defaultConfirmMessageRouteMessage = 'All your changes will be lost. Are you sure you want to do this?';
                if (!$scope.ignoredUrls) {
                    $scope.ignoredUrls = [];
                }
                window.onbeforeunload = function () {
                    if ($scope.confirmOnExit()) {
                        return $scope.confirmMessageWindow || defaultConfirmMessageWindowMessage;
                    }
                }
                var $locationChangeStartUnbind = $scope.$on('$locationChangeStart', function (event, next, current) {
                    if ($scope.confirmOnExit()) {
                        log('$locationChangeStart event', event, next, current);

                        //If next is not within a specified isolated area.
                        if (!$scope.isolateArea || ($scope.isolateArea && !_.includes(next, '/' + $scope.isolateArea + '/'))) {
                            // If next is not one of the specified ignored urls
                            if (!$scope.ignoredUrls.length || !(_.some($scope.ignoredUrls, function (url) { return _.includes(next, url) }))) {
                                if (!confirm($scope.confirmMessageRoute || defaultConfirmMessageRouteMessage)) {
                                    event.preventDefault();
                                }
                            }
                        }
                    }
                });

                $scope.$on('$destroy', function () {
                    window.onbeforeunload = null;
                    $locationChangeStartUnbind();
                });
            }
        };
    });

})();;
(function () {
    'use strict';

    angular.module('nha.core')
        .directive('meetingBlockDisplay', ['appSettings',
            function (appSettings) {
                return {
                    restrict: 'EA',
                    template: '<ul style="list-style-type: none; padding: 0;"><li ng-repeat="meetingBlock in getNewMeetingBlockTimes() track by $index">{{meetingBlock}}</li></ul>',
                    scope: {
                        meetingBlockTimes: '=',
                        masterScheduleTypeId: '=?',
                        displayHorizontally: '=?',
                        hideTime: '=?'
                    },
                    controller: ['$scope', function (scope) {
                        scope.getNewMeetingBlockTimes = function () {
                            var returnValue = [];

                            if (scope.masterScheduleTypeId && scope.meetingBlockTimes && _.isArray(scope.meetingBlockTimes)) {
                                // meetingBlockTime expected object: {MeetingBlockName, MeetingBlockStartTime, MeetingBlockEndTime} 
                                //   where start and end time are derived from TimeSpan (time only, no date).  
                                //   Retrieve formatted string using: moment(timeSpan, 'HH:mm:ss').format('LT')
                                if (scope.masterScheduleTypeId === 3) {
                                    // self contained full day
                                    if (scope.meetingBlockTimes.length === 2
                                        && _.find(scope.meetingBlockTimes, { meetingBlockName: 'AM' })
                                        && _.find(scope.meetingBlockTimes, { meetingBlockName: 'PM' })) {
                                        returnValue.push('AM/PM'); // No time added, as per requirement
                                    }
                                } else if (scope.meetingBlockTimes.length === 1) {
                                    // replace with e.g. 'AM (8:00am - 11:30am)'
                                    if (scope.hideTime) {
                                        // do not add time
                                        returnValue.push(scope.meetingBlockTimes[0].meetingBlockName);
                                    } else {
                                        // add time
                                        returnValue.push(scope.meetingBlockTimes[0].meetingBlockName + ' (' + moment(scope.meetingBlockTimes[0].meetingBlockStartTime, 'HH:mm:ss').format('LT') + ' - ' + moment(scope.meetingBlockTimes[0].meetingBlockEndTime, 'HH:mm:ss').format('LT') + ')');
                                    }
                                } else if (scope.meetingBlockTimes.length > 1) {
                                    
                                    // if we come in here, we have multiple values.  let's check to see if we can concat them to show them friendler
                                    // Expects to process records like:
                                    //    3rd Period - Tu
                                    //    3rd Period - W
                                    //    3rd Period - Th
                                    // into: 3rd Period - Tu/W/Th (8:00am - 11:30am)

                                    // get the left side so we can see if they are all the same
                                    // e.g. matches: ['3rd Period']
                                    var matches = [];
                                    _.forEach(scope.meetingBlockTimes, function (mbt) {
                                        var firstSpaceIndex = mbt.meetingBlockName.indexOf(' ');
                                        var secondSpaceIndex = mbt.meetingBlockName.indexOf(' ', firstSpaceIndex + 1);

                                        if (firstSpaceIndex === -1 || secondSpaceIndex === -1) {
                                            // if not in expected format, just push name as it is
                                            matches.push(mbt.meetingBlockName);
                                        } else {
                                            // otherwise, slice it up
                                            matches.push(new String(mbt.meetingBlockName).slice(0, secondSpaceIndex));
                                        }
                                    });

                                    // get unique items for the left side
                                    var uniques = _.uniq(matches);

                                    _.forEach(uniques, function (leftSide) {

                                        // now go through and figure out our right side
                                        var dayAndTime = [];
                                        _.forEach(scope.meetingBlockTimes, function (mbt) {

                                            var firstSpaceIndex = mbt.meetingBlockName.indexOf(' ');
                                            var secondSpaceIndex = mbt.meetingBlockName.indexOf(' ', firstSpaceIndex + 1);

                                            // process those that match left side
                                            // e.g. { day: 'M', time: '12:00pm - 1:00pm'}
                                            if ((firstSpaceIndex === -1 || secondSpaceIndex === -1) && (leftSide === mbt.meetingBlockName)) {
                                                // if not in expected format, just use name as it is
                                                if (!scope.hideTime) {
                                                    // only push if time is requested
                                                    dayAndTime.push({
                                                        day: '',
                                                        time: ' (' + moment(mbt.meetingBlockStartTime, 'HH:mm:ss').format('LT') + ' - ' + moment(mbt.meetingBlockEndTime, 'HH:mm:ss').format('LT') + ')'
                                                    });
                                                }
                                            } else if (leftSide === new String(mbt.meetingBlockName).slice(0, secondSpaceIndex)) {
                                                // otherwise, slice it up
                                                if (scope.hideTime) {
                                                    // do not add time
                                                    dayAndTime.push({
                                                        day: _.trim(new String(mbt.meetingBlockName).slice(secondSpaceIndex, mbt.meetingBlockName.length).replace('-', '')),
                                                        time: ''
                                                    });
                                                } else {
                                                    // add time
                                                    dayAndTime.push({
                                                        day: _.trim(new String(mbt.meetingBlockName).slice(secondSpaceIndex, mbt.meetingBlockName.length).replace('-', '')),
                                                        time: ' (' + moment(mbt.meetingBlockStartTime, 'HH:mm:ss').format('LT') + ' - ' + moment(mbt.meetingBlockEndTime, 'HH:mm:ss').format('LT') + ')'
                                                    });
                                                }
                                            }

                                        });

                                        // group days together by times
                                        // e.g. [
                                        //          {   time: '12:00pm - 1:00pm', 
                                        //              days: [
                                        //                  { day: 'M', time: '12:00pm - 1:00pm'}, 
                                        //                  { day: 'Tu', time: '12:00pm - 1:00pm'}, 
                                        //                  { day: 'Th', time: '12:00pm - 1:00pm'}
                                        //              ]
                                        //          },
                                        //          {   time: '2:00pm - 3:00pm', 
                                        //              days: [
                                        //                  { day: 'W', time: '2:00pm - 3:00pm'}, 
                                        //                  { day: 'F', time: '2:00pm - 3:00pm'}
                                        //              ]
                                        //          }
                                        //      ]
                                        var daysByTime = _
                                            .chain(dayAndTime)
                                            .groupBy('time')
                                            .toPairs()
                                            .map(function (currentItem) {
                                                return _.zipObject(['time', 'days'], currentItem);
                                            })
                                            .value();

                                        // build out the day / times and append to leftSide
                                        // e.g. '3rd Period M/Tu/Th (12:00pm - 1:00pm)' and '3rd Period W/F (2:00pm - 3:00pm)'
                                        var target = [];
                                        if (!daysByTime || daysByTime.length === 0) {
                                            // if there are no days and hideTime is true, still need left side
                                            target.push(leftSide);
                                        } else {
                                            // tack days and times to the leftside
                                            _.forEach(daysByTime, function (item) {
                                                var joinedDays = _.map(item.days, 'day').join('/');
                                                joinedDays = sortJoinedDays(joinedDays);
                                                if (joinedDays === 'M/Tu/W/Th/F' || joinedDays === 'M/T/W/Th/F') {
                                                    // If all days are included, don't need to display them; just display the ;
                                                    // Instead of: 3rd Period M/Tu/W/Th/F
                                                    // ...just display: 3rd Period
                                                    joinedDays = '';
                                                }
                                                target.push(leftSide + (joinedDays ? ' ' + joinedDays : '') + (item.time && !scope.hideTime ? ' ' + item.time : ''));
                                            });
                                        }

                                        // ...and replace meeting block
                                        returnValue = _.union(returnValue, target);

                                    });

                                    // transform to comma separated list as single array element, if need to display horizontally
                                    if (scope.displayHorizontally) {
                                        var horizontalValues = returnValue.join(', ');
                                        returnValue = [];
                                        returnValue.push(horizontalValues);
                                    }

                                }
                            }

                            else if (scope.meetingBlockTimes) {
                                // original implementation

                                // if this is a self contained with only AM and PM
                                if (scope.meetingBlockTimes.length === 2 && scope.meetingBlockTimes[0] === 'AM' && scope.meetingBlockTimes[1] === 'PM') {
                                    returnValue.push('AM/PM');
                                } else if (scope.meetingBlockTimes.length > 1) {

                                    // if we come in here, we have multiple values.  let's check to see if we can concat them to show them friendler

                                    // get the left side so we can see if they are all the same
                                    var matches = [];
                                    _.forEach(scope.meetingBlockTimes, function (mbt) {
                                        var firstSpaceIndex = mbt.indexOf(' ');
                                        var secondSpaceIndex = mbt.indexOf(' ', firstSpaceIndex + 1);
                                        matches.push(new String(mbt).slice(0, secondSpaceIndex));
                                    });

                                    // if they are all the same, its a candidate for concat
                                    var uniques = _.uniq(matches);
                                    if (uniques.length === 1) {

                                        // now go through and figure out our right side
                                        var concattedResult = [];
                                        _.forEach(scope.meetingBlockTimes, function (mbt) {

                                            var firstSpaceIndex = mbt.indexOf(' ');
                                            var secondSpaceIndex = mbt.indexOf(' ', firstSpaceIndex + 1);

                                            concattedResult.push(_.trim(new String(mbt).slice(secondSpaceIndex, mbt.length).replace('-', '')));

                                        });

                                        // finally, bring it all together
                                        returnValue.push(uniques[0] + ' ' + concattedResult.join('/'));
                                    }
                                }
                            }

                            return returnValue;
                        }

                        function sortJoinedDays(strJoinedDays) {

                            if (strJoinedDays && strJoinedDays.length > 0) {
                                var str = strJoinedDays.split("/");
                                if (str.length > 0) {
                                    str.sort(compareDays);
                                    strJoinedDays = str.join("/");
                                }
                            }
                            return strJoinedDays;
                        }


                        function compareDays(day1, day2) {
                            switch (day1) {
                                case 'M':
                                    if (day2 === 'T' || day2 === 'W' || day2 === 'Th' || day2 === 'F') {
                                        return -1;
                                    }
                                    break;
                                case 'T':
                                    if (day2 === 'W' || day2 === 'Th' || day2 === 'F') {
                                        return -1;
                                    }
                                    else if (day2 === 'M') {
                                        return 1;
                                    }
                                    break;
                                case 'W':
                                    if (day2 === 'Th' || day2 === 'F') {
                                        return -1;
                                    }
                                    else if (day2 === 'M' || day2 === 'T') {
                                        return 1;
                                    }
                                    break;

                                case 'Th':
                                    if (day2 === 'F') {
                                        return -1;
                                    }
                                    else if (day2 === 'M' || day2 === 'T' || day2 === 'W') {
                                        return 1;
                                    }
                                    break;

                                case 'F':
                                    if (day2 === 'M' || day2 === 'T' || day2 === 'W' || day2 === 'Th') {
                                        return 1;
                                    }
                                    break;
                            }
                            return 0;
                        }
                    }]
                }
            }
        ]);

})();;
/*  modified version of infinite scroll
 *  originial directive found here: https://github.com/lorenzofox3/lrInfiniteScroll
 * 
 *  had to seek out an alternative as ngInfiniteScroll would not work in modals because of its reliance on $window elements 
 */

(function () {
    'use strict';
    angular
        .module('nha.core')
        .directive('infiniteScrollModal', infiniteScrollModal);

    infiniteScrollModal.$inject = ['$timeout'];

    function infiniteScrollModal($timeout) {
        var directive = {
            restrict: 'A',
            link: nhaInfiniteScrollLink
        };

        return directive;

        function nhaInfiniteScrollLink(scope, element, attr) {
            var
                lengthThreshold = attr.scrollThreshold || 50,
                timeThreshold = attr.timeThreshold || 400,
                promise = null,
                lastRemaining = 9999;

            lengthThreshold = parseInt(lengthThreshold, 10);
            timeThreshold = parseInt(timeThreshold, 10);


            element.bind('scroll', function () {
                var remaining = element[0].scrollHeight - (element[0].clientHeight + element[0].scrollTop);

                //if we have reached the threshold and we scroll down
                if (remaining < lengthThreshold && (remaining - lastRemaining) < 0) {

                    //if there is already a timer running which has no expired yet we have to cancel it and restart the timer
                    if (promise !== null) {
                        $timeout.cancel(promise);
                    }
                    promise = $timeout(function () {
                        scope.$eval(attr.infiniteScrollModal);
                        promise = null;
                    }, timeThreshold);
                }
                lastRemaining = remaining;
            });

        }
    }

})();

;
(function () {
    'use strict';

    angular.module('nha.core')
        .directive('pageTabs', [
            '$state', 'appSettings', 'apiSecurityService', 'apiResolutionService', 'Restangular', function ($state, appSettings, apiSecurityService, apiResolutionService, restangular) {
                return {
                    restrict: 'EA',
                    transclude: true,
                    scope: {
                        tabs: '=',
                        params: '='
                    },
                    templateUrl: appSettings.coreWebRootUrl + 'app/directives/pageTabs/pageTabs.html',
                    link: function (scope, el, attrs) {

                        // we have to bind to a local variable inside this directive in order for two way binding to work, because of how we are passing in the json array as a value parm.  that make perfect sense, right?
                        scope.tabToDisplay = scope.tabs;

                        _.forEach(scope.tabToDisplay, function (tab) {

                            if (tab.security) {
                                var tabRestangular = tab.security.api ? apiResolutionService.getApiByName(tab.security.api) : restangular;

                                var parsedResource = apiSecurityService.parseResource(tab.security.requiredResource);

                                apiSecurityService.isAccessAllowed(parsedResource.resource, parsedResource.action, tabRestangular).then(function (result) {
                                    tab.hidden = !result;
                                });
                            }
                        });

                        scope.isActive = function (tab) {
                            var indexOfParen = tab.sref.indexOf('(');

                            var srefToCheck = indexOfParen > -1 ? tab.sref.substring(0, indexOfParen) : tab.sref;

                            //return $state.current.name.indexOf(srefToCheck) > -1; // Includes srefToCheck; may have unexpected matches
                            return $state.current.name === srefToCheck;
                        }
                    }
                }
            }
        ]);
})();;
/// <reference path="avatar-resizer.html" />
/**
 * avatar-resizer.directive
 * @namespace Core
 */
(function () {
    'use strict;';

    angular.module('nha.core').directive('avatarResizer', ['appSettings', function (appSettings) {
        return {
            restrict: 'E',
            templateUrl: appSettings.coreWebRootUrl + 'app/directives/avatarResizer/avatar-resizer.html',
            require: '^resizeWrapper'
        };
    }]);

    /**
   * @name resizeWrapper
   * @description Add to element that contains the elements to be resized.
   * @memberOf Behavior & Attendance (probably need to place in core).
   */
    angular.module('nha.core').directive('resizeWrapper', ['appSettings', function (appSettings) {
        return {
            restrict: 'A',
            controller: resizeWrapperController,
            controllerAs: 'resizeWrapperVM',
            };
    }]);

    angular.module('nha.core').directive('resizeMe', resizeMe);

    /**
    * @name resizeWrapperController
    * @description Controller for resizeWrapper directive. Contains logic for element scale storage.
    * @memberOf Behavior & Attendance (probably need to place in core).
    */
    function resizeWrapperController($cookieStore) {
        var resizeWrapperVM = this;
			
	    function init() {
	        // Retreive from storage;
	        var defaultScale = $cookieStore.get('avatar-scale');

	        // Make sure it's in our range
	        if (!defaultScale || defaultScale > 6 || defaultScale < 1) {
	            defaultScale = 3;
	        }

	        resizeWrapperVM.avatarScale = defaultScale; // Update VM with scale;
	    }

	    init();
    }

    /**
     * @name resizeMe
     * @description Attaches to the elements to be resized.
     * @memberOf Behavior & Attendance (probably need to place in core).
     */
    function resizeMe() {
        var directive = {
            restrict: 'A',
            scope: { avatarScale: '=' },
            link: resizeMeLink
        };

        function resizeMeLink(scope, element) {
            scope.$watch('avatarScale', function () {
                var widths = {
                    6: '25%',
                    5: '22%',
                    4: '19%',
                    3: '16%',
                    2: '13%',
                    1: '10%'
                };

                element.css({ 'width': widths[scope.avatarScale] });
            });
        }
        return directive;
    }

    // protect against minification
    /* @ngInject */
    resizeWrapperController.$inject = ['$cookieStore'];
})();
;
(function () {
    'use strict';

    var app = angular.module('nha.core');

    app.directive('overflowContainer', ['$window', '$timeout', function ($window, $timeout) {
        return {
            restrict: 'A',
            transclude: true,
            scope: {
                overflowItems: '=',
                rightBuffer: '=?',
                maxItemCount: '=?'
            },
            controller: ['$scope', '$element', '$window', function ($scope, $element, $window) {
                $scope.overflowItems = [];
                $scope.items = [];

                var resizeDelay = 200;
                var delayedHandler = null;

                var rightBuffer = ($scope.rightBuffer || 150);

                this.registerItem = function (item) {
                    $scope.items.push(item);
                    checkForOverflows();
                }

                this.deregisterItem = function (item) {
                    _.remove($scope.items, item);
                    _.remove($scope.overflowItems, item);
                }

                function checkForOverflows() {
                    $timeout(function () {
                        var sum = 0;
                        _($scope.items).map(function(item, i) {
                            sum += item.element.outerWidth(true);
                            if (sum > ($element.innerWidth() - rightBuffer) || ($scope.maxItemCount && i > ($scope.maxItemCount - 1))) {
                                if (!_.some($scope.overflowItems, item.content)) {
                                    $scope.overflowItems.push(item.content);
                                    item.element.addClass('hidden');
                                }
                            } else {
                                _.remove($scope.overflowItems, item.content);
                                item.element.removeClass('hidden');
                            }
                        }).value();
                    });
                }

                angular.element($window).bind('resize', function () {
                    if (delayedHandler !== null) {
                        clearTimeout(delayedHandler);
                    }
                    
                    delayedHandler = setTimeout(checkForOverflows, resizeDelay);
                });

            }],
            link: function (scope, el, attrs, ctrl, transclude) {
                transclude(function (clone) {
                    el.append(clone);
                });
            }

        };
    }]);

    app.directive('overflowItem', function () {
        return {
            require: '^overflowContainer',
            restrict: 'A',
            scope: {
                overflowItem: '='
            },
            link: function (scope, el, attrs, overflowCtrl) {
                var item = {
                    element: el,
                    content: scope.overflowItem || el[0].innerText,
                    hide: function() {
                        el.addClass('hidden');
                    },
                    show: function() {
                        el.removeClass('hidden');
                    }
                }
                //Hide by default until registered.
                el.addClass('hidden');
                //Register the item with the container controller
                overflowCtrl.registerItem(item);

                scope.$on("$destroy", function handleDestroyEvent() {
                    overflowCtrl.deregisterItem(item);
                });
            }

        };
    });

})();
;
(function () {
    'use strict';

    var app = angular.module('nha.core');

    app.directive('dropPosition', function () {
        return {
            restrict: 'A',
            link: function (scope, el) {
                el.on("click", function(ev) {
                    var dropdownContainer = ev.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var buttonHeight = dropdownContainer.getBoundingClientRect().height;

                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu');
                    var menuHeight = dropdownMenu.outerHeight();

                    var $win = $(window);

                    //alert('Position: ' + position + '. MenuHeight: ' + menuHeight + '. WinHeight: ' + $win.height() + '. ButtonHeight: ' + buttonHeight + '. WindowHeight - Position: ' + ($win.height() - position) + '. ButtonHeight + MenuHeight: ' + (buttonHeight + menuHeight));
                    
                    if (position > menuHeight && $win.height() - position < buttonHeight + menuHeight) {
                        el.addClass('dropup');
                    }
                    else {
                        el.removeClass('dropup');
                    }
                });
            }

        };
    });

})();
;
(function () {
    'use strict';

    angular.module('nha.core').directive('widthConstraint', widthConstraint);

    widthConstraint.$inject = [];

    function widthConstraint() {
        var directiveObj = {
            restrict: 'A',
            link: linkFn
        };

        return directiveObj;

        function linkFn(scope, element, attrs) {
            function setConstraints() {
                var offsetPosition = element.offset();
                element.css({
                    "min-width": (1000 - offsetPosition.left) + 'px',
                    "max-width": (1800 - offsetPosition.left) + 'px'
                });
            }

            setConstraints();

            scope.$on('filterPanelOpened', setConstraints);
            scope.$on('filterPanelClosed', setConstraints);
        }
    }
})();;
(function () {
	'use strict';
	angular.module('nha.core').directive('nhaTest', function () {
		return {
			restrict: 'A',
			link: function ($scope, element, attributes) {
				element[0].setAttribute('data-cy', attributes.nhaTest);
			}
		}
	});
})();;
(function () {
    'use strict';

    // camelCase To Human Filter
    // ---------------------
    // Converts a camelCase string to a human readable string.
    // i.e. myVariableName => My Variable Name

    angular.module('nha.core').filter('camelCaseToHuman', function () {
        return function (input) {
            if (input)
                return input.charAt(0).toUpperCase() + input.substr(1).replace(/[A-Z]/g, ' $&');
            else {
                return input;
            }

        }
    });

})();;
angular
    .module('nha.core')
    .filter('characters', function () {
        return function(input, chars, breakOnWord) {
            if (isNaN(chars)) return input;
            if (chars <= 0) return '';
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    //get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length - 1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        };
    });;
(function () {
	'use strict';

	angular.module('nha.core').filter('dateFilterNullable',['$filter', function ($filter) {
		return function (input, format) {
			var formattedDateString = 'N/A';
			
			/** check for input */
			if (input) {
				/** default the format if none set */
				if (!format) format = 'MMMM d, yyyy hh:mm a'; // September 3, 2013 7:43 AM

				// check to see if this is a msdate
				if (new String(input).indexOf('\/Date') > -1) {
					input = parseInt(new String(input).substr(6));
				}

				var momentDate = moment(input);
				if (momentDate.isValid()) {
					formattedDateString = $filter('date')(new Date(input), format);
				}
			}

			return formattedDateString;
		}
	}]);
})();;
(function () {
    'use strict';
    angular.module('nha.core').filter('dateTz', function () {
        return function (date, timeZone, format) {

            // default our format if not passed in
            if (!format) {
                format = 'MM/DD/YYYY hh:mm:ss a z';
            }

            if (!!date && moment.isMoment(date) && !!date.tz && !!date.tz()) {
                var zone = timeZone || date.tz();
                return date.tz(zone).format(format);
            } else {
                return moment.tz(date, timeZone).format(format);
            }
        };
    });
})();;
angular.module("nha.core").filter("escapeSingleQuote", function() {
    return function(input) {
        input = input.replace(/'/g, '\\\'');
        return input;
    };
});
;
(function () {
    'use strict';
    angular.module('nha.core').filter('localTime', function () {
        return function (date) {
            return moment(date).toDate();
        };
    });
})();;
(function () {
    'use strict';
    angular.module('nha.core').filter('lowercaseTime', function () {
        return function (d) {
            // Simply replaces uppercase AM:PM timestamps with lowercase version.
            return d.toString().replace("AM", "am").replace("PM", "pm");
        };
    });
})();;
(function () {
    'use strict';
    angular.module('nha.core')
		.filter('militaryTo12Hour', function () {
		    return function (time) {
		        return moment(time, "HH:mm:ss").format('h:mm a');
		    }
		});
})();;
(function () {
    'use strict';

	angular.module('nha.core').filter('namecase', function () {
	    return function (name) {
	        if (NameCase && NameCase.checkName(name)) {
	            return NameCase(name);
	        } else {
	            return name;
	        }
	    };
	});

})();;
angular.module('nha.core').filter('namecase', function () {
    return function (input) {
        return input ? input.toNameCase() : '';
    };
});

;
(function () {
    'use strict';

    angular
        .module('nha.core')
        .filter('phoneNumber', function () {
            return function (tel) {
                if (!tel) { return ''; }

                var value = tel.toString().trim().replace(/^\+/, '');

                if (value.match(/[^0-9]/)) {
                    return tel;
                }

                var country, city, number;

                switch (value.length) {
                    case 10: // +1PPP####### -> C (PPP) ###-####
                        country = 1;
                        city = value.slice(0, 3);
                        number = value.slice(3);
                        break;

                    case 11: // +CPPP####### -> CCC (PP) ###-####
                        country = value[0];
                        city = value.slice(1, 4);
                        number = value.slice(4);
                        break;

                    case 12: // +CCCPP####### -> CCC (PP) ###-####
                        country = value.slice(0, 3);
                        city = value.slice(3, 5);
                        number = value.slice(5);
                        break;

                    default:
                        return tel;
                }

                if (country === 1) {
                    country = '';
                }

                number = number.slice(0, 3) + '-' + number.slice(3);

                return (country + ' (' + city + ') ' + number).trim();
            };
        });
})();;
(function () {
    'use strict';
    angular.module('nha.core')
		.filter('rangeFilter', function () {
		    return function (items, rangeInfo) {
		        var filtered = [];
		        var min = parseInt(rangeInfo.minIndex);
		        var max = parseInt(rangeInfo.maxIndex);

		        var currentIndex = 0;

		        angular.forEach(items, function (item) {
		            if (currentIndex >= min && currentIndex <= max) {
		                filtered.push(item);
		            }

		            currentIndex++;
		        });

		        return filtered;
		    };
		});
})();;
(function () {
    'use strict';
    angular.module('nha.core')
        .filter('startsWithFirstOrLast', function () {
            return function (dataArray, searchText) {
                if (!dataArray) return;
                if (!searchText) return dataArray;
                var termLower = searchText.toLowerCase();
                return dataArray.filter(function(item) {
                    var startsWithFirst = _.startsWith(item.firstName.toLowerCase(), termLower);
                    var startsWithLast = _.startsWith(item.lastName.toLowerCase(), termLower);
                    var startsWithFirstLast = _.startsWith(item.firstName.toLowerCase() + " " + item.lastName.toLowerCase(), termLower);
                    var startsWithLastFirst = _.startsWith(item.lastName.toLowerCase() + ", " + item.firstName.toLowerCase(), termLower);
                    var startsWithLastFirst2 = _.startsWith(item.lastName.toLowerCase() + " " + item.firstName.toLowerCase(), termLower);
                    var startsWithLastFirst3 = _.startsWith(item.lastName.toLowerCase() + "," + item.firstName.toLowerCase(), termLower);
                    return startsWithFirst || startsWithLast || startsWithFirstLast || startsWithLastFirst || startsWithLastFirst2 || startsWithLastFirst3;
                });
            };
        });
})();;
/** Formats bound phone numbers to appropriate display based on length **/
(function() {
    'use strict';

    angular
        .module('nha.core')
        .filter('telephone', function() {
            return function(tel) {
                if (!tel) {
                    return '';
                }

                var value = tel.toString().trim().replace(/^\+/, '');

                if (value.match(/[^0-9]/)) {
                    return tel;
                }

                var country, city, number, extension;
                if (value.length <= 10) {
                    city = value.slice(0, 3);
                    number = value.slice(3);
                    number = number.slice(0, 3) + '-' + number.slice(3);
                    return (" (" + city + ") " + number).trim();
                } else {
                    city = value.slice(0, 3);
                    number = value.slice(3, 10);
                    number = number.slice(0, 3) + '-' + number.slice(3);
                    extension = value.slice(10);
                    return (" (" + city + ") " + number + "  ext:" + extension).trim();
                }
                //switch (value.length) {
                //    case 10: // +1PPP####### -> C (PPP) ###-####
                //        country = 1;
                //        city = value.slice(0, 3);
                //        number = value.slice(3);
                //        break;

                //    case 11: // +CPPP####### -> CCC (PP) ###-####
                //        country = value[0];
                //        city = value.slice(1, 4);
                //        number = value.slice(4);
                //        break;

                //    case 12: // +CCCPP####### -> CCC (PP) ###-####
                //        country = value.slice(0, 3);
                //        city = value.slice(3, 5);
                //        number = value.slice(5);
                //        break;

                //    default:
                //        return tel;
                //}

                //if (country == 1) {
                //    country = "";
                //}

                //number = number.slice(0, 3) + '-' + number.slice(3);

                //return (" (" + city + ") " + number).trim();
            };
        });
})();;
angular
    .module('nha.core')
    .filter('words', function () {
        return function (input, words) {
            if (isNaN(words)) return input;
            if (words <= 0) return '';
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        };
    });;
(function () {
	'use strict';
	angular.module('nha.core')
		.filter('yesNo', function () {
			return function (text, length, end) {
				if (text) {
					return 'Yes';
				}
				return 'No';
			}
		});
})();;
/**
 * module-navbar.controller
 * @namespace core
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.core').controller('module-navbar.controller', moduleNavbarController);

	/** setup injection */
	moduleNavbarController.$inject = ['$injector', 'appSettings', 'message.manager', 'businessApplicationsSvc'];

	/** implementation */
	function moduleNavbarController($injector, appSettings, messageManager, businessApplicationsSvc) {
		/** public properties */
		var vm = this;
		vm.loading = false;
		vm.hasPortalAppLogo = true;
		vm.businessApplication = null;
		vm.businessApplicationLink = '';
		vm.maskVisible = false;
		vm.isTraining = false;
		vm.defaultConfig = {
			'appIcon': true,
			'breadcrumb': true,
			'miniSearch': true,
			'miniLauncher': true,
			'walkMe': true,
			'schoolSelector': true,
			'userSettings': true
		};

		/** public methods */
		vm.hideCallout = hideCallout;

		/** run init */
		init();

		/** public methods implementations */

		/** hide the callout */
		function hideCallout() {
			/** send message */
			messageManager.setData('message', { 'key': 'module-callout-mask', 'value': { 'visible': false, 'window': null }});
		}

		/** private methods */

		/** initialize */
		function init() {
			/** check for configuration object */
			if (vm.config && _.isObject(vm.config)) _.merge(vm.defaultConfig, vm.config);

			/** check for training environment */
			vm.isTraining = appSettings['environment'] && appSettings['environment'].toLowerCase() === 'tr';

			/** set the message receiver */
			messageManager.addCallback('message', messageCheck, true);

			/** check for the portal-app-logo directive */
			if (!$injector.has('portalAppLogoDirective')) {
				/** show fallback app name */
				vm.hasPortalAppLogo = false;

				/** flip loading flag */
				vm.loading = true;

				/** load the business application as fallback */
				businessApplicationsSvc.getById(vm.moduleId).then(function(businessApplication) {
					/** set the business application */
					vm.businessApplication = businessApplication;

					/** set the business application link */
					vm.businessApplicationLink = appSettings[businessApplication.url];

					/** flip loading flag */
					vm.loading = false;
				});
			}
		}

		/** receive a message */
		function messageCheck(message) {
			if (message.key && message.key === 'module-callout-mask') {
				/** set the visible flag */
				vm.maskVisible = message.value.visible;

				/** toggle body scrolling */
				if (message.value.visible === true) angular.element('body').addClass('module-callout-mask-open');
				else angular.element('body').removeClass('module-callout-mask-open');
			}
		}
	}
})();;
/**
 * module-navbar.directive
 * @namespace core
 */

(function () {
	'use strict';

	/** get the angular module and add directive */
	angular.module('nha.core').directive('moduleNavbar', moduleNavbarDirective);

	/** injection */
	moduleNavbarDirective.$inject = ['appSettings'];

	/** implementation */
	function moduleNavbarDirective(appSettings) {
		/** return directive */
		return {
			restrict: 'E',
			replace: true,
			transclude: true,
			templateUrl: appSettings.coreWebRootUrl + 'app/components/module-navbar/module-navbar.directive.html',
			controller: 'module-navbar.controller',
			controllerAs: 'moduleNavbarCtrl',
			bindToController: {
				moduleId: '=',
				settingKey: '=',
				schoolSelectorOnChange: '=',
				config: '='
			},
			scope: {}
		};
	}
})();;
(function () {
	'use strict';

	angular.module('nha.core').component('maintenanceNotification', {
		controller: maintenanceNotificationController
	});

	maintenanceNotificationController.$inject = ['$location', 'appSettings', 'ipCookie', 'toastr'];

	function maintenanceNotificationController($location, appSettings, ipCookie, toastr) {
		var ctrl = this;

		ctrl.$onInit = function () {
			if (appSettings['maintenanceNotification']) {
				showMaintenanceNotification();
			}
		};

		function showMaintenanceNotification() {
			var notification = parseAppSetting();

			if (notification && !hasDismissed(notification.id) && moment().isBefore(notification.date.endOf('day'))) {
				toastr.warning(notification.message, notification.title, {
					closeButton: true,
					timeOut: 0,
					extendedTimeOut: 0,
					onHidden: function () {
						var hostnameParts = $location.host().split('.');
						var domainName = $location.host();
						if (hostnameParts.length > 2) {
							domainName = hostnameParts[hostnameParts.length - 2] + '.' + hostnameParts[hostnameParts.length - 1];
						}

						ipCookie('maintenanceNotificationDismissed', notification.id, {
							path: '/',
							secure: true,
							domain: domainName,
							expires: 24,
							expirationUnit: 'hours'
						});
					}
				});
			}
		}

		function parseAppSetting() {
			try {
				var notification = JSON.parse(appSettings['maintenanceNotification']);
				if (notification.date && notification.message && notification.title) {
					notification.date = moment(notification.date);
					return notification;
				}
			}
			catch (e) {
				return null;
			}
		}

		function hasDismissed(id) {
			var dismissedID = ipCookie('maintenanceNotificationDismissed');
			console.log(dismissedID);
			return dismissedID && dismissedID === id;
		}
	}
})();
;
(function () {
    'use strict';

angular.module('nha.core').controller('NavbarCtrl', NavbarCtrl);

NavbarCtrl.$inject = ['$scope', '$location', '$window', 'appSettings', 'userContextService', 'cache', '$cookies'];

function NavbarCtrl($scope, $location, $window, appSettings, userContextService, cache, $cookies) {

        $scope.isActive = function(route) {
            return route === $location.path();
        };

        $scope.getCurrentUser = function() {
            var currentContext = userContextService.getUserContext(); 

            return currentContext;
        }

        function clearAllCookies() {
            var cookies = $cookies.getAll();

            _.forEach(cookies, function (v, k) {
                $cookies.remove(k);
            });
        }

        $scope.signOut = function() {
            var signOutUrl = appSettings.adfsBaseUrl;
            var redirectUrl = appSettings.moduleWebRootUrl;

            clearAllCookies();

            cache.clearAll();

            $window.location.href = signOutUrl + '?wa=wsignout1.0' + '&wreply=' + redirectUrl;
        }
    }

})();;
(function() {
    'use strict';

    angular.module("nha.core")
        .directive("coreNavbar", [
            'appSettings', function(appSettings) {
                return {
                    restrict: "AEC",
                    scope: {
                        moduleId: "@moduleid",
						schoolSelectorOnChange: '='
                    },
                    controller: "CoreNavbarCtrl",
                    templateUrl: appSettings.coreWebRootUrl + "app/components/core-navbar/coreNavbar.html",
                    link: function(scope, element, attribute) {

                    }
                };
            }
        ])
        .controller("CoreNavbarCtrl", [
            '$scope', '$location', '$window', '$sce', 'appSettings', 'userContextService', '$rootScope', 'businessApplicationsSvc', 'staffService',
            function ($scope, $location, $window, $sce, appSettings, userContextService, $rootScope, businessApplicationsSvc, staffService) {
                //console.log('navbar controller initialized');
                $scope.appCalloutActive = false;
                $scope.maskActive = false;
                $scope.applications = [];
                $scope.activeModule = null;
                $scope.profileDropDownLabel = 'Loading Profile Info...';
                $scope.isTrainingEnv = appSettings['environment'] && String(appSettings['environment']).toLowerCase() === 'tr';

                $scope.isActive = function(route) {
                    return route === $location.path();
                };

                $scope.getActiveModule = function() {
                    userContextService.ensureUserContext().then(function(context) {
                        businessApplicationsSvc.getById($scope.moduleId).then(function (data) {
                            log(data)
                            $scope.activeModule = data;
                            $scope.activeModuleRootUrl = $sce.trustAsResourceUrl(appSettings[$scope.activeModule.url]);
                        });
                    });
                };
                $scope.getActiveModule();

                //TODO: consider using the core avatar.directive.js
                $scope.getStaffImage = function() {
                    userContextService.ensureUserContext().then(function(context) {
                        staffService.getAvatar(context['http://schemas.mynha.com/SIS/Core/StaffID']).then(function(image) {
                            $scope.staffImage = image;
                        });
                    });
                }
                $scope.getStaffImage();

                $scope.$on("nha:portal:applicationResults", function(event, data) {
                    $scope.applications = data;
                });

                $scope.$on("nha:core:callout-active", function(event, data) {
                    $scope.maskActive = true;
                });

                $scope.$on("nha:core:callout-inactive", function (event, data) {
                    $scope.maskActive = false;
                });

                $scope.getCurrentUser = function() {
                    var currentContext = userContextService.getUserContext();

                    return currentContext;
                };

                $scope.toggleSearch = function() {
                    $rootScope.$broadcast('toggleSearch');
                    $scope.appCalloutActive = false;
                };

                $scope.toggleMask = function() {
                    $rootScope.$broadcast('nha:core:callout-active', 'mask');
                    $scope.maskActive = false;
                }

            }
        ]);
})();;
(function() {
    "use strict";

	var userSessionService = new myNHA.UserSessionService();
	var accountService = myNHA.GetApiService('Account', 'AccountService');

	var _appSettings = myNHA.appSettings;
	var IMPERSONATION_COOKIE = _appSettings.environment + '-mynha-impersonation';

    angular.module("nha.core")
        .directive("portalUserSettings", ["appSettings", function(appSettings) {
            return {
                restrict: 'AEC',
                scope: {maskVisible:'='},
                controller: "PortalUserSettingsCtrl",
                templateUrl: appSettings.coreWebRootUrl + 'app/components/user-settings/userSettingsTemplate.html'
            };
        }])
        .controller("PortalUserSettingsCtrl", [
            "$scope", 'userContextService', 'dataSecurityService', 'appSettings', '$rootScope', '$cookies', 'ipCookie', '$location', 'message.manager', 'uiAlertService', function ($scope, userContextService, dataSecurityService, appSettings, $rootScope, $cookies, ipCookie, $location, messageManager, uiAlertService) {
				$scope.search = { username: '' };
				$scope.canImpersonate = false;
				$scope.isImpersonating = Cookies.get(IMPERSONATION_COOKIE) ? true : false;
				$scope.impersonationUser = Cookies.get(IMPERSONATION_COOKIE);
                $scope.userSettingsCalloutActive = false;
                $scope.calloutName = "settingsCallout";
				$scope.staffID = null;
                $scope.userId = null;
                $scope.userTitle = '';

				var _impersonationCheckTimer = null;

                $scope.toggleUserSettings = function (event, data) {
                    $scope.userSettingsCalloutActive = $scope.userSettingsCalloutActive ? false : true;
                    if ($scope.userSettingsCalloutActive) {
                        $rootScope.$broadcast('nha:core:callout-active', $scope.calloutName);
						messageManager.setData('message', { 'key': 'module-callout-mask', 'value': { 'visible': true, 'window': 'module-user-settings' }});
                    } else {
                        $rootScope.$broadcast('nha:core:callout-inactive', $scope.calloutName);
						messageManager.setData('message', { 'key': 'module-callout-mask', 'value': { 'visible': false, 'window': null }});
                    }
                };

                $scope.getCurrentUser = function () {
					var currentContext = userContextService.getUserContext();
                    return currentContext;
                };

                $scope.$on("nha:core:callout-active", function (event, data) {
                    if (data !== $scope.calloutName) {
                        $scope.userSettingsCalloutActive = false;
                    }

                });

                $scope.close = function() {
                   messageManager.setData('message', { 'key': 'module-callout-mask', 'value': { 'visible': false, 'window': null } });
                };

				$scope.impersonateUser = function() {
					const username = $scope.search.username;

					if (!username) {
						uiAlertService.error('Please enter a username to impersonate');
						return;
					}

					if (username !== null && username === window.userContext.unique_name) {
						uiAlertService.error('Why would you want to impersonate yourself...? Come on man... ');
						return;
					}

					if (username !== null) {
						uiAlertService.info('Searching for user ' + username + '...');

						accountService.getByUsername(username).then(function(account) {
							clearAllCookies(userSessionService.getDomain());

							Cookies.set(IMPERSONATION_COOKIE, username, { path: '/', secure: true, domain: userSessionService.getDomain() });
							uiAlertService.success('About to start impersonation session as ' + username + '...');

							setTimeout(function() {
								window.location.reload();
							}, 1000);
						}, function(error) {
							uiAlertService.error('Username not found');
						});
					}
				};

				$scope.endImpersonationSession = function() {
					clearAllCookies(userSessionService.getDomain());

					Cookies.remove(IMPERSONATION_COOKIE, { path: '/', secure: true, domain: userSessionService.getDomain() });
					uiAlertService.success('Ending impersonation session for ' + $scope.impersonationUser + '...');

					setTimeout(function() {
						window.location.reload();
					}, 2000);
				};

                function clearAllCookies(domainName) {
                    var cookies = $cookies.getAll();

					_.forEach(cookies, function (v, k) {
						if (!k.startsWith(myNHA.appSettings.environment)) {
							ipCookie.remove(k, { path: '/', domain: domainName });
						}
                    });
                }

                $scope.signout = function() {
                   messageManager.setData('message', { 'key': 'module-callout-mask', 'value': { 'visible': false, 'window': null } });

					var signOutUrl = appSettings.adfsBaseUrl;
                    var redirectUrl = appSettings.moduleWebRootUrl;
                    var hostnameParts = $location.host().split('.');
                    var domainName = $location.host();
                    if (hostnameParts.length > 2) {
                        domainName = hostnameParts[hostnameParts.length-2] + '.' + hostnameParts[hostnameParts.length-1];
                    }

                    clearAllCookies(domainName);

					userSessionService.logout();

                    //$window.location.href = signOutUrl + '?wa=wsignout1.0' + '&wreply=' + redirectUrl;
                };


                function init() {
					userContextService.ensureUserContext().then(function(context) {
						$scope.staffID = context['http://schemas.mynha.com/SIS/Core/StaffID'];
						$scope.userId = context['http://schemas.mynha.com/Savyint/UserID'];
						$scope.userTitle = context['http://schemas.mynha.com/ILM/Title'] !== '' ? context['http://schemas.mynha.com/ILM/Title'] : 'No title Found';

						$scope.canImpersonate = dataSecurityService.isAdminUser(window.userContext) && ['dev', 'ci', 'qa'].includes(appSettings.environment);

						watchForImpersonationStartEnd();
                    });

                    messageManager.addCallback('message', messageCheck, true);
                }

				/** receive a message */
				function messageCheck(message) {
					if (message.key && message.key === 'module-callout-mask' && (message.value.visible === false || (message.value.visible === true && message.value.window !== 'module-user-settings'))) {
						$scope.userSettingsCalloutActive = false;
						$scope.maskVisible = false;
					}
				}

				function watchForImpersonationStartEnd() {
					if (!$scope.canImpersonate) {
						return;
					}

					window.clearInterval(_impersonationCheckTimer);
					_impersonationCheckTimer = window.setInterval(function() {
						var isImpersonatingNow = Cookies.get(IMPERSONATION_COOKIE) ? true : false;

						if (($scope.isImpersonating && !isImpersonatingNow) || (!$scope.isImpersonating && isImpersonatingNow)) {
							window.location.reload();
						}
					}, 1000);
				}

                init();
            }
        ]);
})();;
'use strict';

angular.module('nha.core')
  .factory('Modal', function ($rootScope, $uibModal) {
    /**
     * Opens a modal
     * @param  {Object} scope      - an object to be merged with modal's scope
     * @param  {String} modalClass - (optional) class(es) to be applied to the modal
     * @return {Object}            - the instance $uibModal.open() returns
     */
    function openModal(scope, modalClass) {
      var modalScope = $rootScope.$new();
      scope = scope || {};
      modalClass = modalClass || 'modal-default';

      angular.extend(modalScope, scope);

      return $uibModal.open({
        templateUrl: '/core/components/modal/modal.html',
        windowClass: modalClass,
        scope: modalScope
      });
    }

    // Public API here
    return {

      /* Confirmation modals */
      confirm: {

        /**
         * Create a function to open a delete confirmation modal (ex. ng-click='myModalFn(name, arg1, arg2...)')
         * @param  {Function} del - callback, ran when delete is confirmed
         * @return {Function}     - the function to open the modal (ex. myModalFn)
         */
        delete: function(del) {
          del = del || angular.noop;

          /**
           * Open a delete confirmation modal
           * @param  {String} name   - name or info to show on modal
           * @param  {All}           - any additional args are passed staight to del callback
           */
          return function() {
            var args = Array.prototype.slice.call(arguments),
                name = args.shift(),
                deleteModal;

            deleteModal = openModal({
              modal: {
                dismissable: true,
                title: 'Confirm Delete',
                html: '<p>Are you sure you want to delete <strong>' + name + '</strong> ?</p>',
                buttons: [{
                  classes: 'btn-danger',
                  text: 'Delete',
                  click: function(e) {
                    deleteModal.close(e);
                  }
                }, {
                  classes: 'btn-default',
                  text: 'Cancel',
                  click: function(e) {
                    deleteModal.dismiss(e);
                  }
                }]
              }
            }, 'modal-danger');

            deleteModal.result.then(function(event) {
              del.apply(event, args);
            });
          };
        }
      }
    };
  });
;
(function () {
    'use strict';
    angular.module("nha.core")
        .directive("miniAppLauncher", ["appSettings", function (appSettings) {
            return {
                restrict: "AEC",
                scope: {
                    appCalloutActive: '=',
                    moduleId: "@moduleid"
                },
                controller: "MiniAppLauncherCtrl",
                templateUrl: appSettings.coreWebRootUrl + "app/components/app-launcher/miniAppLauncher.html",
                link: function (scope, element, attribute) {
                    
                }
            };
        }])
        .controller("MiniAppLauncherCtrl", [
            '$scope', '$location', '$window', 'appSettings', 'userContextService', '$rootScope', "businessApplicationsSvc", "$filter", "$interval", "apiSecurityService","ipCookie", function ($scope, $location, $window, appSettings, userContextService, $rootScope, businessApplicationsSvc, $filter, $interval, apiSecurityService, ipCookie) {
                $scope.calloutName = "appCallout";
                $scope.applications = [];
                $scope.JWTIsValid = true;
                $scope.networkFailed = false;

                $scope.isActive = function (route) {
                    return route === $location.path();
                };

                $scope.getApplications = function () {
                    userContextService.ensureUserContext().then(function (context) {
                        businessApplicationsSvc.getForUser().then(function (data) {
                            $scope.dataLoading = false;
                            var sortedData = $filter('orderBy')(data, 'applicationName', false);
                            $scope.applications = _.without(sortedData, _.find(sortedData, { businessApplicationID: parseInt($scope.moduleId) }));
                        });
                    });
                };
                
                $scope.launchApplication = function (path) {
                    //$scope.appCalloutActive = $scope.appCalloutActive ? false : true;
                    $scope.toggleAppCallout();
                    $window.open(appSettings[path]);
                };

                $scope.toggleAppCallout = function (event) {
                    if (event) {
                        event.stopPropagation();
                    }
                        
                    $scope.appCalloutActive = $scope.appCalloutActive ? false : true;
                    if ($scope.appCalloutActive) {
                        $rootScope.$broadcast('nha:core:callout-active', $scope.calloutName);
                    } else {
                        $rootScope.$broadcast('nha:core:callout-inactive', $scope.calloutName);
                    }
                };

                $scope.$on('nha:core:callout-active', function (event, data) {
                    if (data !== $scope.calloutName) {
                        $scope.appCalloutActive = false;
                    }
                });

                $scope.init = function () {
                    $scope.getApplications();
                    $scope.$on('nha:core:tokenUpdated', function(event, data) {
                        $scope.JWTIsValid = true;
                        //log('JWT is valid');
                    });
                    $scope.$on('nha:core:tokenExpired', function (event, data) {
                        $scope.JWTIsValid = false;
                        //log('JWT is NOT Valid');
                    });
                }
                $scope.init();

            }
    ]);
})();;
(function () {
    "use strict";

    angular.module("nha.core")
        .directive("schoolSelector", ["appSettings", function (appSettings) {
            return {
                restrict: "AEC",
                scope: {
					maskVisible: '=',
					onChange: '='
				},
				controller: "SchoolSelectorCtrl",
                templateUrl: appSettings.coreWebRootUrl + "app/components/school-selector/schoolSelector.html",
                link: function (scope, el, attr) {

                }
            };
        }])
        .controller("SchoolSelectorCtrl", [
            "$scope", "schoolService", 'userContextService', 'ipCookie', 'appSettings', '$window', '$rootScope', '$location', 'stateRepository', 'message.manager', function ($scope, schoolService, userContextService, ipCookie, appSettings, $window, $rootScope, $location, stateRepository, messageManager) {
                $scope.schoolSelectorCalloutActive = false;
                $scope.calloutName = "schoolCallout";
                $scope.schools = [];
                $scope.defaultSchoolForUser = null;
                $scope.selectedSchools = [];
                $scope.schoolFilter = "";
                $scope.defaultToAllSchools = false;
                $scope.defaultSchoolCookieName = null;
                $scope.moduleDefaultSchoolCookieName = 'filter-School';
                $scope.noCourseLoaded = true;

                function init() {
                    userContextService.ensureUserContext().then(function (context) {
                        $scope.defaultSchoolCookieName = 'nha.core.user-default-school.' + context['http://schemas.mynha.com/Savyint/UserID'];
                        var defaultSchool = ipCookie($scope.defaultSchoolCookieName) != null ? ipCookie($scope.defaultSchoolCookieName) : null;
                        if (defaultSchool !== null) {
                            $scope.defaultSchoolForUser = defaultSchool;
                            $scope.setSelectedSchoolLabel(defaultSchool ? defaultSchool.shortName : '');
                        } else {
                            $scope.setSelectedSchoolLabel("Loading your schools...");
                        }
                        $scope.getSchools();
                    });

					/** watch for message */
					messageManager.addCallback('message', messageCheck, true);
                }

                init();

				/** receive a message */
				function messageCheck(message) {
					if (message.key && message.key === 'module-callout-mask' && (message.value.visible === false || (message.value.visible === true && message.value.window !== 'module-navbar-school-selector'))) {
						$scope.schoolSelectorCalloutActive = false;
					}
				}

                var _defaultSchoolCookie = ipCookie($scope.defaultSchoolCookieName);

                //log("SCHOOL-SELECTOR DIRECTIVE, DEFAULT SCHOOL COOKIE VALUE: ", _defaultSchoolCookie);
                if (!_defaultSchoolCookie) {
                    $scope.defaultToAllSchools = true;
                };

                $scope.$on("filterChange", function (event, data) {
                    if (data.selectedFilters.School) {
                        if (data.selectedFilters.School.items[0].id !== $scope.defaultSchoolForUser.schoolID) {

                            var school = _.find($scope.schools, function (school) {
                                return school.schoolID === data.selectedFilters.School.items[0].id;
                            });


                            $scope.setUserDefaultSchool(school);
                        }
                    }
                });

                //hook to sync the selected school with the master scheduling course the user is viewing.....could be different if the user
                //used a direct link (versus browsing through courses/teachers list) to access the course.
                $scope.$on('master-scheduling-course-loaded', function (event, data) {
                    //log('master-scheduling-course-loaded', data);
                    $scope.noCourseLoaded = false;
                    if (data.schoolID !== $scope.defaultSchoolForUser.schoolID) {
                        var school = _.find($scope.schools, function (school) {
                            return school.schoolID === data.schoolID;
                        });


                        $scope.setUserDefaultSchool(school);
                        log('master-scheduling-course-loaded - changed school', school);
                    }
                });

                //when we load a course in master scheduling, we need to block changes in the selected school as
                //these are hooked into filters, which can cause invalid results (like showing rosters for a school
                //that differs from the course school).
                $scope.$on('master-scheduling-course-unloaded', function (event, data) {
                    log('master-scheduling-course-unloaded');
                    $scope.noCourseLoaded = true;
                });

                // sets the user's default school selection
                $scope.setUserDefaultSchool = function (value) {
                    var hostnameParts = $location.host().split('.');
                    var domainName = $location.host();
                    if (hostnameParts.length > 2) {
                        domainName = hostnameParts[hostnameParts.length-2] + '.' + hostnameParts[hostnameParts.length-1];
                    }

                    ipCookie($scope.defaultSchoolCookieName, value, { domain: domainName, path: '/' });
                    ipCookie($scope.moduleDefaultSchoolCookieName, value.schoolID, { domain: domainName, path: '/' });

                    $scope.defaultSchoolForUser = value;
                    $rootScope.$broadcast('nha:core:default-school-changed', value);

					if ($scope.onChange) $scope.onChange(value);
                    $scope.defaultToAllSchools = false;
                    $scope.setSelectedSchoolLabel(value ? value.shortName : '');

                    $scope.schoolSelectorCalloutActive = false;
                    $rootScope.$broadcast('nha:core:callout-inactive', $scope.calloutName);
					messageManager.setData('message', { 'key': 'module-callout-mask', 'value': { 'visible': false, 'window': null } });
                };

                //is the school passed the user's default selection?
                $scope.isDefaultSchool = function (schoolId) {
                    var retVal = false;
                    var defaultsCookie = ipCookie($scope.defaultSchoolCookieName);
                    if (defaultsCookie != null) {
                        if (defaultsCookie.hasOwnProperty('schoolID')) {
                            retVal = defaultsCookie ? defaultsCookie.schoolID === schoolId : false;
                        }
                    }
                    return retVal;
                };

                $scope.getCurrentUser = function () {
                    var currentContext = userContextService.getUserContext();
                    return currentContext;
                };

                $scope.$on("nha:core:callout-active", function (event, data) {
                    if (data !== $scope.calloutName) {
                        $scope.schoolSelectorCalloutActive = false;
                    }

                });

                $scope.getSchools = function () {

                    userContextService.ensureUserContext().then(function (context) {
                        stateRepository.getAll().then(function(states) {
                            schoolService.getSchoolsForUser().then(function (data) {
                                //log('SCHOOLS: ', data);

                                if (!Array.isArray(data)) {
                                    $scope.schools.push(data);  // there is only one school, so add it
                                    $scope.setSelectedSchoolLabel(data ? data.shortName : '');
                                } else if (data.length === 0) {
                                    $scope.setSelectedSchoolLabel("No schools found!");
                                } else {
                                    $scope.schools = _.sortBy(data, function(item) {
                                        return item.shortName;
                                    });
                                }

                                mergeStatesAndSchools($scope.schools, states, 'stateID');

                                //TODO: maybe return a promise or use a callback instead of this....
                                if ($scope.defaultSchoolForUser === null) {
                                    var defaultSchool = _.find($scope.schools, 'isPrimary') || $scope.schools[0];

                                    $scope.setUserDefaultSchool(defaultSchool);
                                }
                            });
                        });
                    });
                };

                //This could probably be done at the repository level
                function mergeStatesAndSchools(arr1, arr2, prop) {
                    _.each(arr2, function (arr2obj) {
                        var arr1obj = _.filter(arr1, function (arr1obj) {
                            return arr1obj[prop] === arr2obj[prop];
                        });

                        if (arr1obj) {
                            _.each(arr1obj, function(school) {
                                _.extend(school, arr2obj);
                            });
                        }
                    });
                }

                $scope.setSelectedSchoolLabel = function(label) {
                    $scope.profileDropDownLabel = label;
                };

                $scope.toggleSchoolSelector = function () {

                    if ($scope.noCourseLoaded) {
                        $scope.schoolFilter = "";
                        $scope.schoolSelectorCalloutActive = $scope.schoolSelectorCalloutActive ? false : true;
                        if ($scope.schoolSelectorCalloutActive) {
                            $rootScope.$broadcast('nha:core:callout-active', $scope.calloutName);
							messageManager.setData('message', { 'key': 'module-callout-mask', 'value': { 'visible': true, 'window': 'module-navbar-school-selector' } });
                        } else {
                            $rootScope.$broadcast('nha:core:callout-inactive', $scope.calloutName);
							messageManager.setData('message', { 'key': 'module-callout-mask', 'value': { 'visible': false, 'window': null } });
                        }
                    }

                };

            }
        ]);
})();;
(function () {
    'use strict';

    angular.module('nha.core').controller('BusinessResponseModalCtrl', BusinessResponseModalCtrl);

    BusinessResponseModalCtrl.$inject = ['$scope', '$uibModalInstance', 'displayModal'];

    function BusinessResponseModalCtrl($scope, $uibModalInstance, displayModal) {

        $scope.displayModal = displayModal;
        log('BusinessResponseModalCtrl->displayModal', $scope.displayModal);

        function businessResponseHasOnlyWarnings() {
            log('businessResponseHadOnlyWarnings -> displayModal', $scope.displayModal);
            if ($scope.displayModal.businessResponse && $scope.displayModal.businessResponse.operationResult && !$scope.displayModal.businessResponse.operationResult.exception) {

                // get all of our failed rules
                var rules = _.filter($scope.displayModal.businessResponse.operationResult.rules, function (r) {
                    return r.criteriaMet !== true;
                });

                // are their any warnings?
                var warningRules = _.filter(rules, function (r) {
                    return r.ruleSeverity === 'Warning';
                });

                // if the total rules and the warning rules match, show the warning footer
                return (warningRules.length === rules.length);
            }

            return false;
        }

        $scope.showWarningFooter = function () {
            log('showWarningFooter -> displayModal', $scope.displayModal);
            return !$scope.displayModal.checkboxWarning && businessResponseHasOnlyWarnings();

        };  

        $scope.showCheckboxWarningFooter = function () {
            log('showCheckboxWarningFooter -> displayModal', $scope.displayModal);
            return $scope.displayModal.checkboxWarning && businessResponseHasOnlyWarnings();

        }

        $scope.overrideWarning = function() {
            $uibModalInstance.close({ ignoreWarnings: true });
        }

        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        }
    }

})();
;
angular.module('module-sliding-sidebar', [])

.directive('moduleSlidingSidebar', ['$document', '$timeout', '$compile',
    function ($document, $timeout, $compile) {
        var defaults = {};

        return {
            restrict: 'EAC',
            transclude: false,
            scope: {
                mssOpen: '=?',
                mssAutoClose: '=?',
                mssSpeed: '@',
                mssClass: '@',
                mssSize: '@',
                mssSqueeze: '@',
                mssCloak: '@',
                mssPush: '@',
                mssContainer: '@',
                mssKeyListener: '@',
                mssBodyClass: '@',
                mssModuleId: '@',
                mssStudentId: '@'
            },
            link: function ($scope, el, attrs) {

                /* Inspect */
                var param = {};

                param.speed = $scope.mssSpeed || '0.5';
                param.size = $scope.mssSize || '300px';
                param.zindex = 1000; // Override with custom CSS
                param.className = $scope.mssClass || 'ng-pageslide';
                param.cloak = $scope.mssCloak && $scope.mssCloak.toLowerCase() == 'false' ? false : true;
                param.squeeze = Boolean($scope.mssSqueeze) || false;
                param.push = Boolean($scope.mssPush) || false;
                param.container = $scope.mssContainer || false;
                param.keyListener = Boolean($scope.mssKeyListener) || false;
                param.bodyClass = $scope.mssBodyClass || false;
                param.moduleId = $scope.mssModuleId || 0;
                param.studentId = $scope.mssStudentId || null;

                el.addClass(param.className);
                el.addClass('vertical-stretch-minus-header-pixels');

                /* DOM manipulation */

                var content = null;
                var slider = null;
                var openClose = null;
                var body = param.container ? document.getElementById(param.container) : document.body;

                // TODO verify that we are meaning to use the param.className and not the param.bodyClass

                function setBodyClass(value){
                    if (param.bodyClass) {
                        var bodyClass = param.className + '-body';
                        var bodyClassRe = new RegExp(bodyClass + '-closed|' + bodyClass + '-open');
                        body.className = _.trim(body.className.replace(bodyClassRe, ''));
                        body.className += ' ' + bodyClass + '-' + value;
                    }
                }

                setBodyClass('closed');

                slider = el[0];
                
                //open/close tag


                //content
                content = angular.element(slider.children);

                /* Append */
                body.appendChild(slider);

                /* Style setup */
                slider.style.zIndex = param.zindex;
                //slider.style.position = param.container !== false ? 'absolute' : 'fixed';
                slider.style.position =  'absolute';
                slider.style.width = 0;
                slider.style.height = 0;
                //slider.style.overflow = 'hidden';
                slider.style.transitionDuration = param.speed + 's';
                slider.style.webkitTransitionDuration = param.speed + 's';
                slider.style.transitionProperty = 'width, height';

                if (param.squeeze) {
                    body.style.position = 'absolute';
                    body.style.transitionDuration = param.speed + 's';
                    body.style.webkitTransitionDuration = param.speed + 's';
                    body.style.transitionProperty = 'top, bottom, left, right';
                }
                
                slider.style.height = attrs.mssCustomHeight || 'calc(100% - ' + attrs.mssCustomTop || '44px' + ')';
                slider.style.top = attrs.mssCustomTop || '0px';
                slider.style.bottom = attrs.mssCustomBottom || '0px';
                slider.style.right = attrs.mssCustomRight || '0px';
                
                $scope.toggle = function () {
                    $scope.mssOpen = !$scope.mssOpen;
                }
                /* Closed */
                function mssClose(slider, param) {
                    if (slider && slider.style.width !== 0) {
                        //if (param.cloak) content.css('display', 'none');
                        slider.style.width = '0px';

                        _.each(slider.children, function (element) {
                                element.style.display = 'none';
                        });

                        if (param.squeeze) body.style.right = '0px';
                        if (param.push) {
                            body.style.top = '2px';
                            body.style.right = '0px';
                            body.style.left = '0px';
                        }
                         
                    }
                    $scope.mssOpen = false;

                    if (param.keyListener) {
                        $document.off('keydown', keyListener);
                    }

                    setBodyClass('closed');
                }

                /* Open */
                function mssOpen(slider, param) {
                    if (slider.style.width !== 0) {
                        
                        slider.style.width = param.size;
                        if (param.squeeze) body.style.right = param.size;
                        if (param.push) {
                            body.style.right = param.size;
                            body.style.left = '-' + param.size;
                        }
                        
                        $timeout(function() {
                            if (param.cloak) content.css('display', 'block');
                        }, (param.speed * 1000));

                        $scope.mssOpen = true;
                        if (param.keyListener) {
                            $document.on('keydown', keyListener);
                        }

                        setBodyClass('open');
                        body.style.position = 'absolute';
                        body.style.width = '100%';
                    }
                }

                function isFunction(functionToCheck) {
                    var getType = {};
                    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
                }

                /*
                * Close the sidebar if the 'esc' key is pressed
                * */

                function keyListener(e) {
                    var ESC_KEY = 27;
                    var key = e.keyCode || e.which;

                    if (key === ESC_KEY) {
                        mssClose(slider, param);
                    }
                }

                /*
                * Watchers
                * */

                $scope.$watch('mssOpen', function(value) {
                    if (!!value) {
                        mssOpen(slider, param);
                    } else {
                        mssClose(slider, param);
                    }
                });

                $scope.$watch('mssSize', function(newValue, oldValue) {
                    if (oldValue !== newValue) {
                        param.size = newValue;
                        mssOpen(slider, param);
                    }
                });

                /*
                * Events
                * */

                $scope.$on('$destroy', function () {
                    body.removeChild(slider);
                });

                if ($scope.mssAutoClose) {
                    $scope.$on('$locationChangeStart', function() {
                        mssClose(slider, param);
                    });
                    $scope.$on('$stateChangeStart', function() {
                        mssClose(slider, param);
                    });

                }
            }
        };
    }
]);
;
(function () {
	'use strict';

	/** define component */
	angular.module('nha.core').component('smallCalendar', {
		templateUrl: ['appSettings', function(appSettings){
			return appSettings.coreWebRootUrl + 'app/directives/small-calendar/small-calendar.component.html'
		}],
		controller: CalendarController,
		bindings: {
			selected: '=?',
			events: '=?',
			isSelected: '=?',
			onSelect: '=?'
		}
	});

	/** setup injection for the controller */
	CalendarController.$inject = [];

	/** define controller */
	function CalendarController() {
		/** get this */
		var ctrl = this;

		/** public properties */
		ctrl.today = removeTime(moment());
		ctrl.selected = ctrl.selected || moment();
		ctrl.month = ctrl.selected.clone();
		ctrl.weeks = [];
		ctrl.events = ctrl.events || [];

		/** remove time from the selected day */
		ctrl.selected = removeTime(ctrl.selected);

		/** public methods */
		ctrl.select = select;
		ctrl.next = next;
		ctrl.prev = prev;
		ctrl.goToToday = goToToday;
		ctrl.isSelected = ctrl.isSelected || isSelected;

		/** run init */
		init();

		/** public method implementations */

		/** select a day */
		function select(day) {
			ctrl.selected = day.date;
			if (ctrl.onSelect) ctrl.onSelect(day);
		}

		/** go to next month */
		function next() {
			var next = ctrl.month.clone();
			removeTime(next.month(next.month()+1).date(1));
			ctrl.month.month(ctrl.month.month()+1);
			buildMonth(next, ctrl.month);
		}

		/** go to previous month */
		function prev() {
			var previous = ctrl.month.clone();
			removeTime(previous.month(previous.month()-1).date(1));
			ctrl.month.month(ctrl.month.month()-1);
			buildMonth(previous, ctrl.month);
		}

		/** go to today */
		function goToToday() {
			ctrl.today = removeTime(moment());
			ctrl.selected = removeTime(ctrl.selected || moment());
			ctrl.month = ctrl.selected.clone();
			init();
		}

		/** check to see if the day should be selected */
		function isSelected(day) {
			/** check to see if events holds the */
			var selected = false;
			_.forEach(ctrl.events, function(ev) {
				ev.date = removeTime(ev.date);
				if (ev.date.isSame(day.date)) selected = true;
			});

			/** return selected */
			return selected;
		}

		/** private methods */

		/** initialize the calendar */
		function init() {
			var start = ctrl.month.clone();
			start.date(1);
			removeTime(start.day(0));
			buildMonth(start, ctrl.month);
		}

		/** remove the time */
		function removeTime(date) {
			return date.day(0).hour(0).minute(0).second(0).millisecond(0);
		}

		/** build out the month */
		function buildMonth(start, month) {
			ctrl.weeks = [];
			var done = false;
			var date = start.clone();
			var monthIndex = date.month();
			var count = 0;
			while (!done) {
				ctrl.weeks.push({ days: buildWeek(date.clone(), month) });
				date.add(1, "w");
				done = count++ > 2 && monthIndex !== date.month();
				monthIndex = date.month();
            }
		}

		/** build out the week */
		function buildWeek(date, month) {
			var days = [];
			for (var i = 0; i < 7; i++) {
				days.push({
					name: date.format("dd").substring(0, 1),
					number: date.date(),
					isCurrentMonth: date.month() === month.month(),
					isToday: date.isSame(new Date(), "day"),
					date: date
				});
				date = date.clone();
				date.add(1, "d");
			}
			return days;
		}
	}
})();;
(function(){'use strict';angular.module('nha.core').run(['$templateCache', function($templateCache) {$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/directives.html','<style>\n    .bs-docs-sidebar {\n        padding-left: 20px;\n    }\n\n    .bs-docs-sidenav {\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n\n    .bs-docs-section {\n        margin-bottom: 60px;\n    }\n\n    .bs-callout-info {\n        border-left-color: #1b809e;\n    }\n\n    .bs-callout {\n        padding: 20px;\n        margin: 20px 0;\n        border: 1px solid #eee;\n        border-left-width: 5px;\n        border-radius: 3px;\n    }\n\n    .zero-clipboard {\n        display: block;\n    }\n\n    .zero-clipboard {\n        position: relative;\n        display: none;\n    }\n\n    .bs-example + .zero-clipboard + .highlight {\n        margin-top: -16px;\n        margin-right: 0;\n        margin-left: 0;\n        border-width: 1px;\n        border-bottom-right-radius: 4px;\n        border-bottom-left-radius: 4px;\n    }\n\n    .bs-example + .highlight, .bs-example + .zero-clipboard + .highlight {\n        margin: -15px -15px 15px;\n        border-width: 0 0 1px;\n        border-radius: 0;\n    }\n\n    .highlight {\n        padding: 9px 14px;\n        margin-bottom: 14px;\n        background-color: #f7f7f9;\n        border: 1px solid #e1e1e8;\n        border-radius: 4px;\n    }\n\n    .bs-docs-sidebar .nav > .active:focus > a, .bs-docs-sidebar .nav > .active:hover > a, .bs-docs-sidebar .nav > .active > a {\n        padding-left: 18px;\n        font-weight: 700;\n        color: #563d7c;\n        background-color: transparent;\n        border-left: 2px solid #563d7c;\n    }\n\n    .bs-docs-sidebar .nav > li > a {\n        display: block;\n        padding: 4px 20px;\n        font-size: 13px;\n        font-weight: 500;\n        color: #767676;\n    }\n\n    .back-to-top {\n        display: block;\n    }\n\n    .back-to-top {\n        padding: 4px 10px;\n        margin-top: 10px;\n        margin-left: 10px;\n        font-size: 12px;\n        font-weight: 500;\n        color: #999;\n    }\n\n    .language-html {\n        text-align: left;\n    }\n</style>\n\n<div class="container">\n    <div class="row">\n        <div class="page-header">\n            <h1 id="top">Directives</h1>\n        </div>\n    </div>\n\n    <div class="row">\n\n\n\n        <div class="col-md-9" role="main">\n            <div class="bs-docs-section" id="actionsave">\n                <h1 id="list-group" class="page-header">Action Save Status</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n                <p class="lead">\n                    Accepts an array of promises and displays the current status of the save based on the promises\' resolution, rejection, or notification.\n                    Live examples can be seen on the Retention and Reenrollment editors.\n                </p>\n\n                <h3>Basic Example</h3>\n                <p>Promises in Queue: <strong>{{promiseQueue.length}}</strong></p>\n                <button class="btn btn-warning" ng-click="pushSave()">Save</button>\n                <action-save-status save-queue="promiseQueue"></action-save-status>\n\n                <p>\n                    Pressing "Save" creates a deferred promise which is pushed into an array of promises. That array of promises is passed into the action-save-status directive.\n                    Once the promises in the array are resolved, rejected, or notified, the status updates accordingly. You can also pass a custom message through the promise resolve,\n                    reject, or notify.  Such as promise.resolve(\'Save Complete!\'), promise.reject(\'FAIL!\').  If you do not specify custom messages, default messages are given.\n                </p>\n\n\n                <h4 id="list-group-basic">Code Example</h4>\n                <div class="highlight">\n                    <pre>\n                    <code class="language-html" data-lang="html">\n                &lt;action-save-status save-queue=&quot;promiseQueue&quot;&gt;&lt;/action-save-status&gt;\n                    </code>\n                </pre>\n                </div>\n            </div>\n\n            <div class="bs-docs-section" id="tablesort">\n                <h1 id="list-group" class="page-header">Table Sort</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n                <h3>Basic Example</h3>\n                <p class="lead">Maintain Sort Parameters/Visual Indicators. Sort parameters can then be passed into services for server side sorting/ordering.</p>\n                <strong ng-if="sortChangeRaised" class="fade-in text-info">\n                    Sort Change Event Raised\n                </strong>\n                <table table-sort sort-expression="testSort" sort-changed="sortChanged(expression)">\n                    <thead>\n                    <th table-sort-criteria="name">Name</th>\n                    <th table-sort-criteria="city">Location</th>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat="rec in testArray">\n                            <td>{{rec.name}}</td>\n                            <td>{{rec.city}}</td>\n                        </tr>\n                        <tr>\n                            <td colspan="3"></td>\n                        </tr>\n                    </tbody>\n                </table>\n                Sort: {{testSort}}\n\n                <h4 id="list-group-basic">Code Example</h4>\n                <div class="highlight">\n                    <pre>\n                    <code class="language-html" data-lang="html">\n           &lt;table table-sort sort-expression=&quot;testSort&quot;&gt;\n                &lt;thead&gt;\n                    &lt;th table-sort-criteria=&quot;name&quot;&gt;Name&lt;/th&gt;\n                    &lt;th table-sort-criteria=&quot;city&quot;&gt;Location&lt;/th&gt;\n                &lt;/thead&gt;\n            &lt;/table&gt;\n                    </code>\n                </pre>\n                </div>\n\n                <p>\n                    Giving the directive a model through the <strong>"sort-expression"</strong> attribute will allow you to bind to and use the sort expression/parameters that the directive maintains.\n                </p>\n                <p>\n                    Use the <strong>"sort-changed"</strong> attribute to bind a function to be called when the sort expression is changed.\n                </p>\n                <p>\n                    Use <strong>Shift + Click</strong> to <i>append</i> parameters to your sort expression.\n                </p>\n\n                <h3>Multiple Sort Options in One Column Example</h3>\n                <table table-sort sort-expression="testSort" sort-changed="sortChanged(expression)">\n                    <thead>\n                    <th table-sort-criteria-group="groupModel">Name</th>\n                    <th table-sort-criteria="city">Location</th>\n                    </thead>\n                    <tbody>\n                        <tr ng-repeat="rec in testArray">\n                            <td>{{rec.name}}</td>\n                            <td>{{rec.city}}</td>\n                        </tr>\n                        <tr>\n                            <td colspan="3"></td>\n                        </tr>\n                    </tbody>\n                </table>\n                Sort: {{testSort}}\n\n                <h4 id="list-group-basic">Code example</h4>\n                <div class="highlight">\n                    <pre>\n                    <code class="language-html" data-lang="html">\n        // Define the multiple options for the column.                    \n        $scope.groupModel = [\n            { criteria: \'firstName\', displayName: \'First Name\' },\n            { criteria: \'lastName\', displayName: \'Last Name\' }\n        ];\n           &lt;table table-sort sort-expression=&quot;testSort&quot;&gt;\n                &lt;thead&gt;\n                    &lt;th table-sort-criteria-group=&quot;groupModel&quot;&gt;Name&lt;/th&gt;\n                    &lt;th table-sort-criteria=&quot;city&quot;&gt;Location&lt;/th&gt;\n                &lt;/thead&gt;\n            &lt;/table&gt;\n                    </code>\n                </pre>\n                </div>\n                <p>Using the table-sort-criteria-group, we can handle the cases where we have one logical column that needs to be able to sorted on values from 2 different database columns. A good example of this is the First/Last name scenario.</p>\n\n                <h4><a href="https://newsis-ci.nhatest.com/enrollment/#/setstatus">Live Example - Set Status</a></h4>\n            </div>\n\n            <div class="bs-docs-section" id="avatar">\n                <h1 id="list-group" class="page-header">Avatar</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n\n                <p class="lead">Render Avatars for student photos</p>\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <avatar student-id="::student.studentID" alt-text="::student.fullName"></avatar>\n                    <br /><br /><br />\n                    <avatar student-id="::student.studentID" alt-text="::student.fullName" avatar-width="160"></avatar>\n                    <br /><br /><br />\n                    <avatar staff-id="::staff.staffID" alt-text="::staff.fullName" avatar-width="160"></avatar>\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;avatar student-id=&quot;::student.studentID&quot; alt-text=&quot;::student.fullName&quot;&gt;&lt;/avatar&gt;\n                    </code></pre>\n                </div>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n            <!-- dropdown Submenu -->\n            <div class="bs-docs-section" id="dropdownSubmenu">\n                <h1 id="list-group" class="page-header">Dropdown Submenu</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n\n                <p class="lead">\n                    Dropdown with submenus. A little bit of history, these used to be supported in BS2, but were dropped since they are not that mobile friendly. We still have desktop use cases for this control though.\n                    <a href="http://stackoverflow.com/questions/22957038/angular-ui-multi-level-dropdown-toggle" target="_blank">Stackoveflow question on this</a>\n                </p>\n                <h3 id="list-group-basic">Basic example</h3>\n                <div class="bs-example">\n                    <br />\n                    <h4>Simple</h4>\n                    <dropdown-submenu data="dropDownSubmenu_SimpleData" ng-model="testModel"></dropdown-submenu>\n                    {{testModel}}\n                    <br />\n\n                    <h4>Two Levels</h4>\n\n                    <dropdown-submenu data="dropDownSubmenu_TwoLevelData" ng-model="testDD2"></dropdown-submenu>\n                    {{testDD2}}\n                    <br />\n                    <h4>Two Levels with multi select</h4>\n                    {{dropDownSubmenu_TwoLevelMultiData}}\n                    <dropdown-submenu data="dropdownOptions_TwoLevelMulti" ng-model="testModel3" is-multi="true"></dropdown-submenu>\n                    {{testModel3}}\n                    <br /><br />\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;dropdown-submenu &gt;&lt;/dropdown-submenu&gt;\n                    </code></pre>\n                </div>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n            <!-- tagCloud -->\n            <div class="bs-docs-section" id="tagCloud">\n                <h1 id="list-group" class="page-header">Tag Cloud</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n\n                <p class="lead">\n                    Tag Cloud - this works well in conjunction with the dropdown submenu. It uses the same data structure\n                </p>\n                <h3 id="list-group-basic">Basic example</h3>\n                <div class="bs-example">\n\n                    <tag-cloud data="testModel3"></tag-cloud>\n                    <br /><br />\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;tag-cloud &gt;&lt;/tag-cloud&gt;\n                    </code></pre>\n                </div>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n            <!-- availabilityPanel -->\n            <div class="bs-docs-section" id="availabilityPanel">\n                <h1 id="list-group" class="page-header">Availability Panel</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n\n                <p class="lead">\n                    This will determine if a module is available or not based on conditions such as, does this controller exist?\n                </p>\n                <h3 id="list-group-basic">Basic example</h3>\n                <div class="bs-example">\n                    <br />\n                    This controller called \'DirectivesCtrl\' does exist\n\n                    <availability-panel controller-to-test="DirectivesCtrl"></availability-panel>\n                    <br /><br />\n\n                    <br />\n                    This controller called \'missingCtrl\' does not exist\n\n                    <availability-panel controller-to-test="missingCtrl"></availability-panel>\n                    <br /><br />\n\n                    <br />\n                    This controller called \'missingCtrl\' does not exist, as well as passing in a custom message\n\n                    <availability-panel controller-to-test="missingCtrl" message-to-display=\'Your page is really, really down!  This is an example of a custom message\'></availability-panel>\n                    <br /><br />\n\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;availability-panel controller-to-test=&quot;missingCtrl&quot;&gt;&lt;/availability-panel&gt;\n                    </code></pre>\n                </div>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n            <div class="bs-docs-section" id="spinner">\n                <h1 id="list-group" class="page-header">Spinner</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n\n                <p class="lead">Here is your spinner for load screens</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p ng-init="spinning=true">Basic usage</p>\n                <button class="btn btn-primary" ng-show="!spinning" ng-click="spinning = !spinning">Start Spinning</button>\n                <button class="btn btn-primary" ng-show="spinning" ng-click="spinning = !spinning">Stop Spinning</button>\n                <div spinner is-loading="spinning" message="Loading Custom message...">\n                    <h2>I only show when not spinning :)</h2>\n                </div>\n                <div class="bs-example">\n\n                    <br /><br /><br />\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;div spinner is-loading="dataLoading"&gt;Content to load.&lt;/div&gt;\n                    </code></pre>\n                </div>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n            <div class="bs-docs-section" id="filters">\n                <h1 id="list-group" class="page-header">Filters</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n\n                <p class="lead">Render Filters</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>\n                    Basic usage\n                    Here are the filters currently supported from Core\n                    <br />\n                    <ol>\n                        <li>AcademicYear</li>\n                        <li>School</li>\n                        <li>GradeLevel</li>\n                        <li>Homeroom (requires School pass in SchoolId, due to perf reasons)</li>\n                        <li>MasterStatus (specify subType aka MasterStatusTypeId with subType = 1 in filter config)</li>\n                        <li>Staff (requires School pass in SchoolId, due to perf reasons)</li>\n                        <li>Wing</li>\n                        <li>Period</li>\n                        <li>MarkingPeriod</li>\n                    </ol>\n                    <br />\n                </p>\n                <div class="bs-example">\n                    <div style="width: 18em;">\n                        <filters></filters>\n                    </div>\n                </div>\n\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;filters&gt;&lt;/filters&gt;\n                    </code></pre>\n                </div>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n            <div class="bs-docs-section" id="dateentry">\n                <h1 id="list-group" class="page-header">Date Entry</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n\n                <p class="lead">Date Entry</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div style="width: 50em; float: right;">\n                        <date-entry></date-entry>\n                    </div>\n                    <br class="clearfix" />\n                    <br class="clearfix" /><br class="clearfix" />\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;date-entry&gt;&lt;/date-entry&gt;\n                    </code></pre>\n                </div>\n\n                <h3 id="list-group-basic">Time example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div style="width: 50em; float: right;">\n                        <date-entry options="{format: \'hh : mm a\'}" icon-class="nha-circle-clock"></date-entry>\n                    </div>\n                    <br class="clearfix" />\n                    <br class="clearfix" /><br class="clearfix" />\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;date-entry options="{format: \'hh : mm a\'}" icon-class="nha-circle-clock"&gt;&lt;/date-entry&gt;\n                    </code></pre>\n                </div>\n\n\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n            <div class="bs-docs-section" id="datepanel">\n                <h1 id="list-group" class="page-header">Date Panel</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n\n                <p class="lead">Date Panel</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div style="width: 50em; float: right;">\n                        <date-panel />\n                    </div>\n                    <br class="clearfix" />\n                    <br class="clearfix" /><br class="clearfix" />\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;date-panel&gt;&lt;/date-panel&gt;\n                    </code></pre>\n                </div>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n            <div class="bs-docs-section" id="timepicker">\n                <h1 id="list-group" class="page-header">Timepicker Pop</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n\n                <p class="lead">A helper for the timepicker in AngularUI</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        <timepicker-pop input-time="time1" class="input-group"\n                                        show-meridian=\'showMeridian\'>\n                        </timepicker-pop>\n                        <br />\n                    </div>\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;timepicker-pop&gt;&lt;/timepicker-pop&gt;\n                    </code></pre>\n                </div>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n            <div class="bs-docs-section" id="datetimepicker">\n                <h1 id="list-group" class="page-header">DatePicker</h1>\n\n                <p class="lead">Date Only</p>\n                <div class="bs-example">\n                    <div class="input-group date" date-picker>\n                        <input name="datePicker" type="text" class="form-control" ng-model="date" ng-required="true" />\n                        <span class="input-group-addon">\n                            <span class="fa fa-calendar"></span>\n                        </span>\n                    </div>\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                    &lt;div class=&quot;input-group date&quot; date-picker&gt;\n                             &lt;input name=&quot;datePicker&quot; type=&quot;text&quot; class=&quot;form-control&quot; ng-model=&quot;date&quot; ng-required=&quot;true&quot; /&gt;\n                             &lt;span class=&quot;input-group-addon&quot;&gt;\n                             &lt;span class=&quot;fa fa-calendar&quot;&gt;&lt;/span&gt;\n                        &lt;/span&gt;\n                    &lt;/div&gt;\n                    \n                    </code></pre>\n                </div>\n\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n            <!--Date Entry-->\n            <div class="bs-docs-section" id="dateentry">\n                <h1 id="list-group" class="page-header">DateEntry</h1>\n\n\n                <p class="lead">Date Only</p>\n                <div class="bs-example">\n                    <date-entry date="dateEntry"></date-entry>\n                    \n                </div>\n                    <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                    <div class="highlight">\n                        <pre><code class="language-html" data-lang="html">\n                           &lt;div class=&quot;form-group&quot;&gt;\n                                 &lt;label class=&quot;control-label col-sm-3&quot;>Date:&lt;/label &gt;\n                                 &lt;div class=&quot;col-sm-2&quot; &gt;\n                                     &lt;date-entry date=&quot;model&quot;\n                                        options=&quot;options =&quot; {mindate: \'01/01/2000\' , maxdate: \'01/01/2020\' }}&quot;\n                                        on-change=&quot;myfunction()&quot;\n                                        require&gt;&lt;/date-entry&gt;\n                            \n                               &lt;/div&gt;  \n                            &lt;/div&gt;\n                            \n                            </code></pre>\n                    </div>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n            <div class="bs-docs-section" id="errorPanel">\n                <h1 id="list-group" class="page-header">Error Panel</h1><a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n\n                <p class="lead">Use this to handle an error coming from a HTTP call</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        <transaction-error-panel display-type="error"></transaction-error-panel>\n                        <br />\n                    </div>\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;transaction-error-panel&gt;&lt;/transaction-error-panel&gt;\n                    </code></pre>\n                </div>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">Back to top</a>\n            </div>\n\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#datepanel">Draggable</h1>\n\n                <p class="lead">Drag Drop in AngularJs without using jQueryUI</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        Coming soon\n                        <br /><br />\n                    </div>\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        Coming Soon\n                    </code></pre>\n                </div>\n            </div>\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#datepanel">Focus On</h1>\n\n                <p class="lead">Focus On Directive when opening a form and focusing on a field</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        Coming soon\n                        <br /><br />\n                    </div>\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        Coming Soon\n                    </code></pre>\n                </div>\n            </div>\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#datepanel">Prompt If Dirty</h1>\n\n                <p class="lead">Prompt if dirty when navigating away</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        Coming soon\n                        <br /><br />\n                    </div>\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        Coming Soon\n                    </code></pre>\n                </div>\n            </div>\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#datepanel">Slide Bottom Panel</h1>\n\n                <p class="lead">Drag Drop in AngularJs without using jQueryUI</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        Coming soon\n                        <br /><br />\n                    </div>\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        Coming Soon\n                    </code></pre>\n                </div>\n            </div>\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#datepanel">Breadcrumb</h1>\n\n                <p class="lead">The Breadcrumb directive (see top of the screen). This is included with navbar</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        <nav class="pages-nav pull-left">\n                            <div class="navigation hidden-print hidden-xs">\n                                <ncy-breadcrumb></ncy-breadcrumb>\n                            </div>\n                        </nav>\n                        <br /><br />\n                    </div>\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        Coming Soon\n                    </code></pre>\n                </div>\n            </div>\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#datepanel">Navbar</h1>\n\n                <p class="lead">Navbar see top of the screen</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        <div class="top-nav" style="position: relative" ng-include="\'app/components/navbar/navbar.html\'"></div>\n                        <br /><br /><br /><br />\n                    </div>\n                </div>\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                                                     &lt;div class=&quot;top-nav&quot; ng-include=&quot;\'app/components/navbar/navbar.html\'&quot;&gt;&lt;/div&gt;\n                    </code></pre>\n                </div>\n            </div>\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#search">Search Box</h1>\n\n                <p class="lead">Search ahead</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        <search-box search="searchText" display="searchDisplayText" changed="searchBoxCallback(value)" />\n                        <br /><br class="clearfix" />\n                    </div>\n                </div>\n                <br />\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code class="language-html" data-lang="html">\n                        &lt;search-box /&gt;\n                    </code></pre>\n                </div>\n            </div>\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#crudPanel">CRUD Panel</h1>\n\n                <p class="lead"></p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        <crud-panel last-saved-date="lastModifiedDate" save-call="save()" saving="saving" cancel-call="cancel()" cancel-label="Cancel me custom label"></crud-panel>\n                        <br /><br class="clearfix" />\n                    </div>\n                </div>\n                <br />\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code ng-non-bindable class="language-html" data-lang="html">&lt;crud-panel last-saved-date=&quot;{{date}}&quot; save-call=&quot;save()&quot; saving=&quot;saving&quot; cancel-call=&quot;cancel()&quot;&gt;&lt;/crud-panel&gt;</code></pre>\n                </div>\n            </div>\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#camelCaseFilter">Camel Case Filter</h1>\n\n                <p class="lead"></p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        {{status | camelCaseToHuman}}\n                        <!--<select class="form-control" title="" name="statuses" ng-model="status.selectedStatus | camelCaseToHuman" ng-options="status.name for status in validStatuses" required>\n                            <option value="">Please select...</option>\n                        </select>-->\n                        <br /><br class="clearfix" />\n                    </div>\n                </div>\n            </div>\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#camelCaseFilter">Avatar Resuzer</h1>\n\n                <p class="lead">Control that will help you resize avatars in grid views</p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        <avatar-resizer></avatar-resizer>\n                        <br /><br class="clearfix" />\n                    </div>\n                </div>\n            </div>\n\n            <div class="bs-docs-section">\n                <h1 id="list-group" class="page-header" href="#pageTabs">Page Tabs</h1>\n\n                <p class="lead"></p>\n\n                <h3 id="list-group-basic">Basic example</h3>\n                <p>Basic usage</p>\n                <div class="bs-example">\n                    <div>\n                        <page-tabs tabs="[{ \'title\': \'Overview\', \'sref\': \'schedule.overview\', \'isActive\': \'active\', security: { requiredResource: \'MasterSch333333333eduleOverviewMetrics:GetForNHA\', api: \'MasterScheduling\' } },\n                            { \'title\': \'States/Schools\', \'sref\': \'schedule.schools\', \'isActive\': \'\', security: { requiredResource: \'MasterScheduleOverviewMetrics:GetForNHA\', api: \'MasterScheduling\' } },\n                            { \'title\': \'Section Groups\', \'sref\': \'schedule.section-groups\', \'isActive\': \'\', security: { requiredResource: \'SectionGroupsSummary\', api: \'MasterScheduling\' } },\n                            { \'title\': \'Settings\', \'sref\': \'schedule.settings\', \'isActive\': \'\', security: { requiredResource: \'NHAGradeLevelInfo\', api: \'MasterScheduling\' } }\n\t\t                ]"></page-tabs>\n                        <br /><br class="clearfix" />\n                    </div>\n                </div>\n                <br />\n                <div class="zero-clipboard"><span class="btn-clipboard">Copy</span></div>\n                <div class="highlight">\n                    <pre><code ng-non-bindable class="language-html" data-lang="html"></code></pre>\n                </div>\n            </div>\n        </div>\n        <div class="col-md-3" role="complementary">\n            <nav class="bs-docs-sidebar hidden-print hidden-xs hidden-sm affix-top">\n                <ul class="nav bs-docs-sidenav">\n                    <li class="">\n                        <a ng-click="jumpTo(\'actionsave\')">Action Save Status</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'tablesort\')">Table Sort</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'avatar\')">Avatar</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'dropdownSubmenu\')">Dropdown Submenu</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'tagCloud\')">Tag Cloud</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'availabilityPanel\')">Availability Panel</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'spinner\')">Spinner</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'filters\')">Filters</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'dateentry\')">Date Entry</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'datepanel\')">Date Panel</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'timepickerpop\')">TimePickerPop</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'datetimepicker\')">DatePicker</a>\n                    </li>\n                    <li class="">\n                        <a href="#errorPanel">Error Panel</a>\n                    </li>\n                    <li class="">\n                        <a href="#draggable">Draggable</a>\n                    </li>\n                    <li class="">\n                        <a href="#focusOn">Focus On</a>\n                    </li>\n                    <li class="">\n                        <a href="#promptIfDirty">Prompt If Dirty</a>\n                    </li>\n                    <li class="">\n                        <a href="#slideBottomPanel">Slide Bottom Panel</a>\n                    </li>\n                    <li class="">\n                        <a href="#search">Search Box</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'crudPanel\')">CRUD Panel</a>\n                    </li>\n                    <li class="">\n                        <a href="#breadcrumb">Breadcrumb</a>\n                    </li>\n                    <li class="">\n                        <a href="#navbar">Navbar</a>\n                    </li>\n                    <li class="">\n                        <a href="#avatarResizer">Avatar Resizer</a>\n                    </li>\n                    <li class="">\n                        <a ng-click="jumpTo(\'pageTabs\')">Page Tabs</a>\n                    </li>\n                </ul>\n                <a class="back-to-top" ng-click="jumpTo(\'top\')">\n                    Back to top\n                </a>\n            </nav>\n        </div>\n    </div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/templates/403.html','<div class="alert alert-warning text-center" role="alert" style="margin-right: 1em; margin-left: 1em;">\n    <i class="fa fa-lock" style="color: black; margin-right: .5em; font-size: 1.5em;"></i>\n    <strong> Sorry, the user account that you are using does not have access to this data or feature.</strong>\n    <p>\n        If you believe you should have access, please logout, then log back in.  \n    </p>\n    <p>\n        If you still believe you require access, please contact the administrator.\n    </p>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/templates/404.html','<div class="alert alert-warning text-center" role="alert" style="margin-right: 1em;">\n    <i class="fa nha-link-broken" style="color: black; margin-right: .5em; font-size: 1.5em;"></i>\n    <strong>Sorry, the resource you have requested cannot be found.</strong>\n    <p>\n        Please recheck your URL as it may be out of date or load the list/summary view that contains this URL and try again.\n    </p>\n    <p>\n        If you believe this message to be in error, please contact your systems administrator.\n    </p>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/templates/business-response-modal.html','<div tabindex="-1" role="dialog">\n    <form name="businessResponseModal" novalidate>\n        <div class="modal-content">\n            <div class="modal-header">\n                <h4 class="modal-title">{{displayModal.title}}</h4>\n            </div>\n            <div class="modal-body">\n                <p ng-if="!showCheckboxWarningFooter()">{{displayModal.message}}</p>\n                <p ng-if="showCheckboxWarningFooter()">{{displayModal.warningMessage}}</p>\n                <div business-response="displayModal.businessResponse"></div>\n            </div>\n            <div class="modal-footer">\n                <div ng-if="showWarningFooter()">\n                    <button class="btn btn-default" ng-click="closeModal()">Cancel</button>\n                    <button class="btn btn-primary" ng-click="overrideWarning()">Override</button>\n                </div>\n\n                <div ng-if="showCheckboxWarningFooter()">\n                    <p><label><input type="checkbox" ng-model="displayModal.doOverride" /> {{displayModal.checkboxLabel}}</label></p>\n                    <button class="btn btn-default" ng-click="closeModal()">Cancel</button>\n                    <button class="btn btn-primary" ng-disabled="!displayModal.doOverride" ng-click="overrideWarning()">{{displayModal.confirmButtonText}}</button>\n                </div>\n\n                <div ng-if="!showWarningFooter() && !showCheckboxWarningFooter()">\n                    <button class="btn btn-primary" ng-click="closeModal()">Close</button>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/templates/offline.html','<div class="container-wrap">\n    <div class="alert alert-warning text-center" role="alert">\n        <i class="fa fa-exclamation-triangle" style="color: black; margin-right: .5em; font-size: 1.5em;"></i>\n        <strong> This page is not currently available. Please try again later.</strong>\n    </div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/components/core-navbar/coreNavbar.html','<div>\n    <div class="core-header-wrap">\n        <header class="options" ng-class="{\'training-navbar-color\': isTrainingEnv }">\n            <div class="pull-left logo" ng-style="{\'background-color\': activeModule.color }">\n                <a ng-href="{{activeModuleRootUrl}}" target="_self">\n                    <i ng-class="activeModule.logo"></i>\n                    <span ng-if="moduleId == 14" class="core-header-wrap hidden-xs">my<strong>NHA</strong></span>\n                    <span ng-if="moduleId != 14" class="core-header-wrap hidden-xs">{{activeModule.applicationName}}</span>\n                </a>\n            </div>\n            <div class="pull-left nha-core-triangle-right" ng-style="{\'border-left-color\': activeModule.color }">\n\n            </div>\n            <div class="pull-left training-navbar-text training-navbar-color" ng-if="isTrainingEnv">\n                <span>Training</span>\n            </div>\n\n            <nav class="pages-nav pull-left">\n                <div class="navigation hidden-print hidden-xs">\n                    <ncy-breadcrumb></ncy-breadcrumb>\n                </div>\n            </nav>\n            <portal-user-settings mask-visible="maskActive" class="pull-right"></portal-user-settings>\n            <div class="pull-right user-wrap">\n                <school-selector on-change="schoolSelectorOnChange"></school-selector>\n            </div>\n            <mini-app-launcher mask-visible="maskActive" app-callout-active="appCalloutActive" moduleid="{{moduleId}}"></mini-app-launcher>\n            <div class="pull-right nha-portal-search-icon-mobile ">\n                <i class="fa fa-search" ng-click="toggleSearch()"></i>\n            </div>\n\n        </header>\n        \n    </div>\n    <div class="nha-portal-callout-mask" ng-show="maskActive" ng-click="toggleMask()"></div>\n</div>\n\n');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/components/app-launcher/miniAppLauncher.html','<div ui-keydown="{esc: \'toggleAppCallout($event)\'}">\n    <div class="pull-right app-launcher-wrap">\n        <div class="btn-group">\n            <div class="mini-launcher pull-right">\n                <a class="square">\n\t                <!--<span class="fa fa-th" ng-click="toggleAppCallout($event)">-->\n\t\t\t\t\t<span class="glyphicon glyphicon-th" ng-click="toggleAppCallout($event)"></span>\n                </a>\n            </div>\n        </div>\n    </div>\n    <div class="mini-launcher-callout-container" ng-show="appCalloutActive">\n        <div class="mini-launcher-callout">\n            <div class="mini-launcher-apps">\n                <div class="mini-launcher-application" ng-repeat="app in applications">\n                    <div ng-click="launchApplication(app.url)">\n                        <i class="portal-application-icon fa" ng-class="app.logo" title="{{app.applicationName}}" ng-style="{\'background-color\': app.color}"></i>\n                        <span class="portal-application-name">{{app.applicationName}}</span>\n                    </div>\n                </div>\n\n                <div class="mini-launcher-no-apps" ng-show="applications.length < 1">\n                    No applications found!\n                </div>\n            </div>\n            <div class="core-callout-footer">\n                <div class="core-callout-close" ng-click="toggleAppCallout($event)">\n                    Close\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/components/modal/modal.html','<div class="modal-header">\n  <button ng-if="modal.dismissable" type="button" ng-click="$dismiss()" class="close">&times;</button>\n  <h4 ng-if="modal.title" ng-bind="modal.title" class="modal-title"></h4>\n</div>\n<div class="modal-body">\n  <p ng-if="modal.text" ng-bind="modal.text"></p>\n  <div ng-if="modal.html" ng-bind-html="modal.html"></div>\n</div>\n<div class="modal-footer">\n  <button ng-repeat="button in modal.buttons" ng-class="button.classes" ng-click="button.click($event)" ng-bind="button.text" class="btn"></button>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/components/module-navbar/module-navbar.directive.html','<div class="module-navbar" ng-class="{ \'is-training\': moduleNavbarCtrl.isTraining }">\n\t<portal-app-logo setting-key="moduleNavbarCtrl.settingKey" is-training="moduleNavbarCtrl.isTraining" ng-if="moduleNavbarCtrl.defaultConfig.appIcon === true" />\n\t<div class="business-application" ng-if="!moduleNavbarCtrl.hasPortalAppLogo" ng-if="moduleNavbarCtrl.defaultConfig.appIcon === true">\n\t\t<a ng-href="{{moduleNavbarCtrl.businessApplicationLink}}">\n\t\t\t{{moduleNavbarCtrl.businessApplication.applicationName}}\n\t\t</a>\n\t</div>\n\n\t<div class="module-navbar-breadcrumb" ng-if="moduleNavbarCtrl.defaultConfig.breadcrumb === true">\n\t\t<ncy-breadcrumb />\n\t</div>\n\n\t<portal-user-settings mask-visible="moduleNavbarCtrl.maskActive" class="module-navbar-item" ng-show="moduleNavbarCtrl.defaultConfig.userSettings === true" />\n\n\t<div class="module-navbar-school-selector module-navbar-item" ng-show="moduleNavbarCtrl.defaultConfig.schoolSelector === true">\n\t\t<school-selector on-change="moduleNavbarCtrl.schoolSelectorOnChange" />\n\t</div>\n\n\t<portal-mini-launcher ng-if="moduleNavbarCtrl.defaultConfig.miniLauncher === true" />\n\n\t<portal-mini-search ng-if="moduleNavbarCtrl.defaultConfig.miniSearch === true" />\n\n\t<ng-transclude />\n\n\t<div class="module-callout-mask" ng-if="moduleNavbarCtrl.maskVisible" ng-click="moduleNavbarCtrl.hideCallout();"></div>\n\t<maintenance-notification></maintenance-notification>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/components/navbar/navbar.html','<!-- start footer -->\n<div class="header-wrap" ng-controller="NavbarCtrl">\n    <header class="options">\n\n        <div class="pull-left logo">\n            <a ui-sref="main"><img src="https://newsis-ci.nhatest.com/Core/Content/images/logo.png" alt=""></a>\n        </div>\n\n        <nav class="pages-nav pull-left">\n            <div class="navigation hidden-print hidden-xs">\n                <ncy-breadcrumb></ncy-breadcrumb>\n            </div>\n        </nav>\n\n        <div class="pull-right user-wrap">\n            <div class="btn-group">\n                <div class="pull-left">\n                    <div class="pull-left">\n                        <a class="dropdown-toggle" data-toggle="dropdown" ng-if="getCurrentUser().commonname">\n                            <span class="pull-left text"><span>{{getCurrentUser().commonname}}</span></span>\n                            <span class="caret downArrow pull-right"></span>\n                        </a>\n                            <ul class="dropdown-menu" role="menu" ng-if="getCurrentUser().commonname">\n                                <li role="presentation"><a role="menuitem" style="color: #aaa;" ng-click="signOut()">Sign Out</a></li>\n                            </ul>\n                    </div>\n                </div>\n                <div class="pull-right">\n                    <a class="square" href="#"><span class="nha-grid-small"></span></a>\n                </div>\n            </div>\n        </div>\n    </header>\n</div>\n<!-- end footer -->');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/components/school-selector/schoolSelector.html','<div class="nha-core-schoolselector">\n\t<div class="nha-mobile-school-icon pull-left">\n\t\t<i class="fa fa-building" ng-click="toggleSchoolSelector()"></i>\n\t</div>\n\n\t<div class="nha-portal-user-name pull-left" ng-click="toggleSchoolSelector()">\n\t\t<span nha-test="selected-school">{{profileDropDownLabel}}</span>\n\t</div>\n\t<div class="nha-portal-schoolselector-caret pull-left" ng-click="toggleSchoolSelector()" ng-show="noCourseLoaded">\n\t\t<i class="fa fa-caret-down"></i>\n\t</div>\n\n\t<div ng-show="schoolSelectorCalloutActive" class="nha-core-schoolselector-callout" nha-test="school-selector-popup">\n\t\t<div class="nha-core-schoolselector-filter" ng-show="schools.length > 5">\n\t\t\t<input type="search" ng-model="schoolFilter" placeholder="What school are you looking for?" class="form-control" />\n\t\t\t<i class="fa fa-search" ng-click="filterSchools()" nha-test="school-search"></i>\n\t\t</div>\n\n\t\t<div class="nha-core-schoolselector-school-list">\n\t\t\t<ul>\n\t\t\t\t<li ng-repeat="school in filteredSchools = (schools | filter: {schoolName: schoolFilter})" nha-test="selector-item">\n\t\t\t\t\t<a ng-click="setUserDefaultSchool(school)" ng-class="{ \'selected\': isDefaultSchool(school.schoolID), \'single\': schools.length === 1 }">\n\t\t\t\t\t\t<span nha-test="school-name">{{school.shortName}}</span>\n\t\t\t\t\t\t<span nha-test="school-location">{{school.city}}, {{school.stateCode}}</span>\n\t\t\t\t\t\t<input type="radio" ng-click="setUserDefaultSchool(school)" ng-checked="isDefaultSchool(school.schoolID)" />\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\n\t\t<div class="nha-core-schoolselector-footer">\n\t\t\t<div class="nha-core-schoolselector-close">\n\t\t\t\t<button type="button" class="btn btn-link" ng-click="toggleSchoolSelector();">Close</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/components/user-settings/userSettingsTemplate.html','<div class="nha-portal-user-settings-directive">\n\t<div class="nha-user-icon">\n\t\t<a ng-click="toggleUserSettings($event)">\n\t\t\t<avatar staff-id="staffID" avatar-width="60" nha-test="profile-avatar" />\n\t\t\t<div class="impersonation" ng-if="isImpersonating" uib-tooltip="Impersonating {{impersonationUser}}" tooltip-placement="left" tooltip-append-to-body="true">\n\t\t\t\t<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#FFFFFF"><path d="M0 0h24v24H0z" fill="none"/><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>\n\t\t\t</div>\n\t\t</a>\n\t</div>\n\n\t<div class="nha-portal-user-settings-callout-container" ng-show="userSettingsCalloutActive" nha-test="nha-user-popup">\n\t\t<div class="nha-portal-user-settings-callout nha-portal-user-settings-right-callout">\n\t\t\t<div class="nha-portal-user-settings-header">\n\n\t\t\t\t<div class="nha-portal-user-settings-name-title">\n\t\t\t\t\t<div class="nha-portal-user-settings-name">\n\t\t\t\t\t\t<div nha-test="user-name">{{getCurrentUser().common_name}} <div ng-if="isImpersonating" class="acting-as">as {{impersonationUser}}</div></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="nha-portal-user-settings-title" nha-test="job-title">{{userTitle}}</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div ng-if="!isImpersonating && canImpersonate" class="impersonation-user">\n\t\t\t\t\t<input type="text" ng-model="search.username" class="form-control" placeholder="Impersonation Username" /><button class="impersonate-begin-btn btn btn-primary" uit-tooltip="Impersonate User" ng-click="impersonateUser()"><i class="fa fa-user"></i></button>\n\t\t\t\t</div>\n\t\t\t\t<div ng-if="isImpersonating" class="impersonation-user">\n\t\t\t\t\t<button class="impersonate-end-btn btn btn-primary" ng-click="endImpersonationSession()">End Impersonation Session</button>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<div class="nha-core-callout-footer">\n\t\t\t\t<div class="nha-core-callout-signout">\n\t\t\t\t\t<button type="button" class="btn btn-link" ng-click="signout()">Sign Out</button>\n\t\t\t\t</div>\n\t\t\t\t<div class="nha-core-callout-close">\n\t\t\t\t\t<button type="button" class="btn btn-link" ng-click="close()">Close</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/avatar/avatar.html','<img ng-src="{{avatarUrl}}" class="avatar circle" nha-test="student-avatar" ng-class="{\'fixed-col-2\': !avatarWidth}" alt="{{::altText}}" />');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/avatarResizer/avatar-resizer.html','<div class="avatar-resizer">\n    <!-- slider -->\n    <input class="avatar-sizing-slider"\n           type="range"\n           min="1"\n           max="6"\n           ng-model="resizeWrapperVM.avatarScale"\n           title="Resize Avatars"\n           value="3" />\n    <!-- zoom in and out buttons -->\n    <div class="btn-group" role="group">\n        <button type="button" class="btn btn-secondary" ng-click="resizeWrapperVM.avatarScale = resizeWrapperVM.avatarScale <= 1 ?  1 : 1 * resizeWrapperVM.avatarScale - 1">\n            <i class="nha-zoom-out"></i>\n        </button>\n        <button type="button" class="btn btn-secondary" ng-click="resizeWrapperVM.avatarScale = resizeWrapperVM.avatarScale >= 6 ?  6 : 1 * resizeWrapperVM.avatarScale + 1">\n            <i class="nha-zoom-in"></i>\n        </button>\n    </div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/breadcrumb/breadcrumb.html','<div>\n    <ul ng-controller="coreBreadcrumbController as coreBreadcrumbVM" class="list-unstyled list-inline bread-crumb">\n        <!-- TODO: nav-dropdown is so wonky -- it\'s working for Admin but feels ugly -->\n        <!-- TODO: Was only able to find the correct scope by traversing through parents -- right now this is only used in Admin project but if we need it elsewhere it will need to be fixed. I am tired of spinning cycles on it though. Good luck! -->\n        <li ng-repeat="step in steps | limitTo:(steps.length-1)" style="">\n            <a ng-hide="step.data.showDropdown" ng-href="{{step.ncyBreadcrumbLink}}" ng-bind-html="step.ncyBreadcrumbLabel"></a>\n            <nav-dropdown ng-show="step.data.showDropdown" label="$parent.$parent.$parent.nav.parentLabel" dd-items="$parent.$parent.$parent.nav.parentItems" go-to-state="$parent.$parent.$parent.goToState(item)"></nav-dropdown>\n        </li>\n        <li ng-repeat="step in steps | limitTo:-1" class="active" style="color: #FFF; font-weight: bold; padding-right: 1em;">\n            <span ng-hide="step.data.showDropdown" ng-bind-html="step.ncyBreadcrumbLabel"></span>\n            <nav-dropdown ng-show="step.data.showDropdown" label="step.ncyBreadcrumbLabel" dd-items="$parent.$parent.$parent.nav.items" go-to-state="$parent.$parent.$parent.goToState(item)"></nav-dropdown>\n        </li>\n\n        <li ng-repeat="customStep in coreBreadcrumbVM.customSteps | filter : coreBreadcrumbVM.currentState" class="active" style="color: #FFF; font-weight: bold; padding-right: 1em;">\n            <span ng-if="!customStep.items.length" ng-bind-html="customStep.label"></span>\n            <nav-dropdown ng-if="customStep.items.length" dd-items="customStep.items" label="customStep.label"></nav-dropdown>\n        </li>\n    </ul>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/business-response/business-response.html','<div>\n    <div ng-if="businessResponse.operationResult.exception" class="alert alert-danger" role="alert" style="margin-left: 1em; margin-right: 1em;">\n        <div>\n            <span class="fa fa-exclamation-circle"></span> <span>Save was not successful!</span>\n            <div>\n                <div>\n                    <div style="margin-top: 1em;font-weight: bold; margin-bottom: 1em;" ng-click="showDetails = !showDetails">\n                        Technical Details\n                        <span class=" fa fa-chevron-up" ng-show="showDetails" title="Hide technical detail">\n                        </span>\n                        <span class="fa fa-chevron-down" ng-hide="showDetails" title="Show technical detail"></span>\n                    </div>\n                </div>\n                <div class="clearfix" style="margin-top: 1em;background: lightyellow;padding: 1em;" ng-show="showDetails">\n                    <p>{{businessResponse.operationResult.exception}}</p>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ng-if="businessResponse.modelState" class="alert alert-danger" role="alert">\n        {{businessResponse.modelState}}\n    </div>\n    <div ng-repeat="rule in businessResponse.operationResult.rules" ng-show="showRuleAlert(rule)" class="alert" ng-class="{ \'alert-info\' : rule.ruleSeverity === \'Info\', \'alert-warning\' : rule.ruleSeverity === \'Warning\', \'alert-danger\' : rule.ruleSeverity === \'Error\' || rule.ruleSeverity === \'Critical\'}" role="alert">\n        <p ng-repeat="message in rule.messages">{{message}}</p>\n    </div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/crudPanel/crudPanel.html','\n<div class="save-cancel-footer">\n    <div class="save-cancel-footer-inner">\n        <span class="bottom-text-left" ng-show="lastSavedDate">Last Saved: {{lastSavedDate | dateFilterNullable}} <span class="bottom-text-left" ng-show="lastSavedBy"> {{lastSavedBy}}</span></span>\n\n        <button ng-disabled="disabled" ng-show="showSave" ng-click="save()" class="btn btn-primary" ladda="saving" data-spinner-color="#333333" data-style="zoom-in">{{::saveLabel}}</button>\n        <button ng-disabled="disabled" ng-if="showDelete" ng-click="delete()" class="btn btn-secondary" ladda="deleting" data-spinner-color="#333333" data-style="expand-left">{{::deleteLabel}}</button>\n        <button ng-show="showCancel" ng-click="cancel()" class="btn btn-secondary">{{::cancelLabel}}</button>\n    </div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/dateEntry/dateEntry.html','<div class="input-append date input-group date-picker" date-picker dynamic-date-picker-options="dynamicDatePickerOptions" date-picker-options="{{options}}" ng-class="{\'scaledDateEntry\': scaled}">\n    <input class="form-control" name="{{inputName}}" type="text" data-format="MM/dd/yyyy" class="form-control" placeholder="{{placeholderMessage}}"\n           ng-model="date" ng-required="{{isRequired}}" ng-disabled="isDisabled || isFieldSetDisabled" ng-readonly="isReadOnly" ng-change="changed()" autocomplete="off"/>\n    <span class="add-on input-group-addon" style="background-color: transparent;">\n        <i ng-when="true" class="{{iconClass || \'fa fa-calendar\'}}" ng-disabled="isDisabled || isFieldSetDisabled"></i>\n    </span>\n</div>\n');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/datePanel/datePanel.html','<div class="hidden-xs hidden-print day-week-browser">\n    <div class="day-week-browser-inner">\n\n        <!-- right positioned desc -->\n        <div ng-show="datePanelOptions.currentDateRangePosition === \'right\'" class="dateDesc" role="group" style="display: inline-block;">\n            <span class="text" nha-test="current-date" ng-if="viewOptions.startDate.getTime() == viewOptions.endDate.getTime()">{{ viewOptions.startDate | date:\'EEE MMM d, y\'}}</span>\n            <span class="text" nha-test="current-date" ng-if="viewOptions.startDate.getTime() != viewOptions.endDate.getTime()">{{ viewOptions.startDate | date:\'mediumDate\'}} - {{ viewOptions.endDate | date:\'mediumDate\'}}</span>\n        </div>\n\n        <!-- left positioned desc -->\n        <div ng-show="!datePanelOptions || datePanelOptions.currentDateRangePosition === \'left\'" class="dateDesc" style="display: inline-block; margin-right: 1em;">\n            <span class="text" nha-test="current-date" ng-if="viewOptions.startDate.getTime() == viewOptions.endDate.getTime()">{{ viewOptions.startDate | date:\'EEE MMM d, y\'}}</span>\n            <span class="text" nha-test="current-date" ng-if="viewOptions.startDate.getTime() != viewOptions.endDate.getTime()">{{ viewOptions.startDate | date:\'mediumDate\'}} - {{ viewOptions.endDate | date:\'mediumDate\'}}</span>\n        </div>\n\n        <!-- prev/next date paginator -->\n        <div class="btn-group" style="margin-right: 5px;">\n            <button class="btn btn-secondary" ng-click="showPreviousDay()" nha-test="previous-day" ng-attr-title="{{datePanelOptions.selectedDateView === \'weekView\' ? \'Go to previous week\' : \'Go to previous day\'}}">\n                <i class=" fa fa-arrow-left"></i>\n            </button>\n            <button class="btn btn-secondary" ng-click="showCurrentTimePeriod()" ng-class="{active: isCurrentTimePeriod()}">{{getCurrentTimePeriodDescription()}}</button>\n            <button class="btn btn-secondary" ng-click="showNextDay()" nha-test="next-day" ng-attr-title="{{datePanelOptions.selectedDateView === \'weekView\' ? \'Go to next week\' : \'Go to next day\'}}" ng-disabled="isMaxDateReached();">\n                <i class="fa fa-arrow-right"></i>\n            </button>\n        </div>\n\n        <!-- calendar picker -->\n        <div ng-show="!datePanelOptions || datePanelOptions.showCalendarSelector" class="btn-group" role="group" title="Select date from calendar">\n            <div class=\'input-group date\' id=\'datetimepicker1\' nha-test="date-picker">\n                <input type=\'text\' class="form-control" style="opacity: 0; width: 0; margin: 0; padding: 0;" ng-model="viewOptions.startDate" date-picker-button />\n                <span class="input-group-addon btn btn-secondary" style="border-radius: 3px;border-left: solid 1px #D3D6DE;">\n                    <span class="fa fa-calendar"></span>\n                </span>\n            </div>\n        </div>\n\n        <!-- Today/Week button toggle -->\n        <div ng-show="datePanelOptions.showDayWeekSelector" class="btn-group hidden-sm bg" role="group" style="margin-left: 5px;">\n            <!-- day view -->\n            <button class="btn btn-secondary button-text-a" ng-click="showDayView()" ng-class="{active: !isMultiDayView()}">\n                Day\n            </button>\n\n            <!-- week view -->\n            <button class="btn btn-secondary" ng-disabled="isWeekDisabled()" ng-click="showWeekView()" ng-class="{active: isMultiDayView()}">\n                Week\n            </button>\n        </div>\n\n    </div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/dropdownSubmenu/dropdownSubmenu.html','<div class="dropdown dropdown-submenu-composite" uib-dropdown ng-click="toggleDropdownPosition($event)" drop-position>\n    <button id="dLabel" role="button" ng-disabled="disabled" class="btn btn-secondary" uib-dropdown-toggle>\n        {{getModelDisplayValue()}} <span class="caret"></span>\n    </button>\n    <ul uib-dropdown-menu role="menu" aria-labelledby="dropdownMenu">\n        <li ng-repeat="opt in options track by $index" ng-if="!settings.groupBy">\n            <a tabindex="-1" ng-if="singleSelection" ng-click="setSelectedItem(getPropertyForObject(opt, settings.optionID))">\n                <span ng-show="isChecked(getPropertyForObject(opt,settings.optionID))" class="fa fa-check"></span>\n                <span>\n                    {{getPropertyForObject(opt,settings.optionLabel)}}\n                </span>\n            </a>\n            <span ng-if="!singleSelection" ng-click="checkboxClick($event, getPropertyForObject(opt,settings.optionID))">\n                <input type="checkbox" ng-checked="isChecked(getPropertyForObject(opt,settings.optionID))" ng-disabled="getPropertyForObject(opt,settings.disabled)" />\n                {{getPropertyForObject(opt,settings.optionLabel)}}\n            </span>\n        </li>\n        <li ng-class="{ \'dropdown-submenu\' : opts.length > 1}" ng-repeat="(key, opts) in groupedOptions" ng-if="settings.groupBy">\n            <a tabindex="-1" ng-click="selectAll($event, opts, key, true)">\n                <span>\n                    {{key}}\n                </span>\n            </a>\n            <ul class="dropdown-menu dropdown-menu-scrollable short-scroll multi-level" role="menu" aria-labelledby="dropdownMenu" ng-if="opts.length > 1">\n                <li ng-show="settings.selectAll">\n                    <span ng-click="selectAll($event, opts, key)">\n                        <span style="width: 1.5em; display: inline-block;">\n                            <span class="fa fa-1-5x" ng-class="{ \'fa-check-square-o\' : grpSelectAll[key], \'fa-square-o\' : !grpSelectAll[key] }"></span>\n                        </span>\n                        {{texts.selectAll}}\n                    </span>\n                </li>\n                <li ng-repeat="opt in opts">\n                    <a tabindex="-1" ng-if="singleSelection" ng-click="setSelectedItem(getPropertyForObject(opt, settings.optionID))">\n                        <span ng-show="isChecked(getPropertyForObject(opt,settings.optionID))" class="fa fa-check"></span>\n                        <span>\n                            {{getPropertyForObject(opt,settings.optionLabel)}}\n                        </span>\n                    </a>\n                    <span tabindex="-1" ng-if="!singleSelection" ng-click="checkboxClick($event, getPropertyForObject(opt,settings.optionID), key)" class="dropdown-menu-item">\n                        <span style="width: 1.5em; display: inline-block;">\n                            <span class="fa fa-1-5x" ng-class="{ \'fa-check-square-o\' : isChecked(getPropertyForObject(opt,settings.optionID)), \'fa-square-o\' : !isChecked(getPropertyForObject(opt,settings.optionID)), \'text-muted disabled-item\' : grpSelectAll[key]}"></span>\n                        </span>\n                        {{getPropertyForObject(opt,settings.optionLabel)}}\n                    </span>\n                </li>\n            </ul>\n        </li>\n    </ul>\n</div>\n<div class="tag-cloud" ng-if="showTagCloud && settings.groupBy">\n    <span ng-repeat="(key, opts) in groupedOptions">\n        <div class="filter-tag" ng-if="grpSelectAll[key]" ng-click="selectAll($event, opts, key, true)" style="margin-left: 10px;">\n            <i class="fa fa-times-circle"></i>\n            <span>{{key}}</span>\n        </div>\n        <div class="filter-tag" style="margin-left: 10px;" ng-if="!grpSelectAll[key] && isChecked(getPropertyForObject(opt,settings.optionID))" ng-repeat="opt in opts" ng-click="checkboxClick($event, getPropertyForObject(opt,settings.optionID), key)">\n            <i class="fa fa-times-circle"></i>\n            <span>{{getPropertyForObject(opt,settings.optionLabel)}}</span>\n        </div>\n    </span>\n</div>\n<div class="tag-cloud" ng-if="showTagCloud && !settings.groupBy && options.length > 1">\n    <span ng-repeat="opt in options">\n        <div class="filter-tag" style="margin-left: 10px;" ng-if="isChecked(getPropertyForObject(opt,settings.optionID))" ng-click="checkboxClick($event, getPropertyForObject(opt,settings.optionID), key)">\n            <i class="fa fa-times-circle"></i>\n            <span>{{getPropertyForObject(opt,settings.optionLabel)}}</span>\n        </div>\n    </span>\n</div>\n');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/errorPanel/errorPanel.html','<div ng-if="showErrorPanel()" class="alert alert-danger alert-dismissible" role="alert" style="margin-left: 1em; margin-right: 1em;">\n    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n    <span class="fa fa-exclamation-circle"></span> <strong>Uh oh!</strong> There seems to be a problem!\n    <div style="cursor: pointer;color: gray;" class="pull-right" ng-click="showErrorDetails = !showErrorDetails" title="click to expand technical details">\n        <span class="fa fa-chevron-down " ng-show="showErrorDetails"></span>\n        <span class="fa fa-chevron-up" ng-hide="showErrorDetails"></span>\n        <span>Technical Details</span>\n    </div>\n    <div ng-show="showErrorDetails" style="margin-top: 1em; background-color: lightyellow; padding: 1em; border: 1px solid gray;">\n        <h6>ERROR DETAILS</h6>\n        {{error.errorMessage}}<br />\n        {{error.errorDetails}}\n    </div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/file-input/file-input.html','<span class="btn btn-secondary btn-file">\n    {{buttonText}}<input type="file" accept="{{acceptFilter}}" />\n</span>\n');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/filters/filters.html','<!-- DESKTOP FILTER LAYOUT -->\n<div class="container-wrap" ng-if="!hideFilters && !isPhone">\n    <aside class="sidebar sidebar-fixed" style="width: 100%;" ng-class="{ \'sidebar-fix-closed sidebar-closed\': showFilters !== true }">\n        <section class="clearfix reset-wrap">\n            <a class="reset" href="" ng-click="resetFilters();">Reset Filters</a>\n        </section>\n        <div spinner is-loading="viewState.filtersLoading" nha-test="filter-sidebar">\n\n            <section ng-class="{ \'box-wrap\': filter.name!=\'DateRange\', \'box-wrap-date\': filter.name ==\'DateRange\'  }" class="clearfix" ng-repeat-start="key in notSorted(filterConfig.filters)"\n                     ng-hide="(filter.isHidden || (filter.type ==\'radio\' && filter.items.length < 2)) || filter.items == null"\n                     ng-init="filter = filterConfig.filters[key]" nha-test="filter-group">\n                <a ng-click="filter.isCollapsed = !filter.isCollapsed" class="clearfix toggle-slidebox" ng-class="{ \'closed\': filter.isCollapsed  }">\n                    <h2 class="title pull-left" nha-test="filter-header">{{::filter.displayName}}</h2>\n                    <span class="loading_dots" ng-if="filterConfig.countsLoading">\n                        <span></span>\n                        <span></span>\n                        <span></span>\n                    </span>\n                    <div class="pull-right">\n                        <span class="fa" ng-class="{\'fa-chevron-up\' : !filter.isCollapsed, \'fa-chevron-down\' : filter.isCollapsed}"></span>\n                    </div>\n                </a>\n\n                <div class="inner" uib-collapse="filter.isCollapsed" ng-if="!filter.isCollapsed">\n                    <input ng-show="filter.items.length > 15" type="text" class="form-control" placeholder="Enter a {{::filter.displayName | lowercase}} ..." ng-model="filter.searchModel" ng-init="filter.searchModel = \'\'" style="margin-top: .5em; margin-bottom: 1em;" nha-test="filter-search"/>\n                    <div class="list-unstyled scrolled" ng-class="{ dateFilterExpand : filter.name==\'DateRange\' && !filter.isCollapsed }" nha-test="filter-items">\n                        <div style="position: relative;" scroll-if="item.selected" scroll-when="filterPanelOpened,nha:core:default-school-changed" class="{{::filter.type}}" ng-repeat="item in filter.items | filter: filter.searchModel track by $index" nha-test="filter-item">\n                            <label>\n                                <input type="checkbox" ng-if="filter.type === \'checkbox\'" name="selected-{{::filter.name}}"\n                                       ng-model="item.selected" ng-change="selectCheckbox(item.id, filter.name, true)" />\n                                <input type="radio" ng-if="filter.type === \'radio\' && filter.items && filter.items.length > 1" items name="selected-{{::filter.name}}"\n                                       ng-model="filter.selectedID" ng-value="item.id" ng-click="selectRadio(item.id, filter.name, true); selectedFilter(item.overrideClick);">\n                                <span class="text" title="{{::item.tooltipText}}" ng-bind-html="trust(item.description)" nha-test="item-label"></span>\n                                <span ng-if="showCountForItem(item)">\n                                    <span class="count" ng-if="item.count > 9999" style="margin-left: -3px">9999+</span>\n                                    <span class="count" style="margin-left: -3px" nha-test="item-count">{{item.count}}</span>\n                                </span>\n                            </label>\n                        </div>\n                        <!--Date range custom dates selection-->\n                        <div class="dates" ng-if="filter.name==\'DateRange\' && filter.selectedID==3">\n                            <div class="clearfix" nha-test="from-date">\n                                <label>From:</label>\n                                <date-entry date="filter.customStart" ng-init="initDate(filter, true)"></date-entry>\n                            </div>\n                            <div class="clearfix" nha-test="to-date">\n                                <label>To:</label>\n                                <date-entry date="filter.customEnd" ng-init="initDate(filter)"></date-entry>\n                            </div>\n                            <div class="clearfix">\n                                <button class="btn btn-default" ng-click="applyDateFilter(filter)" style="margin-top: 10px;">Apply date filter</button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </section>\n\n\t\t\t<hr ng-repeat-end ng-hide="(filter.isHidden || (filter.type ==\'radio\' && filter.items.length < 2)) || filter.items == null" />\n\n        </div>\n    </aside>\n</div>\n\n<!-- MOBILE FILTER LAYOUT\n1) Pass in "isPhone: true" in filterConfig to display this layout\n2) Pass in "hideOnMobile: true" at the filter level to hide any given filter\n3) Pass in "isTeacher: true" at the Staff filter level to hide Staff dropdown selector\n4) Pass in "currentYearOnly: true" at the AcademicYear filter level to limit academic year dropdown values\n-->\n<div class="filters-wrap-mobile row clearfix" ng-if="isPhone">\n    <div class="col-xs-12">\n        <div spinner is-loading="viewState.filtersLoading">\n            <section class="box-wrap clearfix filterInput"\n                     ng-repeat="key in notSorted(filterConfig.filters)"\n                     ng-hide="(filter.isHidden || (filter.type ==\'radio\' && filter.items.length < 2) || filter.items == null || filter.hideOnMobile)"\n                     ng-init="filter = filterConfig.filters[key]">\n\n                <!-- Current year only -->\n                <div class="select-values" ng-if="filter.currentYearOnly">\n                    <select class="form-control">\n                        <option>{{mobileAcademicYearSelection}}</option>\n                    </select>\n                </div>\n                <!-- School -->\n                <div class="select-values" ng-hide="(filters.name == \'School\' && oneSchool) || filter.currentYearOnly || filter.isTeacher">\n                    <!-- Checkbox -->\n                    <select class="form-control" ng-options="item.id as item.description for item in filter.items" ng-if="filter.type ==\'checkbox\'" name="selected-{{::filter.name}}"\n                            ng-model="item.selected" ng-change="selectRadio(item.selected, filter.name, true); selectedFilter();"></select>\n                    <!-- Radio -->\n                    <select class="form-control" ng-options="item.id as item.description for item in filter.items" ng-if="filter.type == \'radio\'"\n                            ng-show="(filter.items && filter.items.length > 1)" items name="selected-{{::filter.name}}"\n                            ng-model="filter.selectedID" ng-change="selectRadio(filter.selectedID, filter.name, true); selectedFilter();"></select>\n                </div>\n            </section>\n        </div>\n    </div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/filters/selected-filters.html','<div class="filter-tags filter collapsed">\n\t<!-- filter toggle -->\n\t<a href="" class="toggle" nha-test="filter-toggle" ng-click="togglePosition()"><i class="fa" ng-class="{ \'fa-caret-left\' : !showFilters, \'fa-caret-right\' : showFilters}"></i></a>\n\n\t<div class="filters-bar">\n\t\t<label class="pull-left">Filters:</label>\n\n\t\t<div ng-repeat="filter in selectedFiltersToShow" ng-if="!filter.isHidden" id="{{filter.name}}" class="selected-filter">\n\t\t\t<div ng-if="filter.selectedFilterView && filter.selectedFilterView === \'dropdown\'" class="selected-filter-dropdown">\n\t\t\t\t<div uib-dropdown auto-close="outsideClick">\n\t\t\t\t\t<a ng-click="removeFilterGroup(filter)" ng-if="!filter.required" nha-test="remove-filters">\n\t\t\t\t\t\t<i class="fa fa-times-circle"></i>\n\t\t\t\t\t</a>\n\t\t\t\t\t<a uib-dropdown-toggle nha-test="filtered-dropdown">\n\t\t\t\t\t\t{{filter.displayName}} <span class="caret"></span>\n\t\t\t\t\t</a>\n\t\t\t\t\t<!-- required -->\n\t\t\t\t\t<ul uib-dropdown-menu uib-tooltip="Required filters can\'t be removed." tooltip-placement="right" tooltip-append-to-body="true" ng-if="filter.required" nha-test="filtered-list">\n\t\t\t\t\t\t<li ng-repeat="item in filter.items">\n\t\t\t\t\t\t\t<a nha-test="filtered-item">\n\t\t\t\t\t\t\t\t<span ng-if="item.displayName">{{item.displayName}}</span>\n\t\t\t\t\t\t\t\t<span ng-if="!item.displayName">{{item.description}}</span>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t\t<!-- optional -->\n\t\t\t\t\t<ul uib-dropdown-menu ng-if="!filter.required" nha-test="filtered-list">\n\t\t\t\t\t\t<li ng-repeat="item in filter.items" ng-click="removeFilterSelection(filter, item)">\n\t\t\t\t\t\t\t<a ng-click="removeFilterSelection(filter, item)" nha-test="filtered-item">\n\t\t\t\t\t\t\t\t<i class="fa fa-times-circle" nha-test="remove-filter"></i>\n\t\t\t\t\t\t\t\t<span ng-if="item.displayName">{{item.displayName}}</span>\n\t\t\t\t\t\t\t\t<span ng-if="!item.displayName">{{item.description}}</span>\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div ng-if="!filter.selectedFilterView || filter.selectedFilterView === \'list\'" class="selected-filter-list" nha-test="selected-filter-list">\n\t\t\t\t<!-- required -->\n\t\t\t\t<div class="selected-tag" ng-repeat="item in filter.items" ng-if="filter.required" title="Required filters can\'t be removed." nha-test="filtered-item">\n\t\t\t\t\t<span ng-if="item.displayName">{{item.displayName}}</span>\n\t\t\t\t\t<span ng-if="!item.displayName">{{item.description}}</span>\n\t\t\t\t</div>\n\t\t\t\t<!-- optional -->\n\t\t\t\t<div class="selected-tag" ng-repeat="item in filter.items" ng-if="!filter.required">\n\t\t\t\t\t<a ng-click="removeFilterSelection(filter, item)" nha-test="filtered-item">\n\t\t\t\t\t\t<i class="fa fa-times-circle" nha-test="remove-filter"></i>\n\t\t\t\t\t\t<span ng-if="item.displayName">{{item.displayName}}</span>\n\t\t\t\t\t\t<span ng-if="!item.displayName">{{item.description}}</span>\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/hierarchicalSelector/hierarchical-selector.html','<div class="hierarchical-control">\n    <div class="control-group">\n        <button type="button" ng-if="showButton" class="pull-down" ng-click="onButtonClicked($event)"><div class="arrow-down"></div></button>\n        <div class="hierarchical-input form-control" ng-class="{\'with-btn\': showButton}" ng-click="onControlClicked($event)">\n            <span ng-if="selectedItems.length == 0" class="placeholder">{{placeholder}}</span>\n            <span ng-if="selectedItems.length > 0" class="selected-items">\n                <span ng-repeat="i in selectedItems" class="selected-item" ng-if="showSelectedItem(i)">{{getTagName(i)}} <span class="selected-item-close" ng-click="deselectItem(i, $event)"></span></span>\n            </span>\n            <!-- <input type="text" class="blend-in" /> -->\n        </div>\n    </div>\n    <div class="tree-view-outer" ng-show="showTree">\n        <div class="tree-view" ng-show="showTree">\n            <ul>\n                <tree-item class="top-level" ng-repeat="item in data" item="item" select-only-leafs="selectOnlyLeafs" use-can-select-item="useCanSelectItemCallback" can-select-item="canSelectItem" multi-select="multiSelect" item-selected="itemSelected(item)" on-active-item="onActiveItem(item)" load-child-items="loadChildItems" async="isAsync" item-has-children="hasChildren(parent)" async-child-cache="asyncChildCache" />\n            </ul>\n        </div>\n    </div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/hierarchicalSelector/tree-item.html','<li>\n    <div class="item-container" ng-class="{active: metaData.isActive, selected: metaData.selected}" ng-mouseover="onMouseOver($event)" ng-click="clickSelectItem(item, $event)">\n        <span ng-if="showExpando(item)" class="expando" ng-class="{\'expando-opened\': metaData.isExpanded}" ng-click="onExpandoClicked(item, $event)"></span>\n        <div class="item-details">\n            <span ng-if="showCheckbox()" class="fa fa-1-5x tree-checkbox" ng-class="{ \'fa-check-square-o\' : metaData.selected, \'fa-square-o\' : !metaData.selected, \'text-muted disabled-item\' : metaData.isParentSelected}"></span> {{item.name}}\n        </div>\n    </div>\n    <ul ng-repeat="child in theChildren" ng-if="metaData.isExpanded">\n        <div ng-if="child.placeholder" class="loading">Loading...</div>\n        <tree-item ng-if="!child.placeholder" item="child" item-selected="subItemSelected(item)" select-only-leafs="selectOnlyLeafs" use-can-select-item="useCanSelectItem" can-select-item="canSelectItem" multi-select="multiSelect" on-active-item="activeSubItem(item, $event)" load-child-items="loadChildItems" async="async" async-child-cache="asyncChildCache" />\n    </ul>\n</li>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/loader/loader.directive.html','<div ng-if="!mini && isLoading" class="loader">\n\t<i class="fa fa-refresh fa-spin"></i> <span>{{message || \'Loading...\'}}</span>\n</div>\n\n<span ng-if="mini && isLoading" class="loader mini">\n\t<i class="fa fa-refresh fa-spin"></i>\n</span>\n\n<ng-transclude ng-if="!mini && !isLoading" class="fade-in"></ng-transclude>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/pageTabs/pageTabs.html','<div class="tabs-wrap" nha-test="tab-links">\n\t<ul class="list-unstyled clearfix" overflow-container overflow-items="overflowTabs" right-buffer="200">\n        <li ng-hide="tab.hidden" ng-repeat="tab in tabToDisplay | orderBy:\'sortOrder\'" overflow-item="tab">\n            <a ui-sref="{{tab.sref}}" ng-class="{ \'active\'  : isActive(tab)}" ui-sref-active="active">\n                <i class="{{tab.icon}}" ng-if="tab.icon && tab.icon.length > 0"></i>\n                {{tab.title}}\n            </a>\n        </li>\n\t\t<!--Overflowing Elements-->\n\t\t<li ng-if="overflowTabs.length" uib-dropdown>\n\t\t\t<a uib-dropdown-toggle>More...</a>\n\t\t\t<ul class="dropdown-menu" role="menu">\n\t\t\t\t<li ng-hide="tab.hidden" ng-repeat="tab in overflowTabs | orderBy:\'sortOrder\'">\n\t\t\t\t\t<a ui-sref="{{tab.sref}}" ng-class="{ \'active\'  : isActive(tab)}" ui-sref-active="active">{{tab.title}}</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</li>\n\t</ul>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/search-box/search-box.html','<div class="search-bar clearfix">\n    <i class="fa fa-search pull-left"></i>\n    <input type="text"\n\t\t   class="search-input pull-left"\n\t\t   nha-test="search-input"\n           placeholder="{{::searchPlaceholderText}}"\n           ng-model="display"\n           ng-change="updateSearch(search)"\n           ng-model-options="{ debounce: 500 }">\n</div>\n');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/slideBottomPanel/slideBottomPanel.html','<div class="bottomSlidePanel navbar-fixed-bottom text-center save-cancel-panel" ng-class="{\'panel-opened\': isOpened }">\n    <span class="col-xs-6" ng-include="\'/components/buttons/save-button.html\'"></span>\n    <span class="col-xs-6">\n        <button class="btn" data-ng-click="cancelAttendanceUpdate();">Cancel</button>\n\n    </span>\n</div>\n');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/small-calendar/small-calendar.component.html','<div class="small-calendar">\n\t<div class="header">\n\t\t<i class="fa fa-angle-left" nha-test="previous" ng-click="$ctrl.prev()"></i>\n\t\t<span ng-click="$ctrl.goToToday()">{{$ctrl.month.format("MMMM YYYY")}}</span>\n\t\t<i class="fa fa-angle-right" nha-test="next" ng-click="$ctrl.next()"></i>\n\t</div>\n\t<table>\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Sun</th>\n\t\t\t\t<th>Mon</th>\n\t\t\t\t<th>Tue</th>\n\t\t\t\t<th>Wed</th>\n\t\t\t\t<th>Thu</th>\n\t\t\t\t<th>Fri</th>\n\t\t\t\t<th>Sat</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat="week in $ctrl.weeks">\n\t\t\t\t<td ng-repeat="day in week.days" ng-class="{ today: day.isToday, \'different-month\': !day.isCurrentMonth, selected: $ctrl.isSelected(day) }" ng-click="$ctrl.select(day)" nha-test="day">\n\t\t\t\t\t{{day.number}}\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/spinner/spinner.html','<div style="position: relative;">\n    <div style="height: 200px; color: #CCCCCC; margin-top: 1em;text-align: center;" ng-show="isLoading">\n        <span style="font-size: 2em;">\n            <i class="fa fa-refresh fa-spin fa-fw"></i> <span ng-if="!noMessage">{{message || \'Loading...\'}}</span>\n        </span>\n    </div>\n    <div ng-if="!isLoading">\n        <div ng-transclude class="fade-in"></div>\n    </div>\n</div>\n');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/tagCloud/tagCloud.html','<style>\n    .tag-cloud {\n        width: 30em;\n    }\n\n      .tag-cloud div {\n         display: inline-block;\n    }\n\n     .tag-cloud button {\n         margin: .25em;\n    }\n</style>\n\n\n<div class="tag-cloud">\n    <div ng-repeat="tag in data">\n        <div class="filter-tag" style="margin-left: 10px;" ng-click="unselectItem($index, tag)">\n            <i ng-show="!tag.disabled" class="fa fa-times-circle"></i>\n            <span>{{tag.name}}</span>\n        </div>\n\n            <!--<div ng-repeat="t in tag.items">\n            <button class="btn btn-xs btn-default" style="margin-left: 10px;" ng-click="unselectItem(t)" ng-show="t.selected">\n                <i class="fa fa-times-circle"></i>\n                <span>{{tag.name}} - {{t.name}}</span>\n            </button>\n        </div>-->\n        </div>\n</div>');
$templateCache.put('/app/NHAApp.Core/src/NHA.App.Core.Web/app/directives/transactionErrorPanel/transactionErrorPanel.html','<div ng-if="isVisible()" class="alert {{errorPanelVM.displayClass}}" role="alert" style="margin-left: 1em; margin-right: 1em;">\n    <div ng-repeat="error in errorPanelVM.errorArray | unique : \'message\'">\n        <span class="fa fa-exclamation-circle"></span> <span ng-bind-html="error.message"></span>\n        <div class="pull-right" style="cursor: pointer;" ng-show="allowDismiss"><span class="fa fa-close" ng-click="dismissErrorPanel()"></span></div>\n        <div ng-if="error.detail">\n            \n            <div style="cursor: pointer;">\n                <div style="margin-top: 1em;font-weight: bold; margin-bottom: 1em;" ng-click="showDetails = !showDetails">\n                    Technical Details\n                    <span class=" fa fa-chevron-up" ng-show="showDetails" title="Hide technical detail">\n                    </span>\n                    <span class="fa fa-chevron-down" ng-hide="showDetails" title="Show technical detail"></span>\n                </div>\n            </div>\n            <div class="clearfix" style="margin-top: 1em;background: lightyellow;padding: 1em;" ng-show="showDetails">\n                <p>{{error.detail}}</p>\n            </div>\n        </div>\n    </div>\n</div>');}]);})();